﻿export const localUiCss = `
@import url('https://fonts.googleapis.com/css2?family=Anton&display=swap');
:root {
  --vr-bg: #0b0b0d;
  --vr-bg-2: #141418;
  --vr-panel: rgba(20, 20, 24, 0.8);
  --vr-panel-2: rgba(30, 30, 35, 0.72);
  --vr-border: rgba(232, 193, 90, 0.26);
  --vr-border-strong: rgba(232, 193, 90, 0.55);
  --vr-text: #f4f1e8;
  --vr-muted: #a89a86;
  --vr-purple: #e8c15a;
  --vr-purple-2: #ffd76e;
  --vr-blue: #8fa7ff;
  --vr-green: #22c55e;
  --vr-red: #ef4444;
  --vr-orange: #ffb84d;
  --vr-glow-purple: 0 12px 32px rgba(0, 0, 0, 0.5);
  --vr-glow-green: 0 12px 32px rgba(0, 0, 0, 0.5);
  --vr-accent: #e8c15a;
  --vr-gold: #e8c15a;
  --vr-gold-bright: #ffe9ad;
  --vr-plate: rgba(10, 10, 12, 0.85);
  --vr-foil: linear-gradient(135deg, #fff3c4, #c98f2e 35%, #ffe9a8 55%, #8a5a1a 82%, #ffd76e);
  --mg-display: 'Anton', 'Arial Narrow', sans-serif;
}

* { box-sizing: border-box; }
html, body { width: 100%; height: 100%; }
body {
  margin: 0;
  overflow: hidden;
  background: var(--vr-bg);
  background-image: radial-gradient(rgba(255, 255, 255, 0.045) 1px, transparent 1.4px);
  background-size: 6px 6px;
  color: var(--vr-text);
  font-family: Geist, Inter, "Segoe UI", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 14px;
}
button, input { font: inherit; }
button { cursor: pointer; }
button:focus-visible,
a:focus-visible {
  outline: 2px solid rgba(255, 233, 173, 0.92);
  outline-offset: 3px;
  box-shadow: 0 0 0 6px rgba(0, 0, 0, 0);
}
i[data-icon] {
  width: 16px;
  height: 16px;
  display: inline-grid;
  place-items: center;
  flex: 0 0 auto;
  font-style: normal;
  color: inherit;
}
i[data-icon] svg {
  width: 100%;
  height: 100%;
  display: block;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
i[data-icon] svg path,
i[data-icon] svg circle,
i[data-icon] svg rect,
i[data-icon] svg line,
i[data-icon] svg polyline,
i[data-icon] svg ellipse {
  fill: none;
  stroke: inherit;
}
button i[data-icon],
a i[data-icon] {
  width: 14px;
  height: 14px;
  color: inherit;
}
.vr-context-icon-chip {
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 8px;
  background: rgba(24, 22, 28, 0.72);
  color: #ffe9ad;
}
.vr-context-icon-chip.is-input {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.04);
}
.vr-context-icon-chip i[data-icon] {
  width: 14px;
  height: 14px;
}
.vr-context-icon-chip.is-input i[data-icon] {
  width: 14px;
  height: 14px;
}

.vr-app {
  width: 100vw;
  height: 100dvh;
  min-height: 760px;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  color: var(--vr-text);
}


.vr-sidebar,
.vr-composed-shell,
.vr-project-header,
.vr-providers-panel,
.vr-releases-panel,
.vr-agent-panel,
.vr-bottom-tip-bar {
  border: 1px solid var(--vr-border);
  background:
    linear-gradient(180deg, rgba(24, 22, 28, 0.68), rgba(13, 12, 16, 0.7)),
    var(--vr-panel);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.025);
}

.vr-sidebar {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-rows: auto auto 1fr;
  gap: 12px;
  margin: 14px 0 14px 14px;
  border-radius: 16px;
  padding: 12px 10px;
}

.vr-sidebar-brand {
  display: grid;
  grid-template-columns: 48px;
  justify-content: center;
  align-items: center;
  min-width: 0;
}
.vr-sidebar-brand > div,
.vr-open-source-card,
.vr-workspace-switcher {
  display: none;
}

.vr-brand-mascot {
  position: relative;
  width: 48px;
  height: 48px;
  display: grid;
  place-items: end center;
  overflow: hidden;
  border: 1px solid rgba(255, 215, 110, 0.5);
  border-radius: 14px;
  background:
    radial-gradient(circle at 42% 26%, rgba(34, 197, 94, 0.16), transparent 36%),
    radial-gradient(circle at 68% 76%, rgba(232, 193, 90, 0.5), transparent 54%),
    linear-gradient(145deg, rgba(24, 22, 28, 0.98), rgba(13, 12, 16, 0.8));
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.08),
    0 0 28px rgba(0, 0, 0, 0);
}
.vr-brand-mascot::after {
  content: "";
  position: absolute;
  inset: -1px;
  pointer-events: none;
  border-radius: inherit;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.16), transparent 40%, rgba(34, 197, 94, 0.12));
}
.vr-brand-mascot img {
  position: relative;
  z-index: 1;
  width: 50px;
  height: 50px;
  object-fit: contain;
  object-position: bottom;
  transform: translateY(4px) scale(1.08);
  filter: saturate(1.18) drop-shadow(0 0 18px rgba(255, 215, 110, 0.55));
  animation: vrMascotIdle 3600ms cubic-bezier(0.23, 1, 0.32, 1) infinite;
}

.vr-sidebar-brand strong {
  display: block;
  font-size: 25px;
  line-height: 1;
  font-weight: 850;
}

.vr-sidebar-brand span {
  display: block;
  margin-top: 5px;
  color: var(--vr-muted);
  font-size: 12px;
}

.vr-sidebar-nav {
  display: grid;
  gap: 8px;
  margin-top: 6px;
}

.vr-sidebar-nav button,
.vr-workspace-switcher,
.vr-open-source-card .vr-github-cta,
.vr-report-button,
.vr-branch-selector,
.vr-header-icon,
.vr-user-menu,
.vr-add-provider,
.vr-release-actions button,
.vr-provider-detail-panel button,
.vr-provider-dashboard,
.vr-quick-action {
  border: 1px solid var(--vr-border);
  background: rgba(7, 16, 33, 0.62);
  color: var(--vr-text);
  text-decoration: none;
  transition:
    transform 180ms cubic-bezier(0.23, 1, 0.32, 1),
    border-color 180ms ease,
    box-shadow 180ms ease,
    background 180ms ease;
}

.vr-sidebar-nav button {
  min-height: 42px;
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  align-items: center;
  border-radius: 10px;
  padding: 0;
  text-align: center;
  font-weight: 720;
}
.vr-sidebar-nav button span {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}

.vr-sidebar-nav button i,
.vr-header-icon i,
.vr-quick-action i,
.vr-report-button i,
.vr-branch-selector i,
.vr-add-provider i,
.vr-provider-dashboard i,
.vr-current-star i {
  width: 22px;
  height: 22px;
  display: inline-grid;
  place-items: center;
  border: 1px solid rgba(255, 233, 173, 0.28);
  border-radius: 7px;
  background:
    radial-gradient(circle at 35% 25%, rgba(255, 255, 255, 0.14), transparent 34%),
    rgba(148, 163, 184, 0.050);
  color: #ffe9ad;
}

.vr-sidebar-nav button svg,
.vr-header-icon svg,
.vr-quick-action svg,
.vr-report-button svg,
.vr-branch-selector svg,
.vr-add-provider svg,
.vr-provider-dashboard svg,
.vr-current-star svg,
.vr-modal-card svg {
  width: 15px;
  height: 15px;
  display: block;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.vr-sidebar-nav button.is-active {
  border-color: rgba(255, 215, 110, 0.72);
  background:
    radial-gradient(circle at 18% 50%, rgba(148, 163, 184, 0.050), transparent 38%),
    linear-gradient(90deg, rgba(232, 193, 90, 0.58), rgba(148, 163, 184, 0.050));
  box-shadow: var(--vr-glow-purple);
}

.vr-sidebar-nav button:hover,
.vr-report-button:hover,
.vr-header-icon:hover,
.vr-user-menu:hover,
.vr-release-actions button:hover,
.vr-provider-detail-panel button:hover,
.vr-provider-dashboard:hover,
.vr-quick-action:hover {
  border-color: rgba(255, 215, 110, 0.56);
  transform: translateY(-1px);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0);
}

.vr-sidebar-nav button:active,
.vr-report-button:active,
.vr-header-icon:active,
.vr-user-menu:active,
.vr-provider-card:active,
.vr-release-card:active,
.vr-quick-action:active,
.vr-glow-button:active,
.vr-modal-action-grid button:active,
.vr-modal-button-row button:active {
  transform: scale(0.975);
}

.vr-open-source-card {
  align-self: end;
  display: grid;
  gap: 10px;
  border: 1px solid var(--vr-border);
  border-radius: 14px;
  background: rgba(8, 17, 34, 0.66);
  padding: 14px;
}

.vr-open-source-card strong { font-size: 13px; }
.vr-open-source-card p,
.vr-open-source-card small {
  margin: 0;
  color: var(--vr-muted);
  font-size: 12px;
}

.vr-open-source-card .vr-github-cta {
  width: fit-content;
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 9px;
  padding: 0 12px;
}

.vr-inline-brand-mark {
  width: 22px;
  height: 22px;
  display: inline-grid;
  place-items: center;
  overflow: hidden;
  border: 1px solid rgba(255, 233, 173, 0.26);
  border-radius: 7px;
  background:
    radial-gradient(circle at 34% 20%, rgba(255, 255, 255, 0.16), transparent 34%),
    rgba(24, 22, 28, 0.78);
}

.vr-inline-brand-mark img {
  width: 17px;
  height: 17px;
  object-fit: contain;
  filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0));
}

.vr-workspace-switcher > span {
  width: 28px;
  height: 28px;
  border: 2px solid rgba(13, 12, 16, 0.9);
  border-radius: 999px;
  background:
    radial-gradient(circle at 35% 28%, #f8fafc, transparent 10%),
    linear-gradient(135deg, #10b981, #e8c15a 60%, #f97316);
}

.vr-github-stat-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  color: inherit;
  text-decoration: none;
  transition:
    transform 180ms cubic-bezier(0.23, 1, 0.32, 1),
    filter 180ms ease;
}

.vr-github-stat-row:hover {
  transform: translateY(-1px);
  filter: brightness(1.08);
}

.vr-github-stat-row span {
  min-width: 0;
  border: 1px solid rgba(120, 145, 190, 0.18);
  border-radius: 9px;
  background:
    linear-gradient(180deg, rgba(148, 163, 184, 0.050), rgba(14, 165, 233, 0.04)),
    rgba(13, 12, 16, 0.34);
  padding: 7px 8px;
}

.vr-github-stat-row b,
.vr-github-stat-row em {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr-github-stat-row b {
  color: var(--vr-text);
  font-size: 13px;
  line-height: 1.2;
}

.vr-github-stat-row em {
  color: var(--vr-muted);
  font-size: 10px;
  font-style: normal;
  line-height: 1.25;
  text-transform: uppercase;
}

.vr-github-stat-row.is-loading span {
  animation: vrSoftPulse 1.4s ease-in-out infinite;
  opacity: 0.72;
}

.vr-workspace-switcher {
  min-height: 56px;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  border-radius: 12px;
  padding: 8px 10px;
  text-align: left;
}

.vr-workspace-switcher strong,
.vr-workspace-switcher em {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr-workspace-switcher em {
  color: var(--vr-muted);
  font-size: 11px;
  font-style: normal;
}

.vr-report-button b,
.vr-user-menu b,
.vr-provider-detail-panel button i,
.vr-quick-action b,
.vr-glow-button i {
  width: 8px;
  height: 8px;
  border-right: 1.7px solid currentColor;
  border-bottom: 1.7px solid currentColor;
  opacity: 0.72;
  transform: rotate(45deg);
}

.vr-composed-shell {
  position: relative;
  min-width: 0;
  height: calc(100dvh - 20px);
  min-height: 760px;
  display: grid;
  grid-template-rows: 52px minmax(460px, 1fr) clamp(220px, 27dvh, 290px) 34px;
  margin: 10px 12px;
  border-radius: 16px;
  overflow: hidden;
  background:
    radial-gradient(circle at 45% 9%, rgba(148, 163, 184, 0.050), transparent 30%),
    rgba(12, 13, 16, 0.92);
}

.vr-app.is-dragging-provider .vr-composed-shell::before,
.vr-app.is-dragging-release .vr-composed-shell::before,
.vr-app.is-dragging-chat .vr-composed-shell::before {
  content: "Drop into chat";
  position: absolute;
  left: 50%;
  top: 96px;
  z-index: 60;
  pointer-events: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(255, 233, 173, 0.5);
  border-radius: 999px;
  background:
    radial-gradient(circle at 18px 50%, rgba(34, 197, 94, 0.24), transparent 22px),
    rgba(23, 25, 31, 0.98);
  color: #f8fafc;
  box-shadow:
    0 18px 48px rgba(0, 0, 0, 0.42),
    0 0 0 1px rgba(255, 255, 255, 0.04),
    0 0 30px rgba(0, 0, 0, 0);
  padding: 9px 14px;
  font-size: 12px;
  font-weight: 780;
  line-height: 1;
  transform: translate(-50%, -50%);
}

.vr-app.is-dragging-provider .vr-composed-shell::before {
  content: "Drop provider into chat";
}

.vr-app.is-dragging-release .vr-composed-shell::before {
  content: "Drop version into chat";
}

.vr-app.is-dragging-chat .vr-composed-shell::before {
  content: "Drop chat to split";
}

.vr-app.is-dragging-provider .vr-composed-shell::after,
.vr-app.is-dragging-release .vr-composed-shell::after,
.vr-app.is-dragging-chat .vr-composed-shell::after {
  content: "";
  position: absolute;
  left: clamp(410px, 30vw, 680px);
  top: clamp(500px, 57vh, 600px);
  z-index: 27;
  pointer-events: none;
  width: clamp(250px, 20vw, 390px);
  height: clamp(84px, 12vh, 150px);
  border-left: 2px dashed rgba(255, 215, 110, 0.64);
  border-top: 2px dashed rgba(255, 215, 110, 0.64);
  border-radius: 120px 0 0 0;
  filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0));
  transform: skewX(-28deg) rotate(-10deg);
  animation: vrDragRoute 1500ms linear infinite;
}

.vr-studio-topbar {
  display: grid;
  grid-template-columns: auto auto minmax(150px, 190px) minmax(130px, 170px) minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  border-width: 0 0 1px;
  border-radius: 0;
  padding: 0 14px;
  background: rgba(13, 12, 16, 0.52);
}
.vr-topbar-brand {
  display: inline-grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 10px;
  color: #f8fafc;
  text-decoration: none;
}
.vr-topbar-brand span {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: end center;
  overflow: hidden;
  border-radius: 12px;
  background:
    radial-gradient(circle at 42% 20%, rgba(34, 197, 94, 0.16), transparent 38%),
    radial-gradient(circle at 64% 72%, rgba(148, 163, 184, 0.050), transparent 48%),
    rgba(8, 17, 34, 0.82);
}
.vr-topbar-brand img {
  width: 38px;
  height: 38px;
  object-fit: contain;
  transform: translateY(4px);
}
.vr-topbar-brand strong {
  font-size: 18px;
  letter-spacing: 0;
}
.vr-topbar-select-wrap {
  position: relative;
  min-width: 0;
}
.vr-topbar-select {
  width: 100%;
  min-height: 34px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-rows: auto auto;
  align-items: center;
  column-gap: 8px;
  border: 1px solid rgba(226, 232, 240, 0.12);
  border-radius: 9px;
  background: rgba(7, 16, 33, 0.56);
  color: #f8fafc;
  padding: 6px 10px;
  text-align: left;
}
.vr-topbar-select span {
  grid-column: 1;
  color: var(--vr-muted);
  font-size: 10px;
}
.vr-topbar-select strong {
  grid-column: 1;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
}
.vr-topbar-select strong i {
  width: 14px;
  height: 14px;
}
.vr-topbar-select strong svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.vr-topbar-select b {
  grid-column: 2;
  grid-row: 1 / span 2;
  width: 7px;
  height: 7px;
  border: solid #94a3b8;
  border-width: 0 1.5px 1.5px 0;
  transform: rotate(45deg) translateY(-2px);
}
.vr-topbar-menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 35;
  width: min(260px, 88vw);
  display: grid;
  gap: 2px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  background: rgba(39, 40, 41, 0.98);
  box-shadow: 0 22px 70px rgba(0, 0, 0, 0.48);
  padding: 8px;
  animation: vrMenuIn 130ms cubic-bezier(0.23, 1, 0.32, 1) both;
}
.vr-topbar-menu button {
  min-height: 34px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 16px;
  align-items: center;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #f5f5f4;
  padding: 0 9px;
  text-align: left;
}
.vr-topbar-menu button:hover {
  background: rgba(255, 255, 255, 0.08);
}
.vr-topbar-menu button span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vr-topbar-menu button b {
  width: 8px;
  height: 14px;
  justify-self: center;
  border: solid #f5f5f4;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.vr-top-stage-strip {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(4, minmax(120px, 1fr));
  align-items: center;
  justify-self: center;
  width: min(720px, 100%);
  border: 1px solid rgba(226, 232, 240, 0.1);
  border-radius: 11px;
  background: rgba(7, 12, 24, 0.45);
  overflow: hidden;
}
.vr-top-stage-strip button {
  position: relative;
  min-width: 0;
  min-height: 38px;
  display: grid;
  grid-template-columns: 26px minmax(0, 1fr);
  grid-template-rows: auto auto;
  align-items: center;
  gap: 0 8px;
  border: 0;
  border-right: 1px solid rgba(226, 232, 240, 0.08);
  background: transparent;
  color: #e5e7eb;
  padding: 6px 12px;
  text-align: left;
}
.vr-top-stage-strip button:last-child {
  border-right: 0;
}
.vr-top-stage-strip button:hover {
  background: rgba(255, 255, 255, 0.035);
}
.vr-top-stage-strip button.is-active {
  background:
    radial-gradient(circle at 50% 120%, rgba(148, 163, 184, 0.050), transparent 42%),
    linear-gradient(180deg, rgba(148, 163, 184, 0.050), rgba(14, 16, 24, 0.12));
  box-shadow:
    inset 0 0 0 1px rgba(0, 0, 0, 0),
    0 0 26px rgba(0, 0, 0, 0);
}
.vr-top-stage-strip span {
  grid-row: 1 / span 2;
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(148, 163, 184, 0.32);
  border-radius: 999px;
  color: #cbd5e1;
  font-size: 12px;
  font-weight: 760;
}
.vr-top-stage-strip button.is-active span {
  border-color: rgba(255, 215, 110, 0.78);
  background: rgba(255, 255, 255, 0.04);
  color: #f5f3ff;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0);
}
.vr-top-stage-strip strong,
.vr-top-stage-strip em {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vr-top-stage-strip strong {
  color: #f8fafc;
  font-size: 12px;
  font-weight: 760;
}
.vr-top-stage-strip em {
  color: #93c5fd;
  font-size: 11px;
  font-style: normal;
}
.vr-top-stage-strip button.is-active em {
  color: #ffe9ad;
}
.vr-top-stage-strip b {
  position: absolute;
  right: -5px;
  top: 50%;
  width: 10px;
  height: 10px;
  border-top: 1px solid rgba(226, 232, 240, 0.1);
  border-right: 1px solid rgba(226, 232, 240, 0.1);
  background: rgba(7, 12, 24, 0.45);
  transform: translateY(-50%) rotate(45deg);
}
.vr-top-stage-strip button:last-child b {
  display: none;
}
.vr-topbar-spacer {
  min-width: 0;
  display: flex;
  justify-content: end;
  color: #64748b;
  font-size: 12px;
  font-weight: 760;
}
.vr-top-command-strip {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  overflow-x: auto;
  scrollbar-width: none;
}
.vr-top-command-strip::-webkit-scrollbar {
  display: none;
}
.vr-top-command-strip button,
.vr-topbar-report {
  min-height: 36px;
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(226, 232, 240, 0.12);
  border-radius: 9px;
  background: rgba(10, 16, 30, 0.72);
  color: #f8fafc;
  padding: 0 12px;
  text-decoration: none;
  font-size: 12px;
  font-weight: 780;
  transition:
    transform 180ms cubic-bezier(0.23, 1, 0.32, 1),
    border-color 180ms ease,
    background 180ms ease,
    box-shadow 180ms ease;
}
.vr-top-command-strip button:hover,
.vr-topbar-report:hover {
  border-color: rgba(148, 163, 184, 0.22);
  background: rgba(30, 24, 50, 0.84);
  transform: translateY(-1px);
}
.vr-top-command-strip button i,
.vr-topbar-report i {
  width: 18px;
  height: 18px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.04);
  color: #ffe9ad;
}
.vr-top-command-strip button svg,
.vr-topbar-report svg {
  width: 13px;
  height: 13px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.vr-top-command-strip button[data-action="add-context"] {
  border-color: rgba(148, 163, 184, 0.22);
}
.vr-topbar-report {
  justify-self: end;
}
.vr-user-menu.is-compact {
  width: 42px;
  min-width: 42px;
  grid-template-columns: 1fr;
  justify-items: center;
  padding: 0;
}
.vr-user-menu.is-compact strong {
  font-size: 13px;
}

.vr-project-header {
  display: grid;
  grid-template-columns: 300px auto auto minmax(360px, 1fr);
  align-items: center;
  gap: 16px;
  border-width: 0 0 1px;
  border-radius: 0;
  padding: 0 28px;
  background: rgba(13, 12, 16, 0.5);
}

.vr-project-id {
  min-width: 0;
  width: 260px;
  max-width: 260px;
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr);
  grid-template-rows: auto auto;
  justify-content: stretch;
  gap: 2px 10px;
  align-items: center;
  border: 0;
  background: transparent;
  color: var(--vr-text);
  text-align: left;
}

.vr-project-id::before {
  content: "";
  grid-row: 1 / span 2;
  width: 16px;
  height: 14px;
  border: 1.4px solid #93c5fd;
  border-radius: 4px;
  background: rgba(147, 197, 253, 0.08);
}

.vr-project-id span {
  grid-column: 2;
  color: var(--vr-muted);
  font-size: 11px;
}

.vr-project-id strong {
  grid-column: 2;
  max-width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
}
.vr-status-badge {
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 8px;
  color: var(--vr-muted);
  padding: 0 10px;
  font-size: 12px;
  font-weight: 760;
}
.vr-status-badge[data-tone="green"] {
  border-color: rgba(34, 197, 94, 0.36);
  background: rgba(34, 197, 94, 0.13);
  color: #4ade80;
}
.vr-status-badge[data-tone="red"] {
  border-color: rgba(239, 68, 68, 0.36);
  background: rgba(239, 68, 68, 0.12);
  color: #f87171;
}
.vr-status-badge[data-tone="orange"] {
  border-color: rgba(249, 115, 22, 0.4);
  background: rgba(249, 115, 22, 0.14);
  color: #fdba74;
}
.vr-status-badge[data-tone="purple"] {
  border-color: rgba(148, 163, 184, 0.22);
  background: rgba(255, 255, 255, 0.04);
  color: #ffe9ad;
}
.vr-status-badge[data-tone="blue"] {
  border-color: rgba(56, 189, 248, 0.32);
  background: rgba(56, 189, 248, 0.1);
  color: #38bdf8;
}

.vr-branch-selector,
.vr-report-button {
  min-height: 40px;
  display: inline-grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 9px;
  border-radius: 10px;
  padding: 0 14px;
  white-space: nowrap;
}

.vr-header-actions {
  justify-self: end;
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.vr-header-icon,
.vr-user-menu {
  width: 40px;
  height: 40px;
  display: inline-grid;
  place-items: center;
  border-radius: 999px;
  position: relative;
}
.vr-header-icon.has-dot::after {
  content: "";
  position: absolute;
  right: 8px;
  top: 8px;
  width: 7px;
  height: 7px;
  border: 2px solid var(--vr-bg);
  border-radius: 999px;
  background: var(--vr-red);
}
.vr-user-menu {
  width: 132px;
  grid-template-columns: 38px minmax(0, 1fr) 22px 7px;
  gap: 7px;
  padding: 0 9px 0 5px;
  border-color: rgba(148, 163, 184, 0.22);
  background:
    radial-gradient(circle at 30% 22%, rgba(34, 197, 94, 0.13), transparent 34%),
    radial-gradient(circle at 76% 50%, rgba(148, 163, 184, 0.050), transparent 38%),
    rgba(7, 16, 33, 0.72);
}
.vr-user-menu span {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: end center;
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 999px;
  background:
    radial-gradient(circle at 42% 20%, rgba(34, 197, 94, 0.18), transparent 38%),
    radial-gradient(circle at 65% 72%, rgba(148, 163, 184, 0.050), transparent 48%),
    rgba(8, 17, 34, 0.88);
  box-shadow: 0 0 18px rgba(0, 0, 0, 0);
}
.vr-user-menu strong {
  display: block;
  min-width: 0;
  overflow: hidden;
  color: #f8fafc;
  font-size: 12px;
  font-weight: 850;
  line-height: 1;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vr-user-menu em {
  min-width: 22px;
  min-height: 18px;
  display: inline-grid;
  place-items: center;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  color: #ffe9ad;
  font-size: 10px;
  font-style: normal;
  font-weight: 850;
}
.vr-user-menu span img {
  width: 42px;
  height: 42px;
  object-fit: contain;
  object-position: bottom;
  transform: translateY(4px);
  filter: saturate(1.2) drop-shadow(0 0 10px rgba(34, 197, 94, 0.32));
  animation: vrMascotIdle 3400ms cubic-bezier(0.23, 1, 0.32, 1) infinite;
}

.vr-composition-body {
  min-height: 0;
  height: 100%;
  display: grid;
  grid-template-columns: minmax(292px, 320px) minmax(0, 1fr) minmax(388px, 428px);
  gap: 12px;
  align-items: stretch;
  overflow: hidden;
  padding: 14px 18px 8px;
}

.vr-recent-rail {
  min-width: 0;
  min-height: 0;
  height: 100%;
  display: grid;
  grid-template-rows: auto auto minmax(0, 1fr) auto;
  gap: 10px;
  border: 1px solid rgba(226, 232, 240, 0.105);
  border-radius: 12px;
  background: rgba(19, 23, 29, 0.84);
  box-shadow: none;
  padding: 10px;
  overflow: hidden;
}
.vr-new-chat-button,
.vr-view-all-chats,
.vr-recent-chat {
  border: 1px solid rgba(148, 163, 184, 0.15);
  background: rgba(24, 24, 27, 0.62);
  color: #f8fafc;
  transition:
    transform 180ms cubic-bezier(0.23, 1, 0.32, 1),
    border-color 180ms ease,
    background 180ms ease,
    box-shadow 180ms ease;
}
.vr-recent-chat[draggable="true"],
.vr-provider-card[draggable="true"],
.vr-release-card[draggable="true"],
.vr-release-row[draggable="true"],
.vr-inspector-provider-row[draggable="true"],
.vr-inspector-release-list button[draggable="true"],
.vr-chat-provider-dot[draggable="true"],
.vr-chat-version-dot[draggable="true"] {
  position: relative;
  cursor: grab;
  user-select: none;
  -webkit-user-drag: element;
  touch-action: none;
}
.vr-recent-chat[draggable="true"]:active,
.vr-provider-card[draggable="true"]:active,
.vr-release-card[draggable="true"]:active,
.vr-release-row[draggable="true"]:active,
.vr-inspector-provider-row[draggable="true"]:active,
.vr-inspector-release-list button[draggable="true"]:active,
.vr-chat-provider-dot[draggable="true"]:active,
.vr-chat-version-dot[draggable="true"]:active {
  cursor: grabbing;
}
.vr-recent-chat.is-being-dragged,
.vr-provider-card.is-being-dragged,
.vr-release-card.is-being-dragged,
.vr-release-row.is-being-dragged,
.vr-inspector-provider-row.is-being-dragged,
.vr-inspector-release-list button.is-being-dragged,
.vr-chat-provider-dot.is-being-dragged,
.vr-chat-version-dot.is-being-dragged {
  opacity: 0.94;
  transform: scale(1.018) translateY(-4px);
  border-color: rgba(255, 233, 173, 0.82);
  background:
    radial-gradient(circle at 88% 18%, rgba(34, 197, 94, 0.16), transparent 28px),
    rgba(30, 32, 38, 0.98);
  box-shadow:
    0 0 0 1px rgba(255, 233, 173, 0.3),
    0 18px 46px rgba(0, 0, 0, 0.36),
    0 0 36px rgba(0, 0, 0, 0);
}
.vr-provider-card.is-being-dragged::before,
.vr-release-card.is-being-dragged::before,
.vr-release-row.is-being-dragged::before,
.vr-inspector-provider-row.is-being-dragged::before,
.vr-inspector-release-list button.is-being-dragged::before,
.vr-chat-provider-dot.is-being-dragged::before,
.vr-chat-version-dot.is-being-dragged::before,
.vr-recent-chat.is-being-dragged::before {
  content: "Dragging to chat";
  position: absolute;
  right: 12px;
  top: -34px;
  z-index: 18;
  pointer-events: none;
  border: 1px solid rgba(255, 233, 173, 0.52);
  border-radius: 999px;
  background: rgba(25, 27, 32, 0.96);
  color: #f4f4f5;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.38), 0 0 24px rgba(0, 0, 0, 0);
  padding: 8px 11px;
  font-size: 11px;
  font-weight: 760;
  white-space: nowrap;
}
.vr-release-card.is-being-dragged::before,
.vr-release-row.is-being-dragged::before,
.vr-inspector-release-list button.is-being-dragged::before,
.vr-chat-version-dot.is-being-dragged::before {
  content: "Dragging version";
}
.vr-recent-chat.is-being-dragged::before {
  content: "Dragging chat";
}
.vr-app.is-dragging .vr-provider-grid .vr-provider-card:not(.is-being-dragged),
.vr-app.is-dragging .vr-release-composition button:not(.is-being-dragged),
.vr-app.is-dragging .vr-recent-chat-list .vr-recent-chat:not(.is-being-dragged) {
  opacity: 0.45;
  filter: saturate(0.75);
}
.vr-app.is-dragging,
.vr-app.is-dragging * {
  cursor: grabbing !important;
}
html:has(.vr-app.is-dragging),
body:has(.vr-app.is-dragging) {
  cursor: grabbing !important;
}
.vr-app.is-dragging [data-chat-drop],
.vr-app.is-dragging [data-action="new-chat"] {
  cursor: copy !important;
}
.vr-drag-chip {
  position: fixed;
  left: -9999px;
  top: -9999px;
  z-index: 9999;
  min-width: 176px;
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  align-items: center;
  gap: 9px;
  border: 1px solid rgba(226, 232, 240, 0.22);
  border-radius: 10px;
  background: rgba(31, 32, 36, 0.98);
  color: #f8fafc;
  box-shadow: 0 16px 34px rgba(0, 0, 0, 0.38);
  padding: 8px 10px;
  pointer-events: none;
}
.vr-drag-chip-mark {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(226, 232, 240, 0.14);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.04);
  overflow: hidden;
}
.vr-drag-chip-mark img {
  width: 22px;
  height: 22px;
  object-fit: contain;
}
.vr-drag-chip-mark > i {
  width: 18px;
  height: 18px;
  border-radius: 5px;
  background: rgba(148, 163, 184, 0.22);
}
.vr-drag-chip-mark .vr-version-token {
  width: 26px;
  height: 26px;
  border: 0;
  background: transparent;
}
.vr-drag-chip > div strong,
.vr-drag-chip > div span {
  display: block;
}
.vr-drag-chip > div strong {
  font-size: 12px;
  font-weight: 760;
}
.vr-drag-chip > div span {
  margin-top: 2px;
  color: #a8b3c7;
  font-size: 11px;
}
.vr-new-chat-button {
  min-height: 40px;
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  border-color: rgba(148, 163, 184, 0.22);
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(232, 193, 90, 0.86), rgba(91, 33, 182, 0.9));
  padding: 0 10px;
  text-align: left;
  font-weight: 830;
}
.vr-new-chat-button svg,
.vr-view-all-chats svg,
.vr-recent-chat svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.vr-new-chat-button kbd {
  border: 1px solid rgba(226, 232, 240, 0.12);
  border-radius: 6px;
  background: rgba(13, 12, 16, 0.5);
  color: #cbd5e1;
  padding: 2px 6px;
  font: 10px/1.2 "JetBrains Mono", "SFMono-Regular", Consolas, monospace;
}
.vr-recent-rail h2 {
  margin: 0;
  color: #cbd5e1;
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}
.vr-recent-chat-list {
  min-height: 0;
  display: grid;
  align-content: start;
  gap: 6px;
  overflow: auto;
  scrollbar-width: thin;
}
.vr-recent-empty {
  margin: 0;
  border: 1px dashed rgba(148, 163, 184, 0.18);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.025);
  color: #94a3b8;
  padding: 12px;
  font-size: 12px;
  line-height: 1.45;
}
.vr-recent-chat {
  min-width: 0;
  min-height: 60px;
  display: grid;
  grid-template-columns: 26px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  border-radius: 9px;
  padding: 8px;
  text-align: left;
}
.vr-recent-chat > i {
  width: 26px;
  height: 26px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.04);
  color: #ffe9ad;
}
.vr-recent-chat strong,
.vr-recent-chat em {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vr-recent-chat strong {
  font-size: 12px;
  font-weight: 820;
}
.vr-recent-chat em,
.vr-recent-chat small {
  color: #8b98ad;
  font-style: normal;
  font-size: 11px;
}
.vr-recent-chat small {
  align-self: start;
  padding-top: 2px;
  white-space: nowrap;
}
.vr-recent-chat:hover,
.vr-recent-chat.is-active,
.vr-new-chat-button:hover,
.vr-view-all-chats:hover {
  border-color: rgba(226, 232, 240, 0.18);
  background: rgba(35, 39, 46, 0.76);
  transform: translateY(-1px);
}
.vr-recent-chat.is-active {
  border-color: rgba(148, 163, 184, 0.22);
  box-shadow: inset 2px 0 0 rgba(255, 215, 110, 0.72);
}
.vr-view-all-chats {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 9px;
  color: #cbd5e1;
  font-size: 12px;
  font-weight: 780;
}
.vr-view-all-chats b {
  width: 7px;
  height: 7px;
  border-right: 1.5px solid currentColor;
  border-bottom: 1.5px solid currentColor;
  transform: rotate(-45deg);
}

.vr-main-canvas {
  min-width: 0;
  min-height: 0;
  height: 100%;
  display: grid;
  grid-template-rows: minmax(0, 1fr);
  align-content: stretch;
  gap: 10px;
}

.vr-page-title h1,
.vr-panel-head h2,
.vr-agent-hero h2,
.vr-agent-will h3,
.vr-quick-actions h3 {
  margin: 0;
}

.vr-page-title h1 {
  font-size: 23px;
  line-height: 1.1;
}
.vr-page-title p,
.vr-panel-head p {
  margin: 4px 0 0;
  color: var(--vr-muted);
}

.vr-studio-dock {
  position: relative;
  height: 100%;
  min-height: 0;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  gap: 10px;
  overflow: hidden;
  border: 1px solid rgba(226, 232, 240, 0.11);
  border-radius: 13px;
  background:
    radial-gradient(circle at 14% 0%, rgba(255, 255, 255, 0.035), transparent 34%),
    linear-gradient(180deg, rgba(22, 25, 31, 0.9), rgba(16, 18, 22, 0.94));
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
  padding: 12px;
}
.vr-studio-dock.is-running {
  border-color: rgba(249, 115, 22, 0.55);
  box-shadow: 0 0 40px rgba(249, 115, 22, 0.18);
}
.vr-studio-dock.is-verified {
  border-color: rgba(34, 197, 94, 0.46);
  box-shadow: 0 0 38px rgba(34, 197, 94, 0.15);
}
.vr-studio-head {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
}
.vr-studio-head p,
.vr-studio-head h2 {
  margin: 0;
}
.vr-studio-head p {
  color: #d4d4d8;
  font-size: 11px;
  font-weight: 680;
}
.vr-studio-head p span {
  display: inline-grid;
  place-items: center;
  min-width: 22px;
  min-height: 18px;
  margin-left: 5px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 999px;
  color: #ffe9ad;
  font-size: 10px;
}
.vr-studio-head h2 {
  font-size: 18px;
  line-height: 1.08;
  font-weight: 720;
}
.vr-studio-head span,
.vr-cli-strip em,
.vr-studio-terminal span,
.vr-studio-diff span {
  color: var(--vr-muted);
  font-style: normal;
}
.vr-studio-head > div:first-child > span {
  display: block;
  max-width: 620px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
}
.vr-studio-tabs {
  display: inline-grid;
  grid-auto-flow: column;
  gap: 6px;
  border: 1px solid rgba(226, 232, 240, 0.1);
  border-radius: 10px;
  background: rgba(10, 10, 12, 0.36);
  padding: 3px;
}
.vr-studio-head-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.vr-studio-add-chat {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid rgba(226, 232, 240, 0.12);
  border-radius: 10px;
  background: rgba(31, 34, 40, 0.7);
  color: #f8fafc;
  padding: 0 12px 0 10px;
  font-size: 12px;
  font-weight: 760;
}
.vr-studio-add-chat:hover {
  border-color: rgba(226, 232, 240, 0.22);
  background: rgba(39, 42, 48, 0.86);
}
.vr-studio-add-chat svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.vr-studio-tabs button {
  min-height: 28px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #d4d4d8;
  padding: 0 12px;
  font-weight: 650;
}
.vr-studio-tabs button.is-active {
  border-color: rgba(226, 232, 240, 0.24);
  background: rgba(244, 244, 245, 0.1);
  color: #fff;
  box-shadow: none;
}
.vr-studio-actions {
  display: inline-grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 8px;
}
.vr-studio-actions > button:not(.vr-glow-button) {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(226, 232, 240, 0.12);
  border-radius: 10px;
  background: rgba(31, 34, 40, 0.76);
  color: #f4f4f5;
  padding: 0 12px;
  font-weight: 690;
}
.vr-studio-actions svg {
  width: 16px;
  height: 16px;
}
.vr-studio-actions > button:not(.vr-glow-button) i,
.vr-chat-inline-actions i,
.vr-quick-action i {
  width: 16px;
  height: 16px;
  display: inline-grid;
  place-items: center;
  color: currentColor;
  flex: 0 0 auto;
}
.vr-studio-actions > button:not(.vr-glow-button) svg,
.vr-chat-inline-actions svg,
.vr-quick-action svg {
  width: 15px;
  height: 15px;
  display: block;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.vr-cli-connect {
  display: block;
  border: 1px solid rgba(226, 232, 240, 0.14);
  border-radius: 12px;
  background:
    linear-gradient(180deg, rgba(23, 25, 30, 0.78), rgba(13, 14, 17, 0.72));
  padding: 6px;
}
.vr-cli-connect-head {
  display: grid;
  gap: 2px;
  padding: 8px 10px 4px;
}
.vr-cli-connect-head strong {
  font-size: 12px;
  color: var(--vr-text);
}
.vr-cli-connect-head span {
  font-size: 11px;
  color: var(--vr-muted);
  line-height: 1.35;
}
.vr-cli-setup-steps {
  display: grid;
  gap: 10px;
}
.vr-cli-setup-step {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  gap: 10px;
  align-items: start;
  padding: 10px 12px;
  border: 1px solid rgba(226, 232, 240, 0.12);
  border-radius: 12px;
  background: rgba(15, 17, 22, 0.72);
}
.vr-cli-setup-step > span {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  font-size: 12px;
  font-weight: 700;
  color: #cbd5e1;
  background: rgba(148, 163, 184, 0.14);
}
.vr-cli-setup-step pre {
  margin: 8px 0 0;
  padding: 8px 10px;
  border-radius: 8px;
  background: rgba(13, 12, 16, 0.72);
  overflow: auto;
}
.vr-cli-setup-step pre code {
  font-size: 11px;
  color: #e2e8f0;
  white-space: pre-wrap;
  word-break: break-word;
}
.vr-cli-setup-step button {
  margin-top: 8px;
}
.vr-cli-strip {
  display: grid;
  grid-template-columns: repeat(4, minmax(130px, 1fr));
  gap: 6px;
}
.vr-cli-strip button {
  min-width: 0;
  min-height: 34px;
  display: grid;
  grid-template-columns: 12px 18px minmax(0, 1fr) minmax(58px, auto);
  grid-template-rows: auto;
  align-items: center;
  gap: 0 7px;
  border: 1px solid rgba(226, 232, 240, 0.14);
  border-radius: 10px;
  background: rgba(25, 27, 31, 0.68);
  color: var(--vr-text);
  padding: 6px 8px;
  text-align: left;
}
.vr-cli-strip .vr-cli-glyph {
  grid-column: 2;
  grid-row: 1;
  display: grid;
  place-items: center;
  width: 18px;
  height: 18px;
  color: #f0e2c8;
}
.vr-cli-strip .vr-cli-glyph svg { width: 16px; height: 16px; display: block; }
.vr-cli-strip .vr-cli-glyph[data-cli='codex'] { color: #7fe0b0; filter: drop-shadow(0 0 6px rgba(127, 224, 176, 0.55)); }
.vr-cli-strip .vr-cli-glyph[data-cli='claude'] { color: #e8956a; filter: drop-shadow(0 0 6px rgba(232, 149, 106, 0.55)); }
.vr-cli-strip .vr-cli-glyph[data-cli='gemini'] { color: #8fc9ff; filter: drop-shadow(0 0 6px rgba(143, 201, 255, 0.55)); }
.vr-cli-strip button[data-connected="false"] {
  opacity: 0.68;
}
.vr-cli-strip button[data-connected="false"] > span {
  background: #64748b;
  box-shadow: none;
}
.vr-cli-strip button:hover,
.vr-cli-strip button.is-selected {
  border-color: rgba(248, 250, 252, 0.28);
  transform: translateY(-1px);
  background: rgba(31, 34, 39, 0.86);
}
.vr-cli-strip button > span {
  grid-row: 1;
  width: 9px;
  height: 9px;
  border-radius: 999px;
  background: #22c55e;
  box-shadow: 0 0 12px rgba(34, 197, 94, 0.7);
}
.vr-cli-strip button[data-tone="purple"] > span { background: #ffd76e; box-shadow: 0 0 12px rgba(255, 215, 110, 0.7); }
.vr-cli-strip button[data-tone="blue"] > span { background: #38bdf8; box-shadow: 0 0 12px rgba(56, 189, 248, 0.7); }
.vr-cli-strip button[data-tone="orange"] > span { background: #f97316; box-shadow: 0 0 12px rgba(249, 115, 22, 0.7); }
.vr-cli-strip strong,
.vr-cli-strip em,
.vr-cli-strip b {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vr-cli-strip em {
  display: none;
}
.vr-cli-strip b {
  grid-column: 4;
  grid-row: 1;
  align-self: center;
  justify-self: end;
  min-width: 50px;
  border: 1px solid rgba(120, 145, 190, 0.2);
  border-radius: 999px;
  color: #ffe9ad;
  padding: 3px 7px;
  font-size: 10px;
  font-weight: 850;
  text-align: center;
}
.vr-cli-strip button.is-selected b {
  border-color: rgba(34, 197, 94, 0.44);
  background: rgba(34, 197, 94, 0.1);
  color: #86efac;
}
.vr-cli-strip button[data-connected="false"] b {
  color: #cbd5e1;
}
.vr-studio-body {
  height: 100%;
  min-height: 0;
}
.vr-studio-chat,
.vr-studio-terminal,
.vr-studio-diff {
  height: 100%;
  min-height: 150px;
  display: grid;
  border: 1px solid rgba(226, 232, 240, 0.105);
  border-radius: 12px;
  background: rgba(18, 20, 24, 0.78);
  overflow: hidden;
}
.vr-studio-chat {
  grid-template-rows: minmax(0, 1fr);
  gap: 10px;
  padding: 12px;
}
.vr-studio-terminal footer button,
.vr-studio-diff footer button {
  min-height: 32px;
  border: 1px solid rgba(255, 215, 110, 0.52);
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
  font-weight: 800;
}
.vr-studio-terminal,
.vr-studio-diff {
  grid-template-rows: auto minmax(0, 1fr) auto;
}
.vr-studio-terminal {
  grid-template-rows: auto minmax(0, 1fr);
  gap: 0;
  padding-bottom: 12px;
}
.vr-terminal-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 0;
  padding: 12px 12px 8px;
}
.vr-terminal-head-copy {
  display: grid;
  gap: 2px;
}
.vr-terminal-head-copy strong {
  font-size: 14px;
  color: #f8fafc;
}
.vr-terminal-head-copy span {
  color: #94a3b8;
  font-size: 11px;
}
.vr-terminal-screen {
  display: flex;
  flex-direction: column;
  min-height: 280px;
  margin: 0 12px;
  border-radius: 12px;
  background: #070b12;
  border: 1px solid rgba(148, 163, 184, 0.14);
  overflow: hidden;
}
.vr-terminal-scroll {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 14px 16px 10px;
}
.vr-terminal-line {
  color: #cbd5e1;
  font: 13px/1.55 "JetBrains Mono", "SFMono-Regular", Consolas, monospace;
  white-space: pre-wrap;
  word-break: break-word;
}
.vr-terminal-input-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px 12px;
  border-top: 1px solid rgba(148, 163, 184, 0.12);
  background: rgba(0, 0, 0, 0.28);
}
.vr-terminal-prompt {
  color: #ffe9ad;
  font: 700 13px/1 "JetBrains Mono", "SFMono-Regular", Consolas, monospace;
  user-select: none;
}
.vr-terminal-cursor-input {
  flex: 1;
  min-width: 0;
  border: 0;
  background: transparent;
  color: #f8fafc;
  font: 13px/1.45 "JetBrains Mono", "SFMono-Regular", Consolas, monospace;
  outline: none;
  caret-color: #ffe9ad;
}
.vr-terminal-toolbar {
  padding: 10px 12px 0;
}
.vr-terminal-toolbar .vr-cli-connect-expand-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.vr-terminal-toolbar .vr-cli-action-button {
  min-width: 118px;
  white-space: nowrap;
}
.vr-terminal-toolbar .vr-cli-setup-hint {
  margin-top: 8px;
}
.vr-cli-strip button.is-needs-signin b {
  color: #fbbf24;
}
.vr-terminal-cli-chip.is-signin span {
  background: #fbbf24;
}
.vr-terminal-cli-chip.is-ready span {
  background: #22c55e;
}
.vr-studio-terminal header,
.vr-studio-diff header,
.vr-studio-terminal footer,
.vr-studio-diff footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid rgba(96, 122, 177, 0.18);
  padding: 10px 12px;
}
.vr-studio-terminal footer,
.vr-studio-diff footer {
  justify-content: end;
  border-top: 1px solid rgba(96, 122, 177, 0.18);
  border-bottom: 0;
}
.vr-studio-terminal pre,
.vr-studio-diff pre {
  margin: 0;
  overflow: auto;
  padding: 12px;
  color: #bfdbfe;
  font: 13px/1.55 "JetBrains Mono", "SFMono-Regular", Consolas, monospace;
}
.vr-terminal-compose {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: end;
  gap: 10px;
  border-top: 1px solid rgba(96, 122, 177, 0.18);
  padding: 10px 12px;
}
.vr-terminal-compose textarea {
  min-height: 44px;
  resize: none;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.035);
  color: #e5e7eb;
  padding: 9px 10px;
  font: 13px/1.4 ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  outline: none;
}
.vr-terminal-compose textarea:focus {
  border-color: rgba(148, 163, 184, 0.22);
}
.vr-terminal-compose button {
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
  padding: 0 12px;
  font-weight: 800;
}
.vr-terminal-compose svg {
  width: 15px;
  height: 15px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
}
.vr-studio-diff .add { color: #86efac; }
.vr-studio-diff .del { color: #fca5a5; }

.vr-studio-chat {
  padding: 0;
}
.vr-chat-lanes {
  position: relative;
  height: 100%;
  min-height: 0;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: minmax(0, 1fr);
  align-items: stretch;
  align-content: stretch;
  gap: 10px;
  justify-items: stretch;
  padding: 12px 14px;
}
.vr-app.is-dragging .vr-chat-lanes::before,
.vr-studio-chat.is-drop-preview .vr-chat-lanes::before {
  content: "";
  position: absolute;
  inset: 10px 12px;
  z-index: 4;
  pointer-events: none;
  border: 1px dashed rgba(255, 233, 173, 0.72);
  border-radius: 12px;
  background:
    radial-gradient(circle at 62% 72%, rgba(148, 163, 184, 0.050), transparent 28%),
    rgba(148, 163, 184, 0.035);
  box-shadow:
    inset 0 0 0 1px rgba(255, 233, 173, 0.12),
    inset 0 0 36px rgba(0, 0, 0, 0),
    0 0 44px rgba(0, 0, 0, 0);
  animation: vrDropPulse 1200ms ease-in-out infinite;
}
.vr-app.is-dragging .vr-chat-lanes::after,
.vr-studio-chat.is-drop-preview .vr-chat-lanes::after {
  content: "Drop into chat";
  position: absolute;
  left: 50%;
  bottom: 104px;
  z-index: 16;
  pointer-events: none;
  transform: translateX(-50%);
  border: 1px solid rgba(255, 233, 173, 0.52);
  border-radius: 999px;
  background: rgba(27, 29, 35, 0.96);
  color: #f8fafc;
  padding: 8px 13px;
  font-size: 12px;
  font-weight: 780;
  box-shadow: 0 16px 44px rgba(0, 0, 0, 0.4), 0 0 24px rgba(0, 0, 0, 0);
}
.vr-app.is-dragging-provider .vr-chat-lanes::after {
  content: "Drop provider to add context";
}
.vr-app.is-dragging-release .vr-chat-lanes::after {
  content: "Drop version to compare";
}
.vr-app.is-dragging-chat .vr-chat-lanes::after {
  content: "Drop chat to split workspace";
}
.vr-studio-chat.is-drop-preview .vr-chat-lanes::after {
  content: "Drop provider or version here";
}
.vr-app.is-dragging-provider .vr-studio-dock::after,
.vr-app.is-dragging-release .vr-studio-dock::after,
.vr-app.is-dragging-chat .vr-studio-dock::after {
  content: "";
  position: absolute;
  left: 31%;
  right: 23%;
  bottom: 118px;
  z-index: 3;
  pointer-events: none;
  height: 72px;
  border-left: 2px dashed rgba(255, 215, 110, 0.55);
  border-bottom: 2px dashed rgba(255, 215, 110, 0.55);
  border-radius: 0 0 0 68px;
  opacity: 0.75;
  transform: skewX(-18deg);
  filter: drop-shadow(0 0 12px rgba(0, 0, 0, 0));
}
.vr-studio-chat.is-split .vr-chat-lanes {
  grid-auto-flow: column;
  grid-auto-columns: minmax(420px, 1fr);
  grid-template-columns: none;
  gap: 14px;
  justify-items: stretch;
  overflow-x: auto;
  scrollbar-width: thin;
}
.vr-chat-lane {
  position: relative;
  min-width: 0;
  width: 100%;
  height: 100%;
  min-height: 100%;
  min-height: 0;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  border: 0;
  border-radius: 0;
  background: transparent;
  overflow: hidden;
}
.vr-studio-chat.is-split .vr-chat-lane {
  width: auto;
  border: 1px solid rgba(226, 232, 240, 0.13);
  border-radius: 12px;
  background:
    radial-gradient(circle at 18% 0%, rgba(255, 255, 255, 0.035), transparent 34%),
    rgba(17, 19, 23, 0.74);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.035),
    0 0 0 1px rgba(0, 0, 0, 0.16);
}
.vr-studio-chat.is-split .vr-chat-lane.is-secondary::before {
  content: "";
  position: absolute;
  left: -8px;
  top: 14px;
  bottom: 14px;
  width: 1px;
  background: linear-gradient(180deg, transparent, rgba(226, 232, 240, 0.32), transparent);
  pointer-events: none;
}
.vr-studio-chat.is-split .vr-chat-transcript {
  gap: 10px;
  padding: 16px 18px 8px;
}
.vr-studio-chat.is-split .vr-chat-message > p,
.vr-studio-chat.is-split .vr-chat-copy,
.vr-studio-chat.is-split .vr-chat-mission-summary {
  padding-left: 0;
}
.vr-studio-chat.is-split .vr-chat-message p {
  font-size: 13px;
}
.vr-studio-chat.is-split .vr-chat-mission-summary section,
.vr-studio-chat.is-split .vr-chat-card {
  padding: 11px 12px;
}
.vr-studio-chat.is-split .vr-chat-mission-summary section:not(.vr-chat-plan-card):not(.vr-chat-connect-card) > span,
.vr-studio-chat.is-split .vr-chat-card-list span {
  grid-template-columns: 18px minmax(0, 1fr);
}
.vr-studio-chat.is-split .vr-chat-mission-summary b,
.vr-studio-chat.is-split .vr-chat-card-list b {
  grid-column: 2;
  justify-self: start;
}
.vr-studio-chat.is-split .vr-chat-plan-list li {
  display: block;
  grid-template-columns: none;
}
.vr-studio-chat.is-split .vr-chat-plan-list li button {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
}
.vr-studio-chat.is-split .vr-chat-inline-actions {
  flex-wrap: wrap;
  max-height: none;
  overflow: visible;
}
.vr-studio-chat.is-split .vr-chat-inline-actions button {
  flex: 0 1 auto;
  min-height: 30px;
  padding: 0 10px;
}
.vr-studio-chat.is-split .vr-chat-command-bar > .vr-chat-composer {
  grid-template-columns: minmax(0, 1fr) 38px;
}
.vr-studio-chat.is-split .vr-chat-input {
  grid-column: 1;
}
.vr-studio-chat.is-split .vr-model-picker {
  grid-column: 1 / -1;
  justify-self: start;
}
.vr-studio-chat.is-split .vr-chat-command-bar > .vr-chat-composer > button {
  grid-column: auto;
}
.vr-studio-chat.is-split .vr-chat-command-bar > .vr-chat-composer > .vr-chat-send {
  grid-column: 2;
}
.vr-chat-lane.is-primary {
  box-shadow: none;
}
.vr-studio-chat:not(.is-split) .vr-chat-lane {
  max-width: none;
}
.vr-studio-chat:not(.is-split) .vr-chat-transcript {
  padding: 18px 18px 32px;
}
.vr-studio-chat:not(.is-split) .vr-chat-message,
.vr-studio-chat:not(.is-split) .vr-chat-mission-summary {
  max-width: 760px;
}
.vr-studio-chat:not(.is-split) .vr-chat-message.is-agent {
  max-width: 720px;
}
.vr-studio-chat:not(.is-split) .vr-chat-message.is-user {
  max-width: min(620px, 74%);
  justify-self: end;
}
.vr-studio-chat:not(.is-split) .vr-chat-message.is-user > p {
  max-width: 560px;
}
.vr-studio-chat:not(.is-split) .vr-chat-message p {
  font-size: 13.5px;
  line-height: 1.45;
}
.vr-studio-chat:not(.is-split) .vr-chat-mission-summary section {
  gap: 6px;
  padding: 13px 18px;
}
.vr-studio-chat:not(.is-split) .vr-chat-mission-summary section header {
  margin-bottom: 6px;
}
.vr-studio-chat:not(.is-split) .vr-chat-mission-summary section:not(.vr-chat-plan-card):not(.vr-chat-connect-card) > span {
  min-height: 22px;
  grid-template-columns: 22px minmax(0, 1fr) auto;
}
.vr-studio-chat:not(.is-split) .vr-chat-mission-summary section:not(.vr-chat-plan-card):not(.vr-chat-connect-card) > span + span {
  margin-top: 4px;
}
.vr-studio-chat:not(.is-split) .vr-chat-mission-summary em {
  font-size: 12.5px;
}
.vr-studio-chat:not(.is-split) .vr-chat-mission-summary small {
  display: none;
}
.vr-studio-chat:not(.is-split) .vr-chat-inline-actions {
  margin-top: 0;
}
.vr-studio-chat:not(.is-split) .vr-chat-inline-actions button {
  min-height: 32px;
  padding: 0 12px;
}
/* Align the composer column with the chat messages. The transcript is a centered
   max-width column (min(1440px, 100% - 64px)) with 54px side padding, and messages
   are inset a further ~40px by the agent-avatar gutter. Match all of that here so
   the composer lines up with the message cards at every viewport width. Higher
   specificity (.vr-chat-lane) than the responsive command-bar padding passes. */
.vr-studio-chat:not(.is-split) .vr-chat-lane .vr-chat-command-bar {
  width: min(1440px, calc(100% - 64px));
  max-width: min(1440px, calc(100% - 64px));
  margin-inline: auto;
  justify-self: center;
  padding: 6px 54px 10px 94px;
  align-self: end;
}
/* Size the composer to the same width as the chat messages and left-align it, so
   both edges line up with the cards (which are min(1120px, 100%)). */
.vr-studio-chat:not(.is-split) .vr-chat-lane .vr-chat-command-bar > .vr-chat-composer {
  width: min(1120px, 100%);
  max-width: min(1120px, 100%);
  justify-self: start;
}
.vr-studio-chat:not(.is-split) .vr-chat-command-bar > .vr-chat-composer {
  min-height: 92px;
  border-color: rgba(226, 232, 240, 0.16);
  border-radius: 14px;
  background: #202124;
  color: #f4f4f5;
  padding: 10px 14px;
}
.vr-studio-chat:not(.is-split) .vr-provider-drop-zone > .vr-provider-drop-label {
  border-color: rgba(226, 232, 240, 0.14);
  background: rgba(255, 255, 255, 0.04);
  color: #94a3b8;
}

@media (min-width: 1800px) {
  .vr-studio-chat:not(.is-split) .vr-chat-transcript {
    position: relative;
    padding-top: 18px;
  }
  .vr-studio-chat:not(.is-split) .vr-chat-message.is-user {
    position: relative;
    top: auto;
    right: auto;
    z-index: auto;
  }
  .vr-studio-chat:not(.is-split) .vr-chat-message.is-agent,
  .vr-studio-chat:not(.is-split) .vr-chat-mission-summary {
    max-width: 760px;
  }
}
.vr-chat-transcript > header {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.13);
  background: rgba(13, 15, 19, 0.58);
  padding: 8px 12px;
}
.vr-chat-transcript > header > span {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: end center;
  overflow: hidden;
  border: 1px solid rgba(226, 232, 240, 0.18);
  border-radius: 12px;
  background: rgba(24, 24, 27, 0.9);
}
.vr-chat-transcript > header img {
  width: 39px;
  height: 39px;
  object-fit: contain;
  transform: translateY(4px);
  filter: drop-shadow(0 0 10px rgba(24, 22, 28, 0.75));
}
.vr-chat-transcript > header strong,
.vr-chat-transcript > header em {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vr-chat-transcript > header strong {
  color: #f1f5f9;
  font-size: 13px;
  font-weight: 790;
}
.vr-chat-transcript > header em {
  margin-top: 2px;
  color: var(--vr-muted);
  font-style: normal;
  font-size: 12px;
}
.vr-chat-transcript > header b {
  border: 1px solid rgba(34, 197, 94, 0.36);
  border-radius: 999px;
  color: #86efac;
  background: rgba(34, 197, 94, 0.08);
  padding: 4px 9px;
  font-size: 11px;
  text-transform: uppercase;
}
.vr-chat-close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 8;
  width: 26px;
  height: 26px;
  display: inline-grid;
  place-items: center;
  border: 1px solid rgba(226, 232, 240, 0.14);
  border-radius: 8px;
  background: rgba(24, 24, 27, 0.88);
  color: #cbd5e1;
  margin-left: 0;
  transition: border-color 160ms ease, background 160ms ease, color 160ms ease, transform 160ms ease;
}
.vr-chat-close:hover {
  border-color: rgba(226, 232, 240, 0.28);
  background: rgba(39, 39, 42, 0.96);
  color: #fff;
  transform: translateY(-1px);
}
.vr-chat-close svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.vr-chat-lane > .vr-cli-connect {
  grid-row: 1;
  min-height: 0;
}
.vr-chat-lane > .vr-chat-transcript {
  grid-row: 2;
  min-height: 0;
}
.vr-chat-lane > .vr-chat-command-bar {
  grid-row: 3;
  min-height: 0;
}
.vr-chat-transcript {
  position: relative;
  min-height: 0;
  max-height: 100%;
  display: grid;
  align-content: start;
  gap: 14px;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;
  padding: 20px 24px 28px;
  scroll-padding-bottom: 24px;
}
.vr-chat-message {
  max-width: 760px;
  display: grid;
  gap: 5px;
}
.vr-chat-message.is-user {
  max-width: 560px;
  justify-self: end;
  justify-items: end;
  margin-top: 4px;
}
.vr-chat-message.is-user > p {
  width: fit-content;
  border: 1px solid rgba(148, 163, 184, 0.14);
  border-radius: 13px 13px 4px 13px;
  background: #f8fafc;
  color: #111827;
  padding: 9px 12px;
  text-align: left;
}
.vr-chat-message.is-user > p {
  padding-left: 12px;
}
.vr-sent-context {
  max-width: 560px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 7px;
}
/* Agent answer layout: never apply row flex to .vr-agent-answer-body or .vr-agent-sections. */
.vr-chat-message > div:first-child {
  display: flex;
  align-items: center;
  gap: 8px;
}
.vr-chat-message > div:first-child > span {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: end center;
  overflow: hidden;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.04);
}
.vr-chat-message img {
  width: 34px;
  height: 34px;
  object-fit: contain;
  transform: translateY(4px);
}
.vr-chat-message p {
  margin: 0;
  color: #e7e7e9;
  font-size: 14px;
  line-height: 1.55;
}
.vr-chat-message > p {
  padding-left: 48px;
}
.vr-chat-message strong,
.vr-chat-message b,
.vr-chat-message em {
  display: inline;
  margin-right: 6px;
}
.vr-chat-message strong {
  color: #f4f4f5;
  font-weight: 720;
}
.vr-chat-message b {
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  color: #ffe9ad;
  padding: 1px 5px;
  font-size: 10px;
}
.vr-chat-message em,
.vr-chat-copy {
  color: #aeb9ca;
  font-style: normal;
}
.vr-chat-message > .vr-sent-context,
.vr-chat-message > .vr-agent-context-line {
  width: auto;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  overflow: visible;
}
.vr-chat-copy {
  max-width: 720px;
  margin: 0;
  padding-left: 36px;
  font-size: 12px;
  line-height: 1.35;
}
.vr-chat-bubble {
  max-width: 560px;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 10px;
  background: #1d1e22;
  padding: 5px 10px;
  box-shadow: none;
}
.vr-chat-bubble.is-agent {
  max-width: 560px;
}
.vr-chat-bubble span {
  display: block;
  color: #dbe4f0;
  font-size: 11px;
  font-weight: 760;
}
.vr-chat-bubble p,
.vr-chat-bubble ul {
  margin: 3px 0 0;
  color: #f8fafc;
  line-height: 1.35;
  font-size: 13px;
}
.vr-chat-bubble ul {
  display: grid;
  gap: 5px;
  padding-left: 17px;
}
.vr-chat-bubble.is-system {
  max-width: 58%;
  border-color: rgba(226, 232, 240, 0.16);
  background: #18181b;
}
.vr-chat-note {
  max-width: 720px;
  margin: 0;
  color: #c7d2e1;
  font-size: 11px;
  line-height: 1.2;
}
.vr-chat-mission-summary {
  width: min(860px, 100%);
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  padding-left: 48px;
}
.vr-chat-mission-summary section {
  min-width: 0;
  display: grid;
  gap: 7px;
  border: 1px solid rgba(226, 232, 240, 0.13);
  border-radius: 12px;
  background: rgba(27, 30, 36, 0.78);
  padding: 14px 22px;
}
.vr-chat-mission-summary section header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.vr-chat-mission-summary strong {
  color: #f4f4f5;
  font-size: 14px;
  font-weight: 680;
}
.vr-chat-mission-summary section:not(.vr-chat-plan-card):not(.vr-chat-connect-card) > span,
.vr-chat-mission-summary .vr-chat-card-list > span {
  min-width: 0;
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr) auto;
  align-items: start;
  gap: 9px;
  color: #e4e4e7;
  font-size: 12.5px;
  line-height: 1.35;
}
.vr-chat-mission-summary em,
.vr-chat-mission-summary small {
  display: block;
  min-width: 0;
  overflow: hidden;
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vr-chat-mission-summary small {
  margin-top: 2px;
  color: #aeb8c8;
  font-size: 12px;
}
.vr-chat-mission-summary i {
  width: 18px;
  height: 18px;
  display: grid;
  place-items: center;
  border-radius: 999px;
  font-style: normal;
  font-size: 11px;
  font-weight: 860;
}
.vr-chat-mission-summary i[data-tone="danger"] {
  border: 1px solid rgba(248, 113, 113, 0.78);
  color: #fecaca;
}
.vr-chat-mission-summary i[data-tone="danger"]::before {
  content: "Ã—";
}
.vr-chat-mission-summary i[data-tone="step"] {
  border: 1px solid rgba(148, 163, 184, 0.28);
  color: #cbd5e1;
}
.vr-chat-mission-summary i[data-tone="warn"] {
  border: 1px solid rgba(251, 191, 36, 0.7);
  color: #fde68a;
}
.vr-chat-mission-summary i[data-tone="warn"]::before {
  content: "!";
  line-height: 1;
}
.vr-chat-mission-summary i[data-tone="danger"]::before {
  content: "x";
  line-height: 1;
}
.vr-chat-mission-summary b {
  justify-self: end;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #ffd76e;
  padding: 0;
  font-size: 12px;
  font-weight: 620;
}
.vr-chat-mission-summary > p {
  margin: 0;
  color: #e5e7eb;
  font-size: 13px;
  line-height: 1.5;
}
.vr-chat-empty-state {
  width: min(620px, calc(100% - 48px));
  display: grid;
  gap: 5px;
  margin-left: 48px;
  border: 1px dashed rgba(148, 163, 184, 0.18);
  border-radius: 12px;
  background:
    radial-gradient(circle at 0% 0%, rgba(148, 163, 184, 0.050), transparent 34%),
    rgba(24, 27, 32, 0.48);
  color: #e5e7eb;
  padding: 14px 16px;
}
.vr-chat-empty-state strong {
  color: #f4f4f5;
  font-size: 13px;
  font-weight: 720;
}
.vr-chat-empty-state span {
  color: #aeb8c8;
  font-size: 12px;
  line-height: 1.4;
}
.vr-chat-first-connect {
  gap: 10px;
}
.vr-chat-first-connect .vr-cli-strip.is-inline {
  margin-top: 2px;
}
.vr-chat-first-connect-steps {
  display: grid;
  gap: 8px;
}
.vr-chat-first-connect-note {
  margin: 0;
  color: #cbd5e1;
  font-size: 11px;
  line-height: 1.4;
}
.vr-cli-connect-expand {
  display: grid;
  gap: 8px;
  margin-top: 8px;
  padding: 10px 12px;
  border-top: 1px solid rgba(226, 232, 240, 0.1);
}
.vr-cli-connect-expand p {
  margin: 0;
  color: #e5e7eb;
  font-size: 12px;
}
.vr-cli-connect-expand pre {
  margin: 0;
  padding: 8px 10px;
  border-radius: 8px;
  background: rgba(13, 12, 16, 0.72);
  overflow: auto;
}
.vr-cli-connect-expand pre code {
  font-size: 11px;
  color: #e2e8f0;
}
.vr-cli-connect-expand-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.vr-cli-action-button,
.vr-chat-first-connect .vr-cli-setup-step .vr-cli-action-button {
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid rgba(226, 232, 240, 0.14);
  border-radius: 8px;
  background: rgba(24, 27, 32, 0.88);
  color: #f4f4f5;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 650;
}
.vr-cli-action-button svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
  flex: 0 0 auto;
}
.vr-cli-action-button.is-primary,
.vr-chat-first-connect .vr-cli-setup-step .vr-glow-button {
  border-color: rgba(148, 163, 184, 0.22);
  background: rgba(232, 193, 90, 0.92);
  color: #fff;
}
.vr-cli-strip button.is-connect-target {
  border-color: rgba(248, 250, 252, 0.34);
  box-shadow: inset 0 0 0 1px rgba(248, 250, 252, 0.08);
}
.vr-cli-connect-expand em {
  color: #94a3b8;
  font-size: 11px;
  font-style: normal;
}
.vr-cli-setup-hint {
  margin: 8px 0 0;
  color: #94a3b8;
  font-size: 11px;
  line-height: 1.45;
}
.vr-cli-setup-hint code {
  color: #dbeafe;
  font-size: 11px;
}
.vr-studio-terminal-log {
  min-height: 220px;
  max-height: 360px;
  overflow: auto;
  margin: 0;
  padding: 14px 16px;
  border-radius: 12px;
  background: rgba(13, 12, 16, 0.82);
  border: 1px solid rgba(226, 232, 240, 0.1);
}
.vr-studio-terminal-log code {
  white-space: pre-wrap;
  color: #e2e8f0;
  font-size: 12px;
  line-height: 1.45;
}
.vr-terminal-connect-actions {
  margin-top: 12px;
}
.vr-terminal-cli-switch {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 12px;
}
.vr-terminal-cli-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid rgba(226, 232, 240, 0.14);
  background: rgba(24, 22, 28, 0.72);
  color: #e2e8f0;
  font-size: 12px;
  cursor: pointer;
}
.vr-terminal-cli-chip span {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.55);
}
.vr-terminal-cli-chip.is-active {
  border-color: rgba(255, 233, 173, 0.55);
  background: rgba(88, 28, 135, 0.28);
}
.vr-terminal-cli-chip.is-active span {
  background: #ffe9ad;
}
.vr-terminal-shell textarea {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}
.vr-cli-os-fallback {
  margin-top: 10px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #94a3b8;
  font-size: 11px;
  cursor: pointer;
  text-decoration: underline;
}
.vr-cli-os-fallback svg {
  width: 12px;
  height: 12px;
}
.vr-cli-strip.is-inline {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.vr-chat-plan-row {
  width: min(860px, 100%);
  min-height: 42px;
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto 18px;
  align-items: center;
  gap: 12px;
  border: 1px solid rgba(226, 232, 240, 0.12);
  border-radius: 12px;
  background: rgba(28, 31, 37, 0.7);
  color: #f8fafc;
  padding: 0 16px;
  text-align: left;
}
.vr-chat-plan-row > i {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  background: rgba(148, 163, 184, 0.12);
  color: #cbd5e1;
}
.vr-chat-plan-row svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.vr-chat-plan-row strong,
.vr-chat-plan-row em {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vr-chat-plan-row strong {
  font-size: 13px;
  font-weight: 650;
}
.vr-chat-plan-row em {
  color: #ffe9ad;
  font-size: 11px;
  font-style: normal;
}
.vr-chat-plan-row b {
  width: 8px;
  height: 8px;
  border-right: 1.7px solid rgba(255, 233, 173, 0.8);
  border-bottom: 1.7px solid rgba(255, 233, 173, 0.8);
  transform: rotate(-45deg);
}
.vr-chat-card-row {
  width: min(860px, 100%);
  display: grid;
  grid-template-columns: repeat(2, minmax(230px, 1fr));
  gap: 8px;
}
.vr-chat-card-row .vr-chat-card {
  width: auto;
}
.vr-chat-card {
  width: min(610px, 72%);
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 10px;
  background:
    linear-gradient(180deg, rgba(28, 29, 33, 0.88), rgba(20, 21, 25, 0.9));
  padding: 6px 10px;
}
.vr-chat-agent-task {
  position: relative;
  width: min(520px, calc(100% - 48px));
  display: grid;
  gap: 8px;
  margin-left: 48px;
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.13);
  border-radius: 10px;
  background:
    linear-gradient(180deg, rgba(31, 34, 40, 0.86), rgba(22, 24, 29, 0.9));
  padding: 10px 12px;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.035),
    0 14px 34px rgba(0, 0, 0, 0.2);
  animation: vrTaskEnter 260ms cubic-bezier(0.2, 0, 0, 1) both;
}
.vr-chat-agent-task::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(100deg, transparent 0%, rgba(255, 255, 255, 0.055) 46%, transparent 68%);
  transform: translateX(-70%);
}
.vr-chat-agent-task.is-working::before {
  animation: vrTaskSweep 1450ms cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.vr-chat-agent-task.is-complete {
  border-color: rgba(34, 197, 94, 0.24);
  background:
    linear-gradient(180deg, rgba(24, 31, 31, 0.92), rgba(18, 22, 25, 0.94));
}
.vr-chat-agent-task header {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 18px auto auto minmax(0, 1fr);
  align-items: center;
  gap: 8px;
}
.vr-task-elapsed {
  font-family: var(--vr-hud-mono);
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  color: var(--vr-gold);
  letter-spacing: 0.04em;
}
.vr-task-glyph {
  position: relative;
  width: 14px;
  height: 14px;
  display: grid;
  place-items: center;
  color: #fb923c;
}
.vr-task-glyph::before,
.vr-task-glyph::after {
  content: "";
  position: absolute;
  inset: 6px 0;
  height: 2px;
  border-radius: 999px;
  background: currentColor;
  box-shadow: 0 0 12px rgba(251, 146, 60, 0.58);
}
.vr-task-glyph::before {
  transform: rotate(90deg);
}
.vr-chat-agent-task.is-working .vr-task-glyph {
  animation: vrTaskGlyph 900ms ease-in-out infinite;
}
.vr-chat-agent-task.is-complete .vr-task-glyph {
  color: #22c55e;
}
.vr-chat-agent-task header strong,
.vr-chat-agent-task header em {
  display: inline;
}
.vr-chat-agent-task header strong {
  color: #fb923c;
  font-size: 15px;
  font-weight: 760;
}
.vr-chat-agent-task.is-complete header strong {
  color: #86efac;
}
.vr-chat-agent-task header em {
  margin-left: 4px;
  overflow: hidden;
  color: #9ca3af;
  font-size: 14px;
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vr-chat-agent-task header b {
  justify-self: end;
  overflow: hidden;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #aeb9ca;
  padding: 0;
  font-size: 11px;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vr-chat-agent-task.is-complete header b {
  color: #86efac;
}
.vr-task-rail {
  position: relative;
  z-index: 1;
  height: 1px;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.16);
}
.vr-task-rail span {
  position: absolute;
  inset: 0;
  width: 36%;
  border-radius: inherit;
  background: linear-gradient(90deg, transparent, #fb923c, rgba(255, 215, 110, 0.9), transparent);
  filter: drop-shadow(0 0 10px rgba(251, 146, 60, 0.38));
  animation: vrTaskRail 1200ms cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.vr-chat-agent-task.is-complete .vr-task-rail span {
  width: 100%;
  background: linear-gradient(90deg, #22c55e, rgba(34, 197, 94, 0.38));
  animation: none;
}
.vr-chat-agent-task > p {
  position: relative;
  z-index: 1;
  margin: 0;
  color: #aeb9ca;
  font-size: 12px;
  line-height: 1.35;
}
.vr-chat-command-bar > .vr-chat-agent-task {
  width: 100%;
  margin: 0;
  padding: 8px 10px;
  gap: 0;
  box-shadow: none;
  animation: none;
}
.vr-chat-command-bar > .vr-chat-agent-task.is-compact > p,
.vr-chat-command-bar > .vr-chat-agent-task.is-compact .vr-task-rail {
  display: none;
}
.vr-chat-command-bar > .vr-chat-agent-task.is-compact header {
  grid-template-columns: 14px minmax(0, 1fr) auto;
}
.vr-chat-command-bar > .vr-chat-agent-task.is-compact header em {
  display: inline;
  margin-left: 4px;
}
/* compact header only has 3 columns; the redundant title (<b>) would wrap to a
   clipped second row ("...nges"), so drop it — the status word already says it. */
.vr-chat-command-bar > .vr-chat-agent-task.is-compact header b {
  display: none;
}
.vr-chat-agent-response {
  max-width: min(920px, 82%);
  display: grid;
  gap: 7px;
  animation: vrTaskEnter 220ms cubic-bezier(0.2, 0, 0, 1) both;
}
.vr-agent-context-line {
  margin-left: 48px;
  max-width: min(640px, calc(100% - 48px));
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.vr-agent-answer-text {
  max-width: min(860px, calc(100% - 48px));
  overflow: visible;
  white-space: pre-wrap;
  color: #e5e7eb;
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: 13.5px;
  line-height: 1.58;
}
.vr-agent-response-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  min-width: 0;
}
.vr-agent-response-stack .vr-chat-card {
  width: 100%;
  max-width: min(610px, 100%);
}
.vr-chat-message.is-agent .vr-agent-answer-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  min-width: 0;
}
.vr-agent-answer-body {
  margin-left: 48px;
  max-width: min(860px, calc(100% - 48px));
  color: #e5e7eb;
  font-size: 13.5px;
  line-height: 1.58;
}
.vr-agent-answer-structured {
  width: 100%;
  max-width: min(920px, calc(100% - 48px));
}
.vr-agent-sections {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
  width: 100%;
}
.vr-agent-gate-strip {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 12px;
  background:
    radial-gradient(circle at 0% 0%, rgba(148, 163, 184, 0.050), transparent 42%),
    rgba(24, 22, 28, 0.62);
  padding: 10px 12px;
  min-width: 0;
}
.vr-agent-gate-strip svg {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  color: #ffe9ad;
}
.vr-agent-gate-strip span {
  display: grid;
  gap: 2px;
  min-width: 0;
}
.vr-agent-gate-strip strong {
  color: #f8fafc;
  font-size: 11px;
  font-weight: 780;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.vr-agent-gate-strip em {
  color: #cbd5e1;
  font-style: normal;
  font-size: 13px;
  line-height: 1.45;
}
.vr-agent-gate-strip[data-tone="clear"] {
  border-color: rgba(34, 197, 94, 0.28);
  background:
    radial-gradient(circle at 0% 0%, rgba(34, 197, 94, 0.12), transparent 42%),
    rgba(24, 22, 28, 0.62);
}
.vr-agent-gate-strip[data-tone="clear"] svg {
  color: #86efac;
}
.vr-agent-gate-strip[data-tone="blocked"] {
  border-color: rgba(248, 113, 113, 0.28);
  background:
    radial-gradient(circle at 0% 0%, rgba(248, 113, 113, 0.1), transparent 42%),
    rgba(24, 22, 28, 0.62);
}
.vr-agent-gate-strip[data-tone="blocked"] svg {
  color: #fca5a5;
}
.vr-agent-section {
  border: 1px solid rgba(148, 163, 184, 0.14);
  border-radius: 12px;
  background:
    radial-gradient(circle at 0% 0%, rgba(148, 163, 184, 0.050), transparent 42%),
    rgba(24, 22, 28, 0.55);
  padding: 12px 14px;
  display: grid;
  gap: 8px;
}
.vr-agent-section .vr-agent-heading {
  margin: 0;
  color: #f8fafc;
  font-size: 12px;
  font-weight: 780;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.vr-agent-section-actions,
.vr-agent-inline-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.vr-agent-section-actions {
  margin-top: 2px;
}
.vr-agent-inline-action {
  min-height: 30px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.05);
  color: #f8fafc;
  padding: 0 12px;
  font-size: 11px;
  font-weight: 700;
  text-decoration: none;
}
.vr-agent-inline-action.is-primary {
  border-color: rgba(148, 163, 184, 0.22);
  background: rgba(255, 255, 255, 0.04);
  color: #f5f3ff;
}
.vr-agent-inline-action i[data-icon] {
  width: 14px;
  height: 14px;
  color: currentColor;
}
.vr-agent-inline-action svg {
  width: 14px;
  height: 14px;
}
.vr-agent-muted {
  color: #94a3b8;
  font-size: 12px;
}
.vr-agent-answer-body p {
  margin: 0;
  color: #e2e8f0;
}
.vr-agent-answer-body .vr-agent-empty {
  color: #94a3b8;
}
.vr-agent-heading {
  margin: 4px 0 0;
  color: #f8fafc;
  font-size: 13px;
  font-weight: 760;
  letter-spacing: 0.01em;
}
.vr-agent-list {
  margin: 0;
  padding-left: 1.15rem;
  display: grid;
  gap: 6px;
}
.vr-agent-list li {
  color: #dbe4f0;
}
.vr-agent-list li strong,
.vr-agent-answer-body strong {
  color: #f8fafc;
  font-weight: 720;
}
.vr-agent-answer-body code {
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 6px;
  background: rgba(24, 22, 28, 0.72);
  padding: 1px 6px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12px;
  color: #ffe9ad;
}
.vr-agent-code {
  margin: 0;
  max-height: 220px;
  overflow: auto;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 10px;
  background: rgba(8, 15, 30, 0.92);
  padding: 10px 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12px;
  line-height: 1.45;
  color: #dbeafe;
}
.vr-agent-followups {
  margin-left: 48px;
  max-width: min(860px, calc(100% - 48px));
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  min-width: 0;
  padding-top: 2px;
}
.vr-agent-followups button {
  min-height: 30px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  color: #f8fafc;
  padding: 0 11px;
  font-size: 11px;
  font-weight: 700;
}
.vr-agent-followups button.is-primary {
  border-color: rgba(148, 163, 184, 0.22);
  background: rgba(255, 255, 255, 0.04);
  color: #f5f3ff;
}
.vr-agent-followups button i[data-icon] {
  width: 14px;
  height: 14px;
  color: inherit;
}
.vr-agent-followups button svg,
.vr-agent-followups button svg * {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.vr-agent-inline-action svg,
.vr-agent-inline-action svg * {
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.vr-chat-agent-response.is-error .vr-agent-answer-body {
  border-left: 3px solid rgba(248, 113, 113, 0.72);
  padding-left: 12px;
}
.vr-chat-response-actions {
  padding-left: 48px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.vr-chat-response-actions button {
  min-height: 30px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.035);
  color: #f8fafc;
  padding: 0 10px;
  font-size: 12px;
  font-weight: 740;
}
.vr-chat-response-actions button:hover {
  border-color: rgba(148, 163, 184, 0.22);
  background: rgba(255, 255, 255, 0.04);
}
.vr-chat-response-actions svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.vr-chat-card header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 4px;
}
.vr-chat-card header strong {
  color: #f1f5f9;
  font-size: 12px;
}
.vr-chat-card header b,
.vr-chat-card-list b {
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  color: #ffe9ad;
  padding: 1px 6px;
  font-size: 9px;
  font-weight: 820;
}
.vr-chat-card-list,
.vr-chat-plan-list {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.vr-chat-card-list span {
  min-height: 16px;
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
}
.vr-chat-plan-list li {
  list-style: none;
  margin: 0;
  padding: 0;
  display: block;
}
.vr-chat-plan-list li button,
.vr-plan-step {
  width: 100%;
  min-height: 52px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin: 0;
  padding: 10px 12px;
  border: 1px solid rgba(226, 232, 240, 0.12);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.vr-chat-plan-list li button:hover,
.vr-plan-step:hover {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(148, 163, 184, 0.22);
}
.vr-plan-step-num {
  width: 10px;
  height: 10px;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  border: 1px solid rgba(255, 215, 110, 0.5);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0);
}
.vr-plan-step-body {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.vr-plan-step-title {
  flex: 1 1 auto;
  min-width: 0;
  color: #f8fafc;
  font-size: 13px;
  font-weight: 680;
  line-height: 1.45;
  white-space: normal;
  word-break: normal;
}
.vr-plan-step-tag {
  flex: 0 0 auto;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  color: #ffe9ad;
  padding: 2px 8px;
  font-size: 10px;
  font-style: normal;
  font-weight: 760;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.vr-plan-step-go {
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  color: #ffe9ad;
  opacity: 1;
}
.vr-plan-step-go i[data-icon] {
  width: 16px;
  height: 16px;
  color: #ffe9ad;
}
.vr-plan-step-go svg,
.vr-plan-step-go svg * {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.vr-chat-card-list i {
  position: relative;
  width: 11px;
  height: 11px;
  border: 1px solid #f87171;
  border-radius: 999px;
}
.vr-chat-card-list i::before,
.vr-chat-card-list i::after {
  content: "";
  position: absolute;
  left: 2.5px;
  top: 5px;
  width: 5px;
  height: 1px;
  border-radius: 999px;
  background: #f87171;
}
.vr-chat-card-list i::before { transform: rotate(45deg); }
.vr-chat-card-list i::after { transform: rotate(-45deg); }
.vr-chat-card-list span[data-tone="warn"] i {
  border: 0;
  background: conic-gradient(from 30deg, transparent 0 12%, #fbbf24 0 88%, transparent 0);
  clip-path: polygon(50% 0, 100% 100%, 0 100%);
  border-radius: 0;
}
.vr-chat-card-list span[data-tone="warn"] i::before,
.vr-chat-card-list span[data-tone="warn"] i::after {
  display: none;
}
.vr-chat-card-list em {
  min-width: 0;
  overflow: hidden;
  color: #e5e7eb;
  font-style: normal;
  font-size: 11px;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vr-chat-mission-summary .vr-chat-plan-list span {
  display: revert;
  min-width: 0;
  grid-template-columns: none;
  gap: 0;
}
.vr-chat-mission-summary .vr-plan-step-num {
  display: grid;
  place-items: center;
}
.vr-chat-mission-summary .vr-plan-step-body {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.vr-chat-mission-summary .vr-plan-step-title {
  display: inline;
  flex: 1 1 12rem;
  min-width: 0;
}
.vr-chat-mission-summary .vr-plan-step-tag {
  display: inline-flex;
  width: auto;
  flex: 0 0 auto;
  align-self: center;
}
.vr-chat-mission-summary .vr-plan-step-go {
  display: grid;
  place-items: center;
}
.vr-chat-plan-list {
  counter-reset: none;
}
.vr-chat-inline-actions {
  width: auto;
  display: flex;
  flex-wrap: nowrap;
  gap: 7px;
  margin-top: 0;
  padding: 6px 0 12px;
  overflow-x: auto;
  scrollbar-width: thin;
}
.vr-chat-inline-actions button {
  flex: 0 0 auto;
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid rgba(226, 232, 240, 0.13);
  border-radius: 8px;
  background: rgba(24, 27, 32, 0.72);
  color: #f4f4f5;
  padding: 0 13px;
  font-size: 12px;
  font-weight: 710;
}
.vr-chat-inline-actions button.is-primary {
  border-color: rgba(148, 163, 184, 0.22);
  background: #e8c15a;
  color: #fff;
}
.vr-chat-inline-actions button.is-muted {
  opacity: 0.72;
  font-weight: 650;
}
.vr-chat-inline-actions button span {
  white-space: nowrap;
  max-width: 9.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vr-chat-inline-actions button:first-child:not(.is-primary) {
  border-color: rgba(226, 232, 240, 0.13);
  background: rgba(24, 27, 32, 0.72);
  color: #f4f4f5;
}
.vr-chat-bubble.is-user {
  justify-self: end;
  border-color: rgba(248, 250, 252, 0.62);
  background: #f8fafc;
}
.vr-chat-bubble.is-user span {
  color: #334155;
}
.vr-chat-bubble.is-user p {
  color: #020617;
}
.vr-chat-result {
  display: inline-grid;
  grid-template-columns: 16px auto auto;
  align-items: center;
  gap: 8px;
  width: fit-content;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 999px;
  background: rgba(24, 22, 28, 0.86);
  color: #e2e8f0;
  padding: 7px 12px;
}
.vr-chat-result span {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: #94a3b8;
  box-shadow: 0 0 10px rgba(148, 163, 184, 0.45);
}
.vr-chat-result em {
  color: var(--vr-muted);
  font-style: normal;
}
.vr-chat-result.is-done {
  border-color: rgba(34, 197, 94, 0.42);
  background: rgba(34, 197, 94, 0.1);
}
.vr-chat-result.is-done span {
  background: #22c55e;
  box-shadow: 0 0 14px rgba(34, 197, 94, 0.8);
}
.vr-chat-command-bar {
  position: relative;
  z-index: 2;
  flex-shrink: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 6px;
  align-items: center;
  border-top: 1px dashed rgba(148, 163, 184, 0.13);
  background: linear-gradient(180deg, rgba(18, 20, 24, 0), rgba(18, 20, 24, 0.92) 18%);
  padding: 8px 10px 10px;
}
.vr-chat-command-bar > button,
.vr-chat-command-bar > div {
  min-height: 34px;
  border: 1px solid rgba(226, 232, 240, 0.12);
  border-radius: 10px;
  background: rgba(31, 34, 40, 0.72);
  color: #f8fafc;
  font-weight: 650;
}
.vr-chat-command-bar > button:hover {
  border-color: rgba(248, 250, 252, 0.32);
  background: rgba(39, 39, 42, 0.96);
}
.vr-chat-command-bar > .vr-chat-composer {
  grid-column: 1 / -1;
  min-height: 104px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto 38px;
  grid-template-rows: minmax(38px, 1fr) auto;
  gap: 10px;
  align-items: end;
  border-color: rgba(148, 163, 184, 0.22);
  border-radius: 12px;
  background:
    radial-gradient(circle at 18% 0%, rgba(148, 163, 184, 0.055), transparent 34%),
    #1f2024;
  color: #f8fafc;
  padding: 12px 14px;
}
.vr-chat-input {
  grid-column: 1 / 3;
  grid-row: 1;
  align-self: stretch;
  width: 100%;
  min-width: 0;
  min-height: 38px;
  border: 0;
  outline: 0;
  resize: none;
  background: transparent;
  color: #f8fafc;
  padding: 0;
  font: inherit;
  font-size: 13.5px;
  font-weight: 520;
  line-height: 1.45;
  caret-color: #f8fafc;
}
.vr-chat-input::placeholder {
  color: #a1a8b3;
}
.vr-chat-input:focus {
  outline: 0;
}
.vr-chat-command-bar > .vr-chat-composer > span {
  align-self: start;
  overflow: hidden;
  color: #a1a8b3;
  font-size: 13px;
  font-weight: 520;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vr-provider-drop-zone {
  grid-column: 1;
  min-width: 0;
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  color: #8b98ad;
  font-size: 11px;
}
.vr-provider-drop-zone > .vr-provider-drop-label {
  border: 1px dashed rgba(148, 163, 184, 0.22);
  border-radius: 999px;
  background: rgba(13, 12, 16, 0.2);
  padding: 5px 10px;
}
.vr-provider-drop-zone.is-active > .vr-provider-drop-label {
  border-color: rgba(34, 197, 94, 0.62);
  background: rgba(34, 197, 94, 0.1);
  color: #86efac;
  box-shadow: 0 0 18px rgba(34, 197, 94, 0.18);
}
.vr-app.is-dragging .vr-chat-command-bar > .vr-chat-composer,
.vr-studio-chat.is-drop-preview .vr-chat-command-bar > .vr-chat-composer {
  border-color: rgba(255, 233, 173, 0.72);
  box-shadow:
    inset 0 0 0 1px rgba(0, 0, 0, 0),
    0 0 0 1px rgba(255, 233, 173, 0.08),
    0 0 42px rgba(0, 0, 0, 0);
}
.vr-studio-chat.is-drop-preview .vr-chat-command-bar::before {
  content: "Database\\A PostgreSQL";
  position: absolute;
  right: 150px;
  top: 36px;
  z-index: 6;
  width: 154px;
  min-height: 54px;
  display: grid;
  align-content: center;
  border: 1px solid rgba(226, 232, 240, 0.22);
  border-radius: 10px;
  background:
    radial-gradient(circle at 18px 20px, rgba(34, 197, 94, 0.26), transparent 20px),
    rgba(27, 30, 36, 0.98);
  color: #f8fafc;
  padding: 8px 12px 8px 50px;
  white-space: pre;
  font-size: 12px;
  font-weight: 760;
  line-height: 1.35;
  box-shadow: 0 18px 46px rgba(0, 0, 0, 0.42), 0 0 26px rgba(0, 0, 0, 0);
}
.vr-studio-chat.is-drop-preview .vr-chat-command-bar::after {
  content: "";
  position: absolute;
  right: 246px;
  top: 16px;
  z-index: 5;
  width: 180px;
  height: 84px;
  border-left: 2px dashed rgba(255, 215, 110, 0.58);
  border-bottom: 2px dashed rgba(255, 215, 110, 0.58);
  border-radius: 0 0 0 76px;
  transform: skewX(-24deg);
  pointer-events: none;
  filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0));
}
.vr-app.is-dragging .vr-provider-drop-zone > .vr-provider-drop-label,
.vr-studio-chat.is-drop-preview .vr-provider-drop-zone > .vr-provider-drop-label {
  border-color: rgba(255, 215, 110, 0.54);
  background: rgba(255, 255, 255, 0.04);
  color: #ffe9ad;
}
.is-drop-active .vr-provider-drop-zone > .vr-provider-drop-label,
.vr-provider-drop-zone.is-drop-active > .vr-provider-drop-label {
  border-color: rgba(34, 197, 94, 0.62);
  background: rgba(34, 197, 94, 0.1);
  color: #86efac;
  box-shadow: 0 0 18px rgba(34, 197, 94, 0.18);
}
.vr-provider-drop-zone.has-provider > .vr-provider-drop-label {
  display: none;
}
.vr-context-chip {
  min-width: 0;
  max-width: min(300px, 100%);
  height: 30px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 8px;
  background: rgba(36, 37, 41, 0.92);
  color: #f8fafc;
  padding: 0 4px 0 6px;
}
.vr-context-chip.is-readonly {
  padding: 0 8px 0 6px;
}
.vr-sent-context .vr-context-chip,
.vr-agent-context-line .vr-context-chip {
  max-width: min(360px, 100%);
}
.vr-sent-context .vr-context-chip-icon img,
.vr-agent-context-line .vr-context-chip-icon img {
  transform: none;
}
.vr-context-chip-icon {
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  border-radius: 6px;
  overflow: hidden;
}
.vr-context-chip-icon img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}
.vr-context-chip-icon .vr-context-icon-chip {
  width: 24px;
  height: 24px;
  border-radius: 6px;
}
.vr-context-chip-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}
.vr-context-chip-label .muted {
  color: #94a3b8;
  font-weight: 500;
}
.vr-context-chip-remove {
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #8f98a8;
  padding: 0;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
}
.vr-context-chip-remove:hover {
  background: rgba(255, 255, 255, 0.075);
  color: #f8fafc;
}
.vr-version-token {
  width: 26px;
  height: 26px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.04);
  color: #ffe9ad;
}
.vr-version-token svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.vr-chat-command-bar > .vr-chat-composer > button {
  grid-row: 1 / span 2;
  align-self: center;
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 999px;
  background: #f8fafc;
  color: #020617;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.28);
}
.vr-chat-command-bar > .vr-chat-composer > .vr-chat-send {
  grid-column: 3;
}
.vr-chat-command-bar > .vr-chat-composer > .vr-chat-send.is-stop {
  background: #f8fafc;
  color: #020617;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-shadow: 0 0 0 4px rgba(248, 250, 252, 0.08), 0 10px 26px rgba(0, 0, 0, 0.34);
}
.vr-chat-command-bar > .vr-chat-composer > button svg {
  width: 17px;
  height: 17px;
  display: block;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.vr-chat-command-bar > .vr-chat-composer > .vr-chat-send.is-stop i[data-icon] {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.vr-chat-command-bar > .vr-chat-composer > .vr-chat-send.is-stop svg {
  width: 14px;
  height: 14px;
  display: block;
  fill: currentColor;
  stroke: none;
}
.vr-chat-command-bar > .vr-chat-composer > .vr-chat-send.is-stop svg * {
  fill: currentColor;
  stroke: none;
}
.vr-chat-command-bar > button[data-action="start-agent-fix"],
.vr-chat-command-bar > button[data-action="verify-now"] {
  border-color: rgba(148, 163, 184, 0.22);
  background: rgba(255, 255, 255, 0.04);
  color: #fff3c4;
}
.vr-chat-command-bar > button[data-action="start-agent-fix"]:hover,
.vr-chat-command-bar > button[data-action="verify-now"]:hover {
  border-color: rgba(255, 215, 110, 0.58);
  background: rgba(255, 255, 255, 0.04);
}
.vr-model-picker {
  position: relative;
  display: inline-grid;
  grid-auto-flow: column;
  gap: 6px;
  align-items: center;
  grid-column: 2;
  grid-row: 2;
}
.vr-model-picker > button {
  min-height: 28px;
  display: grid;
  grid-template-columns: minmax(0, auto) auto 8px;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 8px;
  background: rgba(39, 40, 44, 0.92);
  color: #f8fafc;
  padding: 0 9px;
  font-weight: 640;
  box-shadow: none;
}
.vr-model-picker > button span {
  color: #8f98a8;
  font-size: 10px;
  font-weight: 620;
}
.vr-model-picker > button strong {
  max-width: 112px;
  color: #f4f4f5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 720;
}
.vr-model-picker > button i {
  width: 7px;
  height: 7px;
  border: solid #a7b0c0;
  border-width: 0 1.5px 1.5px 0;
  transform: rotate(45deg) translateY(-2px);
}
.vr-model-picker > button:hover {
  border-color: rgba(226, 232, 240, 0.22);
  background: rgba(47, 48, 52, 0.96);
}
.vr-model-menu {
  position: absolute;
  right: 0;
  bottom: calc(100% + 8px);
  z-index: 30;
  min-width: 250px;
  max-height: 320px;
  overflow: auto;
  display: grid;
  gap: 2px;
  border: 1px solid rgba(226, 232, 240, 0.14);
  border-radius: 10px;
  background: #242528;
  color: #f5f5f4;
  box-shadow: 0 16px 34px rgba(0, 0, 0, 0.36);
  padding: 6px;
  color-scheme: dark;
}
.vr-model-menu.is-reasoning {
  left: 0;
  right: auto;
}
.vr-model-menu.is-models {
  left: 96px;
  right: auto;
}
.vr-model-menu.is-context {
  right: 0;
}
.vr-model-menu.is-access {
  right: 0;
  min-width: 270px;
}
.vr-studio-chat.is-split .vr-model-menu {
  bottom: calc(100% + 10px);
  min-width: min(245px, calc(100vw - 32px));
}
.vr-studio-chat.is-split .vr-model-menu.is-reasoning {
  left: 0;
  right: auto;
}
.vr-studio-chat.is-split .vr-model-menu.is-models {
  left: 86px;
  right: auto;
}
.vr-studio-chat.is-split .vr-model-menu.is-context {
  left: auto;
  right: 0;
}
.vr-studio-chat.is-split .vr-model-menu.is-access {
  left: auto;
  right: 0;
}
.vr-model-menu p {
  margin: 2px 4px 6px;
  color: #a8a29e;
  font-size: 12px;
}
.vr-model-menu button {
  min-height: 30px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 14px;
  align-items: center;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #f5f5f4;
  padding: 0 8px;
  text-align: left;
  font-family: inherit;
}
.vr-model-menu button span,
.vr-model-menu button strong,
.vr-model-menu button em {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vr-model-menu button strong {
  color: #f5f5f4;
  font-size: 13px;
  font-weight: 650;
}
.vr-model-menu button em {
  margin-top: 1px;
  color: #a8a29e;
  font-size: 11px;
  font-style: normal;
}
.vr-model-menu button:hover {
  background: rgba(255, 255, 255, 0.075);
}
.vr-model-menu button b {
  width: 8px;
  height: 14px;
  border: solid #f5f5f4;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.vr-providers-panel,
.vr-releases-panel {
  min-height: 0;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  border: 1px solid rgba(226, 232, 240, 0.095);
  border-radius: 12px;
  padding: 10px;
  background: rgba(18, 22, 28, 0.74);
}
.vr-providers-panel {
  border-color: rgba(34, 197, 94, 0.28);
  background:
    radial-gradient(circle at 8% 12%, rgba(34, 197, 94, 0.075), transparent 28%),
    linear-gradient(180deg, rgba(18, 23, 29, 0.8), rgba(15, 18, 23, 0.76));
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.025),
    0 0 0 1px rgba(34, 197, 94, 0.08),
    0 0 46px rgba(34, 197, 94, 0.11);
}
.vr-releases-panel {
  border-color: rgba(148, 163, 184, 0.22);
  background:
    radial-gradient(circle at 8% 8%, rgba(148, 163, 184, 0.050), transparent 26%),
    linear-gradient(180deg, rgba(18, 22, 30, 0.8), rgba(14, 17, 24, 0.76));
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.025),
    0 0 0 1px rgba(0, 0, 0, 0),
    0 0 52px rgba(0, 0, 0, 0);
}
.vr-bottom-inventory {
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(360px, 0.95fr);
  gap: 10px;
  align-items: stretch;
  overflow: visible;
  margin-top: 0;
  padding: 0 18px 8px;
}
.vr-bottom-inventory .vr-panel-head {
  align-items: center;
  margin-bottom: 6px;
}
.vr-add-provider-inline {
  flex: 0 0 auto;
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid rgba(34, 197, 94, 0.24);
  border-radius: 9px;
  background: rgba(22, 163, 74, 0.075);
  color: #d1fae5;
  padding: 0 11px;
  font-size: 12px;
  font-weight: 690;
}
.vr-add-provider-inline:hover {
  border-color: rgba(34, 197, 94, 0.42);
  background: rgba(22, 163, 74, 0.13);
}
.vr-add-provider-inline svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.vr-bottom-inventory .vr-panel-head h2 {
  font-size: 17px;
  font-weight: 760;
}
.vr-bottom-inventory .vr-panel-head p {
  font-size: 11px;
}
.vr-bottom-inventory .vr-provider-composition {
  grid-template-columns: 1fr;
  min-height: 0;
  height: 100%;
}
.vr-bottom-inventory .vr-provider-detail-panel {
  display: none;
}
.vr-bottom-inventory .vr-provider-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px 8px;
  grid-auto-rows: minmax(48px, 1fr);
  min-height: 0;
  height: 100%;
}
.vr-bottom-inventory .vr-provider-card {
  min-height: 48px;
  grid-template-columns: 34px minmax(0, 1fr) 18px 22px;
  grid-template-rows: 1fr;
  align-items: center;
  gap: 8px;
  border-color: rgba(226, 232, 240, 0.085);
  background: rgba(25, 29, 35, 0.62);
  padding: 6px 9px;
}
.vr-bottom-inventory .vr-provider-card:hover,
.vr-bottom-inventory .vr-provider-card.is-selected {
  border-color: rgba(226, 232, 240, 0.15);
  background: rgba(30, 34, 41, 0.68);
  box-shadow: none;
}
.vr-bottom-inventory .vr-provider-card div {
  padding-right: 0;
}
.vr-bottom-inventory .vr-provider-token {
  width: 30px;
  height: 30px;
}
.vr-bottom-inventory .vr-provider-token img {
  width: 24px;
  height: 24px;
}
.vr-bottom-inventory .vr-provider-proof-chip {
  position: static;
  grid-column: 4;
  justify-self: end;
  width: 20px;
  height: 24px;
  min-height: 24px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #94a3b8;
  padding: 0;
  transform: none;
}
.vr-bottom-inventory .vr-provider-proof-chip span {
  display: none;
}
.vr-bottom-inventory .vr-provider-proof-chip i {
  display: grid;
  place-items: center;
  color: inherit;
}
.vr-bottom-inventory .vr-provider-proof-chip svg {
  width: 15px;
  height: 15px;
  stroke: currentColor;
  stroke-width: 2.35;
}
.vr-bottom-inventory .vr-provider-proof-chip svg * {
  fill: none !important;
  stroke: currentColor !important;
}
.vr-bottom-inventory .vr-provider-card .vr-status-badge {
  grid-column: 3;
  min-height: 18px;
  padding: 2px 7px;
  font-size: 10px;
}
.vr-bottom-inventory .vr-provider-card:hover .vr-provider-proof-chip,
.vr-bottom-inventory .vr-provider-card.is-selected .vr-provider-proof-chip {
  color: #e2e8f0;
}
.vr-bottom-inventory .vr-release-track {
  display: none;
}
.vr-bottom-inventory .vr-release-card {
  min-height: 52px;
  border-color: rgba(226, 232, 240, 0.105);
  background: rgba(29, 33, 40, 0.72);
  padding: 8px 10px;
}
.vr-release-composition {
  min-height: 0;
  height: 100%;
  display: grid;
  grid-template-columns: minmax(180px, 0.92fr) minmax(210px, 1.08fr);
  gap: 10px;
}
.vr-release-current {
  min-height: 100%;
  align-content: center;
  border-color: rgba(148, 163, 184, 0.22);
}
.vr-release-current span {
  margin-top: 8px;
  color: #22c55e;
  font-size: 12px;
}
.vr-release-list {
  min-width: 0;
  min-height: 0;
  height: 100%;
  display: grid;
  grid-template-rows: auto repeat(3, minmax(34px, 1fr));
  gap: 0;
  border: 1px solid rgba(226, 232, 240, 0.085);
  border-radius: 10px;
  background: rgba(25, 29, 35, 0.42);
  padding: 7px 10px;
}
.vr-release-list header,
.vr-release-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
}
.vr-release-list header {
  min-height: 24px;
  color: #f4f4f5;
}
.vr-release-list header strong {
  font-size: 12px;
  font-weight: 650;
}
.vr-release-list header button {
  border: 0;
  background: transparent;
  color: #ffd76e;
  font-size: 11px;
}
.vr-release-row {
  min-height: 38px;
  border: 0;
  border-top: 1px solid rgba(226, 232, 240, 0.065);
  background: transparent;
  color: #f4f4f5;
  padding: 5px 0;
  text-align: left;
}
.vr-release-row strong,
.vr-release-row em,
.vr-release-row small {
  display: block;
}
.vr-release-row strong {
  font-size: 13px;
  font-weight: 620;
}
.vr-release-row em {
  color: #22c55e;
  font-size: 11px;
  font-style: normal;
}
.vr-release-row small {
  color: var(--vr-muted);
  font-size: 11px;
}
.vr-bottom-inventory .vr-release-actions {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-top: 8px;
}
.vr-bottom-inventory .vr-release-actions button {
  min-width: 0;
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid rgba(226, 232, 240, 0.105);
  border-radius: 8px;
  background: rgba(31, 34, 40, 0.58);
  color: #e4e4e7;
  font-size: 12px;
  font-weight: 560;
}
.vr-bottom-inventory .vr-release-actions button:last-child {
  color: #f87171;
}
.vr-bottom-inventory .vr-release-actions svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.vr-bottom-inventory .vr-timeline-rail {
  display: none;
}

.vr-panel-head {
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 6px;
}
.vr-panel-head h2 { font-size: 21px; }

.vr-add-provider {
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  border-radius: 999px;
  padding: 0 14px 0 10px;
  font-weight: 780;
}
.vr-add-provider > span,
.vr-provider-add-card > span {
  width: 18px;
  height: 18px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(255, 233, 173, 0.36);
  border-radius: 999px;
}
.vr-add-provider > span::before,
.vr-add-provider > span::after {
  content: "";
  grid-area: 1 / 1;
  width: 9px;
  height: 1.8px;
  border-radius: 999px;
  background: #ffe9ad;
}
.vr-add-provider > span::after {
  transform: rotate(90deg);
}
.vr-provider-picker {
  display: grid;
  grid-template-columns: 190px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  margin: -2px 0 12px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 12px;
  background:
    radial-gradient(circle at 10% 20%, rgba(148, 163, 184, 0.050), transparent 42%),
    rgba(7, 16, 33, 0.78);
  padding: 10px 12px;
}
.vr-provider-picker strong,
.vr-provider-picker span {
  display: block;
}
.vr-provider-picker span {
  color: var(--vr-muted);
  font-size: 12px;
}
.vr-provider-picker-list {
  display: grid;
  grid-template-columns: repeat(9, minmax(0, 1fr));
  gap: 7px;
}
.vr-provider-picker-list button {
  position: relative;
  min-width: 0;
  min-height: 42px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(120, 145, 190, 0.18);
  border-radius: 10px;
  background: rgba(13, 12, 16, 0.44);
  color: var(--vr-text);
  transition:
    transform 180ms cubic-bezier(0.23, 1, 0.32, 1),
    border-color 180ms ease,
    box-shadow 180ms ease;
}
.vr-provider-picker-list button:hover {
  border-color: rgba(255, 215, 110, 0.56);
  transform: translateY(-2px);
  box-shadow: 0 0 18px rgba(0, 0, 0, 0);
}
.vr-provider-picker-list button > span:not(.vr-provider-token) {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}
.vr-provider-composition {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 272px;
  gap: 10px;
}
.vr-provider-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(168px, 1fr));
  gap: 8px;
}

.vr-provider-card {
  position: relative;
  min-height: 92px;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  grid-template-rows: 1fr auto;
  gap: 8px 10px;
  border: 1px solid rgba(226, 232, 240, 0.13);
  border-radius: 9px;
  background:
    linear-gradient(180deg, rgba(25, 28, 34, 0.78), rgba(17, 19, 24, 0.82));
  color: var(--vr-text);
  padding: 10px;
  text-align: left;
  transition:
    transform 180ms cubic-bezier(0.23, 1, 0.32, 1),
    border-color 180ms ease,
    background 180ms ease;
}
.vr-provider-card:hover,
.vr-provider-card.is-selected {
  border-color: rgba(148, 163, 184, 0.28);
  background:
    linear-gradient(180deg, rgba(30, 33, 39, 0.9), rgba(20, 22, 27, 0.9));
  box-shadow: none;
  transform: translateY(-1px);
}
.vr-provider-token {
  position: relative;
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  overflow: hidden;
  border: 1px solid rgba(226, 232, 240, 0.11);
  border-radius: 11px;
  background: rgba(36, 38, 43, 0.76);
  box-shadow: none;
}
.vr-provider-token::after {
  display: none;
}
.vr-provider-token img {
  position: relative;
  z-index: 1;
  width: 26px;
  height: 26px;
  object-fit: contain;
  filter: saturate(1.04) contrast(1.02);
  transition: transform 180ms cubic-bezier(0.23, 1, 0.32, 1);
}
.vr-provider-token .provider-logo__img {
  filter: saturate(1.22) contrast(1.14);
}
.vr-provider-token .provider-logo__img[data-provider-logo-key="github"],
.vr-provider-token .provider-logo__img[data-provider-logo-key="vercel"],
.vr-provider-token .provider-logo__img[data-provider-logo-key="resend"] {
  filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.18));
}
.vr-provider-token .provider-logo__img[data-provider-logo-key="sentry"] {
  filter: saturate(1.34) contrast(1.16) drop-shadow(0 0 9px rgba(0, 0, 0, 0));
}
.vr-provider-token svg {
  position: relative;
  z-index: 1;
  width: 26px;
  height: 26px;
  display: block;
}
.vr-provider-token .vr-provider-logo,
.vr-provider-token .vr-provider-logo img {
  width: 26px;
  height: 26px;
  display: block;
  object-fit: contain;
}
.vr-provider-card:hover .vr-provider-token img,
.vr-provider-card.is-selected .vr-provider-token img,
.vr-provider-card:hover .vr-provider-token svg,
.vr-provider-card.is-selected .vr-provider-token svg {
  transform: scale(1.08);
}
.vr-provider-token.is-picker {
  width: 32px;
  height: 32px;
  border-radius: 10px;
}
.vr-provider-token.is-picker img {
  width: 21px;
  height: 21px;
}
.vr-provider-token.is-large {
  width: 54px;
  height: 54px;
  border-radius: 14px;
}
.vr-provider-token.is-large img {
  width: 34px;
  height: 34px;
}
.vr-provider-token.is-large svg,
.vr-provider-token.is-large .vr-provider-logo,
.vr-provider-token.is-large .vr-provider-logo img {
  width: 34px;
  height: 34px;
}
.vr-provider-card small,
.vr-provider-card strong,
.vr-provider-card em,
.vr-provider-proof-chip {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vr-provider-card small {
  color: #f4f4f5;
  font-size: 11px;
  font-weight: 650;
  line-height: 1.18;
  white-space: nowrap;
}
.vr-provider-card strong {
  margin-top: 2px;
  font-size: 12px;
  font-weight: 520;
  color: #c7cdd6;
}
.vr-provider-card em {
  color: #22c55e;
  font-style: normal;
  font-size: 11px;
  font-weight: 520;
}
.vr-provider-card[data-provider-tone="orange"] em {
  color: #fbbf24;
}
.vr-provider-card[data-provider-tone="red"] em {
  color: #fb7185;
}
.vr-provider-card[data-provider-tone="neutral"] em {
  color: #aeb7c6;
}
.vr-provider-proof-chip {
  grid-column: 1 / -1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  place-items: center;
  justify-self: stretch;
  min-height: 26px;
  border: 1px solid rgba(226, 232, 240, 0.13);
  border-radius: 8px;
  background: rgba(10, 10, 12, 0.62);
  color: #e5e7eb;
  font-size: 11px;
  font-weight: 760;
}
.vr-provider-proof-chip span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vr-provider-card:hover .vr-provider-proof-chip,
.vr-provider-card.is-selected .vr-provider-proof-chip {
  border-color: rgba(248, 250, 252, 0.22);
  background: rgba(13, 12, 16, 0.72);
}
.vr-provider-proof-chip svg {
  width: 13px;
  height: 13px;
  stroke: currentColor;
}
.vr-provider-mcp-chip {
  grid-column: 2;
  grid-row: 2;
  justify-self: end;
  min-width: 0;
  width: 8px;
  height: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  border: 0;
  border-radius: 999px;
  padding: 0;
  color: #fbbf24;
  font-size: 10px;
  font-weight: 720;
  line-height: 1;
  background: transparent;
}
.vr-provider-mcp-chip i {
  width: 8px;
  height: 8px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #f59e0b;
  box-shadow: 0 0 8px rgba(245, 158, 11, 0.36);
  animation: vrStatusPulse 2.7s ease-in-out infinite;
}
.vr-provider-mcp-chip span {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}
.vr-provider-mcp-chip.is-connected {
  border-color: transparent;
  background: transparent;
  color: #bbf7d0;
}
.vr-provider-mcp-chip.is-connected i {
  background: #22c55e;
  box-shadow: 0 0 8px rgba(34, 197, 94, 0.42);
}
@keyframes vrStatusPulse {
  0%, 100% {
    opacity: 0.72;
    transform: scale(0.92);
  }
  50% {
    opacity: 1;
    transform: scale(1.08);
  }
}
.vr-provider-mcp-panel {
  display: grid;
  gap: 10px;
  border: 1px solid rgba(148, 163, 184, 0.13);
  border-radius: 10px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.035);
}
.vr-provider-mcp-panel header {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
}
.vr-mcp-connect-btn {
  border: 1px solid rgba(245, 158, 11, 0.45);
  background: rgba(245, 158, 11, 0.12);
  color: #fbbf24;
  border-radius: 8px;
  padding: 5px 10px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}
.vr-mcp-connect-btn:hover {
  background: rgba(245, 158, 11, 0.22);
}
.vr-provider-mcp-panel header > span {
  width: 30px;
  height: 30px;
  display: inline-grid;
  place-items: center;
  border-radius: 8px;
  background: rgba(245, 158, 11, 0.11);
  color: #fbbf24;
}
.vr-provider-mcp-panel strong,
.vr-provider-mcp-panel em {
  display: block;
  min-width: 0;
}
.vr-provider-mcp-panel strong {
  color: #f8fafc;
  font-size: 13px;
}
.vr-provider-mcp-panel em {
  margin-top: 2px;
  color: #98a2b3;
  font-size: 11px;
  font-style: normal;
}
.vr-provider-mcp-panel > div {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.vr-provider-mcp-panel small {
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.13);
  padding: 4px 7px;
  color: #b9c2cf;
  font-size: 10px;
  font-weight: 680;
}
.vr-provider-mcp-panel.is-connected {
  border-color: rgba(34, 197, 94, 0.24);
  background: rgba(34, 197, 94, 0.055);
}
.vr-provider-mcp-panel.is-connected header > span {
  background: rgba(34, 197, 94, 0.12);
  color: #86efac;
}
.vr-bottom-inventory .vr-provider-mcp-chip {
  grid-column: 3;
  grid-row: 1;
  justify-self: end;
  min-width: 0;
  width: 8px;
  height: 8px;
  padding: 0;
  font-size: 0;
}
.vr-bottom-inventory .vr-provider-proof-chip {
  grid-column: 4;
  justify-self: end;
  width: 20px;
  height: 24px;
  min-height: 24px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #94a3b8;
  padding: 0;
  transform: none;
}
.vr-bottom-inventory .vr-provider-proof-chip span {
  display: none;
}
.vr-bottom-inventory .vr-provider-proof-chip svg {
  width: 15px;
  height: 15px;
  stroke-width: 2.35;
}
.vr-bottom-inventory .vr-provider-card:hover .vr-provider-proof-chip,
.vr-bottom-inventory .vr-provider-card.is-selected .vr-provider-proof-chip {
  background: transparent;
  color: #e2e8f0;
}
.vr-provider-add-card {
  position: relative;
  min-height: 64px;
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  border: 1px dashed rgba(226, 232, 240, 0.16);
  border-radius: 9px;
  background: rgba(29, 33, 40, 0.46);
  color: var(--vr-muted);
  padding: 9px 12px;
  text-align: left;
  transition:
    transform 180ms cubic-bezier(0.23, 1, 0.32, 1),
    border-color 180ms ease,
    background 180ms ease;
}
.vr-provider-add-card:hover {
  border-color: rgba(226, 232, 240, 0.28);
  background: rgba(35, 39, 46, 0.72);
  transform: translateY(-1px);
}
.vr-provider-add-card > span:first-child {
  position: relative;
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(226, 232, 240, 0.12);
  border-radius: 11px;
  background: rgba(36, 38, 43, 0.62);
}
.vr-provider-add-card > span:first-child::before,
.vr-provider-add-card > span:first-child::after {
  content: "";
  grid-area: 1 / 1;
  width: 18px;
  height: 1.5px;
  border-radius: 999px;
  background: #a1a1aa;
}
.vr-provider-add-card > span:first-child::after {
  transform: rotate(90deg);
}
.vr-provider-add-card small,
.vr-provider-add-card strong,
.vr-provider-add-card em {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vr-provider-add-card small {
  color: #f4f4f5;
  font-size: 11px;
  font-weight: 650;
}
.vr-provider-add-card strong {
  margin-top: 2px;
  color: #cbd5e1;
  font-size: 12px;
  font-weight: 540;
}
.vr-provider-add-card em {
  color: #94a3b8;
  font-size: 11px;
  font-style: normal;
}

.vr-provider-detail-panel {
  display: grid;
  align-content: start;
  gap: 8px;
  border: 1px solid rgba(56, 189, 248, 0.26);
  border-radius: 14px;
  background:
    radial-gradient(circle at 20% 20%, rgba(148, 163, 184, 0.050), transparent 36%),
    rgba(7, 16, 33, 0.84);
  padding: 12px;
}
.vr-detail-head {
  display: grid;
  grid-template-columns: 52px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
}
.vr-detail-head span,
.vr-provider-detail-panel p {
  color: var(--vr-muted);
}
.vr-detail-head strong {
  display: block;
  font-size: 18px;
}
.vr-provider-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.vr-provider-stats span {
  border: 1px solid var(--vr-border);
  border-radius: 10px;
  padding: 8px;
}
.vr-provider-stats b,
.vr-provider-stats em {
  display: block;
  font-style: normal;
}
.vr-provider-stats b {
  color: var(--vr-muted);
  font-size: 10px;
  text-transform: uppercase;
}
.vr-provider-detail-panel button,
.vr-provider-dashboard {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 10px;
}
.vr-provider-detail-panel button i,
.vr-provider-dashboard i {
  border: 0;
  background: transparent;
  transform: none;
}

.vr-releases-panel {
  min-height: 0;
}
.vr-release-actions {
  display: inline-flex;
  gap: 8px;
}
.vr-release-actions button {
  min-height: 30px;
  border-radius: 9px;
  padding: 0 12px;
}
.vr-release-track {
  display: grid;
  grid-template-columns: repeat(6, minmax(120px, 1fr));
  gap: 8px;
  align-items: stretch;
}
.vr-release-card {
  position: relative;
  min-height: 54px;
  display: grid;
  align-content: center;
  gap: 3px;
  border: 1px solid rgba(120, 145, 190, 0.15);
  border-radius: 9px;
  background:
    linear-gradient(180deg, rgba(24, 22, 28, 0.64), rgba(8, 13, 24, 0.7));
  color: var(--vr-text);
  padding: 8px 10px;
  text-align: left;
}
.vr-release-card:hover,
.vr-release-card.is-selected {
  border-color: rgba(148, 163, 184, 0.22);
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0);
  transform: translateY(-1px);
}
.vr-release-card small { color: #ffd76e; font-size: 10px; font-weight: 680; }
.vr-release-card strong { font-size: 15px; font-weight: 720; }
.vr-release-card em {
  color: var(--vr-muted);
  font-style: normal;
}
.vr-current-star {
  position: absolute;
  right: -10px;
  top: -10px;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 999px;
  background: linear-gradient(135deg, #e8c15a, #ffd76e);
  box-shadow: var(--vr-glow-purple);
}
.vr-current-star i {
  width: 28px;
  height: 28px;
  border: 0;
  background: transparent;
  color: #fff;
}
.vr-view-all {
  align-content: center;
  justify-items: center;
  text-align: center;
}
.vr-timeline-rail {
  position: relative;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  margin: 4px 50px 0;
}
.vr-timeline-rail::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 2px;
  background: linear-gradient(90deg, #e8c15a, #38bdf8, rgba(148, 163, 184, 0.4));
}
.vr-timeline-rail span {
  z-index: 1;
  width: 12px;
  height: 12px;
  justify-self: center;
  border: 2px solid #94a3b8;
  border-radius: 999px;
  background: var(--vr-bg);
}
.vr-timeline-rail span.is-selected {
  border-color: #ffd76e;
  background: #ffd76e;
  box-shadow: var(--vr-glow-purple);
}
.vr-release-detail {
  display: none;
  margin: 6px 0 0;
  color: var(--vr-muted);
  font-size: 12px;
}

.vr-agent-panel {
  min-width: 0;
  height: 100%;
  min-height: 0;
  display: grid;
  grid-template-rows: minmax(0, 1fr);
  gap: 10px;
  border-radius: 12px;
  padding: 0;
  overflow: hidden;
}
.vr-agent-control {
  min-height: 0;
  height: 100%;
  display: grid;
  grid-template-rows: auto auto minmax(0, 1fr) auto;
  gap: 8px;
  border: 1px solid rgba(148, 163, 184, 0.13);
  border-radius: 12px;
  background:
    linear-gradient(180deg, rgba(22, 27, 35, 0.72), rgba(13, 17, 24, 0.82));
  padding: 10px;
  overflow: hidden;
}
.vr-agent-hero {
  position: relative;
  min-height: 136px;
  overflow: hidden;
  border: 1px solid rgba(96, 165, 250, 0.2);
  border-radius: 10px;
  background:
    radial-gradient(circle at 78% 40%, rgba(34, 197, 94, 0.18), transparent 34%),
    radial-gradient(circle at 82% 22%, rgba(96, 165, 250, 0.18), transparent 31%),
    rgba(8, 17, 34, 0.82);
  padding: 16px;
}
.vr-agent-hero div {
  position: relative;
  z-index: 2;
  max-width: 168px;
}
.vr-agent-hero p {
  margin: 0 0 10px;
  color: #cbd5e1;
  font-weight: 760;
}
.vr-agent-hero p span {
  border: 1px solid rgba(255, 215, 110, 0.5);
  border-radius: 999px;
  padding: 2px 7px;
}
.vr-agent-hero h2 {
  max-width: 155px;
  font-size: 21px;
  line-height: 1.12;
}
.vr-agent-hero em {
  display: block;
  margin-top: 8px;
  color: #cbd5e1;
  font-style: normal;
  line-height: 1.35;
}
.vr-agent-hero img {
  position: absolute;
  right: -2px;
  bottom: -12px;
  z-index: 1;
  width: 116px;
  border-radius: 0;
  opacity: 1;
  filter: saturate(1.16) drop-shadow(0 0 30px rgba(0, 0, 0, 0));
  animation: vrMascotIdle 3200ms cubic-bezier(0.23, 1, 0.32, 1) infinite;
}
.vr-agent-hero.is-fixing img {
  filter: saturate(1.25) drop-shadow(0 0 34px rgba(249, 115, 22, 0.72));
}
.vr-agent-hero.is-verified img {
  filter: saturate(1.25) drop-shadow(0 0 34px rgba(34, 197, 94, 0.66));
}
.vr-agent-hero .vr-glow-button {
  position: absolute;
  left: 18px;
  right: 18px;
  bottom: 18px;
  z-index: 3;
}

.vr-glow-button {
  position: relative;
  min-height: 46px;
  display: inline-grid;
  grid-template-columns: minmax(0, 1fr) 18px;
  align-items: center;
  gap: 10px;
  overflow: hidden;
  border: 1px solid rgba(255, 215, 110, 0.72);
  border-radius: 10px;
  background: linear-gradient(135deg, #e8c15a, #6d28d9 52%, #2563eb);
  color: #fff;
  padding: 0 16px;
  font-weight: 820;
  text-align: center;
  box-shadow: var(--vr-glow-purple);
}
.vr-glow-button[data-tone="green"] {
  border-color: rgba(34, 197, 94, 0.76);
  background: linear-gradient(135deg, rgba(21, 128, 61, 0.96), rgba(16, 185, 129, 0.72));
  box-shadow: var(--vr-glow-green);
}
.vr-glow-button::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(110deg, transparent 0 30%, rgba(255, 255, 255, 0.22) 42%, transparent 56%);
  transform: translateX(-80%);
  animation: vrButtonShimmer 2600ms cubic-bezier(0.23, 1, 0.32, 1) infinite;
}
.vr-glow-button span,
.vr-glow-button i {
  position: relative;
  z-index: 1;
}
.vr-glow-button i { transform: rotate(-45deg); justify-self: end; }

.vr-agent-will,
.vr-quick-actions,
.vr-agent-community {
  border: 1px solid rgba(148, 163, 184, 0.12);
  border-radius: 10px;
  background: rgba(17, 21, 28, 0.5);
  padding: 10px;
}
.vr-agent-will h3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.vr-agent-will h3 a {
  color: #8fb3d9;
  font-size: 12px;
  font-weight: 800;
  text-decoration: none;
}
.vr-agent-will {
  min-height: 0;
  display: grid;
  align-content: start;
  gap: 8px;
  overflow: hidden;
}
.vr-agent-will span {
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  color: #cbd5e1;
  font-size: 11px;
}
.vr-agent-will span i {
  position: relative;
  width: 20px;
  height: 20px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(52, 211, 153, 0.72);
  border-radius: 999px;
  background:
    radial-gradient(circle at 50% 50%, rgba(34, 197, 94, 0.22), transparent 46%),
    rgba(24, 22, 28, 0.78);
  box-shadow: 0 0 14px rgba(34, 197, 94, 0.2);
}
.vr-agent-will span i::before {
  content: "";
  width: 7px;
  height: 11px;
  border-right: 2px solid #86efac;
  border-bottom: 2px solid #86efac;
  transform: rotate(42deg) translateY(-1px);
  color: #86efac;
  font-size: 10px;
  font-style: normal;
  font-weight: 850;
  line-height: 1;
}
.vr-agent-will span.is-done i {
  border-color: #4ade80;
  background:
    radial-gradient(circle at 50% 50%, rgba(34, 197, 94, 0.34), transparent 52%),
    rgba(5, 46, 22, 0.82);
  box-shadow: var(--vr-glow-green);
}
.vr-agent-will span.is-done i::before {
  content: "";
  width: 7px;
  height: 11px;
  border-right: 2px solid #86efac;
  border-bottom: 2px solid #86efac;
  transform: rotate(42deg) translateY(-1px);
}
.vr-agent-will span.is-done {
  color: #86efac;
}
.vr-agent-will span em {
  color: var(--vr-muted);
  font-size: 11px;
  font-style: normal;
}
.vr-quick-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-content: start;
  gap: 8px;
}
.vr-quick-actions h3 {
  grid-column: 1 / -1;
}
.vr-quick-action {
  min-height: 44px;
  display: grid;
  grid-template-columns: 26px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  padding: 0 10px;
  text-align: left;
}
.vr-quick-action strong,
.vr-quick-action em {
  display: block;
}
.vr-quick-action em {
  color: var(--vr-muted);
  font-style: normal;
  font-size: 11px;
}
.vr-quick-actions .vr-glow-button {
  margin-top: 4px;
}
.vr-agent-panel > .vr-glow-button {
  min-height: 50px;
}
.vr-agent-control > .vr-glow-button {
  min-height: 50px;
}
.vr-agent-panel > .vr-releases-panel {
  min-height: 0;
  overflow: hidden;
}
.vr-agent-panel > .vr-releases-panel .vr-panel-head {
  margin-bottom: 8px;
}
.vr-agent-panel > .vr-releases-panel .vr-panel-head h2 {
  font-size: 15px;
}
.vr-agent-panel > .vr-releases-panel .vr-panel-head p {
  display: none;
}
.vr-agent-panel > .vr-releases-panel .vr-release-actions {
  display: none;
}
.vr-agent-panel > .vr-releases-panel .vr-release-track {
  display: grid;
  grid-template-columns: 1fr;
  gap: 7px;
  overflow: auto;
}
.vr-agent-panel > .vr-releases-panel .vr-release-card {
  min-height: 58px;
  border-radius: 9px;
  background:
    linear-gradient(180deg, rgba(26, 30, 38, 0.68), rgba(18, 22, 29, 0.72));
  padding: 10px 12px;
}
.vr-agent-panel > .vr-releases-panel .vr-view-all {
  min-height: 46px;
}
.vr-agent-panel > .vr-releases-panel .vr-timeline-rail,
.vr-agent-panel > .vr-releases-panel .vr-release-detail {
  display: none;
}
.vr-agent-community {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: stretch;
  gap: 10px;
}
.vr-agent-community strong,
.vr-agent-community span {
  display: block;
}
.vr-agent-community span {
  color: var(--vr-muted);
  font-size: 12px;
}
.vr-agent-community .vr-github-stat-row {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.vr-agent-community .vr-github-stat-row span {
  background: rgba(24, 24, 27, 0.82);
}
.vr-agent-community small {
  color: var(--vr-muted);
  font-size: 11px;
}
.vr-agent-community-links {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
.vr-agent-community a {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid rgba(120, 145, 190, 0.2);
  border-radius: 9px;
  background: rgba(13, 12, 16, 0.38);
  color: #dbeafe;
  padding: 0 10px;
  text-decoration: none;
  font-weight: 760;
}
.vr-agent-community a {
  color: #ffe9ad;
  text-decoration: none;
}

.vr-bottom-tip-bar {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  height: 34px;
  min-height: 34px;
  overflow: hidden;
  border-width: 1px 0 0;
  border-radius: 0;
  background:
    radial-gradient(circle at 20% 0%, rgba(148, 163, 184, 0.050), transparent 28%),
    rgba(8, 17, 34, 0.82);
  padding: 0 18px;
}
.vr-bottom-tip-bar nav .vr-bottom-github {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.vr-bottom-tip-bar .vr-inline-brand-mark {
  width: 18px;
  height: 18px;
}
.vr-bottom-tip-bar .vr-inline-brand-mark.is-github {
  display: inline-grid;
  place-items: center;
  color: #f8fafc;
}
.vr-bottom-tip-bar .vr-inline-brand-mark.is-github svg {
  width: 17px;
  height: 17px;
  display: block;
  fill: currentColor;
}
.vr-tip-mascot {
  width: 34px;
  height: 34px;
  align-self: stretch;
  position: relative;
  display: grid;
  place-items: end center;
  overflow: hidden;
  border-right: 1px solid rgba(148, 163, 184, 0.16);
}
.vr-tip-mascot::before {
  content: "";
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 2px;
  height: 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  filter: blur(8px);
}
.vr-tip-mascot img {
  position: relative;
  z-index: 1;
  align-self: end;
  width: 32px;
  height: 32px;
  object-fit: contain;
  object-position: bottom;
  transform: translateY(3px);
  filter: saturate(1.16) drop-shadow(0 0 12px rgba(0, 0, 0, 0));
}
.vr-bottom-tip-bar span {
  color: #cbd5e1;
}
.vr-bottom-tip-bar b {
  color: #fde68a;
}
.vr-bottom-tip-bar nav {
  display: inline-flex;
  gap: 14px;
}
.vr-bottom-tip-bar a {
  color: #cbd5e1;
  text-decoration: none;
}
.vr-bottom-tip-bar a:hover {
  color: #fff;
}

.vr-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 40;
  box-sizing: border-box;
  display: grid;
  place-items: center;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 24px;
  background:
    radial-gradient(circle at 50% 42%, rgba(148, 163, 184, 0.050), transparent 34%),
    radial-gradient(circle at 72% 16%, rgba(34, 197, 94, 0.12), transparent 24%),
    linear-gradient(rgba(148, 163, 184, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(148, 163, 184, 0.03) 1px, transparent 1px),
    rgba(1, 4, 13, 0.86);
  background-size: auto, auto, 42px 42px, 42px 42px, auto;
  /* NOTE: no backdrop-filter here. A full-viewport backdrop-filter: blur()
     renders as SOLID BLACK on many real Windows GPU/driver combos (Intel/ANGLE),
     blacking out the whole Studio whenever a modal (e.g. the welcome modal) is
     open. Headless/software raster hides the bug. The dark base layer above
     gives the same focus without the GPU hazard. Do not re-add blur here. */
  animation: vrModalFade 180ms ease-out both;
}

.vr-modal-card {
  position: relative;
  isolation: isolate;
  box-sizing: border-box;
  width: min(920px, calc(100vw - 48px));
  max-width: 100%;
  max-height: calc(100vh - 56px);
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid rgba(255, 215, 110, 0.72);
  border-radius: 24px;
  background:
    radial-gradient(circle at 80% 15%, rgba(148, 163, 184, 0.050), transparent 27%),
    radial-gradient(circle at 19% 8%, rgba(56, 189, 248, 0.12), transparent 24%),
    radial-gradient(circle at 74% 70%, rgba(34, 197, 94, 0.08), transparent 28%),
    linear-gradient(180deg, rgba(13, 20, 43, 0.98), rgba(13, 12, 16, 0.995));
  box-shadow:
    0 0 0 1px rgba(255, 233, 173, 0.12),
    0 0 70px rgba(0, 0, 0, 0),
    0 30px 110px rgba(0, 0, 0, 0.68);
  padding: 28px;
  animation: vrModalPop 260ms cubic-bezier(0.23, 1, 0.32, 1) both;
}

.vr-modal-backdrop.is-stable-render,
.vr-modal-card.is-stable-render {
  animation: none;
}

.vr-modal-card *,
.vr-modal-card *::before,
.vr-modal-card *::after {
  box-sizing: border-box;
  max-width: 100%;
}

.vr-modal-card::-webkit-scrollbar {
  width: 10px;
}

.vr-modal-card::-webkit-scrollbar-thumb {
  border: 3px solid rgba(13, 12, 16, 0.92);
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.4);
}

.vr-modal-card::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  border-radius: inherit;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.08), transparent 28%),
    radial-gradient(circle at 84% 22%, rgba(34, 197, 94, 0.12), transparent 30%);
}

.vr-modal-card::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  border-radius: inherit;
  background:
    linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.050), rgba(56, 189, 248, 0.18), transparent);
  opacity: 0.34;
  transform: translateX(-44%);
  animation: vrModalEdgeSweep 5200ms cubic-bezier(0.23, 1, 0.32, 1) infinite;
}

.vr-modal-close {
  position: absolute;
  right: 18px;
  top: 18px;
  z-index: 4;
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.04);
  color: #ffe9ad;
  transition: transform 160ms cubic-bezier(0.23, 1, 0.32, 1), border-color 160ms ease, box-shadow 160ms ease;
}

.vr-modal-close:hover {
  border-color: rgba(255, 233, 173, 0.82);
  box-shadow: var(--vr-glow-purple);
  transform: translateY(-1px);
}

.vr-modal-card h2,
.vr-modal-card h3,
.vr-modal-card p {
  margin: 0;
}

.vr-modal-provider-head,
.vr-modal-release-head,
.vr-modal-add-head,
.vr-modal-agent-head,
.vr-modal-health,
.vr-modal-progress,
.vr-modal-checks,
.vr-modal-tasklist,
.vr-modal-notes,
.vr-modal-two-col section {
  position: relative;
  z-index: 2;
}

.vr-modal-provider-head,
.vr-modal-release-head {
  position: relative;
  min-height: 210px;
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr) 250px;
  align-items: center;
  gap: 26px;
  border: 1px solid rgba(96, 122, 177, 0.24);
  border-radius: 18px;
  background:
    linear-gradient(90deg, rgba(148, 163, 184, 0.050), rgba(8, 17, 34, 0.48) 46%, rgba(24, 22, 28, 0.08)),
    radial-gradient(circle at 86% 42%, rgba(148, 163, 184, 0.050), transparent 32%);
  padding: 22px 34px 22px 22px;
  padding-right: 34px;
  overflow: hidden;
}

.vr-modal-provider-head::before,
.vr-modal-release-head::before,
.vr-modal-agent-head::before,
.vr-modal-guide-head::before,
.vr-modal-prompt-head::before {
  content: "";
  position: absolute;
  inset: 12px;
  z-index: -1;
  pointer-events: none;
  border-radius: inherit;
  background:
    radial-gradient(circle at 72% 38%, rgba(148, 163, 184, 0.050), transparent 24%),
    linear-gradient(120deg, transparent 0 44%, rgba(148, 163, 184, 0.050) 45%, transparent 46% 100%);
  opacity: 0.82;
}

.vr-modal-add-provider {
  width: min(760px, calc(100vw - 48px));
  max-width: 100%;
  border-color: rgba(226, 232, 240, 0.16);
  border-radius: 18px;
  background:
    radial-gradient(circle at 84% 4%, rgba(148, 163, 184, 0.050), transparent 28%),
    linear-gradient(180deg, rgba(24, 27, 34, 0.98), rgba(14, 16, 21, 0.99));
  box-shadow: 0 30px 100px rgba(0, 0, 0, 0.7);
}
.vr-modal-add-head {
  min-height: 132px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 132px;
  align-items: center;
  gap: 18px;
  border: 1px solid rgba(226, 232, 240, 0.11);
  border-radius: 14px;
  background: rgba(29, 33, 40, 0.56);
  padding: 18px;
  overflow: hidden;
}
.vr-modal-add-head p {
  color: #ffd76e;
  font-size: 12px;
  font-weight: 760;
}
.vr-modal-add-head h2 {
  margin-top: 5px;
  font-size: 30px;
  line-height: 1.05;
}
.vr-modal-add-head em {
  display: block;
  margin-top: 9px;
  color: #aeb9ca;
  font-style: normal;
}
.vr-modal-add-head .vr-modal-agent-avatar {
  width: 132px;
  height: 132px;
  object-fit: contain;
  justify-self: end;
}
.vr-modal-provider-options {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;
}
.vr-modal-provider-options button {
  min-width: 0;
  min-height: 92px;
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  border: 1px solid rgba(226, 232, 240, 0.11);
  border-radius: 12px;
  background: rgba(29, 33, 40, 0.58);
  color: #f4f4f5;
  padding: 13px;
  text-align: left;
  transition:
    transform 180ms cubic-bezier(0.23, 1, 0.32, 1),
    border-color 180ms ease,
    background 180ms ease;
}
.vr-modal-provider-options button:hover {
  border-color: rgba(148, 163, 184, 0.22);
  background: rgba(35, 39, 46, 0.78);
  transform: translateY(-1px);
}
.vr-modal-provider-options small,
.vr-modal-provider-options strong,
.vr-modal-provider-options em {
  display: block;
}
.vr-modal-provider-options small {
  color: #ffd76e;
  font-size: 11px;
  font-weight: 760;
}
.vr-modal-provider-options strong {
  margin-top: 3px;
  font-size: 15px;
}
.vr-modal-provider-options em {
  margin-top: 3px;
  color: #aeb9ca;
  font-size: 12px;
  font-style: normal;
  line-height: 1.3;
}
.vr-modal-provider-options b {
  border: 1px solid rgba(226, 232, 240, 0.12);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  color: #e5e7eb;
  padding: 6px 10px;
  font-size: 12px;
}
.vr-modal-connect-note {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr);
  gap: 10px;
  margin-top: 14px;
  border: 1px solid rgba(34, 197, 94, 0.18);
  border-radius: 12px;
  background: rgba(34, 197, 94, 0.06);
  color: #aeb9ca;
  padding: 12px 14px;
}
.vr-modal-connect-note svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: #22c55e;
  stroke-width: 1.9;
}

.vr-modal-provider-logo {
  width: 126px;
  height: 126px;
  object-fit: contain;
  border: 2px solid rgba(255, 215, 110, 0.7);
  border-radius: 24px;
  background:
    radial-gradient(circle at 35% 25%, rgba(255, 255, 255, 0.2), transparent 34%),
    linear-gradient(135deg, rgba(16, 185, 129, 0.38), rgba(148, 163, 184, 0.050));
  padding: 24px;
  box-shadow: var(--vr-glow-purple);
  transition: transform 200ms cubic-bezier(0.23, 1, 0.32, 1), box-shadow 200ms ease;
}
.vr-modal-provider-logo.is-logo-html {
  display: grid;
  place-items: center;
}
.vr-modal-provider-logo.is-logo-html img,
.vr-modal-provider-logo.is-logo-html svg,
.vr-modal-provider-logo.is-logo-html .vr-provider-logo {
  width: 74px;
  height: 74px;
  display: block;
  object-fit: contain;
}

.vr-modal-provider-logo:hover {
  transform: translateY(-3px) rotate(-2deg);
  box-shadow: 0 0 36px rgba(232, 193, 90, 0.82), 0 0 82px rgba(34, 197, 94, 0.2);
}

.vr-modal-provider-head h2,
.vr-modal-release-head h2,
.vr-modal-agent-head h2 {
  margin: 0 0 10px;
  font-size: 38px;
  line-height: 1;
}

.vr-modal-provider-head p,
.vr-modal-release-head p,
.vr-modal-agent-head p {
  color: #ffd76e;
  font-weight: 850;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.vr-modal-provider-head > div > p {
  margin-top: 20px;
  color: #ffe9ad;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
}

.vr-modal-mascot {
  width: 268px;
  max-height: 238px;
  object-fit: contain;
  justify-self: end;
  filter: saturate(1.3) contrast(1.04) drop-shadow(0 0 42px rgba(232, 193, 90, 0.82));
  animation: vrMascotIdle 3400ms cubic-bezier(0.23, 1, 0.32, 1) infinite;
}

.vr-modal-health,
.vr-modal-progress {
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr) auto;
  align-items: center;
  gap: 18px;
  border: 1px solid rgba(34, 197, 94, 0.34);
  border-radius: 16px;
  background:
    radial-gradient(circle at 8% 50%, rgba(34, 197, 94, 0.18), transparent 24%),
    rgba(8, 17, 34, 0.92);
  padding: 16px 20px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.vr-modal-health.is-orange,
.vr-modal-progress.is-orange {
  border-color: rgba(251, 146, 60, 0.42);
  background:
    radial-gradient(circle at 8% 50%, rgba(251, 146, 60, 0.16), transparent 24%),
    rgba(8, 17, 34, 0.92);
}

.vr-modal-health.is-orange > span,
.vr-modal-progress.is-orange > i:first-child {
  border-color: rgba(251, 146, 60, 0.64);
  background: rgba(251, 146, 60, 0.12);
  color: #fb923c;
  box-shadow: 0 0 18px rgba(251, 146, 60, 0.24);
}

.vr-modal-health.is-orange strong,
.vr-modal-progress.is-orange strong {
  color: #fb923c;
}

.vr-modal-health.is-red,
.vr-modal-progress.is-red {
  border-color: rgba(248, 113, 113, 0.42);
  background:
    radial-gradient(circle at 8% 50%, rgba(248, 113, 113, 0.16), transparent 24%),
    rgba(8, 17, 34, 0.92);
}

.vr-modal-health.is-red > span,
.vr-modal-progress.is-red > i:first-child {
  border-color: rgba(248, 113, 113, 0.64);
  background: rgba(248, 113, 113, 0.12);
  color: #f87171;
  box-shadow: 0 0 18px rgba(248, 113, 113, 0.24);
}

.vr-modal-health.is-red strong,
.vr-modal-progress.is-red strong {
  color: #f87171;
}

.vr-modal-checks li.pending > span,
.vr-modal-tasklist li.pending > span {
  border-color: rgba(96, 122, 177, 0.7);
  background: rgba(24, 22, 28, 0.5);
  box-shadow: none;
}

.vr-modal-checks li.pending b,
.vr-modal-tasklist li.pending b {
  color: #94a3b8;
}

.vr-modal-health > span,
.vr-modal-progress > i:first-child {
  width: 56px;
  height: 56px;
  display: grid;
  place-items: center;
  border: 2px solid rgba(34, 197, 94, 0.64);
  border-radius: 999px;
  background: rgba(34, 197, 94, 0.12);
  color: #4ade80;
  box-shadow: var(--vr-glow-green);
}

.vr-modal-health strong,
.vr-modal-progress strong {
  display: block;
  color: #4ade80;
  font-size: 21px;
}

.vr-modal-health em,
.vr-modal-progress p,
.vr-modal-tasklist em,
.vr-modal-checks em,
.vr-modal-safe,
.vr-modal-foot {
  color: #aeb9d4;
  font-style: normal;
}

.vr-modal-health b {
  color: #4ade80;
  font-size: 22px;
}

.vr-modal-action-grid,
.vr-modal-button-row {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-top: 18px;
}

.vr-modal-action-grid button,
.vr-modal-action-grid a,
.vr-modal-button-row button,
.vr-modal-button-row a {
  min-height: 56px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px solid rgba(255, 215, 110, 0.56);
  border-radius: 12px;
  background: rgba(7, 16, 33, 0.92);
  color: #ffe9ad;
  text-decoration: none;
  font-size: 16px;
  font-weight: 760;
  transition: transform 170ms cubic-bezier(0.23, 1, 0.32, 1), border-color 170ms ease, background 170ms ease, box-shadow 170ms ease;
}

.vr-modal-action-grid button:hover,
.vr-modal-action-grid a:hover,
.vr-modal-button-row button:hover,
.vr-modal-button-row a:hover {
  border-color: rgba(255, 233, 173, 0.82);
  background:
    radial-gradient(circle at 50% 0%, rgba(148, 163, 184, 0.050), transparent 58%),
    rgba(12, 20, 42, 0.96);
  box-shadow: 0 0 22px rgba(0, 0, 0, 0);
  transform: translateY(-2px);
}

.vr-modal-checks,
.vr-modal-tasklist,
.vr-modal-notes,
.vr-modal-two-col section {
  margin-top: 20px;
  border: 1px solid rgba(96, 122, 177, 0.28);
  border-radius: 16px;
  background:
    linear-gradient(180deg, rgba(24, 22, 28, 0.86), rgba(7, 16, 33, 0.94));
  padding: 18px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

.vr-modal-checks h3,
.vr-modal-tasklist h3,
.vr-modal-notes h3,
.vr-modal-two-col h3 {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #ffd76e;
  font-size: 18px;
}

.vr-modal-checks ul,
.vr-modal-tasklist ul {
  display: grid;
  gap: 0;
  margin: 14px 0 0;
  padding: 0;
  list-style: none;
}

.vr-modal-checks li,
.vr-modal-tasklist li {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  min-height: 58px;
  border-top: 1px solid rgba(96, 122, 177, 0.18);
  transition: background 160ms ease, transform 160ms cubic-bezier(0.23, 1, 0.32, 1);
}

.vr-modal-checks li:hover,
.vr-modal-tasklist li:hover {
  background: rgba(255, 255, 255, 0.04);
  transform: translateX(2px);
}

.vr-modal-checks li:first-child,
.vr-modal-tasklist li:first-child {
  border-top: 0;
}

.vr-modal-checks li > span,
.vr-modal-tasklist li > span {
  position: relative;
  width: 28px;
  height: 28px;
  border: 2px solid rgba(96, 122, 177, 0.7);
  border-radius: 999px;
}

.vr-modal-checks li.done > span,
.vr-modal-tasklist li.done > span {
  border-color: #22c55e;
  background: rgba(34, 197, 94, 0.12);
  box-shadow: var(--vr-glow-green);
}

.vr-modal-checks li.done > span::after,
.vr-modal-tasklist li.done > span::after {
  content: "";
  position: absolute;
  left: 7px;
  top: 5px;
  width: 9px;
  height: 14px;
  border-right: 3px solid #22c55e;
  border-bottom: 3px solid #22c55e;
  transform: rotate(42deg);
}

.vr-modal-checks li.active,
.vr-modal-tasklist li.active,
.vr-modal-checks li.running,
.vr-modal-tasklist li.running {
  margin: 0 -18px;
  border: 1px solid rgba(232, 193, 90, 0.7);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
  padding: 0 18px;
  box-shadow: inset 0 0 24px rgba(0, 0, 0, 0);
}

.vr-modal-checks li.active > span,
.vr-modal-tasklist li.active > span,
.vr-modal-checks li.running > span,
.vr-modal-tasklist li.running > span {
  border-color: #ffd76e;
  box-shadow: var(--vr-glow-purple);
}

.vr-modal-checks strong,
.vr-modal-tasklist strong {
  display: block;
  font-size: 17px;
}

.vr-modal-checks b,
.vr-modal-tasklist b {
  color: #4ade80;
  font-size: 14px;
  font-weight: 760;
}

.vr-modal-checks li.active b,
.vr-modal-tasklist li.active b,
.vr-modal-checks li.running b,
.vr-modal-tasklist li.running b {
  color: #ffd76e;
}

.vr-modal-foot,
.vr-modal-safe {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
}

.vr-modal-foot a {
  color: #ffd76e;
  text-decoration: none;
}

.vr-modal-release-head {
  grid-template-columns: minmax(0, 1fr) 270px;
  min-height: 230px;
}

.vr-modal-release-head span {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-right: 10px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.04);
  color: #ffe9ad;
  padding: 8px 14px;
}

.vr-modal-compare {
  position: relative;
  z-index: 1;
  min-height: 56px;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  border: 1px solid rgba(255, 215, 110, 0.7);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  color: #ffd76e;
  padding: 0 24px;
  font-size: 17px;
  font-weight: 780;
}

.vr-modal-two-col {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.vr-modal-two-col p,
.vr-modal-notes p {
  margin-top: 12px;
  color: #cbd5e1;
  line-height: 1.45;
}

.vr-modal-two-col dl {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 12px 22px;
  margin: 16px 0 0;
}

.vr-modal-two-col dt {
  color: #aeb9d4;
}

.vr-modal-two-col dd {
  margin: 0;
  color: #f8fafc;
}

.vr-changelog-list {
  list-style: none;
  margin: 10px 0 0;
  padding: 0;
  display: grid;
  gap: 8px;
}

.vr-changelog-summary {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 4px 12px;
  margin: 0 0 10px;
  border: 1px solid rgba(148, 163, 184, 0.14);
  border-radius: 12px;
  background: rgba(24, 22, 28, 0.38);
  padding: 10px 12px;
}

.vr-changelog-summary span {
  color: #ffd76e;
  font-size: 11px;
  font-weight: 760;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.vr-changelog-summary strong {
  justify-self: end;
  color: #f8fafc;
  font-size: 13px;
}

.vr-changelog-summary em {
  grid-column: 1 / -1;
  color: #94a3b8;
  font-style: normal;
  font-size: 12px;
}

.vr-changelog-list li {
  display: grid;
  grid-template-columns: 82px minmax(0, 1fr);
  gap: 3px 10px;
  align-items: start;
  padding: 9px 11px;
  border-radius: 10px;
  background: rgba(24, 22, 28, 0.38);
  border: 1px solid rgba(148, 163, 184, 0.13);
  color: #e2e8f0;
  line-height: 1.35;
}

.vr-changelog-list li strong {
  color: #fff3c4;
  font-family: ui-monospace, SFMono-Regular, Consolas, "Liberation Mono", monospace;
  font-size: 12px;
  font-weight: 760;
}

.vr-changelog-list li span {
  min-width: 0;
  overflow: hidden;
  color: #f1f5f9;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr-changelog-list em {
  grid-column: 2;
  color: #94a3b8;
  font-style: normal;
  font-size: 11.5px;
}

.vr-changelog-more {
  margin-top: 10px;
}

.vr-changelog-more summary {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 34px;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.025);
  color: #ffe9ad;
  font-size: 12px;
  font-weight: 720;
  cursor: pointer;
  list-style: none;
}

.vr-changelog-more summary::-webkit-details-marker {
  display: none;
}

.vr-changelog-more[open] .vr-changelog-list {
  max-height: 260px;
  overflow-y: auto;
  padding-right: 4px;
}

.vr-changelog-list.is-condensed li,
.vr-changelog-list li.is-compact {
  padding-block: 7px;
}

.vr-changelog-empty {
  margin: 0;
  color: #94a3b8;
  font-size: 13px;
  line-height: 1.45;
}

.vr-release-error {
  color: #fca5a5;
}

.vr-modal-agent-head {
  position: relative;
  min-height: 210px;
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr) 240px;
  align-items: center;
  gap: 28px;
  border: 1px solid rgba(96, 122, 177, 0.24);
  border-radius: 18px;
  background:
    radial-gradient(circle at 16% 38%, rgba(148, 163, 184, 0.050), transparent 28%),
    linear-gradient(90deg, rgba(8, 17, 34, 0.82), rgba(13, 20, 43, 0.42));
  padding: 18px;
  overflow: hidden;
}

.vr-modal-guide-head,
.vr-modal-prompt-head {
  position: relative;
  min-height: 190px;
  display: grid;
  grid-template-columns: 170px minmax(0, 1fr) 240px;
  align-items: center;
  gap: 28px;
  border: 1px solid rgba(96, 122, 177, 0.24);
  border-radius: 18px;
  background:
    radial-gradient(circle at 14% 40%, rgba(148, 163, 184, 0.050), transparent 30%),
    linear-gradient(90deg, rgba(8, 17, 34, 0.82), rgba(13, 20, 43, 0.42));
  padding: 18px;
  overflow: hidden;
}

.vr-modal-agent-avatar {
  width: 198px;
  height: 198px;
  object-fit: contain;
  filter: saturate(1.32) contrast(1.04) drop-shadow(0 0 38px rgba(232, 193, 90, 0.78));
  animation: vrMascotIdle 3200ms cubic-bezier(0.23, 1, 0.32, 1) infinite;
}

.vr-modal-agent-head em {
  color: #dbeafe;
  font-size: 18px;
  font-style: normal;
  line-height: 1.45;
}

.vr-modal-guide-head em,
.vr-modal-prompt-head em {
  color: #dbeafe;
  font-size: 18px;
  font-style: normal;
  line-height: 1.45;
}

.vr-modal-agent-head aside,
.vr-modal-guide-head aside,
.vr-modal-prompt-head aside {
  display: grid;
  grid-template-columns: 52px minmax(0, 1fr);
  gap: 10px 14px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.04);
  padding: 18px;
}

.vr-modal-agent-head aside > i,
.vr-modal-guide-head aside > i,
.vr-modal-prompt-head aside > i {
  grid-row: 1 / span 2;
  width: 52px;
  height: 52px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  color: #ffd76e;
}

.vr-modal-agent-head aside > span,
.vr-modal-guide-head aside > span,
.vr-modal-prompt-head aside > span {
  color: #ffd76e;
  font-weight: 780;
  text-transform: uppercase;
}

.vr-modal-agent-head aside > strong,
.vr-modal-guide-head aside > strong,
.vr-modal-prompt-head aside > strong {
  font-size: 22px;
}

.vr-modal-guide-head p,
.vr-modal-prompt-head p {
  color: #ffd76e;
  font-weight: 850;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.vr-modal-guide-head h2,
.vr-modal-prompt-head h2 {
  margin: 0 0 10px;
  font-size: 38px;
  line-height: 1;
}

.vr-modal-flow-list,
.vr-modal-signal-list {
  position: relative;
  z-index: 2;
  display: grid;
  gap: 10px;
  border: 1px solid rgba(96, 122, 177, 0.28);
  border-radius: 14px;
  background: rgba(7, 16, 33, 0.92);
  padding: 14px;
}

.vr-modal-flow-list button {
  min-height: 78px;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) 24px;
  align-items: center;
  gap: 14px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 12px;
  background:
    radial-gradient(circle at 0% 50%, rgba(148, 163, 184, 0.050), transparent 36%),
    rgba(13, 12, 16, 0.5);
  color: var(--vr-text);
  padding: 0 16px;
  text-align: left;
  transition: transform 180ms cubic-bezier(0.23, 1, 0.32, 1), border-color 180ms ease, box-shadow 180ms ease;
}

.vr-modal-flow-list button:hover {
  border-color: rgba(255, 215, 110, 0.7);
  box-shadow: var(--vr-glow-purple);
  transform: translateY(-2px);
}

.vr-modal-flow-list button > span {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border: 2px solid rgba(255, 215, 110, 0.74);
  border-radius: 999px;
  color: #ffe9ad;
  font-weight: 850;
}

.vr-modal-flow-list strong,
.vr-modal-flow-list em {
  display: block;
}

.vr-modal-flow-list em {
  margin-top: 4px;
  color: #aeb9d4;
  font-style: normal;
}

.vr-modal-prompt-card {
  position: relative;
  z-index: 2;
  border: 1px solid rgba(96, 122, 177, 0.28);
  border-radius: 14px;
  background:
    radial-gradient(circle at 86% 0%, rgba(148, 163, 184, 0.050), transparent 34%),
    linear-gradient(180deg, rgba(24, 22, 28, 0.96), rgba(13, 12, 16, 0.96));
  padding: 18px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.vr-modal-prompt-card pre {
  max-height: 270px;
  overflow: auto;
  margin: 0;
  color: #dbeafe;
  font: 12px/1.65 ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  white-space: pre-wrap;
}

.vr-modal-signal-list {
  padding: 18px;
}

.vr-modal-signal-list li {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  min-height: 56px;
  border-top: 1px solid rgba(96, 122, 177, 0.18);
}

.vr-modal-signal-list li:first-child {
  border-top: 0;
}

.vr-modal-signal-list li > span {
  position: relative;
  width: 28px;
  height: 28px;
  border: 2px solid rgba(96, 122, 177, 0.7);
  border-radius: 999px;
}

.vr-modal-signal-list li.done > span {
  border-color: #22c55e;
  background: rgba(34, 197, 94, 0.12);
  box-shadow: var(--vr-glow-green);
}

.vr-modal-signal-list li.active > span {
  border-color: #ffd76e;
  box-shadow: var(--vr-glow-purple);
}

.vr-modal-signal-list li.done > span::after {
  content: "";
  position: absolute;
  left: 7px;
  top: 5px;
  width: 9px;
  height: 14px;
  border-right: 3px solid #22c55e;
  border-bottom: 3px solid #22c55e;
  transform: rotate(42deg);
}

.vr-modal-signal-list strong,
.vr-modal-signal-list em {
  display: block;
}

.vr-modal-signal-list em {
  color: #aeb9d4;
  font-style: normal;
}

.vr-modal-progress {
  margin-top: 20px;
  border-color: rgba(34, 197, 94, 0.42);
  background: rgba(5, 46, 22, 0.68);
}

.vr-modal-progress.is-ready {
  border-color: rgba(148, 163, 184, 0.22);
  background:
    radial-gradient(circle at 8% 50%, rgba(148, 163, 184, 0.050), transparent 24%),
    rgba(18, 18, 54, 0.74);
}

.vr-modal-progress > i:last-child {
  justify-self: end;
  color: #86efac;
}

.vr-modal-safe {
  grid-template-columns: 24px auto;
  justify-content: center;
  text-align: center;
}

@keyframes vrBeamSweep {
  0% { transform: translateX(-20%); opacity: 0; }
  12% { opacity: 0.86; }
  100% { transform: translateX(980%); opacity: 0; }
}

@keyframes vrMascotIdle {
  0%, 100% { transform: translateY(0) rotate(-2deg); }
  50% { transform: translateY(-7px) rotate(1deg); }
}

@keyframes vrButtonShimmer {
  0%, 42% { transform: translateX(-90%); opacity: 0; }
  54% { opacity: 0.7; }
  100% { transform: translateX(95%); opacity: 0; }
}

@keyframes vrSoftPulse {
  0%, 100% { transform: translateY(0); opacity: 0.64; }
  50% { transform: translateY(-1px); opacity: 0.92; }
}

@keyframes vrDropPulse {
  0%, 100% { opacity: 0.78; }
  50% { opacity: 1; }
}

@keyframes vrDragRoute {
  0% { opacity: 0.46; filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0)); }
  42% { opacity: 0.96; filter: drop-shadow(0 0 12px rgba(0, 0, 0, 0)); }
  100% { opacity: 0.46; filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0)); }
}

@keyframes vrTaskEnter {
  from { opacity: 0; transform: translateY(8px) scale(0.985); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes vrTaskSweep {
  0% { transform: translateX(-72%); }
  100% { transform: translateX(72%); }
}

@keyframes vrTaskGlyph {
  0%, 100% { opacity: 0.58; transform: rotate(0deg) scale(0.92); }
  50% { opacity: 1; transform: rotate(45deg) scale(1.05); }
}

@keyframes vrTaskRail {
  0% { transform: translateX(-110%); opacity: 0.32; }
  18% { opacity: 1; }
  100% { transform: translateX(285%); opacity: 0.32; }
}

@keyframes vrMenuIn {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes vrModalFade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes vrModalPop {
  from { opacity: 0; transform: translateY(18px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes vrModalEdgeSweep {
  0%, 38% { transform: translateX(-58%); opacity: 0; }
  48% { opacity: 0.38; }
  100% { transform: translateX(58%); opacity: 0; }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 1ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
    transition-duration: 80ms !important;
  }
  .vr-glow-button::before {
    display: none;
  }
  .vr-agent-hero img,
  .vr-modal-mascot,
  .vr-modal-agent-avatar {
    animation: none !important;
  }
}

.vr-sidebar {
  width: 58px;
  overflow: hidden;
  justify-items: center;
}
.vr-sidebar-brand {
  width: 44px;
}
.vr-sidebar-brand > div,
.vr-open-source-card,
.vr-workspace-switcher {
  display: none !important;
}
.vr-brand-mascot {
  width: 42px;
  height: 42px;
  border-radius: 12px;
}
.vr-brand-mascot img {
  width: 44px;
  height: 44px;
  transform: translateY(3px) scale(1.03);
}
.vr-sidebar-nav {
  width: 42px;
}
.vr-sidebar-nav button {
  width: 42px;
  min-height: 42px;
}
.vr-sidebar-nav button span {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  overflow: hidden !important;
  clip: rect(0 0 0 0) !important;
}
.vr-composition-body {
  padding-left: 16px;
}
.vr-agent-panel {
  gap: 10px;
}
.vr-agent-hero {
  min-height: 150px;
}
.vr-quick-action {
  min-height: 50px;
}
.vr-agent-will,
.vr-quick-actions,
.vr-agent-community {
  padding: 12px;
}

@media (max-width: 1320px) {
  .vr-app {
    overflow: auto;
    height: auto;
    min-height: 100vh;
    grid-template-columns: 1fr;
  }
  body { overflow: auto; }
  .vr-sidebar {
    display: none;
  }
  .vr-composed-shell {
    margin: 12px;
  }
  .vr-composition-body {
    padding-left: 16px;
  }
  .vr-composition-body {
    grid-template-columns: 1fr;
    overflow: visible;
  }
  .vr-recent-rail {
    display: none;
  }
  .vr-agent-panel {
    max-width: none;
  }
  .vr-provider-composition {
    grid-template-columns: 1fr;
  }
}

@media (max-height: 760px) and (min-width: 900px) {
  .vr-bottom-tip-bar {
    display: none;
  }
  .vr-composed-shell {
    grid-template-rows: 52px minmax(0, 1fr);
  }
}

@media (max-width: 1100px) {
  .vr-composed-shell {
    grid-template-rows: auto minmax(0, 1fr) auto;
  }
  .vr-studio-topbar {
    grid-template-columns: auto auto minmax(0, 1fr);
    row-gap: 8px;
  }
  .vr-topbar-report {
    display: none;
  }
  .vr-top-command-strip {
    grid-column: 1 / -1;
    justify-content: flex-start;
  }
  .vr-top-stage-strip {
    grid-column: 1 / -1;
    justify-self: stretch;
    width: 100%;
  }
  .vr-topbar-spacer {
    display: none;
  }
  .vr-studio-head {
    grid-template-columns: 1fr;
    align-items: stretch;
  }
  .vr-studio-tabs,
  .vr-studio-actions {
    justify-self: start;
  }
  .vr-studio-dock {
    height: auto;
    min-height: 420px;
  }
  .vr-bottom-inventory .vr-provider-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .vr-bottom-inventory {
    grid-template-columns: 1fr;
  }
  .vr-bottom-inventory .vr-release-track {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 860px) {
  .vr-modal-backdrop {
    padding: 12px;
  }
  .vr-modal-card {
    width: 100%;
    max-height: calc(100vh - 24px);
    padding: 20px;
  }
  .vr-modal-provider-head,
  .vr-modal-release-head,
  .vr-modal-agent-head,
  .vr-modal-two-col,
  .vr-modal-action-grid,
  .vr-modal-button-row {
    grid-template-columns: 1fr;
  }
  .vr-modal-mascot,
  .vr-modal-agent-avatar {
    justify-self: center;
    max-width: 220px;
  }
  .vr-modal-provider-logo {
    width: 96px;
    height: 96px;
  }
  .vr-modal-provider-head h2,
  .vr-modal-release-head h2,
  .vr-modal-agent-head h2 {
    font-size: 32px;
  }
}

@media (max-width: 820px) {
  html,
  body,
  .vr-app,
  .vr-composed-shell,
  .vr-composition-body,
  .vr-main-canvas,
  .vr-studio-dock,
  .vr-studio-body,
  .vr-studio-chat,
  .vr-chat-lanes,
  .vr-chat-transcript,
  .vr-chat-lane {
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
  }
  .vr-project-header,
  .vr-provider-grid,
  .vr-release-track,
  .vr-bottom-tip-bar {
    grid-template-columns: 1fr;
  }
  .vr-studio-topbar {
    grid-template-columns: minmax(0, 1fr);
    padding: 8px 10px;
    overflow: hidden;
  }
  .vr-studio-topbar .vr-status-badge {
    width: auto;
    justify-self: start;
  }
  .vr-topbar-select-wrap {
    display: none;
  }
  .vr-top-stage-strip {
    grid-column: 1 / -1;
    grid-template-columns: repeat(4, minmax(96px, 1fr));
    overflow-x: auto;
    scrollbar-width: none;
  }
  .vr-top-stage-strip::-webkit-scrollbar {
    display: none;
  }
  .vr-top-stage-strip button {
    min-width: 112px;
  }
  .vr-topbar-brand {
    width: auto;
    max-width: 100%;
    min-width: 0;
    justify-self: start;
  }
  .vr-topbar-brand strong,
  .vr-topbar-brand span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .vr-top-command-strip {
    display: none;
  }
  .vr-composed-shell {
    min-height: 100vh;
    margin: 0;
    border-radius: 0;
    border-left: 0;
    border-right: 0;
  }
  .vr-composition-body {
    padding: 8px;
    width: 100%;
    max-width: 100vw;
    min-width: 0;
    overflow-x: hidden;
  }
  .vr-main-canvas {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    height: min(72vh, 720px);
    min-height: 420px;
    grid-template-rows: minmax(0, 1fr);
    align-content: stretch;
  }
  .vr-studio-dock {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    height: min(72vh, 720px);
    min-height: 420px;
    padding: 10px;
    overflow: hidden;
    box-sizing: border-box;
  }
  .vr-studio-body,
  .vr-studio-chat {
    height: 100%;
    min-height: 0;
    overflow: hidden;
    box-sizing: border-box;
  }
  .vr-chat-lane {
    height: 100%;
    min-height: 0;
    overflow: hidden;
    box-sizing: border-box;
  }
  .vr-chat-transcript {
    overflow-x: hidden;
    overflow-y: auto;
    min-height: 0;
    box-sizing: border-box;
  }
  .vr-chat-command-bar,
  .vr-chat-command-bar > .vr-chat-composer {
    overflow: visible;
    box-sizing: border-box;
  }
  .vr-studio-head {
    grid-template-columns: 1fr;
    min-width: 0;
    overflow: hidden;
  }
  .vr-studio-head > div:first-child,
  .vr-studio-head h2 {
    min-width: 0;
    max-width: 100%;
  }
  .vr-studio-tabs,
  .vr-studio-actions {
    max-width: 100%;
    min-width: 0;
    justify-self: start;
  }
  .vr-studio-tabs {
    overflow-x: auto;
    scrollbar-width: thin;
  }
  .vr-cli-strip {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .vr-studio-actions {
    display: flex;
    flex-wrap: wrap;
  }
  .vr-chat-lanes {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    padding: 0;
    overflow: hidden;
  }
  .vr-chat-transcript {
    padding: 16px 14px 32px !important;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
  .vr-studio-chat:not(.is-split) .vr-chat-transcript {
    padding: 18px 16px 12px;
  }
  .vr-studio-chat:not(.is-split) .vr-chat-message,
  .vr-studio-chat:not(.is-split) .vr-chat-mission-summary {
    min-width: 0;
    max-width: 100%;
  }
  .vr-chat-message,
  .vr-chat-message > div:first-child,
  .vr-chat-message > p {
    min-width: 0;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
  .vr-chat-message > div:first-child {
    display: grid;
    grid-template-columns: 32px minmax(0, 1fr);
    align-items: center;
    column-gap: 10px;
  }
  .vr-chat-message.is-agent .vr-agent-response-stack,
  .vr-chat-message.is-agent .vr-agent-answer-body,
  .vr-chat-message.is-agent .vr-agent-followups {
    min-width: 0;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
  .vr-chat-message.is-user {
    position: static !important;
    top: auto;
    right: auto;
    width: 100% !important;
    max-width: 100% !important;
    justify-self: stretch !important;
    justify-items: end;
    padding-left: 0;
    padding-right: 0;
  }
  .vr-chat-message.is-user > div {
    width: auto;
    max-width: calc(100% - 8px);
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    justify-self: end !important;
  }
  .vr-chat-message.is-user > p {
    width: auto;
    max-width: min(58vw, 210px);
    white-space: normal;
    overflow-wrap: anywhere;
    justify-self: end !important;
  }
  .vr-chat-message > div:first-child > p {
    width: auto;
    min-width: 0;
  }
  .vr-chat-message > div:first-child > p strong,
  .vr-chat-message > div:first-child > p em {
    display: inline;
  }
  .vr-studio-chat:not(.is-split) .vr-chat-mission-summary section {
    padding: 18px;
  }
  .vr-studio-chat:not(.is-split) .vr-chat-mission-summary section:not(.vr-chat-plan-card):not(.vr-chat-connect-card) > span {
    min-height: 0;
  }
  .vr-chat-inline-actions {
    max-width: 100%;
    min-width: 0;
    flex-wrap: wrap;
    overflow-x: hidden;
    padding-bottom: 2px;
  }
  .vr-chat-inline-actions button {
    flex: 1 1 120px;
    justify-content: center;
  }
  .vr-chat-bubble,
  .vr-chat-bubble.is-agent,
  .vr-chat-bubble.is-system,
  .vr-chat-card,
  .vr-chat-mission-summary {
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
  }
  .vr-chat-mission-summary section,
  .vr-chat-plan-row {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
  .vr-chat-message > p,
  .vr-chat-mission-summary {
    padding-left: 0;
  }
  .vr-chat-mission-summary section {
    padding: 20px;
  }
  .vr-chat-mission-summary section header b {
    display: none;
  }
  .vr-chat-mission-summary section:not(.vr-chat-plan-card):not(.vr-chat-connect-card) > span,
  .vr-chat-mission-summary .vr-chat-card-list > span {
    grid-template-columns: 22px minmax(0, 1fr);
  }
  .vr-chat-message p,
  .vr-chat-copy,
  .vr-chat-mission-summary em,
  .vr-chat-mission-summary small,
  .vr-studio-head > div:first-child > span {
    min-width: 0;
    width: 100%;
    max-width: 100%;
    overflow: visible;
    text-overflow: clip;
    white-space: normal;
    overflow-wrap: break-word;
    word-break: normal;
  }
  .vr-chat-message p,
  .vr-chat-copy {
    display: block;
  }
  .vr-chat-transcript,
  .vr-chat-command-bar,
  .vr-chat-command-bar > .vr-chat-composer {
    overflow-x: hidden;
  }
  .vr-chat-mission-summary b {
    grid-column: 2;
    justify-self: start;
    font-size: 11px;
  }
  .vr-chat-plan-row {
    grid-template-columns: 28px minmax(0, 1fr) auto;
  }
  .vr-chat-plan-row b {
    display: none;
  }
  .vr-topbar-select {
    display: none;
  }
  .vr-bottom-inventory,
  .vr-providers-panel,
  .vr-releases-panel,
  .vr-agent-panel,
  .vr-bottom-tip-bar {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow-x: hidden;
  }
  .vr-chat-card-row,
  .vr-chat-mission-summary,
  .vr-bottom-inventory .vr-provider-grid,
  .vr-bottom-inventory .vr-release-track {
    grid-template-columns: 1fr;
  }
  .vr-bottom-inventory .vr-provider-card,
  .vr-provider-add-card {
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }
  .vr-release-composition,
  .vr-release-list,
  .vr-release-actions {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    grid-template-columns: 1fr;
  }
  .vr-release-row {
    width: 100%;
    max-width: 100%;
  }
  .vr-chat-mission-summary,
  .vr-chat-message > p,
  .vr-chat-copy {
    padding-left: 0;
  }
  .vr-chat-command-bar > .vr-chat-composer {
    grid-template-columns: minmax(0, 1fr) 38px;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    min-height: 92px;
  }
  .vr-chat-input {
    grid-column: 1;
    min-width: 0;
    overflow-wrap: anywhere;
  }
  .vr-chat-command-bar > .vr-chat-composer > span {
    min-width: 0;
    overflow-wrap: anywhere;
  }
  .vr-model-picker {
    grid-column: 1 / -1;
    max-width: 100%;
    min-width: 0;
    overflow-x: auto;
    justify-self: start;
    scrollbar-width: thin;
  }
  .vr-model-picker > button {
    max-width: 180px;
    min-width: 0;
  }
  .vr-model-picker > button strong {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .vr-chat-command-bar > .vr-chat-composer > button {
    grid-column: auto;
  }
  .vr-chat-command-bar > .vr-chat-composer > .vr-chat-send {
    grid-column: 2;
  }
  .vr-timeline-rail {
    display: none;
  }
}

/* --- Agent answer status rows --- */
.vr-agent-status-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 4px 0;
  padding: 8px 12px;
  border: 1px solid var(--vr-border);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.02);
  font-size: 13px;
  line-height: 1.5;
}
.vr-agent-status-row.is-ok {
  border-color: rgba(34, 197, 94, 0.35);
  background: rgba(34, 197, 94, 0.08);
}
.vr-agent-status-row.is-blocker {
  border-color: rgba(239, 68, 68, 0.4);
  background: rgba(239, 68, 68, 0.09);
}
.vr-agent-status-row.is-warn {
  border-color: rgba(249, 115, 22, 0.35);
  background: rgba(249, 115, 22, 0.08);
}

/* --- Code block copy button --- */
.vr-agent-code-wrap {
  position: relative;
}
.vr-agent-code-wrap .vr-agent-code {
  margin: 0;
}
.vr-agent-code-copy {
  position: absolute;
  top: 8px;
  right: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid var(--vr-border);
  border-radius: 8px;
  background: rgba(12, 13, 16, 0.85);
  color: var(--vr-muted);
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}
.vr-agent-code-wrap:hover .vr-agent-code-copy {
  opacity: 1;
}
.vr-agent-code-copy svg {
  width: 14px;
  height: 14px;
}
.vr-agent-code-copy.is-copied {
  color: var(--vr-green);
  border-color: rgba(34, 197, 94, 0.5);
  opacity: 1;
}

/* --- Chat mission status strip --- */
.vr-chat-status-strip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 2px 2px 6px;
}
.vr-chat-gate-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border: 1px solid var(--vr-border);
  border-radius: 999px;
  font-size: 11px;
  letter-spacing: 0.03em;
  color: var(--vr-muted);
  white-space: nowrap;
}
.vr-chat-gate-chip i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--vr-muted);
}
.vr-chat-gate-chip.is-ok {
  color: var(--vr-green);
  border-color: rgba(34, 197, 94, 0.4);
}
.vr-chat-gate-chip.is-ok i { background: var(--vr-green); }
.vr-chat-gate-chip.is-blocker {
  color: var(--vr-red);
  border-color: rgba(239, 68, 68, 0.45);
}
.vr-chat-gate-chip.is-blocker i { background: var(--vr-red); }
.vr-chat-provider-dots,
.vr-chat-version-dots {
  display: inline-flex;
  align-items: center;
}
.vr-chat-version-dots {
  margin-left: 10px;
  padding-left: 10px;
  border-left: 1px solid rgba(148, 163, 184, 0.14);
}
.vr-chat-provider-dot,
.vr-chat-version-dot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  margin-left: -7px;
  border: 1px solid var(--vr-border);
  border-radius: 50%;
  background: rgba(12, 13, 16, 0.92);
  cursor: grab;
  transition: transform 0.12s ease, border-color 0.12s ease;
}
.vr-chat-provider-dot:first-child,
.vr-chat-version-dot:first-child {
  margin-left: 0;
}
.vr-chat-provider-dot:hover,
.vr-chat-version-dot:hover {
  transform: translateY(-2px);
  border-color: rgba(232, 193, 90, 0.6);
  z-index: 1;
}
.vr-chat-provider-dot svg,
.vr-chat-provider-dot img {
  width: 17px;
  height: 17px;
}
.vr-chat-provider-dot[data-provider-tone='green'] { border-color: rgba(34, 197, 94, 0.4); }
.vr-chat-provider-dot[data-provider-tone='orange'] { border-color: rgba(249, 115, 22, 0.4); }
.vr-chat-provider-dot[data-provider-tone='red'] { border-color: rgba(239, 68, 68, 0.45); }
.vr-chat-version-dot {
  width: auto;
  min-width: 76px;
  padding: 0 10px;
  border-radius: 9px;
  background: rgba(18, 22, 33, 0.94);
  color: #ffe9ad;
}
.vr-chat-version-dot small {
  display: block;
  max-width: none;
  overflow: visible;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.vr-chat-version-dot[data-tone='current'],
.vr-chat-version-dot.is-selected {
  border-color: rgba(34, 197, 94, 0.46);
  color: #86efac;
}
.vr-chat-version-dot[data-tone='prod'] {
  border-color: rgba(148, 163, 184, 0.22);
}

/* --- Provider detail panel: professional pass --- */
.vr-provider-detail-panel[data-provider-tone='green'] {
  border-color: rgba(34, 197, 94, 0.32);
  background:
    radial-gradient(circle at 20% 18%, rgba(34, 197, 94, 0.14), transparent 40%),
    rgba(7, 16, 33, 0.86);
}
.vr-provider-detail-panel[data-provider-tone='orange'] {
  border-color: rgba(249, 115, 22, 0.34);
  background:
    radial-gradient(circle at 20% 18%, rgba(249, 115, 22, 0.13), transparent 40%),
    rgba(7, 16, 33, 0.86);
}
.vr-provider-detail-panel[data-provider-tone='red'] {
  border-color: rgba(239, 68, 68, 0.36);
  background:
    radial-gradient(circle at 20% 18%, rgba(239, 68, 68, 0.13), transparent 40%),
    rgba(7, 16, 33, 0.86);
}
.vr-provider-detail-actions {
  display: grid;
  gap: 8px;
}
.vr-provider-ask-agent {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 9px 12px;
  border: 1px solid rgba(232, 193, 90, 0.55);
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(148, 163, 184, 0.050), rgba(148, 163, 184, 0.050));
  color: var(--vr-text);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, transform 0.12s ease;
}
.vr-provider-ask-agent:hover {
  border-color: rgba(232, 193, 90, 0.85);
  transform: translateY(-1px);
}
.vr-provider-ask-agent svg {
  width: 15px;
  height: 15px;
}

/* --- Modal provider orb (large ringed dot, strip language) --- */
.vr-modal-provider-orb {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border: 1px solid var(--vr-border);
  border-radius: 50%;
  background: rgba(12, 13, 16, 0.92);
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.02), 0 10px 30px rgba(0, 0, 0, 0.45);
}
.vr-modal-provider-orb img,
.vr-modal-provider-orb svg {
  width: 30px;
  height: 30px;
}
.vr-modal-provider-orb[data-provider-tone='green'] {
  border-color: rgba(34, 197, 94, 0.55);
  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.1), 0 10px 30px rgba(0, 0, 0, 0.45);
}
.vr-modal-provider-orb[data-provider-tone='orange'] {
  border-color: rgba(249, 115, 22, 0.55);
  box-shadow: 0 0 0 4px rgba(249, 115, 22, 0.1), 0 10px 30px rgba(0, 0, 0, 0.45);
}
.vr-modal-provider-orb[data-provider-tone='red'] {
  border-color: rgba(239, 68, 68, 0.55);
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.12), 0 10px 30px rgba(0, 0, 0, 0.45);
}
.vr-modal-provider-head.is-green {
  border-bottom: 1px solid rgba(34, 197, 94, 0.18);
}
.vr-modal-provider-head.is-orange {
  border-bottom: 1px solid rgba(249, 115, 22, 0.18);
}

/* --- Modal pill row (gate-chip language) --- */
.vr-modal-pill-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 0 2px;
}
.vr-modal-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 11px;
  border: 1px solid var(--vr-border);
  border-radius: 999px;
  background: rgba(12, 13, 16, 0.7);
  font-size: 11px;
  letter-spacing: 0.03em;
  color: var(--vr-muted);
  white-space: nowrap;
}
.vr-modal-pill i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--vr-muted);
}
.vr-modal-pill.is-green {
  color: var(--vr-green);
  border-color: rgba(34, 197, 94, 0.4);
}
.vr-modal-pill.is-green i { background: var(--vr-green); }
.vr-modal-pill.is-orange {
  color: var(--vr-orange);
  border-color: rgba(249, 115, 22, 0.4);
}
.vr-modal-pill.is-orange i { background: var(--vr-orange); }
.vr-modal-pill.is-red {
  color: var(--vr-red);
  border-color: rgba(239, 68, 68, 0.45);
}
.vr-modal-pill.is-red i { background: var(--vr-red); }

/* --- Composer: ringed pill focus (strip language on input) --- */
.vr-chat-composer {
  border-radius: 16px;
  transition: border-color 0.15s ease, box-shadow 0.2s ease;
}
.vr-chat-composer:focus-within {
  border-color: rgba(232, 193, 90, 0.6);
  box-shadow: 0 0 0 4px rgba(0, 0, 0, 0);
}
.vr-chat-send {
  transition: transform 0.12s ease, box-shadow 0.2s ease;
}
.vr-chat-send:hover {
  transform: translateY(-1px);
  box-shadow: 0 0 0 4px rgba(0, 0, 0, 0);
}

/* --- Chat messages: ringed cards --- */
.vr-chat-message.is-user {
  border-radius: 14px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0);
}
.vr-chat-agent-response.is-ready {
  box-shadow: 0 0 0 1px rgba(34, 197, 94, 0.1);
}
.vr-chat-agent-response.is-error {
  box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.18);
}

/* --- Ask agent inside modals --- */
.vr-modal-action-grid .vr-provider-ask-agent,
.vr-modal-button-row .vr-provider-ask-agent {
  border-radius: 999px;
}

/* --- Mission story rail --- */
.vr-chat-story {
  position: relative;
}
.vr-story-node {
  position: relative;
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  gap: 10px;
  padding: 7px 0;
}
.vr-story-node::before {
  content: '';
  position: absolute;
  left: 13px;
  top: 40px;
  bottom: -10px;
  width: 1px;
  background: linear-gradient(180deg, rgba(148, 163, 184, 0.050), rgba(148, 163, 184, 0.050));
}
.vr-story-node:last-child::before {
  display: none;
}
.vr-story-dot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 27px;
  height: 27px;
  margin-top: 6px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 50%;
  background: rgba(12, 13, 16, 0.96);
  color: var(--vr-muted);
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0);
}
.vr-story-dot svg {
  width: 12px;
  height: 12px;
}
.vr-story-node.is-user .vr-story-dot {
  border-color: rgba(232, 193, 90, 0.65);
  background: rgba(255, 255, 255, 0.04);
}
.vr-story-node.is-user .vr-story-dot i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--vr-purple);
}
.vr-story-node.is-agent .vr-story-dot {
  color: rgba(255, 233, 173, 0.9);
}
.vr-story-node.is-error .vr-story-dot {
  border-color: rgba(239, 68, 68, 0.55);
  color: var(--vr-red);
}
.vr-story-body {
  min-width: 0;
}
.vr-story-body > .vr-chat-message {
  width: 100%;
  max-width: none;
  margin: 0;
}

/* --- Mission status strip pinned above the story --- */
.vr-chat-lane > .vr-chat-status-strip {
  flex-shrink: 0;
  flex-wrap: wrap;
  padding: 8px 10px;
  border-bottom: 1px dashed rgba(148, 163, 184, 0.13);
}

/* --- Responsive: narrow lanes --- */
@media (max-width: 960px) {
  .vr-chat-status-strip {
    gap: 6px;
  }
  .vr-provider-drop-label {
    display: none;
  }
  .vr-model-picker {
    flex-wrap: wrap;
  }
  .vr-model-picker > button span {
    display: none;
  }
  .vr-chat-inline-actions button span {
    max-width: 92px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

/* --- Add-provider catalog: full list, scrollable --- */
.vr-modal-provider-options {
  max-height: 46vh;
  overflow-y: auto;
  scrollbar-width: thin;
}

/* --- User messages: dark mission-input card (kills the white bubble) --- */
.vr-story-node.is-user .vr-chat-message.is-user {
  max-width: none;
  width: 100%;
  justify-self: stretch;
  justify-items: start;
  margin: 0;
  padding: 10px 14px 11px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(148, 163, 184, 0.050), rgba(148, 163, 184, 0.030));
  box-shadow: none;
}
.vr-story-node.is-user .vr-chat-message.is-user::before {
  content: 'Mission input';
  display: block;
  margin-bottom: 4px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: rgba(255, 233, 173, 0.7);
}
.vr-story-node.is-user .vr-chat-message.is-user > p {
  width: 100%;
  max-width: none;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: var(--vr-text);
  padding: 0;
}
.vr-story-node.is-user .vr-sent-context {
  max-width: none;
  justify-content: flex-start;
  margin-top: 8px;
}

/* --- Provider modal: mature pass --- */
.vr-modal-health {
  padding: 12px 14px;
}
.vr-modal-health strong {
  font-size: 14px;
}
.vr-modal-health b {
  font-size: 11px;
  font-weight: 650;
  letter-spacing: 0.04em;
  color: var(--vr-muted);
  border: 1px solid var(--vr-border);
  border-radius: 999px;
  padding: 4px 11px;
  white-space: nowrap;
}
.vr-modal-health.is-green b {
  color: var(--vr-green);
  border-color: rgba(34, 197, 94, 0.4);
}
.vr-modal-health.is-orange b {
  color: var(--vr-orange);
  border-color: rgba(249, 115, 22, 0.4);
}
.vr-modal-checks h3 {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.11em;
  text-transform: uppercase;
  color: var(--vr-muted);
}
.vr-modal-checks li {
  border: 1px solid rgba(148, 163, 184, 0.1);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.02);
}
.vr-modal-checks li.running,
.vr-modal-checks li.active {
  margin: 0;
  border: 1px solid rgba(148, 163, 184, 0.14);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.03);
}
.vr-modal-checks li > span {
  border-color: rgba(148, 163, 184, 0.35);
}
.vr-modal-checks li.done > span {
  border-color: #22c55e;
}
.vr-modal-checks li b {
  font-size: 11px;
  font-weight: 650;
  letter-spacing: 0.04em;
  padding: 3px 10px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 999px;
  color: var(--vr-muted);
  background: rgba(12, 13, 16, 0.6);
}
.vr-modal-checks li.done b {
  color: var(--vr-green);
  border-color: rgba(34, 197, 94, 0.4);
  background: rgba(34, 197, 94, 0.06);
}
.vr-modal-checks li.running b,
.vr-modal-checks li.active b {
  color: var(--vr-orange);
  border-color: rgba(249, 115, 22, 0.4);
  background: rgba(249, 115, 22, 0.06);
}
.vr-modal-foot {
  border-top: 1px solid rgba(148, 163, 184, 0.1);
  padding-top: 12px;
}

/* --- Modal: professional pass (calm surfaces, restrained glow) --- */
.vr-modal-card {
  border-color: rgba(148, 163, 184, 0.24);
  background: linear-gradient(180deg, rgba(16, 18, 23, 0.99), rgba(9, 10, 14, 0.995));
  box-shadow:
    0 0 0 1px rgba(148, 163, 184, 0.07),
    0 24px 80px rgba(0, 0, 0, 0.62);
  padding: 24px;
}
.vr-modal-card::before {
  display: none;
}
.vr-modal-mascot {
  width: 116px;
  max-height: 116px;
  align-self: end;
  filter: saturate(1.05) drop-shadow(0 0 16px rgba(0, 0, 0, 0));
  animation: none;
  opacity: 0.95;
}
.vr-modal-provider-head,
.vr-modal-release-head {
  border: 1px solid rgba(148, 163, 184, 0.12);
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(148, 163, 184, 0.050), rgba(148, 163, 184, 0.020));
  padding: 18px 22px;
  min-height: 0;
}
.vr-modal-provider-head::before,
.vr-modal-provider-head::after,
.vr-modal-release-head::before,
.vr-modal-release-head::after {
  display: none;
}
.vr-modal-provider-head h2,
.vr-modal-release-head h2 {
  font-size: 26px;
  letter-spacing: -0.01em;
}
.vr-modal-provider-head p {
  font-size: 12px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--vr-muted);
}
.vr-modal-button-row {
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
}
.vr-modal-footnote {
  margin: 14px 2px 0;
  font-size: 12px;
  color: var(--vr-muted);
}

/* ==========================================================================
   Clarity pass â€” purple budget + text strength.
   Rule: purple marks interactive/brand only. Surfaces are neutral dark.
   Green/orange/red are reserved for status.
   ========================================================================== */

/* Text strength: body copy reads near-white, muted is for captions only. */
.vr-chat-message p,
.vr-agent-answer-body p,
.vr-agent-answer-body li {
  color: rgba(244, 244, 245, 0.88);
}
.vr-agent-heading {
  color: var(--vr-text);
}

/* User mission card: neutral surface, purple reduced to a left accent. */
.vr-story-node.is-user .vr-chat-message.is-user {
  border: 1px solid rgba(148, 163, 184, 0.14);
  border-left: 3px solid rgba(232, 193, 90, 0.75);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.025);
}
.vr-story-node.is-user .vr-chat-message.is-user::before {
  color: var(--vr-muted);
}

/* Transcript cards: stronger mission input and richer agent output without adding noise. */
.vr-story-node.is-user .vr-chat-message.is-user {
  position: relative;
  min-height: 96px;
  padding: 18px 22px 18px 92px;
  overflow: hidden;
  border-left: 1px solid rgba(232, 193, 90, 0.78);
  border-color: rgba(148, 163, 184, 0.22);
  border-radius: 16px;
  background:
    radial-gradient(circle at 94% 18%, rgba(148, 163, 184, 0.050), transparent 170px),
    linear-gradient(135deg, rgba(19, 18, 33, 0.96), rgba(13, 15, 22, 0.94));
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035);
}

.vr-story-node.is-user .vr-chat-message.is-user::after {
  content: "";
  position: absolute;
  left: 22px;
  top: 22px;
  width: 46px;
  height: 46px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 14px;
  background:
    radial-gradient(circle at 50% 50%, rgba(255, 233, 173, 0.55) 0 3px, transparent 4px),
    radial-gradient(circle at 28% 30%, rgba(148, 163, 184, 0.050), transparent 18px),
    rgba(148, 163, 184, 0.050);
  box-shadow: 0 0 28px rgba(0, 0, 0, 0);
}

.vr-story-node.is-user .vr-chat-message.is-user::before {
  margin: 0 0 9px;
  color: #ffd76e;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.vr-story-node.is-user .vr-chat-message.is-user > p {
  color: #f8fafc;
  font-size: 18px;
  font-weight: 740;
  line-height: 1.28;
}

.vr-chat-agent-response {
  position: relative;
  width: min(980px, 100%);
  padding: 16px 18px;
  overflow: hidden;
  border: 1px solid rgba(34, 197, 94, 0.32);
  border-radius: 16px;
  background:
    radial-gradient(circle at 100% 0%, rgba(16, 185, 129, 0.12), transparent 210px),
    linear-gradient(135deg, rgba(7, 30, 28, 0.9), rgba(13, 16, 24, 0.94));
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

.vr-chat-agent-response.is-error {
  border-color: rgba(239, 68, 68, 0.38);
  background:
    radial-gradient(circle at 100% 0%, rgba(239, 68, 68, 0.12), transparent 210px),
    linear-gradient(135deg, rgba(20, 19, 24, 0.9), rgba(13, 16, 24, 0.94));
}

.vr-chat-agent-response > div:first-child {
  align-items: center;
  gap: 12px;
  padding-bottom: 10px;
}

.vr-chat-agent-response > div:first-child > span {
  width: 44px;
  height: 44px;
  border: 1px solid rgba(34, 197, 94, 0.28);
  border-radius: 999px;
  background: rgba(6, 78, 59, 0.22);
}

.vr-chat-agent-response.is-error > div:first-child > span {
  border-color: rgba(239, 68, 68, 0.35);
  background: rgba(127, 29, 29, 0.18);
}

.vr-chat-agent-response > div:first-child img {
  width: 54px;
  height: 54px;
  transform: translateY(7px);
}

.vr-chat-agent-response > div:first-child p strong {
  display: inline-block;
  color: #f8fafc;
  font-size: 18px;
  font-weight: 760;
}

.vr-chat-agent-response > div:first-child p em {
  color: #94a3b8;
}

.vr-chat-agent-response .vr-agent-context-line,
.vr-chat-agent-response .vr-agent-response-stack {
  margin-left: 56px;
}

.vr-chat-agent-response .vr-agent-answer-body {
  margin-top: 4px;
}

.vr-chat-agent-response .vr-agent-answer-body > p:first-child {
  color: #dbeafe;
  font-size: 15px;
}

/* Story rail: neutral line and dots; purple only marks the user's input. */
.vr-story-node::before {
  background: linear-gradient(180deg, rgba(148, 163, 184, 0.22), rgba(148, 163, 184, 0.04));
}
.vr-story-dot {
  border-color: rgba(148, 163, 184, 0.3);
  box-shadow: none;
  color: var(--vr-muted);
}
.vr-story-node.is-agent .vr-story-dot {
  color: rgba(226, 232, 240, 0.75);
}
.vr-story-node.is-user .vr-story-dot {
  border-color: rgba(232, 193, 90, 0.65);
  background: rgba(255, 255, 255, 0.04);
}

/* Agent responses: drop tint rings; state shows in the meta line, not the frame. */
.vr-chat-agent-response.is-ready {
  box-shadow: none;
}
.vr-chat-message.is-user {
  box-shadow: none;
}

/* Modal headers: neutral band, not a purple wash. */
.vr-modal-provider-head,
.vr-modal-release-head {
  background: rgba(255, 255, 255, 0.025);
}
.vr-modal-card {
  background: linear-gradient(180deg, rgba(15, 18, 28, 0.99), rgba(6, 8, 16, 0.995));
}

/* Provider detail panel: neutral surface; tone stays on the border only. */
.vr-provider-detail-panel {
  background: rgba(10, 14, 24, 0.85);
}
.vr-provider-detail-panel[data-provider-tone='green'],
.vr-provider-detail-panel[data-provider-tone='orange'],
.vr-provider-detail-panel[data-provider-tone='red'] {
  background: rgba(10, 14, 24, 0.85);
}

/* Composer: neutral until focused â€” then purple earns its place. */
.vr-chat-composer {
  border-color: rgba(148, 163, 184, 0.2);
}

/* Uppercase kickers: one consistent voice. */
.vr-modal-checks h3,
.vr-modal-provider-head p {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--vr-muted);
}

/* --- Architecture view --- */
.vr-studio-architecture {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  padding: 12px 14px;
  gap: 10px;
}
.vr-studio-architecture > header {
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-shrink: 0;
}
.vr-studio-architecture > header strong {
  font-size: 15px;
}
.vr-studio-architecture > header span {
  font-size: 12px;
  color: var(--vr-muted);
}
.vr-arch-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  border: 1px solid var(--vr-border);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.015);
  padding: 14px 16px;
  font-size: 13px;
  line-height: 1.55;
}
.vr-arch-empty {
  color: var(--vr-muted);
}
.vr-studio-architecture > footer {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
}
.vr-studio-architecture > footer button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border: 1px solid rgba(232, 193, 90, 0.5);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  color: var(--vr-text);
  font-weight: 600;
  cursor: pointer;
}
.vr-studio-architecture > footer button svg {
  width: 14px;
  height: 14px;
}

/* --- Start-here CTA --- */
.vr-start-here-cta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 8px 14px;
  border: 1px solid rgba(232, 193, 90, 0.55);
  border-radius: 999px;
  background: linear-gradient(135deg, rgba(148, 163, 184, 0.050), rgba(148, 163, 184, 0.050));
  color: var(--vr-text);
  font-weight: 600;
  cursor: pointer;
}
.vr-start-here-cta svg {
  width: 14px;
  height: 14px;
}

.vr-chat-intro-message {
  width: min(780px, 100%);
  max-width: min(780px, 100%);
}

.vr-chat-intro-message > div:first-child > p {
  display: flex;
  align-items: center;
  gap: 8px;
}

.vr-chat-intro-message > div:first-child > p strong {
  font-size: 14px;
}

.vr-chat-intro-message > div:first-child > p b {
  margin: 0;
  border-color: rgba(148, 163, 184, 0.22);
  background: rgba(255, 255, 255, 0.04);
  color: #ffe9ad;
  padding: 3px 8px;
  font-size: 11px;
}

.vr-chat-intro-message > div:first-child > p em.is-ready {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #86efac;
  font-size: 12px;
  font-weight: 650;
}

.vr-chat-intro-message > div:first-child > p em.is-ready::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #22c55e;
}

.vr-chat-intro-message > p {
  padding-left: 48px;
  color: #dbe3ee;
}

.vr-chat-intro-message > p strong {
  color: #f8fafc;
}

.vr-env-connect-card {
  width: min(690px, calc(100% - 48px));
  margin: 20px 0 0 48px;
  display: grid;
  gap: 12px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 16px;
  background:
    radial-gradient(circle at 76% 12%, rgba(148, 163, 184, 0.050), transparent 150px),
    linear-gradient(180deg, rgba(22, 24, 33, 0.82), rgba(15, 17, 24, 0.9));
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.03),
    0 14px 42px rgba(0, 0, 0, 0.24);
  padding: 18px;
}

.vr-env-connect-card header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.vr-env-connect-card header strong {
  color: #f8fafc;
  font-size: 16px;
  font-weight: 760;
}

.vr-env-connect-card > div {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 9px;
}

.vr-env-connect-option {
  min-width: 0;
  min-height: 48px;
  display: grid;
  grid-template-columns: 26px minmax(0, 1fr) auto;
  align-items: center;
  gap: 9px;
  border: 1px solid rgba(148, 163, 184, 0.13);
  border-radius: 10px;
  background: rgba(8, 12, 20, 0.34);
  color: #f4f4f5;
  padding: 9px 10px;
  text-align: left;
}

.vr-env-connect-option:hover {
  border-color: rgba(148, 163, 184, 0.22);
  background: rgba(255, 255, 255, 0.04);
}

.vr-env-connect-option > span {
  width: 26px;
  height: 26px;
  display: grid;
  place-items: center;
  color: #ffe9ad;
}

.vr-env-connect-option > span img,
.vr-env-connect-option > span svg {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.vr-env-connect-option strong {
  min-width: 0;
  overflow: hidden;
  color: #f8fafc;
  font-size: 13.5px;
  font-weight: 720;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr-env-connect-option b {
  margin: 0;
  border: 0;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.09);
  color: #cbd5e1;
  padding: 4px 9px;
  font-size: 11px;
  font-weight: 650;
  white-space: nowrap;
}

.vr-env-connect-option.is-disconnected b {
  background: rgba(255, 255, 255, 0.04);
  color: #ffe9ad;
}

.vr-env-connect-option.is-connected b {
  background: rgba(34, 197, 94, 0.12);
  color: #86efac;
}

/* Not in this repo. Same orange the provider cards use for "Not detected", so
   the panel and the card agree instead of contradicting each other. */
.vr-env-connect-option.is-absent b {
  background: rgba(148, 163, 184, 0.08);
  color: #94a3b8;
}

.vr-env-connect-option.is-absent > span {
  opacity: 0.5;
}

/* Gate chip is a button now â€” keep the pill look. */
button.vr-chat-gate-chip {
  cursor: pointer;
  background: rgba(12, 13, 16, 0.7);
  font: inherit;
  font-size: 11px;
}

/* --- Architecture graph --- */
.vr-arch-body.is-graph {
  padding: 0;
  overflow: auto;
  position: relative;
  background:
    radial-gradient(rgba(148, 163, 184, 0.07) 1px, transparent 1px);
  background-size: 26px 26px;
}
.vr-arch-canvas {
  position: relative;
}
.vr-arch-edges {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
.vr-arch-edges path {
  fill: none;
  stroke: rgba(148, 163, 184, 0.35);
  stroke-width: 1.5;
  stroke-dasharray: 5 4;
}
.vr-arch-node {
  position: absolute;
  left: 0;
  top: 0;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 9px;
  width: 168px;
  height: 56px;
  padding: 0 10px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 12px;
  background: rgba(14, 17, 26, 0.96);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  user-select: none;
  touch-action: manipulation;
  transition:
    border-color 150ms ease,
    background 150ms ease,
    box-shadow 150ms ease,
    transform 150ms ease;
}
.vr-arch-node:active {
  border-color: rgba(232, 193, 90, 0.6);
}
.vr-arch-node:hover,
.vr-arch-node.is-selected {
  border-color: rgba(255, 215, 110, 0.58);
  background:
    radial-gradient(circle at 100% 0%, rgba(148, 163, 184, 0.050), transparent 34px),
    rgba(16, 19, 29, 0.98);
  box-shadow:
    0 0 0 1px rgba(0, 0, 0, 0),
    0 12px 30px rgba(0, 0, 0, 0.38);
}
.vr-arch-node strong {
  display: block;
  font-size: 13px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vr-arch-node em {
  display: block;
  font-size: 10.5px;
  font-style: normal;
  color: var(--vr-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vr-arch-node-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid rgba(148, 163, 184, 0.25);
  border-radius: 50%;
  background: rgba(12, 13, 16, 0.9);
}
.vr-arch-node-icon svg {
  width: 14px;
  height: 14px;
}
.vr-arch-node-icon img {
  width: 14px;
  height: 14px;
}
.vr-arch-node-icon.is-core {
  color: rgba(255, 233, 173, 0.9);
  border-color: rgba(148, 163, 184, 0.22);
}
.vr-arch-node-icon[data-provider-tone='green'] { border-color: rgba(34, 197, 94, 0.5); }
.vr-arch-node-icon[data-provider-tone='orange'] { border-color: rgba(249, 115, 22, 0.5); }
.vr-arch-node-icon[data-provider-tone='red'] { border-color: rgba(239, 68, 68, 0.55); }
.vr-arch-node.is-provider {
  cursor: pointer;
}
.vr-arch-node-ask {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.04);
  color: rgba(255, 233, 173, 0.9);
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.12s ease;
}
.vr-arch-node:hover .vr-arch-node-ask {
  opacity: 1;
}
.vr-arch-node-ask svg {
  width: 12px;
  height: 12px;
}
.vr-studio-architecture > footer {
  gap: 8px;
}
.vr-studio-architecture > footer button {
  border: 1px solid var(--vr-border);
  background: rgba(255, 255, 255, 0.03);
  color: var(--vr-text);
  font-weight: 600;
  border-radius: 999px;
  padding: 8px 14px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.vr-studio-architecture > footer button.is-primary {
  border-color: rgba(232, 193, 90, 0.5);
  background: rgba(255, 255, 255, 0.04);
}

/* --- Launch signals (right panel) --- */
.vr-agent-signals {
  display: grid;
  gap: 8px;
}
.vr-agent-signals h3 {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--vr-muted);
}
.vr-signal-row {
  display: grid;
  grid-template-columns: 12px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  padding: 9px 11px;
  border: 1px solid var(--vr-border);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.02);
  color: var(--vr-text);
  text-align: left;
  cursor: pointer;
}
.vr-signal-row:hover {
  border-color: rgba(232, 193, 90, 0.5);
}
.vr-signal-row i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--vr-muted);
}
.vr-signal-row i.is-blocker { background: var(--vr-red); }
.vr-signal-row i.is-warn { background: var(--vr-orange); }
.vr-signal-row i.is-info { background: var(--vr-blue); }
.vr-signal-row strong {
  display: block;
  font-size: 12.5px;
  line-height: 1.25;
}
.vr-signal-row em {
  display: block;
  font-size: 11px;
  font-style: normal;
  color: var(--vr-muted);
  text-transform: capitalize;
}
.vr-signal-row b {
  font-size: 11px;
  font-weight: 650;
  padding: 3px 10px;
  border: 1px solid rgba(232, 193, 90, 0.5);
  border-radius: 999px;
  color: rgba(255, 233, 173, 0.95);
}
.vr-signal-empty {
  margin: 0;
  font-size: 12px;
  color: var(--vr-muted);
}

/* --- Simplified provider modal --- */
.vr-modal-health-line {
  margin: 2px 2px 0;
  font-size: 12.5px;
  color: var(--vr-muted);
}
.vr-modal-checks h3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.vr-checks-fix {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border: 1px solid rgba(232, 193, 90, 0.5);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  color: var(--vr-text);
  font-size: 11px;
  font-weight: 650;
  letter-spacing: 0.02em;
  text-transform: none;
  cursor: pointer;
}
.vr-checks-fix svg {
  width: 12px;
  height: 12px;
}

/* --- Release modal symmetry --- */
.vr-modal-release {
  width: min(820px, calc(100vw - 48px));
}
.vr-modal-two-col {
  align-items: stretch;
}
.vr-modal-release .vr-modal-two-col {
  grid-template-columns: minmax(0, 1.18fr) minmax(220px, 0.82fr);
}
.vr-modal-two-col > section {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--vr-border);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.02);
  padding: 14px 16px;
}
.vr-modal-two-col > section h3 {
  margin: 0 0 10px;
  font-size: 13px;
}
.vr-modal-two-col dl {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 6px 16px;
  margin: 0;
  font-size: 12.5px;
}
.vr-modal-two-col dt {
  color: var(--vr-muted);
}
.vr-modal-two-col dd {
  margin: 0;
  text-align: right;
  min-width: 0;
  overflow-wrap: anywhere;
}

@media (max-width: 860px) {
  .vr-modal-release .vr-modal-two-col {
    grid-template-columns: 1fr;
  }
}

/* --- Architecture graph: zones and guidance --- */
.vr-arch-zone {
  position: absolute;
  z-index: 1;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(148, 163, 184, 0.55);
  pointer-events: none;
}
.vr-arch-divider {
  position: absolute;
  left: 12px;
  right: 12px;
  height: 1px;
  background: linear-gradient(90deg, rgba(148, 163, 184, 0.18), rgba(148, 163, 184, 0.02));
  pointer-events: none;
}
.vr-arch-hint {
  position: absolute;
  right: 16px;
  top: 14px;
  z-index: 1;
  font-size: 11px;
  color: rgba(148, 163, 184, 0.6);
  pointer-events: none;
}
.vr-arch-node-ask {
  opacity: 0.5;
}

/* --- Worktree panel --- */
.vr-agent-worktree {
  display: grid;
  gap: 8px;
}
.vr-agent-worktree h3 {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--vr-muted);
}
.vr-branch-row {
  display: grid;
  grid-template-columns: 12px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  padding: 8px 11px;
  border: 1px solid var(--vr-border);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.02);
  color: var(--vr-text);
  text-align: left;
  cursor: pointer;
}
.vr-branch-row:hover {
  border-color: rgba(232, 193, 90, 0.5);
}
.vr-branch-row i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--vr-muted);
}
.vr-branch-row.is-current i {
  background: var(--vr-green);
  box-shadow: 0 0 8px rgba(34, 197, 94, 0.6);
}
.vr-branch-row strong {
  display: block;
  font-size: 12.5px;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vr-branch-row em {
  display: block;
  font-size: 11px;
  font-style: normal;
  color: var(--vr-muted);
}
.vr-branch-row b {
  font-size: 11px;
  font-weight: 650;
  padding: 3px 10px;
  border: 1px solid rgba(232, 193, 90, 0.5);
  border-radius: 999px;
  color: rgba(255, 233, 173, 0.95);
}
.vr-branch-row b.is-current {
  border-color: rgba(34, 197, 94, 0.4);
  color: var(--vr-green);
}

/* Apply Fix Plan: normal button, not a billboard. */
.vr-agent-panel .vr-glow-button {
  flex: 0 0 auto;
  min-height: 46px;
  max-height: 52px;
  margin-top: auto;
}

/* --- Architecture health overlay --- */
.vr-arch-node.has-health-red { border-color: rgba(239, 68, 68, 0.55); box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.08), 0 8px 24px rgba(0, 0, 0, 0.4); }
.vr-arch-node.has-health-orange { border-color: rgba(249, 115, 22, 0.5); box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.07), 0 8px 24px rgba(0, 0, 0, 0.4); }
.vr-arch-node-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  min-width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
}
.vr-arch-node-badge.is-red { background: var(--vr-red); }
.vr-arch-node-badge.is-orange { background: var(--vr-orange); }

/* --- Architecture drawer --- */
.vr-arch-drawer {
  position: absolute;
  top: 12px;
  right: 12px;
  bottom: 12px;
  width: 300px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 14px;
  background: rgba(10, 13, 22, 0.97);
  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.55);
  padding: 14px;
  overflow-y: auto;
  scrollbar-width: thin;
}
.vr-arch-drawer header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.vr-arch-drawer header strong { font-size: 14px; }
.vr-arch-drawer header button {
  display: inline-flex;
  border: 1px solid var(--vr-border);
  border-radius: 8px;
  background: transparent;
  color: var(--vr-muted);
  padding: 4px;
  cursor: pointer;
}
.vr-arch-drawer header button svg { width: 12px; height: 12px; }
.vr-arch-drawer ul {
  margin: 0;
  padding: 0 0 0 16px;
  font-size: 12px;
  line-height: 1.7;
  color: rgba(244, 244, 245, 0.85);
}
.vr-arch-drawer h4 {
  margin: 4px 0 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--vr-muted);
}
.vr-arch-drawer-gap {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 12px;
}
.vr-arch-drawer-gap i { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }
.vr-arch-drawer-gap.is-red i { background: var(--vr-red); }
.vr-arch-drawer-gap.is-orange i { background: var(--vr-orange); }
.vr-arch-drawer footer {
  margin-top: auto;
  display: flex;
  gap: 8px;
}
.vr-arch-drawer footer button {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 10px;
  border: 1px solid var(--vr-border);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.03);
  color: var(--vr-text);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.vr-arch-drawer footer button.is-primary {
  border-color: rgba(232, 193, 90, 0.5);
  background: rgba(255, 255, 255, 0.04);
}
.vr-arch-drawer footer button svg { width: 12px; height: 12px; }
.vr-arch-body.is-graph { position: relative; }
.vr-arch-node { cursor: pointer; }

/* --- Worktree rows: diff + merge split --- */
div.vr-branch-row {
  cursor: default;
}
.vr-branch-open {
  display: block;
  min-width: 0;
  border: 0;
  background: transparent;
  color: var(--vr-text);
  text-align: left;
  padding: 0;
  cursor: pointer;
}
.vr-branch-merge {
  font-size: 11px;
  font-weight: 650;
  padding: 3px 10px;
  border: 1px solid rgba(232, 193, 90, 0.5);
  border-radius: 999px;
  background: transparent;
  color: rgba(255, 233, 173, 0.95);
  cursor: pointer;
}
.vr-branch-merge:hover { background: rgba(255, 255, 255, 0.04); }
.vr-branch-row.is-dirty i { background: var(--vr-orange); box-shadow: 0 0 8px rgba(249, 115, 22, 0.6); }

/* --- Provider modal header: tight rhythm --- */
.vr-modal-provider-head {
  align-items: center;
  gap: 18px;
}
.vr-modal-provider-head > div {
  display: grid;
  gap: 5px;
  justify-items: start;
  align-content: center;
}
.vr-modal-provider-head h2 {
  margin: 0;
  line-height: 1.1;
}
.vr-modal-provider-head > div p {
  margin: 0;
}
.vr-modal-provider-orb svg {
  width: 22px;
  height: 22px;
  color: rgba(255, 233, 173, 0.9);
}

/* --- MCP panel: one clean status row --- */
.vr-provider-mcp-panel {
  border: 1px solid var(--vr-border);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.02);
  padding: 12px 14px;
}
.vr-provider-mcp-panel.is-connected {
  border-color: rgba(34, 197, 94, 0.3);
}
.vr-provider-mcp-panel header {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
}
.vr-provider-mcp-panel header > span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid rgba(34, 197, 94, 0.4);
  border-radius: 50%;
  background: rgba(34, 197, 94, 0.08);
  color: var(--vr-green);
}
.vr-provider-mcp-panel.is-disconnected header > span {
  border-color: var(--vr-border);
  background: rgba(255, 255, 255, 0.03);
  color: var(--vr-muted);
}
.vr-provider-mcp-panel header > span svg {
  width: 14px;
  height: 14px;
}
.vr-provider-mcp-panel header strong {
  display: block;
  font-size: 13px;
}
.vr-provider-mcp-panel header em {
  display: block;
  font-size: 11.5px;
  font-style: normal;
  color: var(--vr-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vr-provider-mcp-panel > div {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 9px;
}
.vr-provider-mcp-panel > div small {
  padding: 2px 9px;
  border: 1px solid var(--vr-border);
  border-radius: 999px;
  font-size: 10.5px;
  color: var(--vr-muted);
  background: rgba(12, 13, 16, 0.6);
}

/* --- Worktree panel: scrollable --- */
.vr-agent-worktree {
  max-height: 300px;
  overflow-y: auto;
  scrollbar-width: thin;
  padding-right: 2px;
}

/* --- Worktree modal: the tree --- */
.vr-wt-dirty {
  display: grid;
  grid-template-columns: 12px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  margin-top: 14px;
  padding: 12px 14px;
  border: 1px solid rgba(249, 115, 22, 0.35);
  border-radius: 12px;
  background: rgba(249, 115, 22, 0.06);
}
.vr-wt-dirty i {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--vr-orange);
  box-shadow: 0 0 10px rgba(249, 115, 22, 0.6);
}
.vr-wt-dirty strong { font-size: 13px; display: block; }
.vr-wt-dirty em { font-size: 11.5px; font-style: normal; color: var(--vr-muted); display: block; }
.vr-wt-dirty button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 13px;
  border: 1px solid rgba(249, 115, 22, 0.5);
  border-radius: 999px;
  background: rgba(249, 115, 22, 0.12);
  color: var(--vr-text);
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}
.vr-wt-dirty button svg { width: 12px; height: 12px; }
.vr-wt-tree {
  margin-top: 14px;
  position: relative;
}
.vr-wt-node {
  position: relative;
  display: grid;
  grid-template-columns: 26px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 11px 12px;
  border: 1px solid var(--vr-border);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.02);
  margin-bottom: 8px;
}
.vr-wt-node.is-trunk {
  border-color: rgba(148, 163, 184, 0.22);
  background: rgba(255, 255, 255, 0.04);
}
.vr-wt-node.is-current {
  border-color: rgba(34, 197, 94, 0.35);
}
.vr-wt-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid rgba(148, 163, 184, 0.5);
  background: rgba(12, 13, 16, 0.9);
  justify-self: center;
}
.vr-wt-node.is-trunk .vr-wt-dot {
  border-color: var(--vr-purple-2);
  background: rgba(255, 255, 255, 0.04);
}
.vr-wt-node.is-current .vr-wt-dot {
  border-color: var(--vr-green);
  background: rgba(34, 197, 94, 0.3);
}
.vr-wt-limbs {
  position: relative;
  margin-left: 24px;
}
.vr-wt-limbs::before {
  content: '';
  position: absolute;
  left: -11px;
  top: -8px;
  bottom: 18px;
  width: 1.5px;
  background: linear-gradient(180deg, rgba(148, 163, 184, 0.050), rgba(148, 163, 184, 0.1));
}
.vr-wt-limbs .vr-wt-node::before {
  content: '';
  position: absolute;
  left: -11px;
  top: 50%;
  width: 22px;
  height: 1.5px;
  background: rgba(148, 163, 184, 0.25);
}
.vr-wt-node strong {
  font-size: 13.5px;
  display: block;
}
.vr-wt-node strong b {
  margin-left: 8px;
  padding: 1px 8px;
  border: 1px solid rgba(34, 197, 94, 0.4);
  border-radius: 999px;
  font-size: 10px;
  font-weight: 650;
  color: var(--vr-green);
}
.vr-wt-node em {
  display: block;
  font-size: 11.5px;
  font-style: normal;
  color: var(--vr-muted);
}
.vr-wt-subject {
  opacity: 0.8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 380px;
}
.vr-wt-actions {
  display: flex;
  gap: 6px;
}
.vr-wt-actions button {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 11px;
  border: 1px solid var(--vr-border);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.03);
  color: var(--vr-text);
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
}
.vr-wt-actions button svg { width: 11px; height: 11px; }
.vr-wt-actions button.is-primary {
  border-color: rgba(232, 193, 90, 0.55);
  background: rgba(255, 255, 255, 0.04);
}
.vr-wt-actions button:hover { border-color: rgba(232, 193, 90, 0.6); }

/* --- Architecture drawer: control panel --- */
.vr-arch-drawer-blurb {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: rgba(244, 244, 245, 0.8);
}
.vr-arch-drawer-actions {
  display: grid;
  gap: 7px;
}
.vr-arch-drawer-actions button {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
  color: var(--vr-text);
  font-size: 12.5px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
}
.vr-arch-drawer-actions button:hover {
  border-color: rgba(232, 193, 90, 0.65);
  background: rgba(255, 255, 255, 0.04);
}
.vr-arch-drawer-actions button svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  color: rgba(255, 233, 173, 0.9);
}

/* ==========================================================================
   Professional pass v2 â€” flat, aligned, quiet.
   ========================================================================== */

/* Provider modal: flat header, no glow toys. */
.vr-modal-provider-orb {
  width: 46px;
  height: 46px;
  border: 1px solid rgba(148, 163, 184, 0.25);
  border-radius: 12px;
  box-shadow: none;
  background: rgba(255, 255, 255, 0.03);
}
.vr-modal-provider-orb[data-provider-tone='green'],
.vr-modal-provider-orb[data-provider-tone='orange'],
.vr-modal-provider-orb[data-provider-tone='red'] {
  box-shadow: none;
}
.vr-modal-provider-orb[data-provider-tone='green'] { border-color: rgba(34, 197, 94, 0.4); }
.vr-modal-provider-orb[data-provider-tone='orange'] { border-color: rgba(249, 115, 22, 0.4); }
.vr-modal-provider-orb[data-provider-tone='red'] { border-color: rgba(239, 68, 68, 0.4); }
.vr-modal-provider-orb img,
.vr-modal-provider-orb svg {
  width: 22px;
  height: 22px;
}
.vr-modal-provider-head {
  grid-template-columns: 46px minmax(0, 1fr) auto;
  gap: 14px;
  padding: 16px 18px;
  background: transparent;
  border: 1px solid rgba(148, 163, 184, 0.12);
}
.vr-modal-provider-head h2 {
  font-size: 20px;
  letter-spacing: -0.01em;
}
.vr-modal-card .vr-modal-provider-head p {
  color: var(--vr-muted);
  font-size: 10.5px;
}
.vr-modal-mascot {
  width: 76px;
  max-height: 76px;
  opacity: 0.85;
  filter: none;
}
.vr-modal-card {
  padding: 22px;
  border-radius: 18px;
}
/* MCP row: flat, no green wash. */
.vr-provider-mcp-panel,
.vr-provider-mcp-panel.is-connected {
  background: transparent;
  border-color: rgba(148, 163, 184, 0.14);
}
.vr-provider-mcp-panel header > span {
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: transparent;
}
.vr-provider-mcp-panel header > span svg { width: 13px; height: 13px; }
/* Action buttons: rectangles, not pills. */
.vr-modal-action-grid .vr-provider-ask-agent,
.vr-modal-action-grid > button,
.vr-modal-action-grid > a,
.vr-modal-button-row > button,
.vr-modal-button-row .vr-provider-ask-agent {
  border-radius: 10px;
  min-height: 40px;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid rgba(148, 163, 184, 0.2);
  background: rgba(255, 255, 255, 0.02);
  color: var(--vr-text);
}
.vr-modal-action-grid .vr-provider-ask-agent,
.vr-modal-button-row .vr-provider-ask-agent {
  border-color: rgba(232, 193, 90, 0.5);
  background: rgba(255, 255, 255, 0.04);
}
/* Checks: neutral circles. */
.vr-modal-checks li > span {
  width: 20px;
  height: 20px;
  border-width: 1.5px;
  border-color: rgba(148, 163, 184, 0.3);
}
.vr-modal-checks li.done > span::after {
  left: 5px;
  top: 3px;
  transform: scale(0.75) rotate(45deg);
}

/* Architecture drawer: status-first, neutral. */
.vr-arch-drawer {
  background: rgba(13, 16, 24, 0.98);
  border-color: rgba(148, 163, 184, 0.18);
}
.vr-arch-drawer-status {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 8px 11px;
  border-radius: 9px;
  font-size: 12.5px;
  font-weight: 600;
}
.vr-arch-drawer-status i { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.vr-arch-drawer-status.is-red { background: rgba(239, 68, 68, 0.08); color: #fca5a5; }
.vr-arch-drawer-status.is-red i { background: var(--vr-red); }
.vr-arch-drawer-status.is-orange { background: rgba(249, 115, 22, 0.08); color: #fdba74; }
.vr-arch-drawer-status.is-orange i { background: var(--vr-orange); }
.vr-arch-drawer-status.is-green { background: rgba(34, 197, 94, 0.07); color: #86efac; }
.vr-arch-drawer-status.is-green i { background: var(--vr-green); }
.vr-arch-drawer-actions button {
  border: 1px solid rgba(148, 163, 184, 0.18);
  background: rgba(255, 255, 255, 0.03);
}
.vr-arch-drawer-actions button:hover {
  border-color: rgba(232, 193, 90, 0.55);
  background: rgba(255, 255, 255, 0.04);
}

/* Map viewport + zoom (Google-Maps feel). */
.vr-arch-viewport {
  position: absolute;
  inset: 0;
  overflow: auto;
  scrollbar-width: thin;
}
.vr-arch-body.is-graph {
  overflow: hidden;
}
.vr-arch-canvas {
  transform-origin: 0 0;
}
.vr-arch-zoom {
  position: absolute;
  left: 14px;
  bottom: 14px;
  z-index: 3;
  display: inline-flex;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 10px;
  background: rgba(12, 15, 24, 0.95);
  overflow: hidden;
}
.vr-arch-zoom button {
  min-width: 34px;
  padding: 7px 10px;
  border: 0;
  background: transparent;
  color: var(--vr-text);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.vr-arch-zoom button + button {
  border-left: 1px solid rgba(148, 163, 184, 0.16);
}
.vr-arch-zoom button:hover { background: rgba(255, 255, 255, 0.06); }

/* Worktree: no dead gap; the list fills the panel. */
.vr-agent-worktree {
  flex: 1;
  min-height: 0;
  max-height: none;
  align-content: start;
}
.vr-agent-panel .vr-glow-button {
  margin-top: 12px;
}

/* Worktree modal: map-like tree canvas. */
.vr-wt-tree {
  padding: 16px 14px;
  border: 1px solid rgba(148, 163, 184, 0.12);
  border-radius: 14px;
  background:
    radial-gradient(rgba(148, 163, 184, 0.07) 1px, transparent 1px);
  background-size: 26px 26px;
}
.vr-wt-limbs::before {
  left: -12px;
  top: -10px;
  bottom: 26px;
  width: 2px;
  background: linear-gradient(180deg, rgba(232, 193, 90, 0.55), rgba(148, 163, 184, 0.12));
}
.vr-wt-limbs .vr-wt-node::before {
  left: -12px;
  top: -12px;
  width: 24px;
  height: calc(50% + 12px);
  background: transparent;
  border-left: 2px solid rgba(148, 163, 184, 0.22);
  border-bottom: 2px solid rgba(148, 163, 184, 0.22);
  border-bottom-left-radius: 12px;
}
.vr-wt-node {
  background: rgba(14, 17, 26, 0.96);
}

/* --- Worktree canvas: the actual tree --- */
.vr-wt-canvas {
  position: relative;
  margin-top: 14px;
  border: 1px solid rgba(148, 163, 184, 0.12);
  border-radius: 14px;
  background: radial-gradient(rgba(148, 163, 184, 0.07) 1px, transparent 1px);
  background-size: 26px 26px;
  overflow-x: auto;
  overflow-y: hidden;
}
.vr-wt-edges {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
.vr-wt-edges path {
  fill: none;
  stroke: rgba(148, 163, 184, 0.32);
  stroke-width: 1.6;
  stroke-dasharray: 5 4;
}
.vr-wt-edges path.is-current {
  stroke: rgba(34, 197, 94, 0.55);
  stroke-dasharray: none;
}
.vr-wt-cnode {
  position: absolute;
  left: 0;
  top: 0;
  display: grid;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 12px;
  background: rgba(14, 17, 26, 0.97);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}
.vr-wt-cnode.is-trunk {
  grid-template-columns: 16px minmax(0, 1fr) auto;
  width: 190px;
  border-color: rgba(232, 193, 90, 0.5);
  background: rgba(19, 15, 34, 0.97);
}
.vr-wt-cnode.is-trunk > button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.04);
  color: rgba(255, 233, 173, 0.9);
  cursor: pointer;
}
.vr-wt-cnode.is-trunk > button svg { width: 12px; height: 12px; }
.vr-wt-cnode.is-branch {
  grid-template-columns: 16px minmax(0, 1fr) auto;
  width: 470px;
}
.vr-wt-cnode.is-current {
  border-color: rgba(34, 197, 94, 0.45);
}
.vr-wt-cnode strong { font-size: 13px; display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.vr-wt-cnode em { display: block; font-size: 11px; font-style: normal; color: var(--vr-muted); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.vr-wt-cnode .vr-wt-subject { max-width: 220px; opacity: 0.8; }
.vr-wt-cnode .vr-wt-actions button { padding: 5px 9px; font-size: 11px; }

/* Checks: kill the last purple tint on every state. */
.vr-modal-checks li.pending,
.vr-modal-checks li.active,
.vr-modal-checks li.running,
.vr-modal-checks li.done {
  margin: 0;
  border: 1px solid rgba(148, 163, 184, 0.12);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.02);
}
.vr-modal-checks li.pending > span,
.vr-modal-checks li.active > span,
.vr-modal-checks li.running > span {
  border-color: rgba(148, 163, 184, 0.32);
  background: transparent;
  box-shadow: none;
}
.vr-modal-health-line {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 4px 2px 0;
}

/* ==========================================================================
   Global calm pass â€” flat surfaces, one quiet accent, breathing room.
   ========================================================================== */

/* raven deck: the crimson room — fire glows + coarse gold screentone,
   painted once as body background layers (no extra composited layers).
   PERF: tiles stay >= 22px and no backdrop-filter, ever. */
body {
  /* manga skin: clean ink base. The full-bleed speed-line art was removed —
     it read as disconnected wallpaper behind the chat. Just a fine screentone
     dot grid + a faint gold glow at the top edge. */
  background-color: #0a0a0d;
  background-image:
    radial-gradient(circle, rgba(255, 255, 255, 0.035) 1.2px, transparent 1.5px),
    radial-gradient(ellipse 72% 46% at 50% -6%, rgba(232, 193, 90, 0.05), transparent 62%);
  background-size: 24px 24px, 100% 100%;
  background-position: 0 0, center;
  background-repeat: repeat, no-repeat;
  /* scroll, not fixed: body never scrolls (overflow:hidden) so it looks
     identical, and fixed-attachment on the large art stalls headless capture. */
  background-attachment: scroll, scroll, scroll;
}

/* Glow buttons become solid, quiet primaries. */
.vr-glow-button {
  box-shadow: none !important;
  background: #e8c15a;
  border: 1px solid rgba(232, 193, 90, 0.6);
}
.vr-glow-button i {
  display: none;
}
.vr-glow-button:hover {
  background: #e8c15a;
}
.vr-glow-button[data-tone='green'] {
  background: rgba(34, 197, 94, 0.16);
  border-color: rgba(34, 197, 94, 0.45);
}
.vr-new-chat-button {
  box-shadow: none;
}

/* Provider cards: status whispers, doesn't shout. */
.vr-provider-card div em {
  font-size: 11px;
  font-weight: 500;
}

/* One shadow language everywhere: soft, dark, no colored halos. */
.vr-agent-hero,
.vr-providers-panel,
.vr-releases-panel,
.vr-studio-dock,
.vr-agent-panel {
  box-shadow: none;
}

/* Density: smaller monitors get a uniformly scaled-down UI instead of overlap. */
@media (max-width: 1680px) {
  body { zoom: 0.93; }
}
@media (max-width: 1440px) {
  body { zoom: 0.87; }
}
@media (max-width: 1280px) {
  body { zoom: 0.8; }
}

/* Mid-size screens: shed the chat rail, stack the inventory. */
@media (max-width: 1360px) {
  .vr-recent-rail {
    display: none;
  }
  .vr-composition-body {
    grid-template-columns: minmax(0, 1fr) minmax(300px, 340px);
  }
  .vr-bottom-inventory {
    grid-template-columns: 1fr;
  }
}

/* Provider popup checks: identical geometry for every row state. */
.vr-modal-checks li,
.vr-modal-checks li.pending,
.vr-modal-checks li.active,
.vr-modal-checks li.running,
.vr-modal-checks li.done {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  min-height: 52px;
  margin: 0 0 6px;
  padding: 6px 14px;
}
.vr-modal-checks li > span,
.vr-modal-checks li.pending > span,
.vr-modal-checks li.active > span,
.vr-modal-checks li.running > span,
.vr-modal-checks li.done > span {
  width: 20px;
  height: 20px;
  justify-self: center;
}
.vr-modal-health-line {
  flex-wrap: wrap;
  align-items: center;
  line-height: 1.4;
  font-size: 12.5px;
}
.vr-modal-health-line .vr-modal-pill {
  flex-shrink: 0;
}
.vr-mcp-connect-btn {
  border: 1px solid rgba(232, 193, 90, 0.5);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  color: var(--vr-text);
  font-size: 12px;
  font-weight: 600;
  padding: 6px 14px;
  cursor: pointer;
}

/* Provider modal: calm cockpit treatment. */
.vr-modal-provider {
  width: min(860px, calc(100vw - 48px));
}
.vr-modal-provider .vr-modal-mascot {
  display: none;
}
.vr-modal-provider-head {
  grid-template-columns: 48px minmax(0, 1fr);
  min-height: 0;
  border-color: rgba(148, 163, 184, 0.14);
  background: rgba(255, 255, 255, 0.018);
}
.vr-modal-provider-head h2 {
  font-size: 22px;
}
.vr-modal-provider-head .vr-status-badge {
  margin-left: 8px;
}
.vr-provider-mcp-panel,
.vr-provider-mcp-panel.is-connected,
.vr-provider-mcp-panel.is-disconnected {
  border-color: rgba(148, 163, 184, 0.14);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.018);
  box-shadow: none;
}
.vr-provider-mcp-panel header {
  grid-template-columns: 34px minmax(0, 1fr) auto;
}
.vr-provider-mcp-panel header > span {
  width: 32px;
  height: 32px;
  border-color: rgba(148, 163, 184, 0.18);
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.025);
  color: #aeb9ca;
}
.vr-provider-mcp-panel.is-connected header > span {
  border-color: rgba(34, 197, 94, 0.24);
  background: rgba(34, 197, 94, 0.06);
  color: #86efac;
}
.vr-provider-mcp-panel header small {
  display: block;
  margin-bottom: 2px;
  color: #8f9bad;
  font-size: 10.5px;
  font-weight: 750;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.vr-provider-mcp-panel header strong {
  color: #f4f4f5;
  font-size: 13.5px;
}
.vr-provider-mcp-panel header em {
  margin-top: 2px;
  color: #9ca3af;
  font-size: 12px;
}
.vr-provider-mcp-panel > div small {
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.025);
  color: #aeb9ca;
}
.vr-mcp-connect-btn {
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.025);
  color: #e5e7eb;
}
.vr-mcp-connect-btn:hover {
  border-color: rgba(148, 163, 184, 0.22);
  background: rgba(255, 255, 255, 0.04);
}
.vr-composer-controls .vr-model-picker > button:nth-child(4) {
  min-width: 158px;
  max-width: 178px;
}
.vr-composer-controls .vr-model-picker > button:nth-child(4) strong {
  max-width: 132px;
}

/* Quickstart */
.vr-qs-steps {
  display: grid;
  gap: 8px;
  margin-top: 16px;
}
.vr-qs-step {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  padding: 13px 16px;
  border: 1px solid rgba(148, 163, 184, 0.14);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.02);
}
.vr-qs-step.is-done {
  opacity: 0.72;
}
.vr-qs-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid rgba(148, 163, 184, 0.3);
  border-radius: 50%;
  font-size: 13px;
  font-weight: 700;
  color: var(--vr-muted);
}
.vr-qs-step.is-done .vr-qs-num {
  border-color: rgba(34, 197, 94, 0.5);
  color: var(--vr-green);
}
.vr-qs-num svg { width: 13px; height: 13px; }
.vr-qs-step strong { display: block; font-size: 14px; }
.vr-qs-step em { display: block; font-size: 12px; font-style: normal; color: var(--vr-muted); }
.vr-qs-step > b {
  font-size: 11px;
  font-weight: 650;
  color: var(--vr-green);
  border: 1px solid rgba(34, 197, 94, 0.4);
  border-radius: 999px;
  padding: 3px 11px;
}
.vr-qs-step > button {
  border: 1px solid rgba(232, 193, 90, 0.55);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  color: var(--vr-text);
  font-size: 12.5px;
  font-weight: 650;
  padding: 7px 16px;
  cursor: pointer;
}
.vr-qs-step > button:hover { background: rgba(255, 255, 255, 0.04); }
.vr-qs-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 16px;
}
.vr-qs-foot button {
  border: 0;
  background: transparent;
  color: var(--vr-muted);
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
}
.vr-qs-foot span { font-size: 12px; color: var(--vr-muted); }

/* --- Claude-style composer: one + button, actions on demand, air. --- */
.vr-chat-plus {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 1px solid rgba(148, 163, 184, 0.25);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.03);
  color: var(--vr-muted);
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, transform 0.12s ease;
}
.vr-chat-plus:hover {
  border-color: rgba(232, 193, 90, 0.55);
  color: var(--vr-text);
}
.vr-chat-plus.is-open {
  border-color: rgba(232, 193, 90, 0.55);
  color: var(--vr-text);
  transform: rotate(0deg);
}
.vr-chat-plus svg {
  width: 14px;
  height: 14px;
}
.vr-chat-inline-actions.is-collapsed {
  overflow: visible;
  padding: 6px 0 10px;
}
.vr-chat-inline-actions {
  align-items: center;
}

/* Breathing room in the chat lane. */
.vr-chat-transcript {
  padding: 14px 16px 10px;
}
.vr-chat-command-bar {
  gap: 8px;
  padding: 10px 14px 14px;
}
.vr-chat-command-bar > .vr-chat-composer {
  border-radius: 18px;
  padding: 14px 16px;
}

/* --- Clean chat canvas correction: sidebars are commands, inspector opens on demand. --- */
.vr-composed-shell {
  grid-template-rows: 52px minmax(0, 1fr);
}

.vr-bottom-tip-bar {
  display: none;
}

.vr-composition-body,
.vr-composition-body.has-inspector {
  grid-template-columns: 248px minmax(0, 1fr);
  gap: 10px;
  padding: 10px;
}

.vr-composition-body.has-inspector {
  grid-template-columns: 248px minmax(0, 1fr) clamp(460px, 31vw, 620px);
}

.vr-composition-body.has-inspector.inspector-expanded {
  grid-template-columns: 248px minmax(760px, 0.95fr) minmax(640px, 0.8fr);
}

.vr-left-context-rail {
  grid-template-rows: auto minmax(0, 1fr);
}

.vr-left-context-rail .vr-releases-panel,
.vr-context-rail,
.vr-agent-panel,
.vr-providers-panel {
  display: none;
}

.vr-left-context-rail .vr-recent-rail {
  border-color: rgba(148, 163, 184, 0.12);
  background: rgba(17, 19, 23, 0.72);
}

.vr-rail-launchers {
  display: grid;
  gap: 7px;
  border: 1px solid rgba(148, 163, 184, 0.12);
  border-radius: 12px;
  background: rgba(17, 19, 23, 0.72);
  padding: 8px;
}

.vr-rail-launcher {
  min-width: 0;
  min-height: 44px;
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) 10px;
  align-items: center;
  gap: 9px;
  border: 1px solid transparent;
  border-radius: 9px;
  background: transparent;
  color: #f4f4f5;
  padding: 7px 8px;
  text-align: left;
}

.vr-rail-launcher:hover {
  border-color: rgba(148, 163, 184, 0.18);
  background: rgba(255, 255, 255, 0.035);
}

.vr-rail-launcher i[data-icon] {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.03);
  color: #cbd5e1;
}

.vr-rail-launcher i[data-icon] svg {
  width: 14px;
  height: 14px;
}

.vr-rail-launcher strong,
.vr-rail-launcher em {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr-rail-launcher strong {
  font-size: 12.5px;
  line-height: 1.2;
}

.vr-rail-launcher em {
  color: var(--vr-muted);
  font-size: 11px;
  font-style: normal;
  line-height: 1.25;
}

.vr-rail-launcher b {
  width: 7px;
  height: 7px;
  border-right: 1.5px solid #717987;
  border-bottom: 1.5px solid #717987;
  transform: rotate(-45deg);
}

.vr-main-canvas,
.vr-studio-dock {
  min-height: 0;
}

.vr-studio-dock {
  border-color: rgba(148, 163, 184, 0.1);
  background: rgba(15, 17, 21, 0.58);
  padding: 8px;
}

.vr-studio-head {
  padding: 4px 4px 0;
}

.vr-studio-body {
  min-height: 0;
}

.vr-studio-chat {
  border-color: rgba(148, 163, 184, 0.09);
  background: rgba(12, 14, 18, 0.54);
}

.vr-studio-chat:not(.is-split) .vr-chat-transcript {
  padding: clamp(18px, 3vh, 34px) clamp(24px, 5vw, 76px) 24px;
}

.vr-studio-chat:not(.is-split) .vr-chat-message,
.vr-studio-chat:not(.is-split) .vr-chat-mission-summary {
  max-width: min(920px, 100%);
}

.vr-studio-chat:not(.is-split) .vr-chat-message.is-agent {
  max-width: min(900px, 100%);
}

.vr-studio-chat:not(.is-split) .vr-chat-command-bar {
  padding: 8px clamp(20px, 5vw, 70px) 12px;
}

.vr-studio-chat:not(.is-split) .vr-chat-command-bar > .vr-chat-composer {
  min-height: 112px;
  border-radius: 18px;
  border-color: rgba(148, 163, 184, 0.16);
  background: #202124;
}

.vr-inspector-panel {
  min-width: 0;
  min-height: 0;
  height: 100%;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  border: 1px solid rgba(148, 163, 184, 0.14);
  border-radius: 13px;
  background: rgba(17, 19, 23, 0.86);
  overflow: hidden;
}

.vr-inspector-head {
  min-height: 52px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 32px 32px;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.1);
  padding: 8px 10px 8px 14px;
}

.vr-inspector-head strong,
.vr-inspector-head span {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr-inspector-head strong {
  font-size: 13.5px;
}

.vr-inspector-head span {
  color: var(--vr-muted);
  font-size: 11.5px;
}

.vr-inspector-head button {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(148, 163, 184, 0.15);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.03);
  color: #cbd5e1;
}

.vr-inspector-body {
  min-height: 0;
  overflow: auto;
  padding: 8px;
  scrollbar-width: thin;
}

.vr-inspector-body .vr-studio-architecture,
.vr-inspector-body .vr-studio-terminal,
.vr-inspector-body .vr-studio-diff {
  height: 100%;
  min-height: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
}

.vr-inspector-body .vr-studio-architecture > header {
  grid-template-columns: 1fr;
  gap: 4px;
  padding: 10px 12px;
  border: 1px solid rgba(148, 163, 184, 0.12);
  border-radius: 12px;
  background:
    radial-gradient(circle at 100% 0%, rgba(148, 163, 184, 0.050), transparent 32%),
    rgba(255, 255, 255, 0.025);
}

.vr-inspector-body .vr-studio-architecture > header strong {
  font-size: 17px;
}

.vr-inspector-body .vr-arch-body {
  border-radius: 12px;
  border-color: rgba(148, 163, 184, 0.12);
  background-color: rgba(9, 12, 18, 0.78);
}

.vr-inspector-body .vr-studio-architecture > footer {
  justify-content: start;
  overflow-x: auto;
}

.vr-inspector-body .vr-studio-architecture.is-inspector-map {
  padding: 0;
  gap: 10px;
}

.vr-inspector-body .vr-studio-architecture.is-inspector-map > header {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  padding: 12px 14px;
}

.vr-inspector-body .vr-studio-architecture.is-inspector-map > header span {
  max-width: 40ch;
}

.vr-inspector-body .vr-studio-architecture.is-inspector-map .vr-arch-body {
  min-height: 0;
  border-radius: 14px;
  overflow: hidden;
}

.vr-inspector-body .vr-studio-architecture.is-inspector-map .vr-arch-viewport {
  inset: 0;
  overflow: auto;
  padding: 0;
}

.vr-inspector-body .vr-studio-architecture.is-inspector-map .vr-arch-canvas {
  transform-origin: 0 0;
}

.vr-inspector-body .vr-studio-architecture.is-inspector-map .vr-arch-node {
  width: 168px;
  height: 54px;
  border-radius: 11px;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.28);
}

.vr-inspector-body .vr-studio-architecture.is-inspector-map .vr-arch-node strong {
  font-size: 12px;
}

.vr-inspector-body .vr-studio-architecture.is-inspector-map .vr-arch-node em {
  font-size: 10px;
}

.vr-inspector-body .vr-studio-architecture.is-inspector-map .vr-arch-hint {
  display: none;
}

.vr-inspector-body .vr-studio-architecture.is-inspector-map .vr-arch-zone {
  color: rgba(255, 233, 173, 0.66);
}

.vr-inspector-body .vr-studio-architecture.is-inspector-map .vr-arch-zoom {
  left: 12px;
  right: auto;
  bottom: 12px;
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.34);
}

.vr-inspector-body .vr-studio-architecture.is-inspector-map > footer {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  overflow: visible;
}

.vr-inspector-body .vr-studio-architecture.is-inspector-map > footer button {
  justify-content: center;
  min-width: 0;
  padding-inline: 10px;
}

.vr-inspector-card {
  min-height: 0;
  display: grid;
  gap: 10px;
}

.vr-inspector-hero {
  position: relative;
  min-height: 112px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 88px;
  align-items: center;
  gap: 12px;
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.14);
  border-radius: 13px;
  background:
    radial-gradient(circle at 90% 42%, rgba(148, 163, 184, 0.050), transparent 34%),
    linear-gradient(180deg, rgba(30, 33, 42, 0.78), rgba(18, 20, 27, 0.82));
  padding: 14px 16px;
}

.vr-inspector-hero p,
.vr-inspector-hero h3,
.vr-inspector-hero em {
  margin: 0;
}

.vr-inspector-hero p {
  color: #b794f6;
  font-size: 11px;
  font-weight: 800;
}

.vr-inspector-hero h3 {
  margin-top: 5px;
  font-size: 24px;
  line-height: 1.05;
}

.vr-inspector-hero em {
  display: block;
  margin-top: 7px;
  color: #cbd5e1;
  font-size: 12.5px;
  font-style: normal;
  line-height: 1.35;
}

.vr-inspector-hero img {
  width: 86px;
  height: 86px;
  object-fit: contain;
  object-position: bottom;
  filter: saturate(1.16) drop-shadow(0 0 20px rgba(0, 0, 0, 0));
}

.vr-inspector-provider-grid,
.vr-inspector-release-list,
.vr-inspector-branch-list,
.vr-inspector-changelog {
  display: grid;
  gap: 8px;
}

.vr-inspector-provider-row,
.vr-inspector-release-list button,
.vr-inspector-branch-list > div,
.vr-inspector-changelog button {
  min-width: 0;
  display: grid;
  align-items: center;
  gap: 10px;
  border: 1px solid rgba(148, 163, 184, 0.13);
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.025);
  color: #f4f4f5;
  padding: 10px 12px;
  text-align: left;
}

.vr-inspector-provider-row {
  grid-template-columns: 34px minmax(0, 1fr) auto;
}

.vr-inspector-provider-row:hover,
.vr-inspector-release-list button:hover,
.vr-inspector-branch-list > div:hover,
.vr-inspector-changelog button:hover {
  border-color: rgba(148, 163, 184, 0.22);
  background: rgba(255, 255, 255, 0.04);
}

.vr-inspector-provider-row span,
.vr-inspector-release-list span,
.vr-inspector-branch-list span {
  min-width: 0;
}

.vr-inspector-provider-row strong,
.vr-inspector-provider-row em,
.vr-inspector-provider-row small,
.vr-inspector-release-list strong,
.vr-inspector-release-list em,
.vr-inspector-release-list small,
.vr-inspector-branch-list strong,
.vr-inspector-branch-list em,
.vr-inspector-changelog strong,
.vr-inspector-changelog span,
.vr-inspector-changelog em {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr-inspector-provider-row small {
  color: #ffd76e;
  font-size: 10px;
  font-weight: 760;
}

.vr-inspector-provider-row strong,
.vr-inspector-release-list strong,
.vr-inspector-branch-list strong {
  font-size: 13px;
}

.vr-inspector-provider-row em,
.vr-inspector-release-list em,
.vr-inspector-release-list small,
.vr-inspector-branch-list em,
.vr-inspector-changelog em {
  color: var(--vr-muted);
  font-size: 11px;
  font-style: normal;
}

.vr-inspector-section {
  display: grid;
  gap: 8px;
  border: 1px solid rgba(148, 163, 184, 0.12);
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.018);
  padding: 10px;
}

.vr-inspector-section > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.vr-inspector-section > header strong {
  font-size: 12px;
}

.vr-inspector-section > header button,
.vr-inspector-footer button,
.vr-inspector-branch-list button {
  min-height: 30px;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.03);
  color: #f4f4f5;
  padding: 0 10px;
  font-size: 11.5px;
  font-weight: 650;
}

.vr-inspector-release-list button {
  grid-template-columns: minmax(0, 1fr) auto;
}

.vr-inspector-release-list button.is-selected {
  border-color: rgba(148, 163, 184, 0.22);
  background: rgba(255, 255, 255, 0.04);
}

.vr-inspector-compare {
  min-height: 58px;
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  grid-template-rows: auto auto;
  align-items: center;
  gap: 0 10px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.04);
  color: #f4f4f5;
  padding: 10px 13px;
  text-align: left;
}

.vr-inspector-compare i {
  grid-row: 1 / span 2;
}

.vr-inspector-compare span {
  color: #ffe9ad;
  font-size: 12px;
  font-weight: 760;
}

.vr-inspector-compare strong {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}

.vr-inspector-changelog {
  max-height: 320px;
  overflow: auto;
  padding-right: 2px;
  scrollbar-width: thin;
}

.vr-inspector-changelog button {
  grid-template-columns: 74px minmax(0, 1fr);
  grid-template-rows: auto auto;
}

.vr-inspector-changelog em {
  grid-column: 2;
}

.vr-inspector-branch-list > div {
  grid-template-columns: minmax(0, 1fr) auto;
}

.vr-inspector-branch-list > div.is-current {
  border-color: rgba(34, 197, 94, 0.3);
}

.vr-inspector-branch-list > div > div {
  display: inline-flex;
  gap: 6px;
}

.vr-inspector-warning {
  display: grid;
  grid-template-columns: 10px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  border: 1px solid rgba(249, 115, 22, 0.32);
  border-radius: 12px;
  background: rgba(249, 115, 22, 0.07);
  padding: 10px 12px;
}

.vr-inspector-warning > i {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--vr-orange);
}

.vr-inspector-warning strong,
.vr-inspector-warning em {
  display: block;
}

.vr-inspector-warning em {
  color: var(--vr-muted);
  font-size: 11px;
  font-style: normal;
}

.vr-inspector-footer {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.vr-inspector-footer button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.vr-inspector-empty {
  margin: 0;
  color: var(--vr-muted);
  font-size: 12px;
  line-height: 1.45;
}

@media (max-width: 1180px) {
  .vr-composition-body,
  .vr-composition-body.has-inspector {
    grid-template-columns: 1fr;
    grid-template-areas:
      "main"
      "inspector"
      "left";
  }
  .vr-left-context-rail {
    grid-area: left;
    grid-template-columns: 1fr;
    grid-template-rows: auto minmax(220px, 360px);
  }
  .vr-inspector-panel {
    grid-area: inspector;
    height: min(560px, 72dvh);
  }
}

@media (max-width: 760px) {
  .vr-composed-shell {
    grid-template-rows: auto minmax(0, 1fr);
  }
  .vr-main-canvas {
    height: 72dvh;
    min-height: 560px;
  }
  .vr-studio-head-actions {
    gap: 6px;
  }
  .vr-studio-tabs button {
    padding: 0 10px;
  }
  .vr-studio-chat:not(.is-split) .vr-chat-command-bar {
    padding: 8px;
  }
  .vr-studio-chat:not(.is-split) .vr-chat-command-bar > .vr-chat-composer {
    min-height: 112px;
  }
}

/* --- Premium composer surface --- */
.vr-chat-command-bar {
  border-top: 0;
  background: linear-gradient(180deg, rgba(10, 12, 17, 0), rgba(10, 12, 17, 0.86) 24%);
}

.vr-chat-command-bar > .vr-chat-composer {
  position: relative;
  min-height: 182px;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto minmax(58px, 1fr) auto auto auto;
  gap: 14px;
  align-items: stretch;
  overflow: visible;
  border: 1px solid rgba(255, 215, 110, 0.66);
  border-radius: 22px;
  background:
    radial-gradient(circle at 94% 84%, rgba(148, 163, 184, 0.050), transparent 110px),
    radial-gradient(circle at 12% 0%, rgba(148, 163, 184, 0.050), transparent 210px),
    linear-gradient(180deg, rgba(22, 25, 35, 0.96), rgba(13, 16, 24, 0.98));
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.04),
    inset 0 0 0 1px rgba(255, 255, 255, 0.025),
    0 0 0 1px rgba(0, 0, 0, 0),
    0 18px 60px rgba(0, 0, 0, 0.38);
  padding: 18px 20px;
}

.vr-chat-command-bar > .vr-chat-composer::before {
  content: "";
  position: absolute;
  left: 24px;
  right: 24px;
  top: 70px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.18), transparent);
  pointer-events: none;
}

.vr-composer-top,
.vr-composer-bottom,
.vr-composer-controls {
  min-width: 0;
  display: flex;
  align-items: center;
}

.vr-composer-top {
  justify-content: flex-start;
}

.vr-composer-scope-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.vr-composer-scope {
  height: 42px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
  color: #f8fafc;
  padding: 0 13px;
  font-size: 13px;
  font-weight: 740;
  transition: border-color 0.14s ease, background 0.14s ease, transform 0.14s ease;
}

.vr-composer-scope:hover {
  border-color: rgba(255, 233, 173, 0.52);
  background: rgba(255, 255, 255, 0.04);
  transform: translateY(-1px);
}

.vr-composer-scope i[data-icon] {
  width: 18px;
  height: 18px;
  color: #ffe9ad;
}

.vr-composer-scope i[data-icon] svg {
  width: 18px;
  height: 18px;
}

.vr-composer-scope > i:not([data-icon]) {
  width: 8px;
  height: 8px;
  border-right: 1.5px solid #9ca3af;
  border-bottom: 1.5px solid #9ca3af;
  transform: rotate(45deg) translateY(-2px);
  margin-left: 4px;
}

.vr-scope-menu {
  position: absolute;
  left: 0;
  bottom: calc(100% + 8px);
  z-index: 22;
  width: 212px;
  display: grid;
  gap: 3px;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 12px;
  background: rgba(16, 18, 24, 0.98);
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.44);
  padding: 8px;
}

.vr-scope-menu p {
  margin: 0 0 4px;
  padding: 0 4px;
  color: #9ca3af;
  font-size: 11px;
  font-weight: 720;
}

.vr-scope-menu button {
  min-height: 36px;
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr) 14px;
  align-items: center;
  gap: 9px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: #e5e7eb;
  padding: 0 9px;
  text-align: left;
}

.vr-scope-menu button:hover {
  background: rgba(255, 255, 255, 0.055);
}

.vr-scope-menu button i[data-icon],
.vr-scope-menu button svg {
  width: 15px;
  height: 15px;
  color: #ffe9ad;
}

.vr-scope-menu button b {
  width: 8px;
  height: 14px;
  border: solid #ffe9ad;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.vr-chat-command-bar .vr-chat-input {
  grid-column: 1;
  grid-row: 2;
  min-height: 64px;
  padding: 0 4px;
  color: #f8fafc;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.55;
}

.vr-chat-command-bar .vr-chat-input::placeholder {
  color: #9ca3af;
}

.vr-composer-bottom {
  grid-column: 1;
  grid-row: 5;
  align-self: end;
  justify-content: space-between;
  gap: 14px;
}

.vr-chat-command-bar > .vr-chat-composer > .vr-provider-drop-zone {
  grid-row: 4;
  grid-column: 1;
  align-self: start;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  overflow: hidden;
}

.vr-chat-command-bar > .vr-chat-composer > .vr-provider-drop-zone:not(.has-provider):not(.is-active) {
  display: none;
  min-height: 0;
}

.vr-chat-command-bar > .vr-chat-composer > .vr-provider-drop-zone.has-provider {
  min-height: 34px;
}

.vr-chat-command-bar > .vr-chat-composer > .vr-provider-drop-zone .vr-context-chip {
  flex: 0 1 auto;
  max-width: min(240px, 48%);
}

.vr-chat-inline-actions {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  overflow: visible;
}

.vr-chat-command-trigger {
  position: relative;
  display: inline-flex;
  align-items: center;
  overflow: visible;
}

.vr-chat-inline-actions > button,
.vr-chat-command-trigger > button {
  height: 40px;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  border: 1px solid rgba(148, 163, 184, 0.14);
  border-radius: 10px;
  background: rgba(12, 15, 22, 0.62);
  color: #cbd5e1;
  padding: 0 13px;
  font-size: 13px;
  font-weight: 680;
}

.vr-chat-inline-actions > button:hover,
.vr-chat-command-trigger > button:hover {
  border-color: rgba(148, 163, 184, 0.22);
  background: rgba(255, 255, 255, 0.04);
  color: #f8fafc;
}

.vr-chat-inline-actions > button i[data-icon],
.vr-chat-inline-actions > button svg,
.vr-chat-command-trigger > button i[data-icon],
.vr-chat-command-trigger > button svg {
  width: 16px;
  height: 16px;
}

.vr-chat-command-popover {
  position: absolute;
  right: -12px;
  bottom: calc(100% + 8px);
  z-index: 8;
  width: min(292px, 78vw);
  display: grid;
  gap: 4px;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 12px;
  background: rgba(14, 17, 24, 0.98);
  box-shadow: 0 18px 52px rgba(0, 0, 0, 0.46);
  padding: 8px;
}

.vr-chat-command-popover button {
  min-height: 34px;
  display: grid;
  grid-template-columns: 16px minmax(0, 1fr);
  align-items: center;
  gap: 9px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #d1d5db;
  padding: 0 10px;
  text-align: left;
  font-size: 12.5px;
  font-weight: 650;
}

.vr-chat-command-popover button.is-primary {
  border-color: transparent;
  background: transparent;
  color: #f3e8ff;
}

.vr-chat-command-popover button.is-muted {
  color: #9ca3af;
}

.vr-chat-command-popover button:hover {
  border-color: rgba(148, 163, 184, 0.16);
  background: rgba(255, 255, 255, 0.04);
}

.vr-context-tray {
  grid-row: 3;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  border: 1px solid rgba(148, 163, 184, 0.15);
  border-radius: 14px;
  background: rgba(12, 15, 22, 0.78);
  padding: 10px;
}

.vr-context-tray header {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.vr-context-tray header strong {
  color: #f8fafc;
  font-size: 13px;
}

.vr-context-tray header button {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(148, 163, 184, 0.14);
  border-radius: 8px;
  background: transparent;
  color: #9ca3af;
}

.vr-context-tray section {
  min-width: 0;
  display: grid;
  gap: 7px;
}

.vr-context-tray section p {
  margin: 0;
  color: #9ca3af;
  font-size: 11px;
  font-weight: 720;
}

.vr-context-tray section > div {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px;
}

.vr-context-tray section button {
  min-width: 0;
  min-height: 40px;
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  grid-template-rows: auto auto;
  align-items: center;
  gap: 0 8px;
  border: 1px solid rgba(148, 163, 184, 0.13);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.025);
  color: #e5e7eb;
  padding: 8px 9px;
  text-align: left;
}

.vr-context-tray section button:hover {
  border-color: rgba(148, 163, 184, 0.22);
  background: rgba(255, 255, 255, 0.04);
}

.vr-context-tray section button span {
  grid-row: 1 / 3;
  display: grid;
  place-items: center;
}

.vr-context-tray section button span img,
.vr-context-tray section button span svg {
  width: 18px;
  height: 18px;
}

.vr-context-tray section button strong,
.vr-context-tray section button em {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr-context-tray section button strong {
  font-size: 12px;
}

.vr-context-tray section button em {
  color: #9ca3af;
  font-size: 10.5px;
  font-style: normal;
}

.vr-context-tray-empty {
  color: #9ca3af;
  font-size: 12px;
}

.vr-composer-controls {
  justify-content: flex-end;
  gap: 10px;
}

.vr-composer-controls .vr-provider-drop-zone {
  max-width: 300px;
}

.vr-composer-controls .vr-provider-drop-zone:not(.has-provider):not(.is-active) {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}

.vr-composer-controls .vr-provider-drop-zone > .vr-provider-drop-label {
  border-radius: 12px;
}

.vr-composer-controls .vr-model-picker {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0;
  border: 1px solid rgba(148, 163, 184, 0.13);
  border-radius: 14px;
  background: rgba(15, 18, 27, 0.74);
  overflow: visible;
}

.vr-composer-controls .vr-model-picker > button {
  height: 46px;
  min-width: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #d1d5db;
  padding: 0 13px;
}

.vr-composer-controls .vr-model-picker > button + button {
  border-left: 1px solid rgba(148, 163, 184, 0.1);
}

.vr-composer-controls .vr-model-picker > button span {
  display: none;
}

.vr-composer-controls .vr-model-picker > button strong {
  max-width: 150px;
  color: #e5e7eb;
  font-size: 12.5px;
  font-weight: 650;
}

.vr-composer-controls .vr-model-picker > button:first-child,
.vr-composer-controls .vr-model-picker > button:nth-child(3) {
  display: none;
}

.vr-composer-controls .vr-model-picker > button:nth-child(2) {
  min-width: 132px;
}

.vr-composer-controls .vr-model-picker > button:nth-child(4) {
  max-width: 128px;
}

.vr-composer-controls .vr-model-picker > button:nth-child(4) strong {
  max-width: 92px;
}

.vr-composer-controls .vr-model-picker > button i {
  margin-left: 0;
}

.vr-composer-controls .vr-model-menu {
  bottom: 54px;
  right: 0;
}

.vr-composer-controls .vr-chat-send {
  flex: 0 0 46px;
  width: 46px;
  height: 46px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(255, 233, 173, 0.48);
  border-radius: 12px;
  background: linear-gradient(135deg, #ffe9ad, #e8c15a);
  color: #16090a;
  box-shadow: 0 0 0 4px rgba(0, 0, 0, 0), 0 12px 28px rgba(0, 0, 0, 0.34);
}

.vr-composer-controls .vr-chat-send:hover {
  transform: translateY(-1px);
  box-shadow: 0 0 0 5px rgba(0, 0, 0, 0), 0 16px 32px rgba(0, 0, 0, 0.38);
}

.vr-composer-controls .vr-chat-send.is-stop {
  border-color: rgba(248, 113, 113, 0.44);
  background: rgba(239, 68, 68, 0.16);
  color: #fecaca;
  box-shadow: none;
}

.vr-composer-controls .vr-chat-send svg {
  width: 19px;
  height: 19px;
  stroke-width: 2.2;
}

.vr-composer-controls .vr-chat-send.is-stop svg {
  width: 17px;
  height: 17px;
}

/* --- Compact chat chrome: keep the cockpit full-height without stealing transcript space. --- */
.vr-composed-shell {
  grid-template-rows: 42px minmax(0, 1fr);
}

.vr-studio-topbar {
  min-height: 42px;
  padding: 0 8px;
}

.vr-topbar-brand {
  gap: 7px;
}

.vr-topbar-brand span {
  width: 26px;
  height: 26px;
}

.vr-topbar-brand strong {
  font-size: 18px;
}

.vr-left-context-rail {
  gap: 8px;
}

.vr-rail-launchers {
  gap: 4px;
  padding: 6px;
}

.vr-rail-launcher {
  min-height: 38px;
  grid-template-columns: 24px minmax(0, 1fr) 8px;
  gap: 8px;
  padding: 5px 6px;
}

.vr-rail-launcher i[data-icon] {
  width: 22px;
  height: 22px;
  border-radius: 7px;
}

.vr-rail-launcher strong {
  font-size: 12px;
}

.vr-rail-launcher em {
  font-size: 10.5px;
}

.vr-recent-rail {
  padding: 8px;
}

.vr-new-chat-button {
  min-height: 38px;
}

.vr-recent-chat {
  min-height: 46px;
  padding: 8px;
}

.vr-composition-body,
.vr-composition-body.has-inspector {
  padding: 8px;
  gap: 8px;
}

.vr-main-canvas {
  padding: 6px;
}

.vr-studio-head {
  min-height: 34px;
  padding: 2px 2px 0;
}

.vr-studio-head h1 {
  font-size: 17px;
}

.vr-studio-tabs button,
.vr-studio-head-actions > button {
  min-height: 32px;
}

.vr-cli-panel {
  min-height: 42px;
  padding: 6px;
}

.vr-studio-chat:not(.is-split) .vr-chat-transcript {
  padding: clamp(12px, 2vh, 22px) clamp(20px, 4vw, 64px) 16px;
}

.vr-chat-intro-message {
  margin-top: 0;
}

.vr-env-connect-card {
  margin-top: 18px;
}

.vr-studio-chat:not(.is-split) .vr-chat-command-bar {
  padding: 6px clamp(18px, 4vw, 62px) 8px;
}

.vr-studio-chat:not(.is-split) .vr-chat-command-bar > .vr-chat-composer,
.vr-chat-command-bar > .vr-chat-composer {
  min-height: 132px;
  grid-template-rows: auto minmax(38px, 1fr) auto auto auto;
  gap: 9px;
  border-radius: 16px;
  padding: 12px 14px;
}

.vr-chat-command-bar > .vr-chat-composer::before {
  left: 18px;
  right: 18px;
  top: 54px;
}

.vr-composer-scope {
  height: 34px;
  gap: 8px;
  padding: 0 10px;
  font-size: 12.5px;
}

.vr-composer-scope i[data-icon],
.vr-composer-scope i[data-icon] svg {
  width: 15px;
  height: 15px;
}

.vr-chat-command-bar .vr-chat-input {
  min-height: 42px;
  font-size: 14.5px;
  line-height: 1.42;
}

.vr-chat-inline-actions {
  gap: 6px;
}

.vr-chat-inline-actions > button,
.vr-chat-command-trigger > button {
  height: 34px;
  gap: 7px;
  border-radius: 9px;
  padding: 0 10px;
  font-size: 12.5px;
}

.vr-chat-inline-actions > button i[data-icon],
.vr-chat-inline-actions > button svg,
.vr-chat-command-trigger > button i[data-icon],
.vr-chat-command-trigger > button svg {
  width: 14px;
  height: 14px;
}

.vr-composer-controls {
  gap: 8px;
}

.vr-composer-controls .vr-model-picker {
  border-radius: 12px;
}

.vr-composer-controls .vr-model-picker > button {
  height: 38px;
  padding: 0 11px;
}

.vr-composer-controls .vr-model-picker > button:nth-child(2) {
  min-width: 116px;
}

.vr-composer-controls .vr-model-picker > button:nth-child(4) {
  max-width: 150px;
}

.vr-composer-controls .vr-model-picker > button:nth-child(4) strong {
  max-width: 120px;
}

.vr-composer-controls .vr-chat-send {
  flex-basis: 40px;
  width: 40px;
  height: 40px;
  border-radius: 11px;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0), 0 10px 24px rgba(0, 0, 0, 0.32);
}

.vr-composer-controls .vr-chat-send svg {
  width: 17px;
  height: 17px;
}

/* --- Density and transcript repair pass --- */
.vr-composed-shell {
  grid-template-rows: 38px minmax(0, 1fr);
}

.vr-studio-topbar {
  min-height: 38px;
  padding: 0 6px;
}

.vr-topbar-brand span {
  width: 22px;
  height: 22px;
}

.vr-topbar-brand strong {
  font-size: 16px;
}

.vr-composition-body,
.vr-composition-body.has-inspector {
  padding: 6px;
  gap: 6px;
}

.vr-main-canvas {
  padding: 4px;
}

.vr-studio-head {
  min-height: 30px;
  padding: 0;
}

.vr-studio-head h1 {
  font-size: 16px;
}

.vr-studio-tabs button,
.vr-studio-head-actions > button {
  min-height: 30px;
  padding-inline: 10px;
}

.vr-cli-panel {
  min-height: 36px;
  padding: 5px;
}

.vr-studio-chat:not(.is-split) .vr-chat-transcript {
  gap: 10px;
  padding: 10px clamp(18px, 4vw, 54px) 12px;
}

.vr-story-node {
  column-gap: 12px;
}

.vr-story-dot {
  width: 24px;
  height: 24px;
}

.vr-story-node.is-user .vr-chat-message.is-user {
  min-height: 66px;
  padding: 12px 16px 12px 56px;
  border-color: rgba(148, 163, 184, 0.22);
  border-radius: 13px;
  background:
    radial-gradient(circle at 96% 16%, rgba(148, 163, 184, 0.050), transparent 140px),
    rgba(16, 18, 27, 0.88);
}

.vr-story-node.is-user .vr-chat-message.is-user::after {
  left: 20px;
  top: 22px;
  width: 16px;
  height: 16px;
  border-color: rgba(255, 215, 110, 0.55);
  border-radius: 999px;
  background: radial-gradient(circle at 50% 50%, #ffd76e 0 3px, rgba(148, 163, 184, 0.050) 4px 100%);
  box-shadow: 0 0 16px rgba(0, 0, 0, 0);
}

.vr-story-node.is-user .vr-chat-message.is-user::before {
  margin-bottom: 6px;
  font-size: 10px;
}

.vr-story-node.is-user .vr-chat-message.is-user > p {
  font-size: 15px;
  font-weight: 720;
}

.vr-chat-agent-response {
  width: min(820px, 100%);
  padding: 12px 14px;
  border-radius: 13px;
}

.vr-chat-agent-response > div:first-child {
  gap: 9px;
  padding-bottom: 7px;
}

.vr-chat-agent-response > div:first-child > span {
  width: 34px;
  height: 34px;
}

.vr-chat-agent-response > div:first-child img {
  width: 43px;
  height: 43px;
  transform: translateY(6px);
}

.vr-chat-agent-response > div:first-child p strong {
  font-size: 15px;
}

.vr-chat-agent-response .vr-agent-context-line,
.vr-chat-agent-response .vr-agent-response-stack {
  margin-left: 43px;
}

.vr-chat-agent-response .vr-agent-answer-body > p:first-child {
  font-size: 13.5px;
}

.vr-chat-mission-summary {
  width: min(720px, 100%);
  padding-left: 43px;
}

.vr-chat-command-bar > .vr-chat-composer,
.vr-studio-chat:not(.is-split) .vr-chat-command-bar > .vr-chat-composer {
  min-height: 118px;
  padding: 10px 12px;
}

.vr-composer-controls .vr-chat-send {
  flex-basis: 38px;
  width: 38px;
  height: 38px;
}

.vr-composer-controls .vr-chat-send.is-stop {
  border-color: rgba(255, 233, 173, 0.52);
  background: linear-gradient(135deg, #9b5cf6, #6d28d9);
  color: #f5f3ff;
  box-shadow:
    0 0 0 4px rgba(0, 0, 0, 0),
    0 14px 34px rgba(88, 28, 135, 0.34);
}

.vr-composer-controls .vr-chat-send.is-stop svg {
  width: 17px;
  height: 17px;
  display: block;
  stroke-width: 2.35;
}

.vr-composer-controls .vr-chat-send.is-stop svg rect {
  x: 6.75px;
  y: 6.75px;
  width: 10.5px;
  height: 10.5px;
  rx: 2.25px;
  fill: currentColor;
  stroke: none;
}

/* --- Worktree commit action polish --- */
.vr-branch-row.is-dirty {
  border-color: rgba(249, 115, 22, 0.22);
  background:
    linear-gradient(90deg, rgba(249, 115, 22, 0.09), rgba(148, 163, 184, 0.035)),
    rgba(255, 255, 255, 0.02);
}

.vr-branch-row.is-dirty b {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 66px;
  min-height: 24px;
  padding: 0 12px;
  border-color: rgba(255, 233, 173, 0.34);
  background: rgba(255, 255, 255, 0.04);
  color: #ffe9ad;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.vr-branch-row.is-dirty:hover b {
  border-color: rgba(255, 233, 173, 0.52);
  background: rgba(255, 255, 255, 0.04);
}

.vr-inspector-warning button,
.vr-wt-dirty button {
  min-height: 32px;
  border-color: rgba(255, 233, 173, 0.34);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
  color: #fff3c4;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.vr-inspector-warning button:hover,
.vr-wt-dirty button:hover {
  border-color: rgba(255, 233, 173, 0.52);
  background: rgba(255, 255, 255, 0.04);
}

@media (max-width: 760px) {
  .vr-chat-command-bar > .vr-chat-composer {
    min-height: 156px;
    padding: 14px;
  }
  .vr-composer-bottom,
  .vr-composer-controls {
    align-items: stretch;
    flex-direction: column;
  }
  .vr-chat-inline-actions {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .vr-context-tray {
    grid-template-columns: 1fr;
  }
  .vr-context-tray section > div {
    grid-template-columns: 1fr;
  }
  .vr-chat-inline-actions > button {
    justify-content: center;
    padding: 0 8px;
  }
  .vr-composer-controls .vr-model-picker {
    width: 100%;
  }
  .vr-composer-controls .vr-model-picker > button:nth-child(2) {
    flex: 1;
  }
  .vr-composer-controls .vr-chat-send {
    align-self: flex-end;
  }
  .vr-env-connect-card {
    width: 100%;
    margin-left: 0;
    padding: 16px;
  }
  .vr-chat-intro-message {
    width: 100%;
    max-width: 100%;
  }
  .vr-env-connect-card > div {
    grid-template-columns: 1fr;
  }
  .vr-env-connect-steps {
    grid-template-columns: 1fr;
  }
  .vr-chat-intro-message > p {
    padding-left: 0;
  }
}

/* ==========================================================================
   HUD console layer — final pass, wins the cascade.
   One chassis for every transcript card. Signal color appears in exactly
   two places: the 2px left rail and the status word. Mono = machine facts.
   ========================================================================== */
:root {
  --vr-hud-mono: "JetBrains Mono", ui-monospace, SFMono-Regular, Consolas, monospace;
  --vr-hud-surface: rgba(13, 12, 16, 0.92);
  --vr-hud-line: rgba(232, 193, 90, 0.16);
}

/* Chassis: identical frame for every state. */
.vr-hud-card {
  position: relative;
  border: 1px solid var(--vr-hud-line);
  border-left: 2px solid rgba(148, 163, 184, 0.35);
  border-radius: 12px;
  background: var(--vr-hud-surface);
  box-shadow: none;
  padding: 12px 16px 14px;
}
.vr-hud-card.is-nominal { border-left-color: var(--vr-green); }
.vr-hud-card.is-blocked { border-left-color: var(--vr-red); }
.vr-hud-card.is-working { border-left-color: var(--vr-orange); }
.vr-hud-card.is-mission { border-left-color: var(--vr-purple); }

/* Header strip: one line of telemetry, no chip soup. */
.vr-hud-strip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 8px;
  margin-bottom: 10px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.08);
  font-family: var(--vr-hud-mono);
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--vr-muted);
}
.vr-hud-strip strong {
  font-weight: 700;
  color: var(--vr-text);
  letter-spacing: 0.08em;
}
.vr-hud-strip em { font-style: normal; color: var(--vr-muted); }
.vr-hud-strip b { margin-left: auto; font-weight: 500; color: rgba(156, 163, 175, 0.72); }
.vr-hud-avatar { display: inline-flex; }
.vr-hud-avatar img { width: 20px; height: 20px; border-radius: 6px; display: block; }
.vr-hud-status { display: inline-flex; align-items: center; gap: 5px; font-weight: 700; }
.vr-hud-status i { width: 6px; height: 6px; border-radius: 50%; background: currentColor; }
.vr-hud-status.is-nominal { color: var(--vr-green); }
.vr-hud-status.is-blocked { color: var(--vr-red); }
.vr-hud-status.is-working { color: var(--vr-orange); }

/* Launch Gate readout — the signature piece. */
.vr-hud-gate {
  border: 1px solid var(--vr-hud-line);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.015);
  overflow: hidden;
}
.vr-hud-gate header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.1);
  font-family: var(--vr-hud-mono);
  font-size: 10px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
.vr-hud-gate header strong { color: var(--vr-text); font-weight: 700; }
.vr-hud-gate header b { color: var(--vr-red); font-weight: 700; }
.vr-hud-gate-row {
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding: 8px 12px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.06);
}
.vr-hud-gate-row:last-of-type { border-bottom: 0; }
.vr-hud-gate-row em { flex: 1; font-style: normal; color: rgba(244, 244, 245, 0.88); font-size: 13px; }
.vr-hud-gate-row em small { display: block; margin-top: 2px; font-size: 11px; color: var(--vr-muted); }
.vr-hud-gate-row b {
  font-family: var(--vr-hud-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: var(--vr-muted);
  white-space: nowrap;
}
.vr-hud-sev { flex: none; font-style: normal; font-family: var(--vr-hud-mono); font-size: 10px; letter-spacing: 0.05em; }
.vr-hud-sev.is-critical { color: var(--vr-red); }
.vr-hud-sev.is-warning { color: var(--vr-orange); }
.vr-hud-sev.is-info { color: var(--vr-muted); }
.vr-hud-gate-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 12px;
  border: 0;
  border-top: 1px solid rgba(148, 163, 184, 0.1);
  background: rgba(255, 255, 255, 0.02);
  color: var(--vr-text);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.vr-hud-gate-foot:hover { background: rgba(255, 255, 255, 0.045); }
.vr-hud-gate-foot b { font-family: var(--vr-hud-mono); font-size: 10px; font-weight: 500; letter-spacing: 0.08em; color: var(--vr-muted); text-transform: uppercase; }

/* Raw machine error, demoted under the human headline. */
.vr-hud-raw {
  font-family: var(--vr-hud-mono);
  font-size: 11px;
  color: var(--vr-muted);
  word-break: break-word;
}

/* Raw transcript guard: agent dumped grep/tool output instead of a clean answer.
   Show a themed headline + collapse the raw lines into the work log. */
.vr-agent-answer-raw { display: flex; flex-direction: column; gap: 6px; }
.vr-agent-raw-headline {
  margin: 0;
  font-weight: 700;
  color: var(--vr-gold-bright);
}
.vr-agent-raw-sub {
  margin: 0 0 4px;
  font-size: 12px;
  color: var(--vr-muted);
}

/* Retire legacy state styling: the frame never changes with state.
   Only the three non-rail sides — border-left stays the signal color. */
.vr-chat-agent-response.is-ready,
.vr-chat-agent-response.is-error {
  border-top-color: var(--vr-hud-line);
  border-right-color: var(--vr-hud-line);
  border-bottom-color: var(--vr-hud-line);
  background: var(--vr-hud-surface);
  box-shadow: none;
}
.vr-story-node.is-user .vr-chat-message.is-user {
  border: 1px solid var(--vr-hud-line);
  border-left: 2px solid var(--vr-purple);
  background: var(--vr-hud-surface);
}
.vr-story-node.is-user .vr-chat-message.is-user::before { content: none; }

/* Working/task card sits on the same chassis. */
.vr-chat-agent-task {
  border: 1px solid var(--vr-hud-line);
  border-left: 2px solid var(--vr-orange);
  border-radius: 12px;
  background: var(--vr-hud-surface);
  box-shadow: none;
}

/* HUD layer: provider board — neutral chassis, tone only via status text. */
.vr-provider-card {
  border: 1px solid var(--vr-hud-line);
  border-radius: 12px;
  background: var(--vr-hud-surface);
  box-shadow: none;
}
.vr-provider-card:hover {
  border-color: var(--vr-border-strong);
  background: rgba(255, 255, 255, 0.03);
  box-shadow: none;
}
.vr-provider-card.is-selected {
  border-color: var(--vr-border-strong);
  background: rgba(255, 255, 255, 0.035);
  box-shadow: none;
}
.vr-provider-card > div small {
  font-family: var(--vr-hud-mono);
  font-size: 9px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--vr-muted);
}
.vr-provider-card > div em {
  font-style: normal;
  font-family: var(--vr-hud-mono);
  font-size: 10px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.vr-provider-card[data-provider-tone='green'] > div em { color: var(--vr-green); }
.vr-provider-card[data-provider-tone='orange'] > div em,
.vr-provider-card[data-provider-tone='warn'] > div em { color: var(--vr-orange); }
.vr-provider-card[data-provider-tone='red'] > div em,
.vr-provider-card[data-provider-tone='danger'] > div em { color: var(--vr-red); }
.vr-provider-detail-panel {
  border: 1px solid var(--vr-hud-line);
  border-radius: 12px;
  background: var(--vr-hud-surface);
  box-shadow: none;
}
.vr-providers-panel .vr-panel-head h2 { letter-spacing: -0.01em; }

/* HUD layer: releases — chassis + rail by tone, mono meta. */
.vr-release-card,
.vr-release-row,
.vr-release-list {
  border: 1px solid var(--vr-hud-line);
  border-radius: 12px;
  background: var(--vr-hud-surface);
  box-shadow: none;
}
.vr-release-card { border-left-width: 2px; }
.vr-release-card[data-tone='current'] { border-left-color: var(--vr-green); }
.vr-release-card[data-tone='prod'] { border-left-color: rgba(148, 163, 184, 0.45); }
.vr-release-card[data-tone='planned'] { border-left-color: rgba(148, 163, 184, 0.25); }
.vr-release-card:hover,
.vr-release-row:hover { border-color: var(--vr-border-strong); background: rgba(255, 255, 255, 0.03); }
.vr-release-card:hover,
.vr-release-card.is-selected {
  border-top-color: var(--vr-border-strong);
  border-right-color: var(--vr-border-strong);
  border-bottom-color: var(--vr-border-strong);
  background: rgba(255, 255, 255, 0.035);
  box-shadow: none;
}
.vr-release-row.is-selected { border-color: var(--vr-border-strong); background: rgba(255, 255, 255, 0.035); box-shadow: none; }
.vr-release-card small,
.vr-release-row small,
.vr-release-card em,
.vr-release-row em {
  font-style: normal;
  font-family: var(--vr-hud-mono);
  font-size: 10px;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--vr-muted);
}
.vr-release-actions button {
  border: 1px solid var(--vr-hud-line);
  background: transparent;
  box-shadow: none;
}
.vr-release-actions button:hover { border-color: var(--vr-border-strong); background: rgba(255, 255, 255, 0.03); }

/* HUD layer: strip and modals — mono gate readout, no mascot glow. */
.vr-chat-gate-chip {
  font-family: var(--vr-hud-mono);
  font-size: 10px;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  border: 1px solid var(--vr-hud-line);
  background: transparent;
  box-shadow: none;
}
.vr-chat-gate-chip.is-ok { color: var(--vr-green); border-color: rgba(34, 197, 94, 0.35); }
.vr-chat-gate-chip.is-blocker { color: var(--vr-red); border-color: rgba(239, 68, 68, 0.35); }
.vr-chat-gate-chip.is-info { color: var(--vr-muted); }
.vr-chat-provider-dot,
.vr-chat-version-dot { box-shadow: none; }
.vr-modal-mascot { filter: none; }
.vr-modal-provider-head,
.vr-modal-release-head {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid var(--vr-hud-line);
}

/* HUD layer: agent work log — raw CLI transcript collapsed behind one flat row. */
.vr-agent-work {
  border: 1px solid var(--vr-hud-line);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.015);
  overflow: hidden;
}
.vr-agent-work summary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  cursor: pointer;
  list-style: none;
  font-family: var(--vr-hud-mono);
  font-size: 10px;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: var(--vr-muted);
  user-select: none;
}
.vr-agent-work summary::-webkit-details-marker { display: none; }
.vr-agent-work summary b {
  width: 6px;
  height: 6px;
  border-radius: 1px;
  background: var(--vr-muted);
  transition: transform 0.15s ease, background 0.15s ease;
}
.vr-agent-work[open] summary b { background: var(--vr-green); transform: rotate(45deg); }
.vr-agent-work summary span { color: var(--vr-text); font-weight: 700; }
.vr-agent-work summary em { margin-left: auto; font-style: normal; }
.vr-agent-work summary:hover { background: rgba(255, 255, 255, 0.03); }
.vr-agent-work pre {
  margin: 0;
  padding: 10px 12px;
  border-top: 1px solid var(--vr-hud-line);
  max-height: 260px;
  overflow: auto;
  font-family: var(--vr-hud-mono);
  font-size: 11px;
  line-height: 1.55;
  color: var(--vr-muted);
  white-space: pre-wrap;
  word-break: break-word;
}

/* ==========================================================================
   HUD layer: flat futuristic pass — Linear structure, PostHog color energy.
   Flat surfaces, hairline rows, no decorative purple text. Color is
   semantic only: provider brands, status states, one purple primary.
   ========================================================================== */

/* Modal heads: mono section label, near-white title. */
.vr-modal-release-head p,
.vr-modal-provider-head p,
.vr-inspector-hero p {
  font-family: var(--vr-hud-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--vr-muted);
}
.vr-modal-release-head h2,
.vr-modal-provider-head h2 {
  color: var(--vr-text);
}

/* Compare pill: flat, neutral chrome, mono range. */
.vr-modal-compare {
  border: 1px solid var(--vr-hud-line);
  background: rgba(255, 255, 255, 0.02);
  color: var(--vr-text);
  font-size: 14px;
  font-weight: 650;
}
.vr-modal-compare:hover { border-color: var(--vr-border-strong); background: rgba(255, 255, 255, 0.04); }
.vr-modal-compare b {
  font-family: var(--vr-hud-mono);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: var(--vr-muted);
}

/* Changelog: neutral mono hashes, flat rows, mono section label. */
.vr-changelog-summary { background: rgba(255, 255, 255, 0.015); border-color: var(--vr-hud-line); }
.vr-changelog-summary span {
  font-family: var(--vr-hud-mono);
  color: var(--vr-muted);
  letter-spacing: 0.1em;
}
.vr-changelog-list li { background: rgba(255, 255, 255, 0.015); border-color: var(--vr-hud-line); }
.vr-changelog-list li strong {
  color: var(--vr-muted);
  font-family: var(--vr-hud-mono);
  font-weight: 600;
}
.vr-changelog-more {
  border: 1px solid var(--vr-hud-line);
  background: transparent;
  color: var(--vr-muted);
}
.vr-changelog-more:hover { border-color: var(--vr-border-strong); color: var(--vr-text); }

/* Modal section headers: mono caps labels. */
.vr-modal-two-col h3 {
  font-family: var(--vr-hud-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--vr-muted);
}

/* Inspector drawers: flat rows on the chassis. */
.vr-inspector-card { border: 1px solid var(--vr-hud-line); background: var(--vr-hud-surface); box-shadow: none; }
.vr-inspector-hero { border: 1px solid var(--vr-hud-line); background: rgba(255, 255, 255, 0.015); box-shadow: none; }
.vr-inspector-provider-row {
  border: 1px solid var(--vr-hud-line);
  background: rgba(255, 255, 255, 0.015);
  box-shadow: none;
}
.vr-inspector-provider-row:hover { border-color: var(--vr-border-strong); background: rgba(255, 255, 255, 0.035); }
.vr-inspector-provider-row span small {
  font-family: var(--vr-hud-mono);
  font-size: 9px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--vr-muted);
}

/* One purple primary per view: ask-agent is THE action, flat fill. */
.vr-provider-ask-agent {
  border: 1px solid var(--vr-accent);
  background: var(--vr-accent);
  color: #ffffff;
  box-shadow: none;
}
.vr-provider-ask-agent:hover { background: #6d31d9; border-color: #6d31d9; box-shadow: none; }

/* HUD layer: interactive chips — grab, lift, press. Flat, no glow. */
.vr-chat-provider-dot,
.vr-chat-version-dot {
  cursor: grab;
  transition: transform 0.12s ease, border-color 0.12s ease, background 0.12s ease;
}
.vr-chat-provider-dot:hover,
.vr-chat-version-dot:hover {
  transform: translateY(-1px);
  border-color: var(--vr-border-strong);
  background: rgba(255, 255, 255, 0.05);
}
.vr-chat-provider-dot:active,
.vr-chat-version-dot:active {
  cursor: grabbing;
  transform: scale(0.96);
}
.vr-provider-card,
.vr-release-card,
.vr-release-row,
.vr-inspector-provider-row {
  transition: transform 0.12s ease, border-color 0.12s ease, background 0.12s ease;
}
.vr-provider-card:hover,
.vr-release-card:hover,
.vr-release-row:hover,
.vr-inspector-provider-row:hover { transform: translateY(-1px); }
.vr-provider-card:active,
.vr-release-card:active,
.vr-release-row:active,
.vr-inspector-provider-row:active { transform: translateY(0) scale(0.99); }
.vr-sent-context > span,
.vr-agent-context-line > span {
  transition: border-color 0.12s ease, background 0.12s ease;
}
.vr-sent-context > span:hover,
.vr-agent-context-line > span:hover {
  border-color: var(--vr-border-strong);
  background: rgba(255, 255, 255, 0.04);
}

/* ==========================================================================
   HUD layer: the stamp — passport-style verdict. Signature motif.
   Tones: is-clear (green), is-notyet (red), is-review (amber), is-idle.
   ========================================================================== */
.vr-stamp {
  display: inline-block;
  transform: rotate(-5deg);
  border: 2px solid var(--vr-green);
  border-radius: 7px;
  color: var(--vr-green);
  font-family: var(--vr-hud-mono);
  font-weight: 800;
  font-size: 13px;
  letter-spacing: 0.2em;
  padding: 5px 12px 5px 14px;
  text-transform: uppercase;
  position: relative;
  background: transparent;
  white-space: nowrap;
}
.vr-stamp::after {
  content: "";
  position: absolute;
  inset: 2px;
  border: 1px solid currentColor;
  opacity: 0.45;
  border-radius: 4px;
  pointer-events: none;
}
.vr-stamp.is-notyet { border-color: var(--vr-red); color: var(--vr-red); }
.vr-stamp.is-review { border-color: var(--vr-orange); color: var(--vr-orange); }
.vr-stamp.is-idle { border-color: rgba(148, 163, 184, 0.5); color: var(--vr-muted); }
.vr-stamp.is-mini {
  transform: rotate(-4deg);
  border-width: 1.5px;
  font-size: 9px;
  letter-spacing: 0.14em;
  padding: 2px 7px;
  border-radius: 5px;
}
.vr-stamp.is-mini::after { inset: 1px; border-radius: 3px; }

/* Gate chip in the chat strip becomes the stamp. */
button.vr-chat-gate-chip.vr-stamp {
  cursor: pointer;
  background: transparent;
  box-shadow: none;
  transition: transform 0.12s ease;
}
button.vr-chat-gate-chip.vr-stamp:hover { transform: rotate(-4deg) translateY(-1px); }
button.vr-chat-gate-chip.vr-stamp i { display: none; }
.vr-stamp-row { padding: 4px 0 2px; }

/* ==========================================================================
   HUD layer: white primaries — the one strong action per view is a white
   button (white fill, black text). Purple leaves interactive chrome.
   ========================================================================== */
.vr-agent-followups button.is-primary,
.vr-agent-inline-action.is-primary,
.vr-chat-inline-actions button.is-primary,
.vr-chat-command-popover button.is-primary,
.vr-cli-action-button.is-primary,
.vr-studio-architecture > footer button.is-primary,
.vr-arch-drawer footer button.is-primary,
.vr-wt-actions button.is-primary,
.vr-new-chat-button,
.vr-provider-ask-agent {
  background: #ffffff;
  border-color: #ffffff;
  color: #0a0b0e;
  box-shadow: none;
  font-weight: 700;
}
.vr-agent-followups button.is-primary:hover,
.vr-agent-inline-action.is-primary:hover,
.vr-chat-inline-actions button.is-primary:hover,
.vr-chat-command-popover button.is-primary:hover,
.vr-cli-action-button.is-primary:hover,
.vr-studio-architecture > footer button.is-primary:hover,
.vr-arch-drawer footer button.is-primary:hover,
.vr-wt-actions button.is-primary:hover,
.vr-new-chat-button:hover,
.vr-provider-ask-agent:hover {
  background: #e6e9ef;
  border-color: #e6e9ef;
  color: #0a0b0e;
  box-shadow: none;
}
.vr-agent-followups button.is-primary svg,
.vr-agent-inline-action.is-primary svg,
.vr-new-chat-button svg,
.vr-provider-ask-agent svg {
  stroke: #0a0b0e;
  color: #0a0b0e;
}
.vr-new-chat-button kbd { color: rgba(10, 11, 14, 0.55); border-color: rgba(10, 11, 14, 0.25); background: transparent; }
.vr-new-chat-button span { color: #0a0b0e; }

/* Composer send: white, except the stop state which stays red. */
.vr-composer-controls .vr-chat-send:not(.is-stop),
.vr-chat-command-bar > .vr-chat-composer > .vr-chat-send:not(.is-stop) {
  background: #ffffff;
  border-color: #ffffff;
  color: #0a0b0e;
  box-shadow: none;
}
.vr-composer-controls .vr-chat-send:not(.is-stop):hover,
.vr-chat-command-bar > .vr-chat-composer > .vr-chat-send:not(.is-stop):hover {
  background: #e6e9ef;
  border-color: #e6e9ef;
}
.vr-composer-controls .vr-chat-send:not(.is-stop) svg,
.vr-chat-command-bar > .vr-chat-composer > .vr-chat-send:not(.is-stop) svg {
  stroke: #0a0b0e;
  color: #0a0b0e;
}

/* ==========================================================================
   HUD layer: approve card — proposal rows + one white Approve button.
   ========================================================================== */
.vr-approve-card {
  border: 1px solid var(--vr-hud-line);
  border-radius: 11px;
  background: var(--vr-hud-surface);
  overflow: hidden;
}
.vr-approve-card > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 14px;
  border-bottom: 1px solid var(--vr-hud-line);
  font-family: var(--vr-hud-mono);
  font-size: 10px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}
.vr-approve-card > header strong { color: var(--vr-text); font-weight: 700; }
.vr-approve-card > header b { color: var(--vr-muted); font-weight: 500; }
.vr-approve-cbx {
  width: 15px;
  height: 15px;
  flex: none;
  border: 1.5px solid var(--vr-border-strong);
  border-radius: 4px;
  display: inline-block;
}
.vr-approve-card .vr-plan-step {
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;
  padding: 10px 14px;
  border: 0;
  border-bottom: 1px solid rgba(148, 163, 184, 0.06);
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  cursor: pointer;
  text-align: left;
}
.vr-approve-card .vr-plan-step:hover { background: rgba(255, 255, 255, 0.03); }
.vr-approve-card .vr-plan-step-num { display: none; }
.vr-approve-card .vr-plan-step-title { color: rgba(244, 244, 245, 0.92); font-size: 13.5px; font-weight: 600; }
.vr-approve-card .vr-plan-step-tag {
  font-family: var(--vr-hud-mono);
  font-size: 9px;
  letter-spacing: 0.1em;
  color: var(--vr-muted);
  text-transform: uppercase;
  background: transparent;
  border: 0;
  padding: 0;
}
.vr-approve-foot {
  display: flex;
  gap: 8px;
  padding: 11px 14px;
  border-top: 1px solid var(--vr-hud-line);
  background: rgba(255, 255, 255, 0.015);
}
.vr-approve-all {
  flex: 1;
  background: #ffffff;
  border: 0;
  border-radius: 8px;
  color: #0a0b0e;
  padding: 10px;
  font-size: 13px;
  font-weight: 750;
  cursor: pointer;
}
.vr-approve-all:hover { background: #e6e9ef; }
.vr-approve-review {
  background: transparent;
  border: 1px solid var(--vr-border-strong);
  border-radius: 8px;
  color: var(--vr-text);
  padding: 10px 14px;
  font-size: 12.5px;
  font-weight: 650;
  cursor: pointer;
}
.vr-approve-review:hover { background: rgba(255, 255, 255, 0.04); }

/* ==========================================================================
   HUD layer: architecture map, stamped cartography.
   Dotted canvas + faint contour rings, waypoint nodes, mini-stamp verdicts.
   ========================================================================== */
.vr-arch-canvas {
  background-color: var(--vr-bg);
  background-image:
    radial-gradient(circle at 22% 30%, transparent 118px, rgba(148, 163, 184, 0.045) 119px, rgba(148, 163, 184, 0.045) 120px, transparent 121px),
    radial-gradient(circle at 22% 30%, transparent 178px, rgba(148, 163, 184, 0.035) 179px, rgba(148, 163, 184, 0.035) 180px, transparent 181px),
    radial-gradient(circle at 78% 68%, transparent 138px, rgba(148, 163, 184, 0.045) 139px, rgba(148, 163, 184, 0.045) 140px, transparent 141px),
    radial-gradient(circle at 78% 68%, transparent 208px, rgba(148, 163, 184, 0.03) 209px, rgba(148, 163, 184, 0.03) 210px, transparent 211px),
    radial-gradient(rgba(200, 210, 225, 0.07) 1px, transparent 1px);
  background-size: auto, auto, auto, auto, 22px 22px;
}
.vr-arch-edges path {
  stroke: rgba(200, 210, 225, 0.22);
  stroke-width: 1.2;
  stroke-dasharray: 3 4;
  fill: none;
}
.vr-arch-zone {
  font-family: var(--vr-hud-mono);
  font-size: 9.5px;
  font-weight: 600;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--vr-muted);
  border: 0;
  background: transparent;
}
.vr-arch-node {
  border: 1px solid var(--vr-border-strong);
  border-radius: 11px;
  background: var(--vr-hud-surface);
  box-shadow: none;
}
.vr-arch-node:hover { border-color: rgba(200, 210, 225, 0.42); box-shadow: none; }
.vr-arch-node.is-selected { border-color: rgba(200, 210, 225, 0.55); box-shadow: none; }
.vr-arch-node.has-health-red { border-color: rgba(239, 68, 68, 0.5); }
.vr-arch-node.has-health-orange { border-color: rgba(249, 115, 22, 0.42); }
.vr-arch-node > div strong { color: var(--vr-text); font-weight: 700; }
.vr-arch-node > div em {
  font-style: normal;
  font-family: var(--vr-hud-mono);
  font-size: 9px;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--vr-muted);
}
.vr-arch-node-badge.vr-stamp.is-mini {
  position: absolute;
  top: -10px;
  right: -8px;
  background: var(--vr-bg);
  width: auto;
  height: auto;
  line-height: 1.3;
}

/* ==========================================================================
   HUD layer: stamped heads — modal headers rebuilt in the stamp language.
   Dotted cartography canvas, mono eyebrow, big title, meta chips, verdict.
   ========================================================================== */
.vr-stamped-head {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  border: 1px solid var(--vr-hud-line);
  border-radius: 14px;
  padding: 20px 22px;
  background-color: rgba(255, 255, 255, 0.015);
  background-image: radial-gradient(rgba(200, 210, 225, 0.06) 1px, transparent 1px);
  background-size: 18px 18px;
}
.vr-stamped-head > div { flex: 1; min-width: 0; display: grid; gap: 6px; justify-items: start; }
.vr-stamped-head p {
  margin: 0;
  font-family: var(--vr-hud-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--vr-muted);
}
.vr-stamped-head h2 {
  margin: 0;
  font-family: var(--vr-hud-mono);
  font-size: 30px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--vr-text);
}
.vr-stamped-head > .vr-stamp {
  position: absolute;
  right: 22px;
  bottom: -11px;
  transform: rotate(4deg);
  background: var(--vr-bg);
}
.vr-stamped-head .vr-modal-provider-orb { flex: none; box-shadow: none; }
.vr-stamped-meta { display: flex; flex-wrap: wrap; gap: 6px; }
.vr-meta-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--vr-hud-mono);
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.05em;
  border: 1px solid var(--vr-hud-line);
  border-radius: 7px;
  padding: 4px 10px;
  color: var(--vr-text);
}
.vr-meta-chip.is-ok { color: var(--vr-green); border-color: rgba(34, 197, 94, 0.4); }
.vr-meta-chip svg { width: 12px; height: 12px; stroke: currentColor; }

/* Provider board verdict slot. */
.vr-provider-verdict { margin-left: auto; flex: none; }

/* Specificity fixes: white primary must win inside modal button rows. */
.vr-modal-button-row .vr-provider-ask-agent,
.vr-modal-action-grid .vr-provider-ask-agent,
.vr-modal-button-row button.vr-provider-ask-agent {
  background: #ffffff;
  border-color: #ffffff;
  color: #0a0b0e;
  box-shadow: none;
}
.vr-modal-button-row .vr-provider-ask-agent:hover,
.vr-modal-action-grid .vr-provider-ask-agent:hover {
  background: #e6e9ef;
  border-color: #e6e9ef;
}
.vr-modal-button-row .vr-provider-ask-agent svg,
.vr-modal-action-grid .vr-provider-ask-agent svg { stroke: #0a0b0e; color: #0a0b0e; }

/* Purple text hunt: remaining decorated text goes neutral. */
.vr-changelog-more summary { color: var(--vr-muted); }
.vr-changelog-more summary:hover { color: var(--vr-text); }
.vr-modal-health-line { color: rgba(244, 244, 245, 0.85); }

/* Chat env connect card: flat chassis, no tinted wash. */
.vr-env-connect-card {
  border: 1px solid var(--vr-hud-line);
  background: var(--vr-hud-surface);
  box-shadow: none;
}
.vr-env-connect-card h3,
.vr-env-connect-card strong { color: var(--vr-text); }

/* ==========================================================================
   HUD layer: cartoon sticker pass — hard offset shadows, pressable buttons,
   tilting tokens. The stamp vibe applied to the whole UI.
   ========================================================================== */

/* Stamps become stickers: thicker ink, hard drop, opaque backing. */
.vr-stamp {
  border-width: 2.5px;
  background: var(--vr-bg);
  box-shadow: 2px 3px 0 rgba(0, 0, 0, 0.5);
}
.vr-stamp.is-mini {
  border-width: 2px;
  box-shadow: 1.5px 2px 0 rgba(0, 0, 0, 0.5);
}

/* Key cards get the sticker drop. */
.vr-hud-card,
.vr-hud-gate,
.vr-approve-card,
.vr-stamped-head,
.vr-provider-card,
.vr-release-card,
.vr-env-connect-card {
  box-shadow: 3px 4px 0 rgba(0, 0, 0, 0.35);
}
.vr-modal-card {
  border: 1.5px solid var(--vr-border-strong);
  box-shadow: 7px 9px 0 rgba(0, 0, 0, 0.45);
}

/* White primaries: physical buttons. Press = travel into the shadow. */
.vr-agent-followups button.is-primary,
.vr-agent-inline-action.is-primary,
.vr-approve-all,
.vr-new-chat-button,
.vr-provider-ask-agent,
.vr-modal-button-row .vr-provider-ask-agent,
.vr-composer-controls .vr-chat-send:not(.is-stop) {
  box-shadow: 0 3px 0 rgba(0, 0, 0, 0.55);
  transition: transform 0.08s ease, box-shadow 0.08s ease, background 0.12s ease;
}
.vr-agent-followups button.is-primary:active,
.vr-agent-inline-action.is-primary:active,
.vr-approve-all:active,
.vr-new-chat-button:active,
.vr-provider-ask-agent:active,
.vr-modal-button-row .vr-provider-ask-agent:active,
.vr-composer-controls .vr-chat-send:not(.is-stop):active {
  transform: translateY(2px);
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.55);
}

/* Tokens tilt like stickers on hover. */
.vr-chat-provider-dot:hover,
.vr-chat-version-dot:hover,
.vr-provider-token:hover {
  transform: translateY(-1px) rotate(-3deg);
}

/* Modals dock to the chat: rise from the bottom like they popped out of it. */
.vr-modal-backdrop {
  align-items: center;
  background: rgba(4, 5, 8, 0.72);
}
.vr-modal-card {
  animation: vrStampIn 0.22s cubic-bezier(0.2, 0.9, 0.3, 1.2) both;
  transform-origin: 50% 100%;
}
@keyframes vrStampIn {
  from { opacity: 0; transform: translateY(26px) scale(0.97); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}
@media (prefers-reduced-motion: reduce) {
  .vr-modal-card { animation: none; }
}

/* ==========================================================================
   HUD layer: shell console — the app chrome itself joins the design.
   Masthead = brand | stamp | providers | versions | CLI. Flat rail, mono tabs.
   ========================================================================== */
.vr-studio-topbar.vr-console {
  display: flex;
  align-items: center;
  gap: 14px;
  height: 52px;
  padding: 0 16px;
  border-bottom: 1px solid var(--vr-hud-line);
  background: rgba(10, 12, 16, 0.85);
  box-shadow: none;
}
.vr-studio-topbar.vr-console .vr-topbar-brand {
  display: flex;
  align-items: center;
  gap: 9px;
  height: 100%;
  padding-right: 14px;
  border-right: 1px solid var(--vr-hud-line);
  font-weight: 800;
  letter-spacing: -0.01em;
  text-decoration: none;
  color: var(--vr-text);
}
.vr-studio-topbar.vr-console .vr-topbar-brand span img { width: 24px; height: 24px; border-radius: 7px; }
/* The strip lives in the masthead now: strip chrome off, clusters inline. */
.vr-studio-topbar.vr-console .vr-chat-status-strip {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
  flex-wrap: nowrap;
  min-width: 0;
  overflow: hidden;
}
.vr-console-cli {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: var(--vr-hud-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.1em;
  color: var(--vr-muted);
  white-space: nowrap;
}
.vr-console-cli i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgba(148, 163, 184, 0.5);
}
.vr-console-cli.is-on { color: var(--vr-text); }
.vr-console-cli.is-on i { background: var(--vr-green); }

/* Left rail launchers: flat rows, white active. */
.vr-rail-launcher {
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  box-shadow: none;
}
.vr-rail-launcher:hover {
  border-color: var(--vr-hud-line);
  background: rgba(255, 255, 255, 0.03);
  box-shadow: none;
}
.vr-rail-launcher strong { color: var(--vr-text); font-weight: 650; }
.vr-rail-launcher em {
  font-style: normal;
  font-family: var(--vr-hud-mono);
  font-size: 9.5px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--vr-muted);
}

/* Studio tabs: mono flat, white active pill. */
.vr-studio-tabs {
  border: 1px solid var(--vr-hud-line);
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.015);
  box-shadow: none;
  overflow: hidden;
}
.vr-studio-tabs button {
  border: 0;
  border-radius: 0;
  background: transparent;
  color: var(--vr-muted);
  font-weight: 650;
  box-shadow: none;
}
.vr-studio-tabs button:hover { color: var(--vr-text); background: rgba(255, 255, 255, 0.03); }
.vr-studio-tabs button.is-active {
  background: #ffffff;
  color: #0a0b0e;
  border-radius: 7px;
}

/* Recent chats rail: flat rows. */
.vr-recent-rail { border-right: 1px solid var(--vr-hud-line); background: rgba(10, 12, 16, 0.6); box-shadow: none; }
.vr-recent-chat {
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  box-shadow: none;
}
.vr-recent-chat:hover { border-color: var(--vr-hud-line); background: rgba(255, 255, 255, 0.03); }
.vr-recent-chat.is-active { border-color: var(--vr-border-strong); background: rgba(255, 255, 255, 0.045); }
.vr-recent-rail h2 {
  font-family: var(--vr-hud-mono);
  font-size: 9.5px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--vr-muted);
}

/* CLI agent strip above chat: flat chassis. */
.vr-cli-strip { border: 1px solid var(--vr-hud-line); background: var(--vr-hud-surface); box-shadow: none; border-radius: 10px; }
.vr-cli-strip button { box-shadow: none; }

/* Panel/drawer headers: mono labels. */
.vr-studio-panel-title p,
.vr-inspector-head p {
  font-family: var(--vr-hud-mono);
  font-size: 9.5px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--vr-muted);
}

/* Start-here CTA: white physical primary like everything else. */
.vr-start-here-cta {
  border: 0;
  border-radius: 9px;
  background: #ffffff;
  color: #0a0b0e;
  font-weight: 750;
  box-shadow: 0 3px 0 rgba(0, 0, 0, 0.55);
  transition: transform 0.08s ease, box-shadow 0.08s ease, background 0.12s ease;
}
.vr-start-here-cta:hover { background: #e6e9ef; }
.vr-start-here-cta:active { transform: translateY(2px); box-shadow: 0 1px 0 rgba(0, 0, 0, 0.55); }
.vr-start-here-cta svg { stroke: #0a0b0e; color: #0a0b0e; }
.vr-start-here-cta,
.vr-start-here-cta span { font-family: Geist, Inter, "Segoe UI", system-ui, sans-serif !important; }
.vr-start-here-cta span { color: #0a0b0e; letter-spacing: 0.02em; text-transform: none; font-weight: 700; }

/* ==========================================================================
   HUD layer: manga ink pass — the perceptual redesign.
   1) Display typeface: condensed industrial caps on every heading.
   2) Ink panels: 2px light outlines, notched corners, hard drops.
   3) Screentone: halftone dot texture on major surfaces.
   Provider dots and version chips are untouched by design.
   ========================================================================== */
:root {
  --vr-display: "Anton", "Bahnschrift SemiCondensed", "Bahnschrift", "Avenir Next Condensed", "Arial Narrow", "Segoe UI", sans-serif;
  --vr-ink: rgba(232, 193, 90, 0.6);
}

/* 1) Type: headings go condensed caps — this is what makes it read as new. */
.vr-composed-shell h1,
.vr-composed-shell h2,
.vr-composed-shell h3,
.vr-composed-shell h4,
.vr-modal-card h2,
.vr-modal-card h3 {
  font-family: var(--vr-display);
  text-transform: uppercase;
  letter-spacing: 0.045em;
  font-weight: 700;
}
/* Version numbers and telemetry stay mono; gate readout stays mono. */
.vr-stamped-head h2 { font-family: var(--vr-hud-mono); text-transform: none; letter-spacing: -0.02em; }
.vr-hud-gate header strong,
.vr-approve-card > header strong,
.vr-agent-work summary span { font-family: var(--vr-hud-mono); }
/* Controls join the display voice. */
.vr-studio-tabs button,
.vr-rail-launcher strong,
.vr-new-chat-button span,
.vr-approve-all,
.vr-start-here-cta span,
.vr-provider-ask-agent span {
  font-family: var(--vr-display);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

/* 2) Ink panels: heavier outlines + notched corner (comic panel cut). */
.vr-hud-card,
.vr-hud-gate,
.vr-approve-card,
.vr-agent-work,
.vr-env-connect-card {
  border-width: 2px;
  border-color: var(--vr-ink);
  clip-path: polygon(0 0, calc(100% - 14px) 0, 100% 14px, 100% 100%, 0 100%);
}
.vr-hud-card { border-left-width: 3px; }
.vr-stamped-head,
.vr-provider-card,
.vr-release-card,
.vr-inspector-card,
.vr-arch-node {
  border-width: 2px;
  border-color: var(--vr-ink);
}
.vr-arch-node.has-health-red { border-color: rgba(239, 68, 68, 0.6); }
.vr-arch-node.has-health-orange { border-color: rgba(249, 115, 22, 0.55); }
.vr-modal-card {
  border-width: 2px;
  border-color: var(--vr-ink);
}

/* 3) Screentone: halftone texture, coarse tiles only (cheap to paint). */
.vr-modal-card {
  background:
    radial-gradient(rgba(226, 232, 240, 0.035) 1px, transparent 1px),
    linear-gradient(180deg, rgba(16, 18, 23, 0.99), rgba(9, 10, 14, 0.995));
  background-size: 22px 22px, auto;
}
.vr-arch-canvas {
  background-image: radial-gradient(rgba(200, 210, 225, 0.09) 1px, transparent 1px);
  background-size: 26px 26px;
}

/* Stamps get more ink presence at panel scale. */
.vr-stamp { letter-spacing: 0.24em; }
.vr-stamped-head > .vr-stamp { font-size: 14px; }

/* ==========================================================================
   HUD layer: full conversion — the display voice and flat tags everywhere.
   ========================================================================== */

/* Buttons default to the READABLE sans (was condensed display caps — the #1
   readability complaint). Marquee buttons (tabs, big CTAs) opt back into Anton
   via their own higher-specificity rules in the readability pass. */
.vr-composed-shell button:not(.vr-stamp),
.vr-modal-card button:not(.vr-stamp),
.vr-composed-shell .vr-agent-inline-action {
  font-family: var(--vr-hud-sans, 'Geist', 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif);
  text-transform: none;
  letter-spacing: 0.01em;
}

/* Kill the pill: every badge/chip/tag becomes a flat mono tag.
   Rounded-full is the strongest remaining vibecoded signal. */
.vr-composed-shell b[class*="badge"],
.vr-composed-shell .vr-status-badge,
.vr-modal-checks li b,
.vr-modal-health b,
.vr-env-connect-card b,
.vr-qs-steps b,
.vr-agent-cli-pill,
.vr-chat-message em.is-ready {
  border-radius: 5px !important;
  font-family: var(--vr-hud-mono);
  font-size: 9.5px;
  font-weight: 650;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  background: transparent;
}

/* Captions and metadata run one size smaller — denser telemetry. */
.vr-composed-shell small,
.vr-composed-shell em:not(.vr-plan-step-tag) {
  font-size: 11px;
}

/* The draggable strip lives under the composer — the launch tray. */
.vr-chat-command-bar .vr-chat-status-strip {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 10px 4px 0;
  padding: 8px 12px;
  border: 1px solid var(--vr-hud-line);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.015);
  box-shadow: none;
}

/* Provider modal checks: flat ink rows, mono status words. */
.vr-modal-checks li {
  border: 1px solid var(--vr-hud-line);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.015);
}
.vr-modal-checks li b {
  border: 0;
  padding: 0;
  color: var(--vr-muted);
}
.vr-modal-checks li.done b { color: var(--vr-green); background: transparent; border: 0; }
.vr-modal-checks li.running b,
.vr-modal-checks li.active b { color: var(--vr-orange); background: transparent; border: 0; }

/* Map nodes join the display voice. */
.vr-arch-node > div strong {
  font-family: var(--vr-display);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.vr-modal-foot a { color: var(--vr-text); text-decoration: underline; text-underline-offset: 3px; }

/* ==========================================================================
   HUD layer: quick strikes, fullscreen map, color back, card fix.
   ========================================================================== */

/* Quick actions: one click stages a precise mission in the composer. */
.vr-quickstrike {
  border: 1px solid var(--vr-hud-line);
  border-radius: 10px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.015);
}
.vr-quickstrike header {
  font-family: var(--vr-hud-mono);
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.13em;
  text-transform: uppercase;
  color: var(--vr-text);
  padding: 8px 13px;
  border-bottom: 1px solid var(--vr-hud-line);
  background: rgba(255, 255, 255, 0.02);
}
.vr-quickstrike > div {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 13px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.07);
  font-size: 13px;
  font-weight: 550;
  color: rgba(244, 244, 245, 0.9);
}
.vr-quickstrike > div:last-child { border-bottom: 0; }
.vr-quickstrike button {
  margin-left: auto;
  border: 0;
  border-radius: 7px;
  background: #ffffff;
  color: #0a0b0e;
  font-weight: 750;
  font-size: 12px;
  padding: 5px 16px;
  cursor: pointer;
  box-shadow: 0 3px 0 rgba(0, 0, 0, 0.55);
  transition: transform 0.08s ease, box-shadow 0.08s ease;
}
.vr-quickstrike button:hover { background: #e6e9ef; }
.vr-quickstrike button:active { transform: translateY(2px); box-shadow: 0 1px 0 rgba(0, 0, 0, 0.55); }

/* Expanded inspector = true fullscreen map. */
.vr-inspector-panel.is-expanded {
  position: fixed;
  inset: 0;
  z-index: 80;
  width: auto;
  max-width: none;
  height: auto;
  border-radius: 0;
  border: 0;
  background: var(--vr-bg);
}

/* Color back — semantic hues, more present. */
.vr-arch-zone:nth-of-type(1) { color: var(--vr-green); }
.vr-arch-zone:nth-of-type(2) { color: var(--vr-blue); }
.vr-arch-zone:nth-of-type(3) { color: var(--vr-orange); }
.vr-rail-launcher.is-architecture svg { color: var(--vr-blue); stroke: var(--vr-blue); }
.vr-rail-launcher.is-providers svg { color: var(--vr-green); stroke: var(--vr-green); }
.vr-rail-launcher.is-versions svg { color: var(--vr-orange); stroke: var(--vr-orange); }
.vr-rail-launcher.is-worktree svg { color: #8fa7ff; stroke: #8fa7ff; }
.vr-hud-sev { font-size: 12px; }
.vr-hud-gate header b { font-size: 11px; }
.vr-meta-chip { color: var(--vr-text); }
.vr-provider-card > div strong { color: var(--vr-text); }
.vr-chat-gate-chip.vr-stamp { font-size: 10px; }


/* Map nodes as mini collectibles: tinted glyph plate, display name, press. */
.vr-arch-node {
  cursor: pointer;
  transition: border-color 0.1s ease, background 0.1s ease;
}
.vr-arch-node:active { background: rgba(255, 255, 255, 0.05); }
.vr-arch-node .vr-arch-node-icon {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  border: 1px solid var(--vr-hud-line);
  background-color: rgba(255, 255, 255, 0.03);
  background-image: radial-gradient(rgba(226, 232, 240, 0.07) 1px, transparent 1px);
  background-size: 8px 8px;
  box-shadow: 2px 2px 0 rgba(0, 0, 0, 0.4);
}

/* Welcome quickstart: step buttons are white physicals too. */
.vr-qs-steps button[data-action="quickstart-go"] {
  border: 0;
  border-radius: 8px;
  background: #ffffff;
  color: #0a0b0e;
  font-family: var(--vr-display);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-weight: 700;
  padding: 7px 16px;
  cursor: pointer;
  box-shadow: 0 3px 0 rgba(0, 0, 0, 0.55);
  transition: transform 0.08s ease, box-shadow 0.08s ease, background 0.12s ease;
}
.vr-qs-steps button[data-action="quickstart-go"]:hover { background: #e6e9ef; }
.vr-qs-steps button[data-action="quickstart-go"]:active { transform: translateY(2px); box-shadow: 0 1px 0 rgba(0, 0, 0, 0.55); }
.vr-qs-steps > div { border-color: var(--vr-hud-line); background: rgba(255, 255, 255, 0.015); box-shadow: none; }
.vr-qs-steps b { color: var(--vr-green); font-family: var(--vr-hud-mono); font-size: 10px; letter-spacing: 0.1em; text-transform: uppercase; }

/* ==========================================================================
   raven deck: the card dealt into chat. Portrait on the left, live check
   rows ticking on the right, stamp lands when the run completes.
   ========================================================================== */
.vr-card-message {
  display: grid;
  grid-template-columns: 128px minmax(0, 1fr);
  gap: 14px;
  align-items: start;
}
.vr-card-portrait {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px;
  background: var(--vr-panel-2);
  border: 2px solid var(--vr-ink);
  clip-path: polygon(0 0, calc(100% - 10px) 0, 100% 10px, 100% 100%, 0 100%);
  transform: rotate(-1.5deg);
  font-family: var(--vr-display);
}
.vr-card-message.is-flawless .vr-card-portrait {
  border-color: var(--vr-gold);
  box-shadow: 0 0 16px rgba(232, 193, 90, 0.3);
}
.vr-card-portrait strong {
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--vr-text);
}
.vr-card-portrait em {
  font-family: var(--vr-hud-mono);
  font-style: normal;
  font-size: 8.5px;
  letter-spacing: 1px;
  color: var(--vr-gold-bright);
}
.vr-card-portrait .vr-deck-grade { top: 8px; right: 10px; }
.vr-card-rows {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-family: var(--vr-hud-mono);
  font-size: 12px;
  padding-top: 2px;
}
.vr-card-row {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--vr-text);
}
.vr-card-row.is-ready > span:first-child { color: var(--vr-green); }
.vr-card-row.is-fix > span:first-child { color: var(--vr-orange); }
.vr-card-row.is-running { color: var(--vr-muted); }
.vr-card-fix {
  margin-left: auto;
  background: none;
  border: none;
  padding: 0;
  color: var(--vr-gold-bright);
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
  font: inherit;
}
.vr-card-fix:hover { color: #ffffff; }
.vr-card-summary { margin: 4px 0 0; color: var(--vr-muted); font-size: 11px; }
.vr-card-error { margin: 4px 0 0; color: var(--vr-orange); font-size: 11px; }
.vr-card-stamp-row { margin-top: 6px; }

/* ==========================================================================
   card table: the trading card. Portrait foil frame in the provider's
   brand metal, dark art window with the glowing glyph, grade line.
   Sheen is static (no animation) — paint stays cheap.
   ========================================================================== */
.vr-tcard {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 5px;
  border: none;
  border-radius: 11px;
  background: var(--vr-foil);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.55), inset 0 0 0 1px rgba(0, 0, 0, 0.35);
  cursor: pointer;
  text-align: left;
  transition: transform 140ms ease, box-shadow 140ms ease;
  font-family: var(--vr-display);
}
button.vr-tcard { appearance: none; }
.vr-tcard:hover { transform: translateY(-5px) scale(1.02); box-shadow: 0 16px 30px rgba(0, 0, 0, 0.6), inset 0 0 0 1px rgba(0, 0, 0, 0.35); }
.vr-tcard.is-hand { width: 100px; height: 140px; }
.vr-tcard.is-dealt { width: 128px; height: 179px; }
.vr-tcard.is-map { width: 90px; height: 126px; }
.vr-tcard-sheen {
  position: absolute;
  inset: 0;
  border-radius: 11px;
  background: linear-gradient(115deg, transparent 32%, rgba(255, 255, 255, 0.2) 46%, transparent 58%);
  pointer-events: none;
  z-index: 2;
}
.vr-tcard-inner {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 6px;
  background: #140a0c;
  overflow: hidden;
  padding: 5px 6px 6px;
}
.vr-tcard-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 4px;
}
.vr-tcard-head b {
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vr-tcard.is-dealt .vr-tcard-head b { font-size: 11px; }
.vr-tcard-head i {
  font-style: normal;
  font-size: 13px;
  font-weight: 800;
  color: #ffd76e;
}
.vr-tcard.is-dealt .vr-tcard-head i { font-size: 16px; }
.vr-tcard-artwin {
  position: relative;
  flex: 1;
  margin: 4px 0;
  border-radius: 4px;
  display: grid;
  place-items: center;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.14);
}
.vr-tcard-artwin::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image: radial-gradient(circle, rgba(255, 255, 255, 0.16) 1px, transparent 1.3px);
  background-size: 7px 7px;
}
.vr-tcard-artwin .vr-provider-token.is-tcard {
  position: relative;
  width: auto;
  height: auto;
  background: none;
  border: none;
  box-shadow: none;
}
.vr-tcard-artwin .vr-provider-token.is-tcard svg,
.vr-tcard-artwin .vr-provider-token.is-tcard img {
  width: 32px;
  height: 32px;
}
.vr-tcard.is-dealt .vr-tcard-artwin .vr-provider-token.is-tcard svg,
.vr-tcard.is-dealt .vr-tcard-artwin .vr-provider-token.is-tcard img {
  width: 44px;
  height: 44px;
}
.vr-tcard-type {
  font-family: var(--vr-hud-mono);
  font-size: 6px;
  letter-spacing: 1.4px;
  color: rgba(255, 255, 255, 0.55);
}
.vr-tcard-grade {
  margin-top: auto;
  padding-top: 3px;
  font-family: var(--vr-hud-mono);
  font-size: 6.5px;
  letter-spacing: 0.8px;
  color: #e8d9a8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vr-tcard.is-dealt .vr-tcard-type { font-size: 7px; }
.vr-tcard.is-dealt .vr-tcard-grade { font-size: 7.5px; }
.vr-tcard.is-flawless { box-shadow: 0 10px 22px rgba(0, 0, 0, 0.55), 0 0 22px rgba(232, 193, 90, 0.45), inset 0 0 0 1px rgba(0, 0, 0, 0.35); }
.vr-tcard.is-flawless .vr-tcard-sheen { background: linear-gradient(115deg, transparent 28%, rgba(255, 244, 200, 0.34) 45%, transparent 58%); }
.vr-tcard.is-back {
  border: 2.5px solid #a8743a;
  background:
    radial-gradient(circle at 50% 42%, rgba(232, 193, 90, 0.12), transparent 60%),
    repeating-linear-gradient(45deg, #141418, #141418 7px, #1b1b22 7px, #1b1b22 14px);
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.vr-tcard.is-back .vr-tcard-backart img { width: 44px; height: 44px; opacity: 0.85; }
.vr-tcard.is-back .vr-tcard-backname {
  font-family: var(--vr-hud-mono);
  font-size: 7px;
  letter-spacing: 1.4px;
  color: #c9987e;
  text-transform: uppercase;
}
/* the dealt card sits raw on the table — the old portrait panel chrome dies */
.vr-card-portrait {
  background: none;
  border: none;
  clip-path: none;
  padding: 0;
  overflow: visible;
  transform: rotate(-2.5deg);
}
.vr-card-message { grid-template-columns: 136px minmax(0, 1fr); }

.vr-tcard[data-foil='supabase'] {
  background: linear-gradient(160deg, #eafff2, #3ecf6e 30%, #bdf5d3 52%, #0f6a38 78%, #ffd76e);
}
.vr-tcard[data-foil='supabase'] .vr-tcard-artwin {
  background: radial-gradient(circle at 50% 42%, #1f7a45, #0a1a10 78%);
}
.vr-tcard[data-foil='supabase'] .vr-tcard-artwin .vr-provider-token.is-tcard {
  filter: drop-shadow(0 0 9px #3ecf6e);
}

.vr-tcard[data-foil='vercel'] {
  background: linear-gradient(160deg, #f4f4f8, #9aa0ae 30%, #ffffff 52%, #5a606e 78%, #ffd76e);
}
.vr-tcard[data-foil='vercel'] .vr-tcard-artwin {
  background: radial-gradient(circle at 50% 42%, #3a3f4c, #0d0d12 78%);
}
.vr-tcard[data-foil='vercel'] .vr-tcard-artwin .vr-provider-token.is-tcard {
  filter: drop-shadow(0 0 9px #e8eaf0);
}

.vr-tcard[data-foil='stripe'] {
  background: linear-gradient(160deg, #dbe4ff, #5d76d8 30%, #c6d2ff 52%, #3a4fa8 78%, #ffd76e);
}
.vr-tcard[data-foil='stripe'] .vr-tcard-artwin {
  background: radial-gradient(circle at 50% 42%, #2a3a75, #0a0e20 78%);
}
.vr-tcard[data-foil='stripe'] .vr-tcard-artwin .vr-provider-token.is-tcard {
  filter: drop-shadow(0 0 9px #8fa7ff);
}

.vr-tcard[data-foil='sentry'] {
  background: linear-gradient(160deg, #ffe3ea, #c2405e 30%, #ffd4de 52%, #343040 78%, #ffd76e);
}
.vr-tcard[data-foil='sentry'] .vr-tcard-artwin {
  background: radial-gradient(circle at 50% 42%, #2b2732, #170a10 78%);
}
.vr-tcard[data-foil='sentry'] .vr-tcard-artwin .vr-provider-token.is-tcard {
  filter: drop-shadow(0 0 9px #ff8fa8);
}

.vr-tcard[data-foil='github'] {
  background: linear-gradient(160deg, #f0f0f4, #8a8f9a 30%, #ffffff 52%, #4a4f58 78%, #ffd76e);
}
.vr-tcard[data-foil='github'] .vr-tcard-artwin {
  background: radial-gradient(circle at 50% 42%, #3a3f47, #101318 78%);
}
.vr-tcard[data-foil='github'] .vr-tcard-artwin .vr-provider-token.is-tcard {
  filter: drop-shadow(0 0 9px #d0d5de);
}

.vr-tcard[data-foil='posthog'] {
  background: linear-gradient(160deg, #fff3c4, #e8a33d 30%, #ffe9a8 52%, #9a6414 78%, #ffd76e);
}
.vr-tcard[data-foil='posthog'] .vr-tcard-artwin {
  background: radial-gradient(circle at 50% 42%, #6a4a12, #1a1206 78%);
}
.vr-tcard[data-foil='posthog'] .vr-tcard-artwin .vr-provider-token.is-tcard {
  filter: drop-shadow(0 0 9px #ffd76e);
}

.vr-tcard[data-foil='clerk'] {
  background: linear-gradient(160deg, #e8e0ff, #7a5cd8 30%, #d9ccff 52%, #4a2fa8 78%, #ffd76e);
}
.vr-tcard[data-foil='clerk'] .vr-tcard-artwin {
  background: radial-gradient(circle at 50% 42%, #3a2a75, #140e28 78%);
}
.vr-tcard[data-foil='clerk'] .vr-tcard-artwin .vr-provider-token.is-tcard {
  filter: drop-shadow(0 0 9px #b9a8ff);
}

.vr-tcard[data-foil='authjs'] {
  background: linear-gradient(160deg, #d8f2ff, #3aa2d8 30%, #b8e6ff 52%, #1a5a80 78%, #ffd76e);
}
.vr-tcard[data-foil='authjs'] .vr-tcard-artwin {
  background: radial-gradient(circle at 50% 42%, #144a68, #081420 78%);
}
.vr-tcard[data-foil='authjs'] .vr-tcard-artwin .vr-provider-token.is-tcard {
  filter: drop-shadow(0 0 9px #7fd0f0);
}

.vr-tcard[data-foil='resend'] {
  background: linear-gradient(160deg, #f2f2f2, #9a9aa2 30%, #ffffff 52%, #54545c 78%, #ffd76e);
}
.vr-tcard[data-foil='resend'] .vr-tcard-artwin {
  background: radial-gradient(circle at 50% 42%, #3a3a42, #101014 78%);
}
.vr-tcard[data-foil='resend'] .vr-tcard-artwin .vr-provider-token.is-tcard {
  filter: drop-shadow(0 0 9px #d8d8e0);
}

.vr-tcard[data-foil='upstash'] {
  background: linear-gradient(160deg, #d8fff5, #2fa98c 30%, #b8f0e4 52%, #0f6a55 78%, #ffd76e);
}
.vr-tcard[data-foil='upstash'] .vr-tcard-artwin {
  background: radial-gradient(circle at 50% 42%, #145a48, #081a15 78%);
}
.vr-tcard[data-foil='upstash'] .vr-tcard-artwin .vr-provider-token.is-tcard {
  filter: drop-shadow(0 0 9px #7fe0c8);
}

/* ==========================================================================
   card table: the hand — fanned cards bottom-right of the chat surface —
   and the binder grid in the provider inspector.
   ========================================================================== */
.vr-studio-chat { position: relative; }
.vr-hand {
  position: absolute;
  right: 18px;
  bottom: 272px;
  z-index: 30;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  pointer-events: none;
}
.vr-hand-toggle {
  pointer-events: auto;
  border: 1.5px solid var(--vr-border-strong);
  background: var(--vr-plate);
  color: var(--vr-gold-bright);
  font-family: var(--vr-hud-mono);
  font-size: 8px;
  letter-spacing: 1.6px;
  padding: 3px 9px;
  border-radius: 4px;
  cursor: pointer;
}
.vr-hand-fan {
  display: flex;
  align-items: flex-end;
  padding: 14px 10px 6px 10px;
  pointer-events: auto;
}
.vr-hand-fan .vr-tcard {
  margin-left: -58px;
  transform: rotate(var(--vr-rot, 0deg)) translateY(var(--vr-lift, 0px));
  transform-origin: 50% 120%;
}
.vr-hand-fan .vr-tcard:first-child { margin-left: 0; }
.vr-hand-fan .vr-tcard:hover {
  transform: rotate(0deg) translateY(-18px) scale(1.08);
  z-index: 6;
}
.vr-hand.is-collapsed .vr-hand-fan { display: none; }
.vr-binder {
  display: grid !important;
  grid-template-columns: repeat(auto-fill, minmax(104px, 1fr));
  gap: 14px;
  justify-items: center;
  padding-top: 8px;
}
@media (max-width: 1100px) {
  .vr-hand { display: none; }
}

/* ==========================================================================
   card table: the shell. Slim icon rail, recent chats in a flyout, chat
   floating on the table with a center spotlight, map medallion.
   ========================================================================== */
.vr-composition-body.is-table { grid-template-columns: 64px minmax(0, 1fr); }
.vr-composition-body.is-table.has-inspector { grid-template-columns: 64px minmax(0, 1fr) minmax(388px, 428px); }
.vr-left-context-rail.is-table-rail {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border: none;
  background: transparent;
}
.vr-rail-raven { width: 40px; height: 40px; display: grid; place-items: center; }
.vr-rail-raven img { width: 36px; height: 36px; filter: drop-shadow(0 0 8px rgba(232, 193, 90, 0.4)); }
.vr-rail-sep { width: 22px; height: 1.5px; background: var(--vr-border-strong); }
.vr-rail-icon {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border: 1.5px solid var(--vr-border);
  border-radius: 10px;
  background: rgba(13, 12, 16, 0.55);
  color: var(--vr-muted);
  cursor: pointer;
  transition: border-color 100ms ease, color 100ms ease, transform 100ms ease;
}
.vr-rail-icon:hover { transform: translateY(-1px); color: var(--vr-gold-bright); border-color: var(--vr-border-strong); }
.vr-rail-icon.is-active { color: var(--vr-gold-bright); border-color: var(--vr-gold); box-shadow: 0 0 12px rgba(232, 193, 90, 0.25); }
.vr-rail-icon.is-new { color: #16090a; background: var(--vr-gold-bright); border-color: var(--vr-gold-bright); }
.vr-rail-icon.is-new:hover { color: #16090a; background: #ffffff; }
.vr-rail-icon i[data-icon] { width: 17px; height: 17px; }
.vr-chats-flyout {
  position: absolute;
  left: 62px;
  top: 96px;
  z-index: 70;
  width: 288px;
  max-height: 70vh;
  overflow: auto;
  border: 2px solid var(--vr-border-strong);
  border-radius: 12px;
  background: var(--vr-plate);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.6);
  padding: 10px;
}
.vr-chats-flyout .vr-recent-rail { border: none; background: transparent; padding: 0; height: auto; }
/* the table spotlight under the chat */
.vr-studio-chat::before {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(ellipse 62% 48% at 50% 58%, rgba(232, 193, 90, 0.07), transparent 70%);
}
/* chat floats: lane loses its box, composer gets the gold frame */
.vr-chat-lane.is-primary { border: none; background: transparent; box-shadow: none; }
.vr-studio-chat:not(.is-split) .vr-chat-lane.is-primary .vr-chat-command-bar > .vr-chat-composer {
  border: 2px solid var(--vr-border-strong);
  border-radius: 14px;
  background: rgba(14, 4, 5, 0.88);
  box-shadow: 0 0 26px rgba(232, 193, 90, 0.1), 0 14px 30px rgba(0, 0, 0, 0.45);
}
.vr-chat-lane.is-primary .vr-chat-transcript { max-width: 880px; width: 100%; margin: 0 auto; }
.vr-chat-lane.is-primary .vr-chat-command-bar { max-width: 880px; width: 100%; margin: 0 auto; }
.vr-map-medallion {
  position: absolute;
  right: 22px;
  top: 14px;
  z-index: 31;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--vr-gold);
}
.vr-map-medallion i[data-icon] {
  width: 46px;
  height: 46px;
  padding: 12px;
  border: 2.5px solid var(--vr-gold);
  border-radius: 50%;
  background: radial-gradient(circle at 40% 35%, #17171c, #0b0b0d);
  box-shadow: 0 0 16px rgba(232, 193, 90, 0.3);
  transition: transform 120ms ease, box-shadow 120ms ease;
}
.vr-map-medallion:hover i[data-icon] { transform: scale(1.06); box-shadow: 0 0 24px rgba(232, 193, 90, 0.5); }
.vr-map-medallion em {
  font-style: normal;
  font-family: var(--vr-hud-mono);
  font-size: 7.5px;
  letter-spacing: 1.8px;
  color: var(--vr-gold-bright);
}

/* ==========================================================================
   card table: the region map — fullscreen takeover, gold dotted routes,
   territory header, no buttons but close.
   ========================================================================== */
.vr-studio-architecture.is-region-map {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  flex-direction: column;
  border: none;
  border-radius: 0;
  background:
    radial-gradient(ellipse 65% 50% at 25% 0%, rgba(232, 193, 90, 0.2), transparent 65%),
    radial-gradient(ellipse 50% 45% at 88% 75%, rgba(255, 170, 60, 0.14), transparent 65%),
    var(--vr-bg);
}
.vr-studio-architecture.is-region-map > header {
  display: flex;
  align-items: baseline;
  gap: 16px;
  padding: 16px 22px 10px;
  border-bottom: 1.5px solid var(--vr-border);
}
.vr-studio-architecture.is-region-map > header strong {
  font-family: var(--vr-display);
  font-size: 17px;
  font-weight: 800;
  letter-spacing: 2.5px;
  color: var(--vr-gold-bright);
}
.vr-studio-architecture.is-region-map > header span {
  font-family: var(--vr-hud-mono);
  font-size: 9px;
  letter-spacing: 1.4px;
  color: var(--vr-muted);
  text-transform: uppercase;
}
.vr-region-hint {
  margin-left: auto;
  font-style: normal;
  font-family: var(--vr-hud-mono);
  font-size: 8px;
  letter-spacing: 1.6px;
  color: var(--vr-muted);
}
.vr-region-close {
  border: 1.5px solid var(--vr-border-strong);
  border-radius: 8px;
  background: var(--vr-plate);
  color: var(--vr-gold-bright);
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  cursor: pointer;
}
.vr-studio-architecture.is-region-map .vr-arch-body { flex: 1; min-height: 0; }
.vr-studio-architecture.is-region-map .vr-arch-edges path {
  stroke: var(--vr-gold);
  stroke-dasharray: 5 6;
  stroke-width: 1.6;
  opacity: 0.65;
}
.vr-studio-architecture.is-region-map .vr-arch-node {
  border: 2px solid var(--vr-border-strong);
  background: var(--vr-plate);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.45);
}
.vr-studio-architecture.is-region-map .vr-arch-node.is-provider { border-color: var(--vr-gold); cursor: pointer; }
.vr-studio-architecture.is-region-map .vr-arch-node.is-provider:hover { box-shadow: 0 0 18px rgba(232, 193, 90, 0.45); border-color: var(--vr-gold-bright); }

@keyframes vr-foil-sweep {
  from { transform: translateX(-140%); }
  to { transform: translateX(240%); }
}
.vr-card-message.is-flawless .vr-tcard .vr-tcard-sheen {
  animation: vr-foil-sweep 900ms ease-out 1;
}

/* ==========================================================================
   card table round 2: the real table. Felt surface with a leather rim and
   gold inlay, playmat placed cards, gold pill actions, dealt quickstart,
   versions & worktree in the card language, map laid on the same table.
   ========================================================================== */
/* the table itself */
.vr-composition-body.is-table { position: relative; }
.vr-composition-body.is-table::before {
  content: '';
  position: absolute;
  inset: 8px 12px 6px 4px;
  border-radius: 30px;
  background:
    radial-gradient(ellipse 85% 75% at 50% 42%, rgba(24, 24, 30, 0.92), rgba(12, 12, 16, 0.96) 78%),
    #0e0e12;
  border: 2px solid rgba(232, 193, 90, 0.32);
  box-shadow:
    inset 0 0 0 7px rgba(26, 24, 30, 0.95),
    inset 0 0 0 9px rgba(232, 193, 90, 0.14),
    inset 0 0 90px rgba(0, 0, 0, 0.55),
    0 24px 60px rgba(0, 0, 0, 0.55);
  pointer-events: none;
}
.vr-composition-body.is-table > * { position: relative; z-index: 1; }
/* playmat: cards live anywhere on the table */
.vr-playmat { position: absolute; inset: 0; z-index: 24; pointer-events: none; }
.vr-playmat .vr-tcard,
.vr-playmat .vr-vcard { pointer-events: auto; }
.vr-tcard.is-placed {
  position: absolute;
  z-index: 24;
  transform: translate(-50%, -50%) rotate(var(--vr-rot, 0deg));
  box-shadow: 0 16px 34px rgba(0, 0, 0, 0.6), inset 0 0 0 1px rgba(0, 0, 0, 0.35);
}
.vr-tcard.is-placed:hover {
  transform: translate(-50%, -50%) rotate(0deg) scale(1.06);
  z-index: 26;
}
.vr-tcard-unplace {
  position: absolute;
  top: -9px;
  right: -9px;
  z-index: 5;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1.5px solid var(--vr-border-strong);
  background: var(--vr-plate);
  color: var(--vr-gold-bright);
  display: grid;
  place-items: center;
  font-size: 9px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 100ms ease;
}
.vr-tcard.is-placed:hover .vr-tcard-unplace { opacity: 1; }
/* chat actions: gold pills instead of bare underlines */
.vr-card-fix {
  margin-left: auto;
  border: 1.5px solid var(--vr-border-strong);
  border-radius: 5px;
  background: var(--vr-plate);
  color: var(--vr-gold-bright);
  font-family: var(--vr-hud-mono);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1.2px;
  padding: 2px 9px;
  text-decoration: none;
  cursor: pointer;
  transition: background 100ms ease, color 100ms ease, transform 100ms ease;
}
.vr-card-fix:hover { background: var(--vr-gold-bright); color: #16090a; transform: translateY(-1px); }
.vr-card-actions { display: flex; gap: 8px; margin-top: 8px; }
.vr-card-actions button {
  border: 1.5px solid var(--vr-border-strong);
  border-radius: 6px;
  background: var(--vr-plate);
  color: var(--vr-gold-bright);
  font-family: var(--vr-hud-mono);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.2px;
  padding: 5px 12px;
  cursor: pointer;
  transition: background 100ms ease, color 100ms ease, transform 100ms ease;
}
.vr-card-actions button:hover { background: var(--vr-gold-bright); color: #16090a; transform: translateY(-1px); }
.vr-card-row.is-log span:first-child { color: var(--vr-gold); font-size: 10px; }
.vr-card-stamp-row { margin-top: 8px; }
/* quickstart: draw your starting hand */
.vr-qs-deal {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  padding: 14px 2px 6px;
}
.vr-qs-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 7px;
  min-height: 168px;
  padding: 8px;
  border-radius: 10px;
  border: none;
  background: var(--vr-foil);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.5), inset 0 0 0 1px rgba(0, 0, 0, 0.35);
  color: var(--vr-text);
}
.vr-qs-card::before {
  content: '';
  position: absolute;
  inset: 4px;
  border-radius: 7px;
  background: #140a0c;
}
.vr-qs-card > * { position: relative; z-index: 1; margin: 0 4px; }
.vr-qs-card-top { display: flex; justify-content: space-between; align-items: center; margin-top: 5px; }
.vr-qs-card-top b { font-family: var(--vr-display); font-size: 15px; font-weight: 800; color: #ffd76e; }
.vr-qs-won { color: var(--vr-green); }
.vr-qs-won i[data-icon] { width: 15px; height: 15px; }
.vr-qs-card strong { font-family: var(--vr-display); font-size: 13px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.4px; line-height: 1.15; }
.vr-qs-card em { font-style: normal; font-size: 10.5px; line-height: 1.45; color: var(--vr-muted); }
.vr-qs-card button {
  margin-top: auto;
  margin-bottom: 6px;
  border: none;
  border-radius: 6px;
  background: var(--vr-gold-bright);
  color: #16090a;
  font-family: var(--vr-display);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 6px 0;
  cursor: pointer;
}
.vr-qs-card button:hover { background: #ffffff; }
.vr-qs-claimed {
  margin-top: auto;
  margin-bottom: 8px;
  font-family: var(--vr-hud-mono);
  font-size: 8px;
  letter-spacing: 1.6px;
  color: var(--vr-green);
}
.vr-qs-card.is-done { opacity: 0.86; }
/* versions & worktree speak card */
.vr-release-card,
.vr-release-row,
.vr-branch-row,
.vr-inspector-changelog button {
  border: 1.5px solid var(--vr-border) !important;
  border-radius: 9px !important;
  background: var(--vr-panel) !important;
}
.vr-release-card.is-selected,
.vr-release-row.is-selected,
.vr-release-card:hover,
.vr-release-row:hover,
.vr-branch-row:hover,
.vr-inspector-changelog button:hover {
  border-color: var(--vr-gold) !important;
  box-shadow: 0 0 14px rgba(232, 193, 90, 0.22);
}
/* the map lies on the same table — not a separate black screen */
.vr-studio-body { position: relative; }
.vr-studio-architecture.is-region-map {
  position: absolute;
  inset: 0;
  z-index: 40;
  background: transparent;
}

/* ==========================================================================
   card table round 3: everything on the table. Versions, worktree, and the
   binder are card spreads on the felt; interactive press-feel on all chat
   controls; stop button reads gold, not purple.
   ========================================================================== */
.vr-table-view {
  position: absolute;
  inset: 0;
  z-index: 40;
  display: flex;
  flex-direction: column;
  background: transparent;
  overflow: auto;
}
.vr-table-view-head {
  display: flex;
  align-items: baseline;
  gap: 16px;
  padding: 18px 24px 12px;
  border-bottom: 1.5px solid var(--vr-border);
}
.vr-table-view-head strong {
  font-family: var(--vr-display);
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 2.5px;
  color: var(--vr-gold-bright);
}
.vr-table-view-head span {
  font-family: var(--vr-hud-mono);
  font-size: 9px;
  letter-spacing: 1.3px;
  color: var(--vr-muted);
  text-transform: uppercase;
}
.vr-table-view-head .vr-region-close { margin-left: auto; }
.vr-table-warning {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 14px 24px 0;
  padding: 10px 14px;
  border: 1.5px solid rgba(255, 184, 77, 0.55);
  border-radius: 10px;
  background: rgba(34, 30, 24, 0.5);
  color: var(--vr-text);
  font-size: 12.5px;
}
.vr-table-warning button {
  margin-left: auto;
  border: 1.5px solid var(--vr-orange);
  border-radius: 6px;
  background: var(--vr-plate);
  color: var(--vr-orange);
  font-family: var(--vr-hud-mono);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1.2px;
  padding: 5px 12px;
  cursor: pointer;
}
.vr-table-warning button:hover { background: var(--vr-orange); color: #16090a; }
.vr-table-empty { color: var(--vr-muted); font-family: var(--vr-hud-mono); font-size: 11px; padding: 30px; }
.vr-table-foot { padding: 6px 24px 20px; }
.vr-table-foot button {
  border: 1.5px dashed var(--vr-border-strong);
  border-radius: 8px;
  background: none;
  color: var(--vr-gold-bright);
  font-family: var(--vr-hud-mono);
  font-size: 10px;
  letter-spacing: 1.4px;
  padding: 8px 16px;
  cursor: pointer;
}
.vr-table-foot button:hover { border-style: solid; background: rgba(232, 193, 90, 0.08); }
/* version cards on the felt */
.vr-version-spread,
.vr-branch-spread,
.vr-binder-spread {
  display: flex;
  flex-wrap: wrap;
  gap: 22px;
  align-content: flex-start;
  padding: 26px;
}
.vr-binder-spread { gap: 26px; }
.vr-vcard {
  position: relative;
  width: 168px;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px;
  border-radius: 11px;
  border: none;
  background: var(--vr-foil);
  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.55), inset 0 0 0 1px rgba(0, 0, 0, 0.35);
  cursor: pointer;
  text-align: left;
  transform: rotate(var(--vr-rot, 0deg));
  transition: transform 130ms ease, box-shadow 130ms ease;
}
.vr-vcard::before {
  content: '';
  position: absolute;
  inset: 5px;
  border-radius: 8px;
  background: #140a0c;
}
.vr-vcard > * { position: relative; z-index: 1; }
.vr-vcard:hover { transform: rotate(0deg) translateY(-6px) scale(1.03); box-shadow: 0 18px 36px rgba(0, 0, 0, 0.6), 0 0 18px rgba(232, 193, 90, 0.3); }
.vr-vcard:not(.is-current) { filter: saturate(0.75) brightness(0.9); }
.vr-vcard.is-current { box-shadow: 0 12px 26px rgba(0, 0, 0, 0.55), 0 0 22px rgba(232, 193, 90, 0.4), inset 0 0 0 1px rgba(0, 0, 0, 0.35); }
.vr-vcard-top b {
  font-family: var(--vr-display);
  font-size: 22px;
  font-weight: 800;
  color: #ffe9ad;
  letter-spacing: 0.5px;
}
.vr-vcard-branch {
  font-family: var(--vr-hud-mono);
  font-size: 8.5px;
  letter-spacing: 1px;
  color: var(--vr-muted);
  word-break: break-all;
}
.vr-vcard-meta { font-family: var(--vr-hud-mono); font-size: 8px; letter-spacing: 0.8px; color: #8a6a55; }
.vr-vcard-foot { margin-top: auto; }
/* branch cards */
.vr-bcard {
  position: relative;
  width: 226px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 13px 14px;
  border: 2px solid var(--vr-border-strong);
  border-radius: 11px;
  background: var(--vr-plate);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.5);
  transform: rotate(var(--vr-rot, 0deg));
  transition: transform 130ms ease, box-shadow 130ms ease;
}
.vr-bcard:hover { transform: rotate(0deg) translateY(-4px); box-shadow: 0 14px 28px rgba(0, 0, 0, 0.55), 0 0 14px rgba(232, 193, 90, 0.22); }
.vr-bcard.is-current { border-color: var(--vr-gold); box-shadow: 0 10px 22px rgba(0, 0, 0, 0.5), 0 0 16px rgba(232, 193, 90, 0.3); }
.vr-bcard b {
  font-family: var(--vr-display);
  font-size: 13px;
  font-weight: 800;
  color: var(--vr-text);
  word-break: break-all;
}
.vr-bcard em { font-style: normal; font-family: var(--vr-hud-mono); font-size: 8.5px; letter-spacing: 0.8px; color: var(--vr-muted); }
.vr-bcard-actions { display: flex; gap: 7px; margin-top: 4px; }
.vr-bcard-actions button {
  border: 1.5px solid var(--vr-border-strong);
  border-radius: 5px;
  background: none;
  color: var(--vr-gold-bright);
  font-family: var(--vr-hud-mono);
  font-size: 8.5px;
  font-weight: 700;
  letter-spacing: 1px;
  padding: 3px 9px;
  cursor: pointer;
  transition: background 100ms ease, color 100ms ease;
}
.vr-bcard-actions button:hover { background: var(--vr-gold-bright); color: #16090a; }
.vr-bcard .vr-stamp { position: absolute; top: -9px; right: 10px; transform: rotate(4deg); }
/* interactivity: every chat control presses like a real button */
.vr-card-fix:active,
.vr-card-actions button:active,
.vr-bcard-actions button:active,
.vr-hand-toggle:active,
.vr-rail-icon:active,
.vr-table-warning button:active,
.vr-table-foot button:active { transform: translateY(1px) scale(0.98); }
.vr-chat-inline-actions button,
.vr-agent-actions button {
  transition: transform 100ms ease, border-color 100ms ease, background 100ms ease, color 100ms ease;
}
.vr-chat-inline-actions button:hover { border-color: var(--vr-border-strong); color: var(--vr-gold-bright); transform: translateY(-1px); }
.vr-chat-inline-actions button:active { transform: translateY(1px) scale(0.98); }
.vr-composer-controls .vr-chat-send:active { transform: translateY(1px) scale(0.96); }
.vr-composer-controls .vr-chat-send.is-stop {
  background: var(--vr-plate);
  border-color: var(--vr-orange);
  color: var(--vr-orange);
}
.vr-card-row.is-fix { border-radius: 6px; padding: 2px 6px; margin: 0 -6px; transition: background 100ms ease; }
.vr-card-row.is-fix:hover { background: rgba(232, 193, 90, 0.07); }

/* ==========================================================================
   card table round 4: fullscreen table (masthead gone), raven welcome,
   provider trading cards pinned on the region map, chats flyout fixed.
   ========================================================================== */
.vr-composed-shell.is-fullscreen-table { border: none; background: transparent; box-shadow: none; }
/* welcome: the raven greets you, no icon chrome */
.vr-qs-head {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 4px 2px 0;
}
.vr-qs-raven {
  width: 96px;
  height: 96px;
  flex: 0 0 auto;
  filter: drop-shadow(0 6px 16px rgba(0, 0, 0, 0.55)) drop-shadow(0 0 14px rgba(232, 193, 90, 0.25));
}
.vr-qs-head h2 {
  margin: 0;
  font-family: var(--vr-display);
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--vr-text);
}
.vr-qs-head p { margin: 4px 0 6px; font-size: 13px; color: var(--vr-muted); }
.vr-qs-local {
  font-family: var(--vr-hud-mono);
  font-size: 8.5px;
  letter-spacing: 1.6px;
  color: var(--vr-green);
}
/* chats flyout: opaque, above the table views, clicks land on it */
.vr-left-context-rail.is-table-rail { z-index: 60; }
.vr-chats-flyout {
  background: #0e0e12;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.75), 0 0 0 1px rgba(232, 193, 90, 0.12);
  z-index: 90;
}
/* provider nodes on the region map are the real trading cards */
.vr-studio-architecture.is-region-map .vr-arch-node.is-card {
  border: none;
  background: none;
  box-shadow: none;
  padding: 0;
  width: auto;
  height: auto;
}
.vr-studio-architecture.is-region-map .vr-arch-node.is-card .vr-tcard { display: flex; }
.vr-studio-architecture.is-region-map .vr-arch-node.is-card:hover { box-shadow: none; border: none; }

/* fullscreen table: the masthead row is gone — the body takes the full height */
.vr-composed-shell.is-fullscreen-table {
  grid-template-rows: minmax(0, 1fr);
  height: 100dvh;
  margin: 0;
  border-radius: 0;
}

/* ==========================================================================
   card table round 5: the map is a full table of cards — core and module
   nodes get card frames, canvas centered and bigger; chat messages wear
   card chrome; agent work log clamps; FIX invites the click.
   ========================================================================== */
/* map: center the territory, everything reads bigger (default zoom 1.2) */
.vr-studio-architecture.is-region-map .vr-arch-viewport {
  display: flex;
  justify-content: center;
  overflow: auto;
  height: 100%;
}
.vr-studio-architecture.is-region-map .vr-arch-canvas {
  transform-origin: top center;
  margin: 12px auto 0;
}
/* core + module nodes become cards too */
.vr-studio-architecture.is-region-map .vr-arch-node:not(.is-card) {
  width: 176px;
  border: 2px solid var(--vr-border-strong);
  border-radius: 10px;
  background:
    linear-gradient(160deg, rgba(232, 193, 90, 0.12), transparent 45%),
    var(--vr-plate);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.5), inset 0 0 0 1.5px rgba(15, 14, 18, 0.9), inset 0 0 0 2.5px rgba(232, 193, 90, 0.2);
  padding: 10px 12px;
}
.vr-studio-architecture.is-region-map .vr-arch-node:not(.is-card) strong {
  font-family: var(--vr-display);
  font-size: 13px;
  letter-spacing: 0.5px;
}
.vr-studio-architecture.is-region-map .vr-arch-node:not(.is-card):hover {
  border-color: var(--vr-gold);
  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.55), 0 0 16px rgba(232, 193, 90, 0.25), inset 0 0 0 1.5px rgba(15, 14, 18, 0.9), inset 0 0 0 2.5px rgba(232, 193, 90, 0.3);
}
/* chat messages wear the card chrome */
.vr-chat-message.is-agent.vr-hud-card,
.vr-chat-message.is-user.vr-hud-card {
  border: 1.5px solid var(--vr-border);
  border-radius: 12px;
  clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 0 100%);
  background: linear-gradient(160deg, rgba(232, 193, 90, 0.05), transparent 40%), var(--vr-hud-surface);
}
.vr-chat-message.is-user.vr-hud-card { border-color: var(--vr-border-strong); }
/* agent work log: a quiet clamped card, never a wall of raw dump */
.vr-agent-work {
  border: 1.5px solid var(--vr-border);
  border-radius: 9px;
  background: rgba(12, 5, 5, 0.6);
}
.vr-agent-work[open] > *:not(summary) {
  display: block;
  max-height: 240px;
  overflow: auto;
  font-family: var(--vr-hud-mono);
  font-size: 10.5px;
  line-height: 1.6;
  padding: 8px 12px;
}
.vr-agent-work > summary { cursor: pointer; }
.vr-agent-work > summary:hover { color: var(--vr-gold-bright); }
/* the mini version card in chat */
.vr-vcard.is-mini {
  width: 128px;
  min-height: 168px;
  padding: 10px;
  transform: rotate(-2deg);
}
.vr-vcard.is-mini .vr-vcard-top b { font-size: 17px; }
.vr-vcard.is-mini:hover { transform: rotate(0deg) translateY(-3px) scale(1.02); }
/* FIX earns the click */
.vr-card-fix {
  font-size: 10px;
  padding: 4px 13px;
  border-radius: 6px;
  border-color: rgba(255, 184, 77, 0.7);
  color: var(--vr-orange);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.4);
}
.vr-card-fix::before { content: '⚡ '; }
.vr-card-fix:hover {
  background: var(--vr-orange);
  border-color: var(--vr-orange);
  color: #16090a;
  transform: translateY(-1px);
  box-shadow: 0 3px 0 rgba(0, 0, 0, 0.45), 0 0 14px rgba(255, 184, 77, 0.35);
}
.vr-card-fix:active { transform: translateY(1px); box-shadow: 0 1px 0 rgba(0, 0, 0, 0.4); }
.vr-card-row { min-height: 26px; }

/* table scrollbars: thin, dark, gold thumb — never a white bar on the felt */
.vr-arch-viewport::-webkit-scrollbar,
.vr-table-view::-webkit-scrollbar,
.vr-chat-transcript::-webkit-scrollbar,
.vr-chats-flyout::-webkit-scrollbar,
.vr-agent-work[open] > *:not(summary)::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.vr-arch-viewport::-webkit-scrollbar-track,
.vr-table-view::-webkit-scrollbar-track,
.vr-chat-transcript::-webkit-scrollbar-track,
.vr-chats-flyout::-webkit-scrollbar-track,
.vr-agent-work[open] > *:not(summary)::-webkit-scrollbar-track {
  background: transparent;
}
.vr-arch-viewport::-webkit-scrollbar-thumb,
.vr-table-view::-webkit-scrollbar-thumb,
.vr-chat-transcript::-webkit-scrollbar-thumb,
.vr-chats-flyout::-webkit-scrollbar-thumb,
.vr-agent-work[open] > *:not(summary)::-webkit-scrollbar-thumb {
  background: rgba(232, 193, 90, 0.28);
  border-radius: 4px;
}
.vr-arch-viewport,
.vr-table-view,
.vr-chat-transcript,
.vr-chats-flyout {
  scrollbar-width: thin;
  scrollbar-color: rgba(232, 193, 90, 0.28) transparent;
}

/* ==========================================================================
   card table round 6: the intro IS a pack of trading cards — foil frames,
   glowing art windows, the CLI trio on the connect card.
   ========================================================================== */
.vr-qs-card {
  position: relative;
  overflow: hidden;
  padding: 5px;
  min-height: 240px;
  border-radius: 12px;
  background: var(--vr-foil);
  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.55), inset 0 0 0 1px rgba(0, 0, 0, 0.35);
  transition: transform 130ms ease, box-shadow 130ms ease;
}
.vr-qs-card::before { content: none; }
.vr-qs-card:hover { transform: translateY(-5px) rotate(-0.6deg); box-shadow: 0 18px 34px rgba(0, 0, 0, 0.6), 0 0 18px rgba(232, 193, 90, 0.3); }
.vr-qs-card .vr-tcard-sheen { border-radius: 12px; }
.vr-qs-card-inner {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: 100%;
  border-radius: 8px;
  background: #140a0c;
  padding: 9px 10px 10px;
}
.vr-qs-card-inner > * { margin: 0; }
.vr-qs-art {
  position: relative;
  height: 74px;
  margin: 2px 0 4px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  display: grid;
  place-items: center;
  overflow: hidden;
  background: radial-gradient(circle at 50% 42%, #3a2a12, #140b06 78%);
}
.vr-qs-art::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image: radial-gradient(circle, rgba(255, 255, 255, 0.14) 1px, transparent 1.3px);
  background-size: 7px 7px;
}
.vr-qs-card[data-step='1'] .vr-qs-art { background: radial-gradient(circle at 50% 42%, #1f5a35, #08170e 78%); }
.vr-qs-card[data-step='3'] .vr-qs-art { background: radial-gradient(circle at 50% 42%, #2b2732, #170608 78%); }
.vr-qs-card[data-step='4'] .vr-qs-art { background: radial-gradient(circle at 50% 42%, #1c3a5a, #060e17 78%); }
.vr-qs-glyph { position: relative; }
.vr-qs-glyph i[data-icon] { width: 30px; height: 30px; color: #ffe9ad; filter: drop-shadow(0 0 9px rgba(255, 233, 173, 0.8)); }
.vr-qs-card[data-step='1'] .vr-qs-glyph i[data-icon] { color: #5fe396; filter: drop-shadow(0 0 9px rgba(95, 227, 150, 0.8)); }
.vr-qs-card[data-step='4'] .vr-qs-glyph i[data-icon] { color: #8fc9ff; filter: drop-shadow(0 0 9px rgba(143, 201, 255, 0.8)); }
.vr-qs-clis { position: relative; display: flex; flex-direction: column; gap: 4px; }
.vr-qs-clis i {
  display: flex;
  align-items: center;
  gap: 6px;
  font-style: normal;
  font-family: var(--vr-hud-mono);
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 1.6px;
  color: #f0e2c8;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 4px;
  padding: 2px 8px;
  background: rgba(0, 0, 0, 0.45);
}
.vr-qs-clis i b { width: 6px; height: 6px; border-radius: 50%; }
.vr-qs-clis i[data-cli='codex'] b { background: #3ecf6e; box-shadow: 0 0 6px #3ecf6e; }
.vr-qs-clis i[data-cli='claude'] b { background: #e8b04b; box-shadow: 0 0 6px #e8b04b; }
.vr-qs-clis i[data-cli='gemini'] b { background: #38bdf8; box-shadow: 0 0 6px #38bdf8; }
.vr-qs-minifan { position: relative; display: flex; align-items: center; height: 54px; }
.vr-qs-minifan i {
  width: 30px;
  height: 44px;
  margin-left: -12px;
  border-radius: 4px;
  background: var(--vr-foil);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5), inset 0 0 0 3px #140a0c;
}
.vr-qs-minifan i:first-child { margin-left: 0; transform: rotate(-12deg); }
.vr-qs-minifan i:nth-child(2) { transform: rotate(0deg) translateY(-3px); z-index: 1; }
.vr-qs-minifan i:nth-child(3) { transform: rotate(12deg); }
.vr-qs-card strong { font-size: 12.5px; }
.vr-qs-card em { font-size: 10px; }
.vr-qs-card.is-done { opacity: 1; }
.vr-qs-card.is-done .vr-qs-card-inner { background: #10090a; }
.vr-qs-card.is-done .vr-qs-art { opacity: 0.75; }

/* ==========================================================================
   card table round 7: the intro is four HERO trading cards — full provider
   card anatomy with real Codex / Claude / Gemini glyphs.
   ========================================================================== */
.vr-qs-deal { gap: 18px; padding: 18px 2px 8px; }
.vr-qs-card.is-hero { min-height: 318px; border-radius: 14px; }
.vr-qs-card.is-hero .vr-qs-card-inner { padding: 12px 13px 13px; gap: 8px; border-radius: 10px; }
.vr-qs-card.is-hero .vr-qs-card-top {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
  margin-top: 2px;
}
.vr-qs-card.is-hero .vr-qs-card-top strong {
  font-family: var(--vr-display);
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  line-height: 1.1;
}
.vr-qs-card.is-hero .vr-qs-card-top b {
  font-family: var(--vr-display);
  font-size: 19px;
  font-weight: 800;
  color: #ffd76e;
}
.vr-qs-card.is-hero .vr-qs-art { height: 118px; border-radius: 8px; }
.vr-qs-card.is-hero .vr-qs-glyph i[data-icon] { width: 44px; height: 44px; }
.vr-qs-type {
  font-family: var(--vr-hud-mono);
  font-size: 7.5px;
  letter-spacing: 1.8px;
  color: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  gap: 4px;
}
.vr-qs-type .vr-qs-won i[data-icon] { width: 11px; height: 11px; }
.vr-qs-card.is-hero em { font-size: 11px; line-height: 1.5; }
.vr-qs-card.is-hero button { padding: 8px 0; font-size: 12px; border-radius: 7px; }
.vr-qs-clilogos {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
}
.vr-qs-clilogos i { display: grid; place-items: center; }
.vr-qs-clilogos svg { width: 34px; height: 34px; }
.vr-qs-clilogos i[data-cli='codex'] { color: #7fe0b0; filter: drop-shadow(0 0 8px rgba(127, 224, 176, 0.7)); }
.vr-qs-clilogos i[data-cli='claude'] { color: #e8956a; filter: drop-shadow(0 0 8px rgba(232, 149, 106, 0.7)); }
.vr-qs-clilogos i[data-cli='gemini'] { color: #8fc9ff; filter: drop-shadow(0 0 8px rgba(143, 201, 255, 0.7)); }
.vr-qs-card.is-hero .vr-qs-minifan i { width: 42px; height: 62px; margin-left: -16px; border-radius: 6px; box-shadow: 0 5px 12px rgba(0, 0, 0, 0.5), inset 0 0 0 4px #140a0c; }
@media (max-width: 1180px) {
  .vr-qs-deal { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

/* ==========================================================================
   card table round 8: one big table — version pile bottom-left you can
   pull from, version cards placeable on the felt, drop = play.
   ========================================================================== */
.vr-version-pile {
  position: absolute;
  left: 18px;
  bottom: 272px;
  z-index: 28;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}
.vr-version-pile-stack { position: relative; width: 118px; height: 92px; }
.vr-vpile-card {
  position: absolute;
  left: calc(var(--vr-i) * 3px);
  top: calc(var(--vr-i) * -5px);
  z-index: calc(10 - var(--vr-i));
  width: 112px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  border: none;
  border-radius: 9px;
  background: var(--vr-foil);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.5), inset 0 0 0 3px #140a0c;
  cursor: pointer;
  text-align: left;
  transition: transform 120ms ease, box-shadow 120ms ease;
  transform: rotate(calc(var(--vr-i) * -1.6deg));
}
.vr-vpile-card:not(.is-top) { filter: saturate(0.6) brightness(0.75); }
.vr-vpile-card:hover {
  transform: rotate(0deg) translateY(-5px);
  z-index: 12;
  box-shadow: 0 12px 22px rgba(0, 0, 0, 0.55), 0 0 14px rgba(232, 193, 90, 0.3), inset 0 0 0 3px #140a0c;
}
.vr-vpile-card b {
  font-family: var(--vr-display);
  font-size: 13px;
  font-weight: 800;
  color: #ffe9ad;
}
.vr-vpile-card em {
  font-style: normal;
  font-family: var(--vr-hud-mono);
  font-size: 7px;
  letter-spacing: 0.6px;
  color: #c9b48a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.vr-version-pile-label {
  font-family: var(--vr-hud-mono);
  font-size: 7.5px;
  letter-spacing: 1.8px;
  color: var(--vr-muted);
}
/* placed version cards share the playmat physics */
.vr-vcard.is-mini.is-placed {
  position: absolute;
  z-index: 24;
  transform: translate(-50%, -50%) rotate(var(--vr-rot, 0deg));
}
.vr-vcard.is-mini.is-placed:hover {
  transform: translate(-50%, -50%) rotate(0deg) scale(1.05);
  z-index: 26;
}
.vr-vcard.is-mini.is-placed .vr-tcard-unplace { opacity: 0; }
.vr-vcard.is-mini.is-placed:hover .vr-tcard-unplace { opacity: 1; }
@media (max-width: 1100px) {
  .vr-version-pile { display: none; }
}

/* ==========================================================================
   card table round 9: the map IS a table — felt + rim on the region map,
   grab-and-move cards, auto-fit zoom; pile shuffles; wider chat spread.
   ========================================================================== */
.vr-studio-architecture.is-region-map {
  background:
    radial-gradient(ellipse 85% 75% at 50% 42%, rgba(24, 24, 30, 0.92), rgba(12, 12, 16, 0.96) 78%),
    #0e0e12;
  box-shadow:
    inset 0 0 0 7px rgba(26, 24, 30, 0.95),
    inset 0 0 0 9px rgba(232, 193, 90, 0.14),
    inset 0 0 90px rgba(0, 0, 0, 0.55);
  border-radius: 22px;
}
.vr-studio-architecture.is-region-map .vr-arch-node { cursor: grab; touch-action: none; }
.vr-studio-architecture.is-region-map .vr-arch-node.is-dragging {
  cursor: grabbing;
  z-index: 50;
  filter: brightness(1.08);
}
.vr-studio-architecture.is-region-map .vr-arch-node.is-dragging,
.vr-studio-architecture.is-region-map .vr-arch-node.is-dragging .vr-tcard {
  box-shadow: 0 22px 44px rgba(0, 0, 0, 0.65), 0 0 22px rgba(232, 193, 90, 0.35);
}
.vr-region-reset {
  border: 1.5px solid var(--vr-border);
  border-radius: 6px;
  background: none;
  color: var(--vr-muted);
  font-family: var(--vr-hud-mono);
  font-size: 8px;
  letter-spacing: 1.4px;
  padding: 5px 10px;
  cursor: pointer;
}
.vr-region-reset:hover { color: var(--vr-gold-bright); border-color: var(--vr-border-strong); }
/* pile shuffle */
.vr-version-pile-row { display: flex; align-items: center; gap: 8px; }
.vr-pile-shuffle {
  border: 1.5px solid var(--vr-border);
  border-radius: 5px;
  background: var(--vr-plate);
  color: var(--vr-gold-bright);
  font-family: var(--vr-hud-mono);
  font-size: 7.5px;
  font-weight: 700;
  letter-spacing: 1.4px;
  padding: 3px 8px;
  cursor: pointer;
}
.vr-pile-shuffle:hover { background: var(--vr-gold-bright); color: #16090a; }
.vr-pile-shuffle:active { transform: translateY(1px); }
/* wider spread — the chat is one zone of the table, not a tunnel */
.vr-chat-lane.is-primary .vr-chat-transcript { max-width: 1020px; }
.vr-chat-lane.is-primary .vr-chat-command-bar { max-width: 1020px; }
.vr-chat-message.is-agent.vr-hud-card { transform: rotate(-0.35deg); }
.vr-chat-message.is-user.vr-hud-card { transform: rotate(0.3deg); }
.vr-card-message { transform: rotate(-0.5deg); }

/* ==========================================================================
   card table round 10: whole-card dragging with a live ghost, readable
   pile + chat cards, map cleanup (no grey slab, no transform lag,
   fit = 100%), title row slimmed, wider spread.
   ========================================================================== */
/* the ghost card that follows your cursor */
.vr-drag-ghost {
  position: fixed;
  z-index: 300;
  pointer-events: none;
  margin: 0;
  transform: rotate(3deg) scale(1.06);
  box-shadow: 0 26px 52px rgba(0, 0, 0, 0.7), 0 0 24px rgba(232, 193, 90, 0.35);
  opacity: 0.98;
}
.is-drag-source { opacity: 0.25; }
.vr-chat-composer.is-drop-active { border-color: var(--vr-gold-bright) !important; box-shadow: 0 0 24px rgba(255, 233, 173, 0.25); }
/* version pile: dark plate inside a foil ring — readable */
.vr-vpile-card {
  border: 3px solid transparent;
  background: linear-gradient(#18090b, #18090b) padding-box, var(--vr-foil) border-box;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.5);
}
.vr-vpile-card b { color: #ffe9ad; }
.vr-vpile-card em { color: #d8c4ac; font-size: 8px; }
.vr-vpile-card:not(.is-top) { filter: none; opacity: 0.85; }
.vr-version-pile-label { color: #d8c4ac; }
/* chat cards: crisp text — no rotation blur, brighter ink */
.vr-chat-message.is-agent.vr-hud-card,
.vr-chat-message.is-user.vr-hud-card,
.vr-card-message { transform: none; }
.vr-chat-message.is-agent.vr-hud-card { background: var(--vr-hud-surface); }
.vr-card-rows { font-size: 12.5px; color: #f0e4d0; }
.vr-card-row { color: #f0e4d0; }
.vr-card-summary { color: #d8c4ac; font-size: 12px; }
.vr-vcard-branch { color: #d8c4ac; }
.vr-vcard-meta { color: #b39a80; }
/* region map: pure felt — no grey slab, no dark outline, no transform lag */
.vr-studio-architecture.is-region-map .vr-arch-body,
.vr-studio-architecture.is-region-map .vr-arch-viewport,
.vr-studio-architecture.is-region-map .vr-arch-canvas {
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}
.vr-studio-architecture.is-region-map .vr-arch-node,
.vr-studio-architecture.is-region-map .vr-arch-node .vr-tcard {
  transition: box-shadow 120ms ease, border-color 120ms ease, filter 120ms ease;
  will-change: transform;
}
.vr-studio-architecture.is-region-map .vr-arch-edges path { opacity: 0.5; stroke-width: 1.4; }
/* wider spread — messages live on the table */
.vr-chat-lane.is-primary .vr-chat-transcript { max-width: 1240px; }
.vr-chat-lane.is-primary .vr-chat-command-bar { max-width: 1060px; }

/* ==========================================================================
   card table round 11: composer hugs the bottom, table plaque top-center,
   pile tucks away, the raven keeps his cards.
   ========================================================================== */
/* strip is gone — the composer owns the table edge */
.vr-chat-lane.is-primary .vr-chat-command-bar { margin-bottom: 4px; }
.vr-chat-lane.is-primary { padding-bottom: 6px; }
/* the plaque: project + stamp + next move, etched top-center on the felt */
.vr-table-plaque {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 26;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding: 10px 22px 12px;
  border: 1.5px solid rgba(232, 193, 90, 0.3);
  border-radius: 0 0 16px 16px;
  border-top: none;
  background: rgba(20, 7, 8, 0.72);
  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.4);
  pointer-events: auto;
}
.vr-table-plaque-row { display: flex; align-items: center; gap: 12px; }
.vr-table-plaque strong {
  font-family: var(--vr-display);
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 2.2px;
  color: var(--vr-gold-bright);
}
.vr-table-plaque em {
  font-style: normal;
  font-family: var(--vr-hud-mono);
  font-size: 8px;
  letter-spacing: 1.5px;
  color: var(--vr-muted);
  text-transform: uppercase;
}
.vr-table-plaque-actions { display: flex; gap: 8px; margin-top: 2px; }
.vr-table-plaque-actions button {
  border: 1.5px solid var(--vr-border-strong);
  border-radius: 6px;
  background: var(--vr-plate);
  color: var(--vr-gold-bright);
  font-family: var(--vr-hud-mono);
  font-size: 8.5px;
  font-weight: 700;
  letter-spacing: 1.3px;
  padding: 5px 12px;
  cursor: pointer;
  transition: background 100ms ease, color 100ms ease, transform 100ms ease;
}
.vr-table-plaque-actions button:hover { background: var(--vr-gold-bright); color: #16090a; transform: translateY(-1px); }
.vr-table-plaque-actions button:active { transform: translateY(1px) scale(0.98); }
.vr-chat-lane.is-primary .vr-chat-transcript { padding-top: 92px; }
/* pile tuck */
.vr-version-pile.is-collapsed { bottom: 240px; }
/* the raven keeps his cards — no cropping anywhere the mascot appears */
.vr-rail-raven { width: 52px; height: 52px; }
.vr-rail-raven img {
  width: 50px;
  height: 50px;
  border-radius: 0;
  object-fit: contain;
}
.vr-chat-intro-message > div > span,
.vr-chat-intro-message > div > span img {
  border-radius: 0 !important;
  background: none !important;
  object-fit: contain;
  overflow: visible;
}
.vr-chat-intro-message > div > span img { width: 64px; height: 64px; }

/* release polish: placed cards show a faint x before hover, grab cursor */
.vr-tcard.is-placed .vr-tcard-unplace,
.vr-vcard.is-mini.is-placed .vr-tcard-unplace { opacity: 0.55; }
.vr-tcard.is-placed:hover .vr-tcard-unplace,
.vr-vcard.is-mini.is-placed:hover .vr-tcard-unplace { opacity: 1; }
.vr-hand-fan .vr-tcard,
.vr-vpile-card,
.vr-playmat .vr-tcard.is-placed,
.vr-playmat .vr-vcard.is-placed { cursor: grab; }

/* release fixes: plaque sits below the CLI strip; add-card picker on the felt */
.vr-table-plaque { top: 78px; }
.vr-chat-lane.is-primary .vr-chat-transcript { padding-top: 182px; }
.vr-addpick {
  position: absolute;
  top: 170px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 60;
  width: min(460px, 92%);
  border: 2px solid var(--vr-border-strong);
  border-radius: 14px;
  background: #0e0e12;
  box-shadow: 0 22px 48px rgba(0, 0, 0, 0.7), 0 0 24px rgba(232, 193, 90, 0.15);
  overflow: hidden;
}
.vr-addpick > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1.5px solid var(--vr-border);
}
.vr-addpick > header strong {
  font-family: var(--vr-display);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 2px;
  color: var(--vr-gold-bright);
}
.vr-addpick > header button {
  border: 1.5px solid var(--vr-border);
  border-radius: 6px;
  background: none;
  color: var(--vr-muted);
  width: 26px;
  height: 26px;
  display: grid;
  place-items: center;
  cursor: pointer;
}
.vr-addpick-list { max-height: 300px; overflow: auto; padding: 8px; display: flex; flex-direction: column; gap: 6px; }
.vr-addpick-list button {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 12px;
  border: 1.5px solid var(--vr-border);
  border-radius: 9px;
  background: var(--vr-panel);
  cursor: pointer;
  text-align: left;
  transition: border-color 100ms ease, transform 100ms ease;
}
.vr-addpick-list button:hover { border-color: var(--vr-gold); transform: translateY(-1px); }
.vr-addpick-list button span { display: flex; flex-direction: column; gap: 1px; }
.vr-addpick-list button strong { font-family: var(--vr-display); font-size: 12.5px; color: var(--vr-text); text-transform: uppercase; letter-spacing: 0.4px; }
.vr-addpick-list button em { font-style: normal; font-family: var(--vr-hud-mono); font-size: 8px; letter-spacing: 1px; color: var(--vr-muted); text-transform: uppercase; }
.vr-addpick-list button b {
  margin-left: auto;
  font-family: var(--vr-hud-mono);
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 1.2px;
  color: var(--vr-gold-bright);
}
.vr-addpick-empty { padding: 14px; font-size: 12px; color: var(--vr-muted); }
.vr-addpick > footer {
  padding: 10px 16px 12px;
  border-top: 1.5px solid var(--vr-border);
  font-family: var(--vr-hud-mono);
  font-size: 8.5px;
  letter-spacing: 0.6px;
  color: var(--vr-muted);
  line-height: 1.6;
}

/* ==========================================================================
   card table round 12: the collector's table. The plaque becomes a slim
   etched ribbon (info only — actions live in the composer), the hand tucks
   into the bottom edge like a TCG hand so nothing covers the chat, and the
   cards go full holo: energy types, rarity marks, iridescent foil, slab
   grade label. Pokemon binder energy, not poker night.
   ========================================================================== */
/* -- ONE top bar: status ribbon + connected CLIs + tabs in a single slim
      row. Below it, the table is chat from top to bottom. -- */
.vr-studio-chat:not(.is-split) {
  grid-template-rows: minmax(0, 1fr);
  padding: 6px 10px;
}
.vr-studio-head {
  position: relative;
  z-index: 45;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  min-height: 40px;
}
.vr-studio-head-status { display: flex; min-width: 0; flex: none; }
.vr-studio-head-cli { flex: 1 1 auto; min-width: 0; display: flex; justify-content: center; }
.vr-studio-head-cli .vr-cli-connect {
  position: relative;
  border: none;
  background: none;
  padding: 0;
  width: min(680px, 100%);
}
.vr-studio-head-cli .vr-cli-strip {
  display: flex;
  grid-template-columns: none;
  gap: 6px;
}
.vr-studio-head-cli .vr-cli-strip button {
  flex: 1 1 0;
  min-height: 28px;
  border-radius: 8px;
}
.vr-studio-head-cli .vr-cli-connect-expand {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 80;
  width: max-content;
  max-width: 440px;
  border: 1.5px solid var(--vr-border-strong);
  border-radius: 10px;
  background: var(--vr-plate);
  padding: 8px 14px;
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.5);
}
/* the felt IS the surface: no grey panel boxes floating on the table,
   no broken corner seams */
.vr-composed-shell.is-fullscreen-table .vr-studio-dock {
  background: transparent;
  border-color: transparent;
  box-shadow: none;
}
.vr-studio-chat:not(.is-split) {
  background: transparent;
  border: none;
  box-shadow: none;
}
.vr-composition-body.is-table::before {
  inset: 6px 8px;
  border-radius: 26px;
}
.vr-table-ribbon {
  position: static;
  z-index: 25;
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 0;
  padding: 5px 8px 5px 4px;
  border: 0;
  background: none;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
}
.vr-ribbon-brand { display: flex; align-items: center; gap: 8px; }
.vr-table-ribbon strong {
  font-family: var(--mg-display);
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 1.5px;
  color: var(--vr-text);
}
/* the stats row that replaced the old crimson ribbon text */
.vr-ribbon-stats { display: flex; align-items: stretch; gap: 0; }
.vr-ribbon-stat {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2px 13px;
  border-left: 1px solid var(--vr-border);
}
.vr-ribbon-stat:first-child { border-left: 0; }
.vr-ribbon-stat b {
  font-family: var(--mg-display);
  font-weight: 400;
  font-size: 16px;
  line-height: 1;
  color: var(--vr-text);
}
.vr-ribbon-stat i {
  font-style: normal;
  margin-top: 3px;
  font-family: var(--vr-hud-mono);
  font-size: 8.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--vr-muted);
}
.vr-ribbon-stat.is-gold b { color: var(--vr-gold-bright); }
.vr-ribbon-stat.is-green b { color: var(--vr-green); }
.vr-ribbon-stat.is-orange b { color: var(--vr-orange); }
.vr-ribbon-stat.is-muted b { color: rgba(244, 241, 232, 0.55); }
.vr-chat-lane.is-primary .vr-chat-transcript { padding-top: 16px; }

/* -- the card dock: a SLIM strip on the table rim, like a real card game.
      Idle it costs ~50px — cards peek up from the edge and RISE on hover
      (the Hearthstone hand), the version deck pops its stack up on hover.
      Fixed 3-column grid: the hand stays dead-center no matter what the
      side slots show, so nothing ever jumps. -- */
.vr-table-shelf {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 30;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 12px;
  padding: 0 14px 6px;
  pointer-events: none;
}
.vr-shelf-slot { display: flex; align-items: flex-end; gap: 10px; pointer-events: none; }
.vr-shelf-slot > * { pointer-events: auto; }
.vr-shelf-slot.is-left { justify-content: flex-start; }
.vr-shelf-slot.is-right {
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 6px;
  padding-bottom: 2px;
}
/* the version deck: always visible in the bottom-left corner — the stack
   floats above the dock line so it costs the chat no height */
.vr-table-shelf .vr-version-pile {
  position: relative;
  inset: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
}
.vr-table-shelf .vr-version-pile-stack {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 2px;
}
/* the hand: a 3D deck in the bottom-right corner. Idle it is a tight
   tucked stack; hover the deck and the cards FAN OUT leftward in an arc,
   hover a card and it rises fully off the table. */
.vr-table-shelf .vr-hand {
  position: relative;
  inset: auto;
  display: flex;
  min-width: 0;
  transform: none;
  flex-direction: column;
  align-items: flex-end;
  gap: 0;
  pointer-events: none;
}
.vr-table-shelf .vr-hand .vr-hand-bar,
.vr-table-shelf .vr-hand .vr-hand-fan { pointer-events: auto; }
.vr-hand-bar {
  position: absolute;
  bottom: calc(100% + 6px);
  right: 8px;
  z-index: 3;
  display: flex;
  gap: 8px;
  opacity: 0;
  transform: translateY(6px);
  transition: opacity 120ms ease, transform 120ms ease;
}
.vr-table-shelf .vr-hand:hover .vr-hand-bar { opacity: 1; transform: none; }
.vr-table-shelf .vr-hand.is-collapsed .vr-hand-bar {
  position: static;
  transform: none;
  opacity: 1;
  margin-bottom: 4px;
}
.vr-hand-fan {
  --vr-tuck: -50px;
  position: relative;
  justify-content: flex-end;
  perspective: 900px;
  padding: 0 6px;
  margin-bottom: var(--vr-tuck);
  transition: margin-bottom 200ms ease;
}
/* invisible hover runway above the deck — reaching the cards is easy.
   NOTE: kept small so it does not overlap the shelf-chip-row (TUCK / ADD CARD)
   sitting ~6px above the fan, and pointer-events:none so it never eats a click. */
.vr-hand-fan::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: -6px;
  height: 10px;
  pointer-events: none;
}
.vr-hand-fan .vr-tcard {
  margin-left: -92px;
  transform: rotate(calc(var(--vr-rot, 0deg) * 0.3)) rotateX(12deg);
  transition: margin-left 220ms ease, transform 200ms ease, box-shadow 140ms ease;
}
.vr-table-shelf .vr-hand:hover .vr-hand-fan { margin-bottom: calc(var(--vr-tuck) + 22px); }
.vr-table-shelf .vr-hand:hover .vr-hand-fan .vr-tcard {
  margin-left: -30px;
  transform: rotate(var(--vr-rot, 0deg)) translateY(var(--vr-lift, 0px)) rotateX(6deg);
}
/* the fun part: the hovered card RISES right out of the fan */
.vr-hand-fan .vr-tcard:hover,
.vr-table-shelf .vr-hand:hover .vr-hand-fan .vr-tcard:hover {
  transform: rotate(0deg) translateY(-116px) scale(1.36) rotateX(0deg);
  z-index: 9;
  box-shadow: 0 26px 50px rgba(0, 0, 0, 0.65), 0 0 26px rgba(232, 193, 90, 0.35);
}
/* pointer bridge: the risen card leaves the cursor behind at the bottom
   edge of the screen — without this the hover drops the instant the card
   lifts and it falls back down in a flicker loop. The invisible tail keeps
   the cursor "on" the card while it is raised. */
.vr-hand-fan .vr-tcard:hover::after {
  content: '';
  position: absolute;
  left: -22px;
  right: -22px;
  top: 100%;
  height: 110px;
}
.vr-shelf-chip {
  border: 1.5px solid var(--vr-border-strong);
  border-radius: 6px;
  background: var(--vr-plate);
  color: var(--vr-gold-bright);
  font-family: var(--vr-hud-mono);
  font-size: 8.5px;
  font-weight: 700;
  letter-spacing: 1.4px;
  padding: 6px 12px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 100ms ease, color 100ms ease, transform 100ms ease;
}
.vr-shelf-chip:hover { background: var(--vr-gold-bright); color: #16090a; transform: translateY(-1px); }
.vr-shelf-chip.is-gold { background: var(--vr-gold-bright); color: #16090a; border-color: var(--vr-gold-bright); }
.vr-shelf-chip.is-gold:hover { background: #ffffff; }
.vr-studio-chat:not(.is-split) .vr-chat-lane.is-primary { padding-bottom: 10px; }
.vr-chat-lane.is-primary .vr-chat-command-bar { margin-bottom: 0; }
.vr-table-shelf .vr-pile-shuffle { font-size: 8.5px; padding: 5px 12px; }
/* chat width: use the table — the dock is slim, the sides are gutters only */
.vr-chat-lane.is-primary .vr-chat-transcript { max-width: min(1440px, calc(100% - 64px)); }
.vr-chat-lane.is-primary .vr-chat-command-bar { max-width: min(1240px, calc(100% - 64px)); }
.vr-studio-chat:not(.is-split) .vr-chat-message,
.vr-studio-chat:not(.is-split) .vr-chat-mission-summary,
.vr-studio-chat:not(.is-split) .vr-chat-message.is-agent { max-width: min(1120px, 100%); }
/* the composer slims down to Claude proportions */
.vr-studio-chat:not(.is-split) .vr-chat-command-bar { padding: 6px clamp(16px, 3vw, 42px) 10px; }
.vr-studio-chat:not(.is-split) .vr-chat-command-bar > .vr-chat-composer { min-height: 64px; padding: 8px 12px; gap: 6px; }
.vr-chat-command-bar .vr-chat-input { min-height: 30px; }
.vr-composer-scope { height: 30px; padding: 0 11px; font-size: 12px; }
.vr-composer-controls .vr-model-picker > button { height: 34px; }
.vr-chat-send { width: 34px; height: 34px; }
.vr-chat-inline-actions { padding: 0; }
.vr-chat-inline-actions > button,
.vr-chat-command-trigger > button { height: 32px; padding: 0 11px; font-size: 12px; gap: 7px; }
/* ribbon meter: the table grade reads like a rank bar */
.vr-ribbon-meter {
  width: 110px;
  height: 7px;
  border-radius: 4px;
  border: 1px solid rgba(232, 193, 90, 0.28);
  background: rgba(232, 193, 90, 0.12);
  overflow: hidden;
  flex: none;
}
.vr-ribbon-meter i {
  display: block;
  height: 100%;
  border-radius: 3px;
  background: linear-gradient(90deg, #b8873f, var(--vr-gold-bright));
}
.vr-table-ribbon > b {
  font-family: var(--vr-display);
  font-size: 12.5px;
  font-weight: 800;
  color: var(--vr-gold-bright);
}
/* the composer bottom row wraps instead of colliding */
.vr-composer-bottom { flex-wrap: wrap; row-gap: 8px; }
.vr-composer-controls { margin-left: auto; }
.vr-chat-inline-actions { flex-wrap: wrap; row-gap: 6px; }

/* -- responsive: the table folds up instead of breaking -- */
/* the stacked mobile grid ("main/inspector/left") breaks the table shell:
   the canvas lands in the 64px rail column. Keep the table's rail layout. */
@media (max-width: 1180px) {
  .vr-composition-body.is-table,
  .vr-composition-body.is-table.has-inspector {
    grid-template-columns: 56px minmax(0, 1fr);
    grid-template-areas: none;
  }
  .vr-composition-body.is-table .vr-left-context-rail.is-table-rail {
    grid-area: auto;
    grid-template-rows: none;
  }
  .vr-composition-body.is-table .vr-inspector-panel {
    grid-area: auto;
    position: fixed;
    right: 8px;
    top: 70px;
    bottom: 8px;
    width: min(400px, calc(100vw - 72px));
    height: auto;
    z-index: 70;
    box-shadow: 0 22px 48px rgba(0, 0, 0, 0.65);
  }
}
@media (max-width: 1420px) {
  .vr-tcard.is-hand { width: 88px; height: 124px; }
  .vr-hand-fan { --vr-tuck: -44px; }
  .vr-hand-fan .vr-tcard { margin-left: -82px; }
  .vr-table-shelf .vr-hand:hover .vr-hand-fan .vr-tcard { margin-left: -30px; }
  .vr-hand-fan .vr-tcard:hover,
  .vr-table-shelf .vr-hand:hover .vr-hand-fan .vr-tcard:hover { transform: rotate(0deg) translateY(-98px) scale(1.34) rotateX(0deg); }
}
@media (max-width: 1100px) {
  .vr-chat-lane.is-primary .vr-chat-transcript { max-width: calc(100% - 20px); padding-top: 12px; }
  .vr-chat-lane.is-primary .vr-chat-command-bar { max-width: calc(100% - 190px); }
  .vr-table-ribbon em { display: none; }
  .vr-ribbon-meter { width: 72px; }
  .vr-map-medallion em { display: none; }
  .vr-map-medallion i[data-icon] { width: 36px; height: 36px; padding: 9px; }
  .vr-tcard.is-hand { width: 76px; height: 106px; }
  .vr-hand-fan { --vr-tuck: -38px; }
  .vr-hand-fan .vr-tcard { margin-left: -70px; }
  .vr-table-shelf .vr-hand:hover .vr-hand-fan .vr-tcard { margin-left: -26px; }
  .vr-hand-fan .vr-tcard:hover,
  .vr-table-shelf .vr-hand:hover .vr-hand-fan .vr-tcard:hover { transform: rotate(0deg) translateY(-84px) scale(1.38) rotateX(0deg); }
  .vr-table-shelf { gap: 10px; padding: 0 10px 5px; }
  .vr-version-pile-stack { width: 98px; height: 76px; }
  .vr-vpile-card { width: 94px; padding: 6px 8px; }
  .vr-addpick { top: 64px; }
}
@media (max-width: 1100px) {
  .vr-chat-inline-actions > button span { display: none; }
  .vr-chat-inline-actions > button.is-worst-card span { display: inline; }
}
@media (max-width: 780px) {
  .vr-chat-lane.is-primary .vr-chat-command-bar { max-width: calc(100% - 16px); }
  /* no corner room left — the version stack pops on hover/tap-focus instead */
  .vr-table-shelf .vr-version-pile-stack {
    opacity: 0;
    transform: translateY(10px);
    pointer-events: none;
    transition: opacity 130ms ease, transform 130ms ease;
  }
  .vr-table-shelf .vr-version-pile:hover .vr-version-pile-stack,
  .vr-table-shelf .vr-version-pile:focus-within .vr-version-pile-stack {
    opacity: 1;
    transform: none;
    pointer-events: auto;
  }
  .vr-tcard.is-hand { width: 64px; height: 90px; }
  .vr-hand-fan { --vr-tuck: -32px; }
  .vr-hand-fan .vr-tcard { margin-left: -58px; }
  .vr-table-shelf .vr-hand:hover .vr-hand-fan .vr-tcard { margin-left: -20px; }
  .vr-hand-fan .vr-tcard:hover,
  .vr-table-shelf .vr-hand:hover .vr-hand-fan .vr-tcard:hover { transform: rotate(0deg) translateY(-70px) scale(1.44) rotateX(0deg); }
  .vr-table-shelf { gap: 8px; }
  .vr-version-pile-row .vr-pile-shuffle { display: none; }
}

/* -- the version card's return-to-pile chip pins to the top-right corner
      (.vr-vcard > * forces position: relative on children — undo it here) -- */
.vr-vcard.is-mini.is-placed .vr-tcard-unplace {
  position: absolute;
  top: -9px;
  right: -9px;
  left: auto;
  z-index: 5;
}

/* -- draggable cards behave on touch too -- */
.vr-hand-fan .vr-tcard,
.vr-vpile-card,
.vr-playmat .vr-tcard.is-placed,
.vr-playmat .vr-vcard.is-placed { touch-action: none; }

/* -- composer: the worst-card play gets a gold spark -- */
.vr-chat-inline-actions > button.is-worst-card { color: var(--vr-gold-bright); }
.vr-chat-inline-actions > button.is-worst-card i[data-icon] { color: var(--vr-gold-bright); }

/* -- region map: while evidence loads the felt says so, big and centered —
      an empty table must never look like a broken one -- */
.vr-studio-architecture.is-region-map .vr-arch-body:not(.is-graph) {
  display: grid;
  place-items: center;
}
.vr-studio-architecture.is-region-map .vr-arch-body:not(.is-graph) .vr-arch-empty {
  font-family: var(--vr-hud-mono);
  font-size: 11px;
  letter-spacing: 2.4px;
  text-transform: uppercase;
  color: var(--vr-gold-bright);
  border: 1.5px solid rgba(232, 193, 90, 0.3);
  border-radius: 999px;
  padding: 10px 22px;
  background: rgba(20, 7, 8, 0.66);
}

/* -- add-card picker: pick from REAL cards laid out on a dimmed felt.
      Unknown providers show the raven card-back, like an unopened pack. -- */
.vr-addpick-backdrop {
  position: absolute;
  inset: 0;
  z-index: 55;
  border: none;
  background: rgba(12, 4, 5, 0.55);
  cursor: pointer;
}
.vr-addpick {
  top: 84px;
  width: min(760px, calc(100% - 48px));
  z-index: 60;
}
.vr-addpick-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(118px, 1fr));
  gap: 10px;
  padding: 14px;
  max-height: min(430px, 56vh);
  overflow: auto;
}
.vr-addpick-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7px;
  padding: 8px 6px;
  border: 1.5px solid transparent;
  border-radius: 12px;
  background: none;
  cursor: pointer;
  transition: transform 120ms ease, border-color 120ms ease, background 120ms ease;
}
.vr-addpick-card:hover {
  transform: translateY(-4px);
  border-color: var(--vr-gold);
  background: rgba(232, 193, 90, 0.06);
}
.vr-addpick-card .vr-tcard { pointer-events: none; }
.vr-addpick-card > em {
  font-style: normal;
  font-family: var(--vr-hud-mono);
  font-size: 7.5px;
  letter-spacing: 1.2px;
  color: var(--vr-muted);
  text-transform: uppercase;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* -- shelf chips: TUCK and ADD CARD share one row above the deck -- */
.vr-shelf-chip-row { display: flex; gap: 6px; justify-content: flex-end; }

/* -- connect card: after ADD CARD places a provider, this sheet walks the
      real connection — MCP context, repo wiring mission, dashboard keys. -- */
.vr-connectcard { width: min(660px, calc(100% - 48px)); }
.vr-connectcard-body { display: flex; align-items: flex-start; gap: 18px; padding: 16px; }
.vr-connectcard-card { flex: none; }
.vr-connectcard-card .vr-tcard { pointer-events: none; }
.vr-connectcard-steps {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  min-width: 0;
}
.vr-connectcard-steps li {
  border: 1px solid rgba(232, 193, 90, 0.22);
  border-radius: 10px;
  padding: 10px 12px;
  background: rgba(20, 7, 8, 0.6);
}
.vr-connectcard-steps li.is-done { border-color: rgba(34, 197, 94, 0.45); }
.vr-connectcard-steps li.is-note { border-style: dashed; }
.vr-connectcard-sub {
  margin: 10px 16px 0;
  font-size: 12.5px;
  line-height: 1.55;
  color: var(--vr-muted);
}
.vr-connectcard-steps li strong {
  display: flex;
  align-items: center;
  gap: 7px;
  font-family: var(--vr-hud-mono);
  font-size: 9px;
  letter-spacing: 1.8px;
  color: var(--vr-gold-bright);
  margin-bottom: 5px;
}
.vr-connectcard-steps li strong b {
  flex: none;
  width: 17px;
  height: 17px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: var(--vr-gold-bright);
  color: #16090a;
  font-family: var(--vr-display);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0;
}
.vr-connectcard-steps li.is-done strong b { background: var(--vr-green); color: #04120a; }
.vr-connectcard-steps button[disabled] {
  opacity: 0.6;
  cursor: wait;
}
.vr-connectcard-msg {
  display: block;
  margin-top: 7px;
  font-style: normal;
  font-family: var(--vr-hud-mono);
  font-size: 8.5px;
  letter-spacing: 0.6px;
  line-height: 1.6;
  color: var(--vr-orange);
}
.vr-connectcard-skip {
  display: block;
  font-family: var(--vr-hud-mono);
  font-size: 8.5px;
  letter-spacing: 0.6px;
  line-height: 1.6;
  color: var(--vr-muted);
}
.vr-connectcard-steps li p { margin: 0 0 8px; font-size: 12px; line-height: 1.5; color: var(--vr-muted); }
.vr-connectcard-steps li.is-note p { margin-bottom: 0; }
.vr-connectcard-steps button {
  border: 1.5px solid var(--vr-border-strong);
  border-radius: 6px;
  background: var(--vr-gold-bright);
  color: #16090a;
  font-family: var(--vr-hud-mono);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1.4px;
  padding: 6px 12px;
  cursor: pointer;
}
.vr-connectcard-steps button:hover { background: #ffffff; }
.vr-connectcard-done {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-family: var(--vr-hud-mono);
  font-size: 9px;
  letter-spacing: 1.4px;
  color: var(--vr-green);
}
.vr-connectcard-done i[data-icon] { width: 12px; height: 12px; }
@media (max-width: 700px) {
  .vr-connectcard-body { flex-direction: column; }
  .vr-connectcard-card { display: none; }
}

/* -- the composer sits ON the felt: gold frame, no black slab shadow -- */
.vr-studio-chat:not(.is-split) .vr-chat-lane.is-primary .vr-chat-command-bar {
  background: none;
  border: none;
  box-shadow: none;
}
.vr-studio-chat:not(.is-split) .vr-chat-lane.is-primary .vr-chat-command-bar > .vr-chat-composer {
  box-shadow: 0 0 22px rgba(232, 193, 90, 0.08);
}

/* -- the icon rail fits its content -- */
.vr-composition-body.is-table { grid-template-columns: 54px minmax(0, 1fr); }
.vr-composition-body.is-table.has-inspector { grid-template-columns: 54px minmax(0, 1fr) minmax(388px, 428px); }
.vr-left-context-rail.is-table-rail { gap: 8px; padding: 8px 0 10px; }
.vr-rail-icon { width: 34px; height: 34px; border-radius: 9px; }
.vr-rail-icon i[data-icon] { width: 15px; height: 15px; }
.vr-rail-raven { width: 42px; height: 42px; }
.vr-rail-raven img { width: 40px; height: 40px; }

/* -- flip cards: the Hearthstone reveal. Face-down until clicked, then a
      3D flip with a rank glow — legendary gold, epic purple, rare blue. -- */
.vr-qs-deal,
.vr-discover-grid { perspective: 1200px; }
[data-flip-card] { position: relative; }
[data-flip-card] .vr-flip-inner {
  position: relative;
  display: block;
  height: 100%;
  transform-style: preserve-3d;
  transition: transform 560ms cubic-bezier(0.3, 0.7, 0.25, 1.04);
}
[data-flip-card].is-flipped .vr-flip-inner { transform: rotateY(180deg); }
[data-flip-card] .vr-flip-face {
  position: relative;
  display: block;
  height: 100%;
  transform: rotateY(180deg);
  backface-visibility: hidden;
}
[data-flip-card] .vr-flip-back {
  position: absolute;
  inset: 0;
  z-index: 2;
  backface-visibility: hidden;
  cursor: pointer;
}
[data-flip-card]:not(.is-flipped) .vr-flip-face { pointer-events: none; }
[data-flip-card].is-flipped .vr-flip-back { pointer-events: none; }
/* the discovery pack */
.vr-discover-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 14px;
  justify-items: center;
  padding: 16px 4px 8px;
  max-height: min(52vh, 460px);
  overflow: auto;
}
.vr-discover-card {
  animation: vr-deal-in 420ms ease-out both;
  animation-delay: calc(var(--vr-i, 0) * 80ms);
}
.vr-modal-card.is-stable-render .vr-discover-card { animation: none; }
@keyframes vr-deal-in {
  from { opacity: 0; transform: translateY(26px) rotate(-3deg); }
  to { opacity: 1; transform: none; }
}
.vr-discover-card .vr-flip-back.vr-tcard.is-back {
  width: auto;
  height: auto;
  border-radius: 11px;
}
.vr-discover-rank {
  display: block;
  text-align: center;
  margin-top: 8px;
  font-style: normal;
  font-family: var(--vr-hud-mono);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 2.2px;
  opacity: 0;
  transition: opacity 300ms ease 300ms;
}
.vr-discover-card.is-flipped .vr-discover-rank { opacity: 1; }
.vr-discover-card[data-rank='legendary'] .vr-discover-rank { color: #ffd76e; text-shadow: 0 0 8px rgba(255, 190, 60, 0.8); }
.vr-discover-card[data-rank='epic'] .vr-discover-rank { color: #c084fc; text-shadow: 0 0 8px rgba(192, 132, 252, 0.8); }
.vr-discover-card[data-rank='rare'] .vr-discover-rank { color: #7dd3fc; text-shadow: 0 0 8px rgba(125, 211, 252, 0.7); }
@keyframes vr-reveal-legendary {
  0% { box-shadow: 0 0 0 rgba(255, 190, 60, 0); }
  35% { box-shadow: 0 0 46px rgba(255, 190, 60, 0.95), 0 0 100px rgba(255, 120, 0, 0.55); }
  100% { box-shadow: 0 0 16px rgba(255, 190, 60, 0.4); }
}
@keyframes vr-reveal-epic {
  0% { box-shadow: 0 0 0 rgba(192, 132, 252, 0); }
  35% { box-shadow: 0 0 42px rgba(192, 132, 252, 0.9), 0 0 90px rgba(147, 51, 234, 0.5); }
  100% { box-shadow: 0 0 14px rgba(192, 132, 252, 0.35); }
}
@keyframes vr-reveal-rare {
  0% { box-shadow: 0 0 0 rgba(125, 211, 252, 0); }
  35% { box-shadow: 0 0 38px rgba(125, 211, 252, 0.85), 0 0 80px rgba(56, 189, 248, 0.45); }
  100% { box-shadow: 0 0 12px rgba(125, 211, 252, 0.3); }
}
.vr-discover-card.is-flipped[data-rank='legendary'] .vr-flip-face .vr-tcard { animation: vr-reveal-legendary 1100ms ease-out 240ms both; }
.vr-discover-card.is-flipped[data-rank='epic'] .vr-flip-face .vr-tcard { animation: vr-reveal-epic 1100ms ease-out 240ms both; }
.vr-discover-card.is-flipped[data-rank='rare'] .vr-flip-face .vr-tcard { animation: vr-reveal-rare 1100ms ease-out 240ms both; }
/* --- pack-opening polish --- */
/* contain the collector raven so it never overlaps the first card + separate the header */
.vr-modal-discover .vr-qs-head {
  align-items: center;
  gap: 16px;
  margin: 0 0 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(255, 215, 110, 0.14);
}
.vr-modal-discover .vr-qs-raven { width: 72px; height: 72px; }
/* COMMON tier (silver) so the pack reads like a real spread, not all-RARE */
.vr-discover-card[data-rank='common'] .vr-discover-rank { color: #cbd5e1; text-shadow: 0 0 6px rgba(148, 163, 184, 0.55); }
@keyframes vr-reveal-common {
  0% { box-shadow: 0 0 0 rgba(148, 163, 184, 0); }
  35% { box-shadow: 0 0 24px rgba(203, 213, 225, 0.55), 0 0 48px rgba(148, 163, 184, 0.28); }
  100% { box-shadow: 0 0 8px rgba(148, 163, 184, 0.22); }
}
.vr-discover-card.is-flipped[data-rank='common'] .vr-flip-face .vr-tcard { animation: vr-reveal-common 1000ms ease-out 240ms both; }
/* Hearthstone-style: a rare pull jumps forward as it flips (not on stable re-renders) */
.vr-modal-card:not(.is-stable-render) .vr-discover-card.is-flipped[data-rank='legendary'] { animation: vr-pop-hi 720ms cubic-bezier(0.2, 1.5, 0.3, 1) 180ms both; z-index: 5; }
.vr-modal-card:not(.is-stable-render) .vr-discover-card.is-flipped[data-rank='epic'] { animation: vr-pop-mid 660ms cubic-bezier(0.2, 1.45, 0.3, 1) 180ms both; z-index: 4; }
@keyframes vr-pop-hi { 0%, 100% { transform: scale(1); } 45% { transform: scale(1.16); } }
@keyframes vr-pop-mid { 0%, 100% { transform: scale(1); } 45% { transform: scale(1.1); } }
.vr-discover-take {
  border-color: var(--vr-gold-bright) !important;
  background: var(--vr-gold-bright) !important;
  color: #16090a !important;
  font-weight: 800;
}
/* quickstart step cards share the flip */
.vr-qs-back {
  display: grid;
  place-items: center;
  align-content: center;
  gap: 6px;
  border-radius: 12px;
  border: 2.5px solid #a8743a;
  background:
    radial-gradient(circle at 50% 42%, rgba(232, 193, 90, 0.35), rgba(232, 193, 90, 0.08) 32%, transparent 44%),
    repeating-radial-gradient(circle at 50% 42%, rgba(232, 193, 90, 0.1) 0 2px, transparent 2px 10px),
    radial-gradient(ellipse at 50% 44%, #17171c, #0e0e12 82%);
}
.vr-qs-back img { width: 54px; height: 54px; opacity: 0.9; }
.vr-qs-back b {
  font-family: var(--vr-hud-mono);
  font-size: 8px;
  letter-spacing: 2.2px;
  color: #c9987e;
}
.vr-qs-back-num {
  position: absolute;
  top: 10px;
  right: 13px;
  font-family: var(--vr-display);
  font-size: 16px;
  font-weight: 800;
  color: #ffd76e;
}

/* -- pokemon pass: holo art window with iridescent foil + sparkle field -- */
.vr-tcard-holo {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background:
    radial-gradient(circle at 22% 28%, rgba(255, 255, 255, 0.55) 0.6px, transparent 1.6px),
    radial-gradient(circle at 68% 18%, rgba(255, 255, 255, 0.45) 0.5px, transparent 1.4px),
    radial-gradient(circle at 44% 62%, rgba(255, 255, 255, 0.4) 0.5px, transparent 1.4px),
    radial-gradient(circle at 82% 74%, rgba(255, 255, 255, 0.5) 0.6px, transparent 1.6px),
    radial-gradient(circle at 14% 82%, rgba(255, 255, 255, 0.35) 0.5px, transparent 1.3px),
    repeating-linear-gradient(115deg, rgba(255, 255, 255, 0.06) 0 2px, transparent 2px 7px),
    linear-gradient(115deg,
      rgba(255, 90, 160, 0.16),
      rgba(255, 214, 0, 0.13) 22%,
      rgba(80, 255, 190, 0.15) 46%,
      rgba(90, 170, 255, 0.17) 70%,
      rgba(200, 120, 255, 0.17) 92%);
  mix-blend-mode: screen;
  opacity: 0.55;
  transition: opacity 160ms ease, filter 160ms ease;
}
.vr-tcard:hover .vr-tcard-holo { opacity: 0.9; filter: hue-rotate(30deg) saturate(1.3); }
.vr-tcard.is-flawless .vr-tcard-holo { opacity: 0.8; }
/* sheen goes iridescent instead of casino gold */
.vr-tcard-sheen {
  background: linear-gradient(115deg,
    transparent 30%,
    rgba(255, 190, 240, 0.13) 42%,
    rgba(190, 255, 244, 0.16) 50%,
    rgba(255, 244, 200, 0.13) 58%,
    transparent 68%);
}
/* energy type: the little elemental orb next to the grade number */
.vr-tcard-hp { display: inline-flex; align-items: center; gap: 4px; flex: none; }
.vr-tcard-energy {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: radial-gradient(circle at 35% 30%, rgba(255, 255, 255, 0.85), var(--vr-energy, #e8c15a) 45%, rgba(0, 0, 0, 0.4));
  box-shadow: 0 0 6px var(--vr-energy, #e8c15a);
  flex: none;
}
.vr-tcard.is-map .vr-tcard-energy { width: 7px; height: 7px; }
/* grade mark: bottom-right corner — circle to review, diamond clear, star flawless */
.vr-tcard-mark {
  position: absolute;
  right: 5px;
  bottom: 4px;
  z-index: 3;
  font-size: 8px;
  line-height: 1;
  color: #e8d9a8;
  text-shadow: 0 0 4px rgba(0, 0, 0, 0.8);
}
.vr-tcard.is-flawless .vr-tcard-mark {
  color: #ffe9ad;
  text-shadow: 0 0 6px rgba(255, 233, 173, 0.9);
}
/* grade line reads like the slab label on a graded card */
.vr-tcard-grade {
  background: linear-gradient(180deg, #f6eed9, #e2d0a8);
  color: #241207;
  border-radius: 3px;
  padding: 2px 14px 2px 5px;
  font-weight: 700;
  letter-spacing: 0.7px;
}
.vr-tcard.is-flawless .vr-tcard-grade {
  background: linear-gradient(115deg, #ffe9ad, #fff8e2 45%, #ffd76e);
}
/* card back: the raven OWNS the back — big mascot over a glowing orb,
   gold inner frame, collector energy */
.vr-tcard.is-back {
  position: relative;
  border: 2.5px solid #b8873f;
  padding: 0;
  gap: 0;
  background:
    radial-gradient(circle at 50% 44%, rgba(232, 193, 90, 0.42), rgba(232, 193, 90, 0.1) 36%, transparent 50%),
    repeating-radial-gradient(circle at 50% 44%, rgba(232, 193, 90, 0.1) 0 2px, transparent 2px 11px),
    conic-gradient(from 210deg at 50% 46%, #17171d, #232329 22%, #18181f 48%, #20202a 74%, #17171d),
    #0e0e12;
}
.vr-tcard.is-back::after {
  content: '';
  position: absolute;
  inset: 5px;
  border: 1.5px solid rgba(232, 193, 90, 0.38);
  border-radius: 7px;
  pointer-events: none;
}
.vr-tcard.is-back .vr-tcard-backart {
  flex: 1;
  width: 100%;
  display: grid;
  place-items: center;
  padding-top: 8px;
}
.vr-tcard.is-back .vr-tcard-backart img {
  width: 72%;
  height: auto;
  max-height: none;
  opacity: 1;
  filter:
    drop-shadow(0 5px 12px rgba(0, 0, 0, 0.65))
    drop-shadow(0 0 16px rgba(232, 193, 90, 0.4));
}
.vr-tcard.is-back .vr-tcard-backname {
  margin-bottom: 12px;
  font-size: 7.5px;
  letter-spacing: 2px;
  color: #e8c15a;
  text-shadow: 0 0 6px rgba(0, 0, 0, 0.8);
}
.vr-tcard.is-back:hover .vr-tcard-backart img {
  filter:
    drop-shadow(0 5px 12px rgba(0, 0, 0, 0.65))
    drop-shadow(0 0 22px rgba(232, 193, 90, 0.65));
}
/* Locked card: a provider that is not in this project. Dimmed logo + gold
   lock seal, dashed inner frame (vs the solid frame of a graded card). */
.vr-tcard.is-locked {
  position: relative;
  border: 2.5px solid rgba(184, 135, 63, 0.5);
  padding: 0;
  gap: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  background:
    radial-gradient(circle at 50% 40%, rgba(232, 193, 90, 0.08), transparent 55%),
    conic-gradient(from 210deg at 50% 46%, #141418, #1b1b21 22%, #141419 48%, #191922 74%, #141418),
    #0b0b0f;
}
.vr-tcard.is-locked::after {
  content: '';
  position: absolute;
  inset: 5px;
  border: 1.5px dashed rgba(232, 193, 90, 0.26);
  border-radius: 7px;
  pointer-events: none;
}
.vr-tcard.is-locked .vr-tcard-lockart {
  position: relative;
  flex: 1;
  width: 100%;
  display: grid;
  place-items: center;
}
.vr-tcard.is-locked .vr-provider-token {
  width: 48%;
  opacity: 0.35;
  filter: grayscale(1) brightness(1.3);
}
.vr-tcard.is-locked .vr-provider-token svg,
.vr-tcard.is-locked .vr-provider-token img {
  width: 100%;
  height: auto;
}
.vr-tcard.is-locked .vr-tcard-lockbadge {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30%;
  aspect-ratio: 1 / 1;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #e8c15a;
  background: radial-gradient(circle at 42% 34%, #2b2b34, #121216);
  border: 1.5px solid rgba(232, 193, 90, 0.6);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.6), inset 0 0 8px rgba(232, 193, 90, 0.15);
}
.vr-tcard.is-locked .vr-tcard-lockbadge svg {
  width: 52%;
  height: 52%;
}
.vr-tcard.is-locked .vr-tcard-lockhint {
  font-size: 7.5px;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  font-weight: 800;
  color: #2a1c02;
  text-shadow: 0 1px 0 rgba(255, 245, 205, 0.45);
  margin-bottom: 6px;
}
.vr-tcard.is-locked .vr-tcard-backname {
  margin-bottom: 3px;
  font-size: 10px;
  letter-spacing: 0.3px;
  font-weight: 800;
  color: #1a1201;
  text-shadow: 0 1px 0 rgba(255, 245, 205, 0.45);
}
.vr-tcard.is-locked:hover {
  border-color: rgba(232, 193, 90, 0.7);
}
.vr-tcard.is-locked:hover .vr-provider-token {
  opacity: 0.5;
}
.vr-tcard.is-locked:hover .vr-tcard-lockbadge {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.6), 0 0 14px rgba(232, 193, 90, 0.4), inset 0 0 8px rgba(232, 193, 90, 0.2);
}
/* Pack card back: a sealed mystery — no provider identity until you flip. */
.vr-discover-card .vr-flip-back .vr-pack-seal {
  font-size: 34px;
  line-height: 1;
  color: rgba(232, 193, 90, 0.5);
  text-shadow: 0 0 18px rgba(232, 193, 90, 0.4);
}
/* inside a flip card the back must stay an absolute overlay — the
   position: relative above would otherwise stack it under the face */
[data-flip-card] .vr-flip-back,
[data-flip-card] .vr-flip-back.vr-tcard.is-back {
  position: absolute;
  inset: 0;
  width: auto;
  height: auto;
}
/* the pack card is exactly card-sized; the rank hangs below it */
.vr-discover-card .vr-flip-inner { width: 128px; margin: 0 auto; }
.vr-discover-rank {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 7px);
  margin: 0;
}
.vr-discover-grid { gap: 40px 14px; padding-bottom: 30px; }

/* ==========================================================================
   manga ink pass — the display voice becomes Anton. The HUD layer above set
   headings to Bahnschrift (a generic condensed); this final override swaps the
   marquee surfaces to the real loaded poster face so the Studio reads manga,
   not "condensed sans." Buttons and small labels stay Bahnschrift for
   legibility — Anton at 11px all-caps turns to mud.
   ========================================================================== */
.vr-composed-shell h1,
.vr-composed-shell h2,
.vr-composed-shell h3,
.vr-modal-card h2,
.vr-modal-card h3,
.vr-quickstrike header,
.vr-rail-launcher strong,
.vr-arch-node > div strong,
.vr-studio-architecture.is-region-map .vr-arch-node:not(.is-card) strong,
.vr-card-portrait strong {
  font-family: var(--mg-display);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  font-weight: 400;
  /* faint gold ink bleed so the poster type sits on the felt, not above it */
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.55);
}
/* Anton has no bold — its native weight already reads heavy. Give the big
   section headers a touch more air so the caps don't crowd. */
.vr-composed-shell h1 { letter-spacing: 0.02em; }

/* ==========================================================================
   manga chat: the VibeRaven voice wears the fierce raven emblem (refs 1 & 3
   put the raven bust beside the agent output). The coin frames the raven's
   face out of the transparent emblem; a gold ring seats it as an avatar.
   ========================================================================== */
.vr-story-node.has-raven .vr-story-dot {
  width: 34px;
  height: 34px;
  padding: 0;
  overflow: hidden;
  border: 1.5px solid var(--vr-border-strong);
  background: radial-gradient(circle at 50% 40%, #1a1a1f, #0a0a0d);
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.35), 0 0 12px rgba(232, 193, 90, 0.18);
}
.vr-raven-coin {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* frame the raven's face (right side of the emblem art), not the sign */
  object-position: 74% 40%;
  transform: scale(1.55);
}
.vr-story-node.is-error.has-raven .vr-story-dot { border-color: rgba(239, 68, 68, 0.6); }
/* the intro card's inline raven badge */
.vr-chat-intro-message .vr-intro-raven {
  display: inline-grid;
  place-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  border: 1.5px solid var(--vr-border-strong);
  background: radial-gradient(circle at 50% 40%, #1a1a1f, #0a0a0d);
}
.vr-chat-intro-message .vr-intro-raven img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 74% 40%;
  transform: scale(1.55);
}

/* ==========================================================================
   manga card frame — match the gold-on-black provider-card asset (refs 3 & 4).
   Additive over the round-6/7 trading-card anatomy: ink-black inner (kills the
   last crimson tint at #140a0c), a gold halftone burst behind the glyph, a
   gold inset double-frame line, and Anton on the card name. Brand-colored
   glyphs stay (the binder mockup keeps provider colors on the gold frame).
   ========================================================================== */
.vr-tcard:not(.is-back) .vr-tcard-inner {
  background: #0c0c10;
  /* the second, inner gold line — reads as the ornate double frame */
  box-shadow: inset 0 0 0 1px rgba(232, 193, 90, 0.28);
}
.vr-tcard:not(.is-back) .vr-tcard-artwin {
  border-color: rgba(232, 193, 90, 0.32);
  /* gold burst radiating from behind the provider glyph */
  background:
    radial-gradient(circle at 50% 46%, rgba(232, 193, 90, 0.22), rgba(232, 193, 90, 0.05) 42%, transparent 68%),
    #08080b;
}
/* fine gold sunburst rays over the halftone — the asset's signature shimmer */
.vr-tcard:not(.is-back) .vr-tcard-artwin::after {
  content: '';
  position: absolute;
  inset: 0;
  background:
    repeating-conic-gradient(from 0deg at 50% 46%,
      rgba(232, 193, 90, 0.10) 0deg 2deg, transparent 2deg 10deg);
  -webkit-mask-image: radial-gradient(circle at 50% 46%, #000 0, transparent 70%);
  mask-image: radial-gradient(circle at 50% 46%, #000 0, transparent 70%);
  pointer-events: none;
  z-index: 0;
}
.vr-tcard:not(.is-back) .vr-tcard-artwin .vr-provider-token.is-tcard { z-index: 1; }
/* card name speaks the poster face */
.vr-tcard-head b {
  font-family: var(--mg-display);
  font-weight: 400;
  letter-spacing: 0.03em;
  color: var(--vr-gold-bright);
}
/* corner ticks: four gold L-brackets tucked into the frame corners */
.vr-tcard:not(.is-back) .vr-tcard-inner::before {
  content: '';
  position: absolute;
  inset: 3px;
  pointer-events: none;
  z-index: 3;
  background:
    linear-gradient(var(--vr-gold-bright), var(--vr-gold-bright)) left top,
    linear-gradient(var(--vr-gold-bright), var(--vr-gold-bright)) left top,
    linear-gradient(var(--vr-gold-bright), var(--vr-gold-bright)) right top,
    linear-gradient(var(--vr-gold-bright), var(--vr-gold-bright)) right top,
    linear-gradient(var(--vr-gold-bright), var(--vr-gold-bright)) left bottom,
    linear-gradient(var(--vr-gold-bright), var(--vr-gold-bright)) left bottom,
    linear-gradient(var(--vr-gold-bright), var(--vr-gold-bright)) right bottom,
    linear-gradient(var(--vr-gold-bright), var(--vr-gold-bright)) right bottom;
  background-repeat: no-repeat;
  background-size: 10px 2px, 2px 10px;
  opacity: 0.9;
}

/* THE collector redesign: the frame is always GOLD FOIL (like the binder
   mockup + the gold-on-black provider-card asset). Provider colour lives only
   in the art-window burst and the glyph glow — not the frame. This is what
   turns the cards from "casino colored rectangle" into "premium graded slab". */
.vr-tcard[data-foil]:not(.is-back) {
  background: var(--vr-foil);
}
.vr-tcard:not(.is-back) {
  border-radius: 12px;
  box-shadow:
    0 10px 24px rgba(0, 0, 0, 0.6),
    inset 0 0 0 1px rgba(0, 0, 0, 0.4),
    inset 0 0 0 2px rgba(255, 233, 173, 0.35);
}
.vr-tcard:not(.is-back):hover {
  box-shadow:
    0 16px 32px rgba(0, 0, 0, 0.65),
    0 0 20px rgba(232, 193, 90, 0.4),
    inset 0 0 0 1px rgba(0, 0, 0, 0.4),
    inset 0 0 0 2px rgba(255, 233, 173, 0.5);
}
/* the RAVEN GRADE line reads like a graded-slab label bar */
.vr-tcard-grade {
  color: #241207;
  background: linear-gradient(180deg, #f6eed9, #e2d0a8);
  border-radius: 3px;
  padding: 2px 6px;
  font-weight: 700;
}

/* ==========================================================================
   manga hero watermark — the empty chat void gets a faint raven emblem
   bleeding in from the right, like the faded raven behind the mockup chat.
   Fills dead space and carries the manga presence without hurting readability.
   ========================================================================== */
.vr-chat-lane.is-primary { position: relative; }
/* keep the messages above any lane background */
.vr-chat-lane.is-primary > * { position: relative; z-index: 1; }

/* ==========================================================================
   manga agent message — the screenshot-5 styling on REAL answers: a fierce
   raven avatar, an "AI AGENT" badge, and a faded raven bleeding behind the
   message (like the eye behind the mockup chat). No fake data.
   ========================================================================== */
.vr-chat-agent-response { position: relative; overflow: hidden; }
.vr-chat-agent-response::before {
  content: '';
  position: absolute;
  right: -70px;
  top: 50%;
  transform: translateY(-50%);
  width: 340px;
  height: 340px;
  background: url('/manga/emblem.png') no-repeat center / contain;
  opacity: 0.06;
  pointer-events: none;
  z-index: 0;
}
.vr-chat-agent-response > * { position: relative; z-index: 1; }
.vr-hud-avatar.is-raven {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  overflow: hidden;
  border: 1.5px solid var(--vr-border-strong);
  background: radial-gradient(circle at 50% 40%, #1a1a1f, #0a0a0d);
  box-shadow: 0 0 12px rgba(232, 193, 90, 0.18);
  flex: none;
}
.vr-hud-avatar.is-raven img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 74% 40%;
  transform: scale(1.55);
}
.vr-hud-aibadge {
  font-family: var(--vr-hud-mono);
  font-size: 8.5px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--vr-gold-bright);
  padding: 2px 7px;
  border-radius: 5px;
  background: rgba(232, 193, 90, 0.12);
  box-shadow: inset 0 0 0 1px rgba(232, 193, 90, 0.4);
}

/* ==========================================================================
   full-art provider cards + holographic foil (the "shiny Pokémon" effect).
   The card art (assets/manga/cards/<id>.webp) is the whole face; an
   iridescent foil + a specular glare sweep ride on top and light up on hover.
   ========================================================================== */
.vr-tcard.has-art {
  padding: 0;
  border: none;
  overflow: hidden;
  border-radius: 11px;
  background: #000;
  box-shadow:
    0 10px 24px rgba(0, 0, 0, 0.6),
    inset 0 0 0 1px rgba(255, 233, 173, 0.3);
}
.vr-tcard.has-art .vr-tcard-artfull {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 11px;
}
/* iridescent holo foil — always faintly present, blooms on hover */
.vr-tcard-holofoil {
  position: absolute;
  inset: 0;
  border-radius: 11px;
  pointer-events: none;
  z-index: 2;
  background: repeating-linear-gradient(115deg,
    rgba(255, 110, 150, 0.16) 0 7px,
    rgba(120, 200, 255, 0.16) 7px 14px,
    rgba(150, 255, 190, 0.16) 14px 21px,
    rgba(255, 240, 150, 0.16) 21px 28px);
  background-size: 220% 220%;
  mix-blend-mode: color-dodge;
  opacity: 0.16;
  transition: opacity 220ms ease;
}
/* gold sparkle glints over the foil */
.vr-tcard-holofoil::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 11px;
  background:
    radial-gradient(circle at 28% 22%, rgba(255, 255, 255, 0.55), transparent 9%),
    radial-gradient(circle at 72% 58%, rgba(255, 233, 173, 0.5), transparent 8%),
    radial-gradient(circle at 52% 86%, rgba(255, 255, 255, 0.4), transparent 7%);
  mix-blend-mode: screen;
  opacity: 0.28;
}
/* specular glare bar that sweeps across on hover */
.vr-tcard-glare {
  position: absolute;
  inset: 0;
  border-radius: 11px;
  pointer-events: none;
  z-index: 3;
  background: linear-gradient(115deg, transparent 36%, rgba(255, 255, 255, 0.3) 48%, rgba(255, 240, 200, 0.22) 54%, transparent 64%);
  background-size: 250% 250%;
  background-position: 120% 0%;
  opacity: 0;
  transition: opacity 200ms ease;
}
.vr-tcard.has-art:hover { transform: translateY(-6px) scale(1.04); }
.vr-tcard.has-art:hover .vr-tcard-holofoil { opacity: 0.5; animation: vr-holo-shift 2.6s linear infinite; }
.vr-tcard.has-art:hover .vr-tcard-glare { opacity: 1; animation: vr-glare-sweep 1.1s ease; }
.vr-tcard.has-art.is-flawless { box-shadow: 0 12px 26px rgba(0, 0, 0, 0.6), 0 0 22px rgba(232, 193, 90, 0.5), inset 0 0 0 1px rgba(255, 233, 173, 0.55); }
.vr-tcard.has-art.is-flawless .vr-tcard-holofoil { opacity: 0.34; }
@keyframes vr-holo-shift { 0% { background-position: 0% 0%; } 100% { background-position: 220% 220%; } }
@keyframes vr-glare-sweep { 0% { background-position: 120% 0%; } 100% { background-position: -40% 0%; } }
/* grade medallion — a clean gold-ringed ink coin that suits the ornate art
   (was a pill with a colored energy dot that looked tacked-on). */
.vr-tcard.has-art .vr-tcard-hp.is-onart {
  position: absolute;
  top: 7px;
  right: 7px;
  z-index: 4;
  display: grid;
  place-items: center;
  width: 21px;
  height: 21px;
  padding: 0;
  border-radius: 50%;
  background: radial-gradient(circle at 50% 34%, #2b2721, #0b0a0e);
  box-shadow: inset 0 0 0 1.5px rgba(255, 233, 173, 0.7), 0 1px 3px rgba(0, 0, 0, 0.6);
}
.vr-tcard.has-art .vr-tcard-hp.is-onart .vr-tcard-energy { display: none; }
.vr-tcard.has-art .vr-tcard-hp.is-onart i {
  font-family: var(--mg-display);
  font-style: normal;
  font-size: 12px;
  line-height: 1;
  color: var(--vr-gold-bright);
}
.vr-tcard.is-hand.has-art .vr-tcard-hp.is-onart { width: 17px; height: 17px; top: 5px; right: 5px; }
.vr-tcard.is-hand.has-art .vr-tcard-hp.is-onart i { font-size: 9.5px; }
/* the baked art already carries the RAVEN GRADE band; hide the overlay strip */
.vr-tcard.has-art .vr-tcard-gradebar { display: none; }

/* the agent message already carries the raven in its header (.vr-hud-avatar)
   and the intro carries .vr-intro-raven — so the timeline story-dot drops back
   to a small plain node instead of a second, redundant raven coin. */
.vr-story-node.has-raven .vr-story-dot {
  width: 12px;
  height: 12px;
  margin-top: 16px;
  border-color: rgba(232, 193, 90, 0.5);
  background: radial-gradient(circle, var(--vr-gold) 0 2px, rgba(12, 13, 16, 0.96) 3px);
  box-shadow: 0 0 8px rgba(232, 193, 90, 0.25);
}
.vr-story-node.has-raven .vr-story-dot .vr-raven-coin { display: none; }

/* ==========================================================================
   manga comic panels — the real restructure. The chat panels were generic
   rounded-dark rectangles (why it "looked the same"). Now: hard notched
   corners (comic-panel cut), a bold gold spine on the left, faint gold
   halftone screentone inside, and a gold tab behind the header label.
   Applies to the MISSION cards and the VibeRaven agent answers.
   ========================================================================== */
.vr-chat-message.is-user.is-mission,
.vr-chat-agent-response {
  position: relative;
  border: 1.5px solid var(--vr-border-strong) !important;
  border-left-width: 3px !important;
  border-radius: 4px !important;
  /* two opposite corners cut = comic panel */
  clip-path: polygon(0 0, calc(100% - 20px) 0, 100% 20px, 100% 100%, 20px 100%, 0 calc(100% - 20px)) !important;
  background-color: rgba(13, 12, 16, 0.94) !important;
  background-image:
    radial-gradient(rgba(232, 193, 90, 0.055) 1px, transparent 1.4px),
    linear-gradient(160deg, rgba(232, 193, 90, 0.05), transparent 34%) !important;
  background-size: 9px 9px, auto !important;
}
/* MISSION panels lean cool-gold, agent panels get the warmer gold spine */
.vr-chat-message.is-user.is-mission { border-left-color: var(--vr-gold) !important; }
.vr-chat-agent-response.is-blocked { border-left-color: var(--vr-red) !important; }
.vr-chat-agent-response.is-nominal { border-left-color: var(--vr-green) !important; }

/* header labels become inked tabs: MISSION / VIBERAVEN sit on a gold underline */
.vr-chat-message.is-user.is-mission .vr-hud-strip strong,
.vr-chat-message.is-user.is-mission > header strong,
.vr-chat-agent-response .vr-hud-strip strong {
  position: relative;
}
.vr-chat-agent-response .vr-hud-strip {
  border-bottom: 1px solid rgba(232, 193, 90, 0.16);
  padding-bottom: 7px;
  margin-bottom: 2px;
}
/* a small gold corner bracket on the top-left of each panel */
.vr-chat-message.is-user.is-mission::after,
.vr-chat-agent-response::after {
  content: '';
  position: absolute;
  left: 7px;
  top: 7px;
  width: 12px;
  height: 12px;
  border-left: 2px solid rgba(232, 193, 90, 0.55);
  border-top: 2px solid rgba(232, 193, 90, 0.55);
  pointer-events: none;
  z-index: 2;
}

/* ==========================================================================
   composer = a comic panel too (was a soft rounded "old-school" box). Same
   notched frame + halftone as the chat messages so the column is of-a-piece.
   ========================================================================== */
.vr-chat-lane .vr-chat-command-bar > .vr-chat-composer,
.vr-studio-chat:not(.is-split) .vr-chat-lane.is-primary .vr-chat-command-bar > .vr-chat-composer {
  border: 1.5px solid var(--vr-border-strong) !important;
  border-radius: 5px !important;
  /* NO clip-path: the model/command/access menus are descendants and a notch
     here clipped them when they popped up (looked "corrupted"). */
  background-color: rgba(13, 12, 16, 0.96) !important;
  background-image: radial-gradient(rgba(232, 193, 90, 0.045) 1px, transparent 1.4px) !important;
  background-size: 9px 9px !important;
  box-shadow: 0 0 24px rgba(232, 193, 90, 0.07) !important;
  overflow: visible !important;
}
.vr-chat-lane .vr-chat-command-bar > .vr-chat-composer:focus-within {
  border-color: var(--vr-gold) !important;
  box-shadow: 0 0 26px rgba(232, 193, 90, 0.16) !important;
}

/* ==========================================================================
   the OTHER views join the manga theme: worktree branch cards, the commit
   banner, and the region-map nodes all become comic panels (notched corners,
   gold frame, halftone). A faded raven bleeds in from the right of the table
   views like the warrior in the reference mockup.
   ========================================================================== */
.vr-bcard {
  position: relative;
  border: 1.5px solid var(--vr-border-strong) !important;
  border-radius: 4px !important;
  clip-path: polygon(0 0, calc(100% - 14px) 0, 100% 14px, 100% 100%, 14px 100%, 0 calc(100% - 14px));
  background-color: rgba(13, 12, 16, 0.95) !important;
  background-image: radial-gradient(rgba(232, 193, 90, 0.05) 1px, transparent 1.4px) !important;
  background-size: 9px 9px !important;
}
.vr-bcard.is-current {
  border-color: var(--vr-gold) !important;
  box-shadow: 0 0 18px rgba(232, 193, 90, 0.18);
}
.vr-table-warning {
  position: relative;
  border: 1.5px solid var(--vr-border-strong) !important;
  border-left: 3px solid var(--vr-gold) !important;
  border-radius: 4px !important;
  clip-path: polygon(0 0, calc(100% - 16px) 0, 100% 16px, 100% 100%, 0 100%);
  background-color: rgba(13, 12, 16, 0.95) !important;
  background-image:
    radial-gradient(rgba(232, 193, 90, 0.05) 1px, transparent 1.4px),
    linear-gradient(160deg, rgba(232, 193, 90, 0.06), transparent 40%) !important;
  background-size: 9px 9px, auto !important;
}
/* region-map + architecture nodes get the comic-panel notch + halftone */
.vr-arch-node:not(.is-card) {
  clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 12px 100%, 0 calc(100% - 12px));
  background-image: radial-gradient(rgba(232, 193, 90, 0.05) 1px, transparent 1.4px) !important;
  background-size: 8px 8px !important;
}
/* the raven bleeds in from the right of the worktree/versions/region views */
.vr-table-view,
.vr-studio-architecture { position: relative; }
.vr-table-view::after,
.vr-studio-architecture.is-region-map::after {
  content: '';
  position: absolute;
  right: -40px;
  bottom: -20px;
  width: 460px;
  height: 460px;
  background: url('/manga/emblem.png') no-repeat right bottom / contain;
  opacity: 0.06;
  pointer-events: none;
  z-index: 0;
}
/* rail logo is the fierce raven, framed to its face */
.vr-rail-raven.is-emblem {
  border-radius: 9px;
  overflow: hidden;
  border: 1px solid var(--vr-border-strong);
  background: radial-gradient(circle at 50% 40%, #1a1a1f, #0a0a0d);
}
.vr-rail-raven.is-emblem img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 74% 40%;
  transform: scale(1.5);
}

/* ==========================================================================
   MANGA THEME PASS — dropdowns/menus, readability, world background, top bar,
   modal, chrome. One append block; wins by source order. No !important.
   ========================================================================== */

/* ----- Area 1: dropdowns & popup menus (kill the white selected row) ----- */
.vr-model-picker > button {
  border: 1px solid var(--vr-border);
  border-radius: 5px;
  background-color: rgba(13, 12, 16, 0.95);
  color: var(--vr-text);
}
.vr-model-picker > button span { color: var(--vr-muted); }
.vr-model-picker > button strong { color: var(--vr-gold-bright); }
.vr-model-picker > button i { border-color: var(--vr-gold); }
.vr-model-picker > button:hover { border-color: var(--vr-border-strong); background-color: rgba(20, 18, 12, 0.96); }

.vr-model-menu,
.vr-scope-menu,
.vr-chat-command-popover {
  border: 1px solid var(--vr-border-strong);
  border-left: 3px solid var(--vr-gold);
  border-radius: 5px;
  background-color: rgba(10, 10, 13, 0.99);
  background-image: radial-gradient(rgba(232, 193, 90, 0.045) 1px, transparent 1.4px);
  background-size: 9px 9px;
  box-shadow: 4px 6px 0 rgba(0, 0, 0, 0.55), 0 0 0 1px rgba(0, 0, 0, 0.5);
  color: var(--vr-text);
  overflow: hidden;
}
.vr-model-menu p,
.vr-scope-menu p {
  font-family: var(--mg-display);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--vr-gold);
}
.vr-model-menu button,
.vr-scope-menu button,
.vr-chat-command-popover button { border-radius: 3px; color: rgba(244, 241, 232, 0.9); }
.vr-model-menu button strong { color: rgba(244, 241, 232, 0.95); }
.vr-model-menu button em { color: var(--vr-muted); font-size: 11.5px; }
.vr-chat-command-popover button.is-primary { color: var(--vr-gold-bright); }
.vr-chat-command-popover button.is-muted { color: var(--vr-muted); }
.vr-model-menu button:hover,
.vr-scope-menu button:hover,
.vr-chat-command-popover button:hover {
  background: rgba(232, 193, 90, 0.12);
  box-shadow: inset 3px 0 0 var(--vr-gold);
  color: var(--vr-gold-bright);
}
/* selected row: gold-tinted ink + spine (JS marks the active row with a <b>) */
.vr-model-menu button[aria-selected="true"],
.vr-model-menu button.is-active,
.vr-model-menu button:has(> b),
.vr-scope-menu button:has(> b) {
  background: rgba(232, 193, 90, 0.16);
  box-shadow: inset 3px 0 0 var(--vr-gold);
}
.vr-model-menu button[aria-selected="true"] strong,
.vr-model-menu button:has(> b) strong { color: var(--vr-gold-bright); }
.vr-model-menu button b,
.vr-scope-menu button b { border-color: var(--vr-gold-bright); }
/* themed menu scrollbars */
.vr-model-menu::-webkit-scrollbar,
.vr-scope-menu::-webkit-scrollbar,
.vr-chat-command-popover::-webkit-scrollbar { width: 8px; }
.vr-model-menu::-webkit-scrollbar-thumb,
.vr-scope-menu::-webkit-scrollbar-thumb,
.vr-chat-command-popover::-webkit-scrollbar-thumb { background: var(--vr-border-strong); border: 2px solid rgba(13, 12, 16, 0.97); }

.vr-chat-inline-actions > button,
.vr-chat-command-trigger > button {
  border: 1px solid var(--vr-border);
  border-radius: 5px;
  background: rgba(13, 12, 16, 0.7);
  color: rgba(244, 241, 232, 0.82);
}
.vr-chat-inline-actions > button:hover,
.vr-chat-command-trigger > button:hover {
  border-color: var(--vr-border-strong);
  background: rgba(20, 18, 12, 0.85);
  color: var(--vr-gold-bright);
}

/* ----- Area 2: readability ----- */
.vr-chat-command-bar .vr-chat-input { color: var(--vr-text); }
.vr-chat-command-bar .vr-chat-input::placeholder { color: var(--vr-muted); }
.vr-chat-inline-actions button.is-primary {
  background: var(--vr-gold);
  color: #241207;
  border-color: var(--vr-gold-bright);
  font-weight: 720;
}
.vr-chat-inline-actions button.is-muted { opacity: 1; color: var(--vr-muted); font-weight: 650; }
.vr-cli-os-fallback { color: var(--vr-muted); text-decoration-color: var(--vr-border-strong); }
.vr-cli-os-fallback:hover { color: var(--vr-gold-bright); }

/* ----- Area 4b: primary CTAs -> gold (after Area 1 so filled-gold wins) ----- */
.vr-agent-followups button.is-primary,
.vr-agent-inline-action.is-primary,
.vr-chat-command-popover button.is-primary,
.vr-cli-action-button.is-primary,
.vr-studio-architecture > footer button.is-primary,
.vr-arch-drawer footer button.is-primary,
.vr-wt-actions button.is-primary,
.vr-approve-all,
.vr-new-chat-button,
.vr-provider-ask-agent {
  background: var(--vr-gold);
  border-color: var(--vr-gold-bright);
  color: #0a0b0e;
  font-family: var(--mg-display);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.vr-agent-followups button.is-primary:hover,
.vr-agent-inline-action.is-primary:hover,
.vr-chat-command-popover button.is-primary:hover,
.vr-approve-all:hover,
.vr-new-chat-button:hover,
.vr-provider-ask-agent:hover { background: var(--vr-gold-bright); border-color: var(--vr-gold-bright); color: #0a0b0e; }
.vr-composer-controls .vr-chat-send:not(.is-stop),
.vr-chat-command-bar > .vr-chat-composer > .vr-chat-send:not(.is-stop) {
  background: var(--vr-gold);
  border-color: var(--vr-gold-bright);
  color: #0a0b0e;
}
.vr-composer-controls .vr-chat-send:not(.is-stop):hover,
.vr-chat-command-bar > .vr-chat-composer > .vr-chat-send:not(.is-stop):hover { background: var(--vr-gold-bright); border-color: var(--vr-gold-bright); }

/* ----- Area 3: world background (inked drafting table, lit from above) ----- */
body {
  background-color: #08080a;
  background-image:
    radial-gradient(rgba(232, 193, 90, 0.05) 1px, transparent 1.6px),
    repeating-linear-gradient(52deg, rgba(232, 193, 90, 0.045) 0 1px, transparent 1px 8px),
    repeating-linear-gradient(-52deg, rgba(232, 193, 90, 0.04) 0 1px, transparent 1px 9px),
    radial-gradient(ellipse 70% 42% at 50% -8%, rgba(232, 193, 90, 0.07), transparent 60%),
    radial-gradient(120% 120% at 50% 40%, transparent 58%, rgba(0, 0, 0, 0.55) 100%),
    linear-gradient(180deg, #101015 0%, #0b0b0e 46%, #08080a 100%);
  background-size: 9px 9px, 900px 900px, 900px 900px, 100% 100%, 100% 100%, 100% 100%;
  background-position: 0 0, top right, bottom left, center top, center, center;
  background-repeat: repeat, no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
  background-attachment: scroll;
}
.vr-composed-shell {
  background:
    radial-gradient(ellipse 60% 30% at 50% -4%, rgba(232, 193, 90, 0.06), transparent 60%),
    radial-gradient(circle at 45% 9%, rgba(232, 193, 90, 0.035), transparent 30%),
    rgba(11, 12, 15, 0.965);
  box-shadow:
    inset 0 1px 0 rgba(255, 233, 173, 0.06),
    inset 0 0 0 1px rgba(232, 193, 90, 0.05),
    0 24px 60px rgba(0, 0, 0, 0.55);
}
.vr-studio-topbar {
  background:
    linear-gradient(180deg, rgba(232, 193, 90, 0.05), transparent 70%),
    rgba(13, 12, 16, 0.62);
}

/* ----- Area 4a: top tab bar (CHAT/ARCHITECTURE/TERMINAL/DIFF) ----- */
.vr-studio-tabs {
  border: 1px solid var(--vr-border);
  border-radius: 4px;
  clip-path: polygon(0 0, calc(100% - 9px) 0, 100% 9px, 100% 100%, 9px 100%, 0 calc(100% - 9px));
  background: rgba(13, 12, 16, 0.85);
  overflow: hidden;
}
.vr-studio-tabs button {
  font-family: var(--mg-display);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: rgba(244, 241, 232, 0.7);
}
.vr-studio-tabs button:hover { color: var(--vr-gold-bright); background: rgba(232, 193, 90, 0.08); }
.vr-studio-tabs button.is-active {
  background: var(--vr-gold);
  color: #0a0b0e;
  border-radius: 3px;
  box-shadow: inset 0 0 0 1px rgba(255, 233, 173, 0.5);
}

/* ----- Area 4c: modal (ink+gold, not navy/cyan) ----- */
.vr-modal-card {
  border-radius: 4px;
  clip-path: polygon(0 0, calc(100% - 20px) 0, 100% 20px, 100% 100%, 20px 100%, 0 calc(100% - 20px));
  background:
    radial-gradient(ellipse 70% 40% at 50% -4%, rgba(232, 193, 90, 0.06), transparent 60%),
    radial-gradient(rgba(232, 193, 90, 0.04) 1px, transparent 1.4px),
    linear-gradient(180deg, rgba(16, 15, 12, 0.99), rgba(13, 12, 16, 0.995));
  background-size: 100% 100%, 11px 11px, 100%;
}
.vr-modal-card::before { background: linear-gradient(135deg, rgba(232, 193, 90, 0.08), transparent 28%); }
.vr-modal-card::after { background: linear-gradient(90deg, transparent, rgba(232, 193, 90, 0.05), rgba(232, 193, 90, 0.2), transparent); opacity: 0.3; }
.vr-modal-backdrop { background: radial-gradient(ellipse 60% 40% at 50% 8%, rgba(232, 193, 90, 0.07), transparent 45%), rgba(4, 5, 8, 0.8); }
.vr-modal-card::-webkit-scrollbar-thumb { border: 3px solid rgba(13, 12, 16, 0.92); background: rgba(232, 193, 90, 0.4); }

/* ----- Area 4d: chrome buttons, terminal input, connect rows ----- */
.vr-studio-add-chat,
.vr-studio-actions > button:not(.vr-glow-button) {
  border: 1px solid var(--vr-border);
  border-radius: 5px;
  background: rgba(13, 12, 16, 0.7);
  color: rgba(244, 241, 232, 0.88);
}
.vr-studio-add-chat:hover,
.vr-studio-actions > button:not(.vr-glow-button):hover { border-color: var(--vr-border-strong); background: rgba(232, 193, 90, 0.08); color: var(--vr-gold-bright); }
.vr-terminal-compose textarea {
  border: 1px solid var(--vr-border);
  border-radius: 4px;
  clip-path: polygon(0 0, calc(100% - 8px) 0, 100% 8px, 100% 100%, 8px 100%, 0 calc(100% - 8px));
  background: rgba(13, 12, 16, 0.72);
  color: rgba(244, 241, 232, 0.92);
  font-family: var(--vr-hud-mono);
}
.vr-terminal-compose textarea::placeholder { color: var(--vr-muted); }
.vr-terminal-compose textarea:focus { border-color: var(--vr-gold); box-shadow: 0 0 18px rgba(232, 193, 90, 0.14); }
.vr-env-connect-option {
  border: 1px solid var(--vr-border);
  border-radius: 4px;
  clip-path: polygon(0 0, calc(100% - 10px) 0, 100% 10px, 100% 100%, 10px 100%, 0 calc(100% - 10px));
  background: rgba(13, 12, 16, 0.6);
  color: rgba(244, 241, 232, 0.9);
}
.vr-env-connect-option:hover { border-color: var(--vr-border-strong); background: rgba(232, 193, 90, 0.07); }
.vr-env-connect-option b {
  border-radius: 3px;
  background: rgba(232, 193, 90, 0.1);
  color: var(--vr-gold-bright);
  font-family: var(--vr-hud-mono);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

/* ----- Area 4e: focus ring ----- */
button:focus-visible,
a:focus-visible {
  outline: 2px solid var(--vr-gold);
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(232, 193, 90, 0.16);
}

/* ----- Area 5: raven watermarks fade away from text (readability) ----- */
.vr-chat-agent-response::before {
  opacity: 0.05;
  -webkit-mask-image: linear-gradient(90deg, transparent 0%, #000 62%);
  mask-image: linear-gradient(90deg, transparent 0%, #000 62%);
}
.vr-table-view > *,
.vr-studio-architecture.is-region-map > * { position: relative; z-index: 1; }
.vr-table-view::after,
.vr-studio-architecture.is-region-map::after {
  opacity: 0.05;
  -webkit-mask-image: radial-gradient(circle at right bottom, #000 28%, transparent 72%);
  mask-image: radial-gradient(circle at right bottom, #000 28%, transparent 72%);
}

/* ----- placed cards get an always-visible X to clear them off the table.
   NB: has-art cards have overflow:hidden, so the X must sit INSIDE the card
   corner (top-left, away from the grade coin) or it gets clipped. ----- */
.vr-tcard.is-placed .vr-tcard-unplace,
.vr-vcard.is-mini.is-placed .vr-tcard-unplace {
  opacity: 1;
  width: 21px;
  height: 21px;
  top: 5px;
  left: 5px;
  right: auto;
  z-index: 6;
  background: rgba(6, 6, 8, 0.92);
  border: 1.5px solid var(--vr-gold);
  color: var(--vr-gold-bright);
  font-size: 11px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.7);
  transition: transform 0.1s ease, background 0.1s ease, color 0.1s ease;
}
.vr-tcard.is-placed:hover .vr-tcard-unplace,
.vr-vcard.is-mini.is-placed:hover .vr-tcard-unplace { opacity: 1; }
.vr-tcard.is-placed .vr-tcard-unplace:hover,
.vr-vcard.is-mini.is-placed .vr-tcard-unplace:hover {
  background: var(--vr-red);
  border-color: var(--vr-red);
  color: #fff;
  transform: scale(1.12);
}


/* ==========================================================================
   MANGA B&W CONTRAST PASS — appended AFTER "MANGA THEME PASS" so it wins by
   source order. Direction: blacker blacks, whiter/cream ink, crisp near-white
   hairlines, screentone dots for grey; gold pulled back to an ACCENT only
   (spines, selected rails, small marks). Semantic red kept for errors.
   De-duplicated + conflict-resolved (higher contrast wins). No !important
   except where an existing same-file !important rule must be overridden.
   ========================================================================== */

/* ---------- (1) B&W CONTRAST BASE ---------- */

/* Retone root tokens: fixes the majority of muted labels + gold-alpha edges
   in one place. --vr-muted lifted off the dim tan; borders become near-white
   ink hairlines; gold moves to an explicit accent hook. */
:root {
  --vr-bg: #050506;
  --vr-bg-2: #0e0e11;
  --vr-text: #f7f4ec;
  --vr-muted: #c4bcaf;
  --vr-border: rgba(238, 232, 220, 0.16);
  --vr-border-strong: rgba(238, 232, 220, 0.34);
  --vr-panel: rgba(9, 9, 11, 0.92);
  --vr-panel-2: rgba(14, 14, 17, 0.9);
  --vr-hud-surface: rgba(6, 6, 8, 0.94);
  --vr-hud-line: rgba(238, 232, 220, 0.14);
  --vr-accent-line: rgba(232, 193, 90, 0.55);
}

/* World background: drop the gold cross-hatch haze for black paper + faint
   neutral screentone + vignette. */
body {
  background-color: #050506;
  background-image:
    radial-gradient(rgba(244, 241, 232, 0.028) 1px, transparent 1.5px),
    radial-gradient(ellipse 68% 40% at 50% -8%, rgba(255, 255, 255, 0.035), transparent 62%),
    radial-gradient(130% 120% at 50% 42%, transparent 56%, rgba(0, 0, 0, 0.72) 100%),
    linear-gradient(180deg, #0c0c0f 0%, #08080a 48%, #050506 100%);
  background-size: 8px 8px, 100% 100%, 100% 100%, 100% 100%;
  background-position: 0 0, center top, center, center;
  background-repeat: repeat, no-repeat, no-repeat, no-repeat;
}

/* Composed shell: near-flat true-black with one white top hairline. */
.vr-composed-shell {
  background:
    radial-gradient(ellipse 62% 26% at 50% -3%, rgba(255, 255, 255, 0.04), transparent 60%),
    rgba(7, 7, 9, 0.975);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.07),
    inset 0 0 0 1px rgba(238, 232, 220, 0.05),
    0 24px 60px rgba(0, 0, 0, 0.62);
}

/* Studio topbar: neutral top-light + single thin gold underline accent. */
.vr-studio-topbar {
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.045), transparent 70%),
    rgba(6, 6, 9, 0.72);
  border-bottom: 1px solid var(--vr-border);
  box-shadow: inset 0 -1px 0 var(--vr-accent-line);
}

/* Persistent top-bar readout (was #64748b cold slate, ~3.4:1). */
.vr-topbar-spacer { color: var(--vr-muted); font-weight: 780; }

/* Studio tabs: active tab reads as inked-white paper with a gold underline
   mark, not a gold slab; idle-tab contrast raised. */
.vr-studio-tabs button { color: rgba(244, 241, 232, 0.82); }
.vr-studio-tabs button.is-active {
  background: rgba(244, 241, 232, 0.1);
  color: #f7f4ec;
  box-shadow: inset 0 -2px 0 var(--vr-gold), inset 0 0 0 1px rgba(238, 232, 220, 0.14);
}
.vr-studio-tabs button:hover { color: #ffe9ad; background: rgba(255, 255, 255, 0.05); }

/* Dropdown / popup menus: clean black sheet (kills the gold halftone),
   gold only on the left spine + hover/selected rail; item + label contrast up. */
.vr-model-menu,
.vr-scope-menu,
.vr-chat-command-popover {
  background-color: rgba(5, 5, 7, 0.99);
  background-image: none;
  border-color: var(--vr-border-strong);
  border-left: 3px solid var(--vr-gold);
}
.vr-model-menu button,
.vr-scope-menu button,
.vr-chat-command-popover button { color: #f0ece2; }
.vr-model-menu button em { color: #c4bcae; }
.vr-model-menu button:hover,
.vr-scope-menu button:hover,
.vr-chat-command-popover button:hover {
  background: rgba(255, 255, 255, 0.06);
  box-shadow: inset 3px 0 0 var(--vr-gold);
  color: #ffe9ad;
}

/* HUD strip (telemetry line): raise the faded cool-grey meta to readable ink. */
.vr-hud-strip { color: #c9c1b4; border-bottom-color: rgba(238, 232, 220, 0.12); }
.vr-hud-strip strong { color: #f7f4ec; }
.vr-hud-strip em { color: #c9c1b4; }
.vr-hud-strip b { color: var(--vr-muted); font-weight: 600; } /* merged: was #b0a89b / rgba(156,163,175,.72) */

/* HUD card chassis: white-ruled black panel; the ONE spot of color is the
   left rail (semantic status). */
.vr-hud-card {
  background: rgba(6, 6, 8, 0.94);
  border-color: rgba(238, 232, 220, 0.16);
  border-left-color: rgba(238, 232, 220, 0.45);
}
.vr-hud-card.is-nominal { border-left-color: var(--vr-green); }
.vr-hud-card.is-blocked { border-left-color: var(--vr-red); }
.vr-hud-card.is-working { border-left-color: var(--vr-orange); }
.vr-hud-card.is-mission { border-left-color: var(--vr-gold); }

/* HUD gate row + severity: lift the primary line to full-opacity ink,
   metadata to solid grey. */
.vr-hud-gate { background: rgba(255, 255, 255, 0.02); border-color: rgba(238, 232, 220, 0.14); }
.vr-hud-gate header { border-bottom-color: rgba(238, 232, 220, 0.12); }
.vr-hud-gate-row { border-bottom-color: rgba(238, 232, 220, 0.09); }
.vr-hud-gate-row em { color: #f3efe6; }
.vr-hud-gate-row em small { color: #c4bcae; }
.vr-hud-gate-row b { color: #b6ae9f; }
.vr-hud-sev.is-info { color: #b6ae9f; }
.vr-hud-gate-foot {
  border-top-color: rgba(238, 232, 220, 0.12);
  background: rgba(255, 255, 255, 0.025);
  color: #f4f1e8;
}
.vr-hud-gate-foot b { color: #bcb4a6; }
.vr-hud-gate-foot:hover { background: rgba(255, 255, 255, 0.05); }
.vr-hud-raw { color: #bcb4a6; }
.vr-agent-raw-sub { color: #c4bcae; }

/* ---------- (2) VERSIONS / WORKTREE / SHUFFLE ---------- */

/* Table view container + header: solid ink base so cream text pops; header
   is cream Anton with a hairline rule, gold reserved for the spine accents. */
.vr-table-view { background: #0b0b0d !important; }
.vr-table-view-head { border-bottom: 1.5px solid var(--vr-border-strong) !important; }
.vr-table-view-head strong { color: var(--vr-text) !important; -webkit-text-stroke: 0.4px rgba(0, 0, 0, 0.35); }
.vr-table-view-head span { color: var(--vr-muted) !important; }

/* Big version card: ink plate + white hairline + comic notch (large panel —
   notch is safe here); gold only as border tint on current. NOTE: base rules
   at ~13450-13492 use !important, so these must too. */
.vr-vcard {
  border: 1.5px solid var(--vr-border-strong) !important;
  border-radius: 4px !important;
  background: rgba(10, 10, 12, 0.96) !important;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.55) !important;
  clip-path: polygon(0 0, calc(100% - 16px) 0, 100% 16px, 100% 100%, 16px 100%, 0 calc(100% - 16px));
}
.vr-vcard::before {
  inset: 4px !important;
  border-radius: 3px !important;
  background-color: rgba(11, 11, 13, 0.9) !important;
  background-image: radial-gradient(rgba(232, 193, 90, 0.05) 1px, transparent 1.4px) !important;
  background-size: 9px 9px !important;
}
.vr-vcard:not(.is-current) { filter: none !important; opacity: 0.9; }
.vr-vcard.is-current {
  border-color: var(--vr-gold) !important;
  border-left: 3px solid var(--vr-gold) !important; /* thin gold spine = "chosen" */
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.55), 0 0 16px rgba(232, 193, 90, 0.16) !important;
}
.vr-vcard-top b,
.vr-vpile-card b { color: var(--vr-text) !important; font-family: var(--vr-display) !important; letter-spacing: 0.5px; }
/* merged .vr-vcard-meta: prefer --vr-muted (brightest) + the larger 8.5px */
.vr-vcard-meta { color: var(--vr-muted) !important; font-size: 8.5px !important; letter-spacing: 0.8px; opacity: 0.95; }
.vr-vcard-branch { color: #cfc6b6 !important; font-size: 8.5px !important; }

/* Version pile (bottom-left floating pile): thin hairline + gold spine, not a
   thick foil frame. */
.vr-vpile-card {
  border: 1px solid var(--vr-border-strong) !important;
  border-left: 3px solid var(--vr-gold) !important;
  background: rgba(11, 11, 13, 0.96) !important;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.5) !important;
}
.vr-vpile-card.is-top {
  border-color: var(--vr-gold) !important;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.5), 0 0 12px rgba(232, 193, 90, 0.15) !important;
}
.vr-vpile-card:not(.is-top) { opacity: 0.8; }
.vr-vpile-card em { color: #cfc6b6 !important; }
.vr-version-pile-label { color: var(--vr-muted) !important; letter-spacing: 1.8px; }

/* SHUFFLE button: crisp ink pill + gold hairline; hover = thin gold-tint, not
   a solid gold slab. */
.vr-pile-shuffle {
  border: 1.5px solid var(--vr-border-strong) !important;
  border-radius: 4px !important;
  background: rgba(11, 11, 13, 0.95) !important;
  color: var(--vr-text) !important;
  font-family: var(--vr-hud-mono) !important;
  font-size: 8.5px !important;
  font-weight: 700;
  letter-spacing: 1.4px;
  padding: 4px 10px !important;
}
.vr-pile-shuffle:hover {
  background: rgba(232, 193, 90, 0.12) !important;
  border-color: var(--vr-gold) !important;
  color: var(--vr-gold-bright) !important;
}

/* Worktree branch card (bcard): gold spine + readable title/sub. */
.vr-bcard { border-left: 3px solid var(--vr-gold) !important; }
.vr-bcard b { color: var(--vr-text) !important; font-size: 13.5px !important; }
.vr-bcard em { color: #cfc6b6 !important; font-size: 9px !important; }
.vr-bcard-actions button {
  border: 1.5px solid var(--vr-border-strong) !important;
  color: var(--vr-text) !important;
  background: rgba(11, 11, 13, 0.6) !important;
  letter-spacing: 1px;
}
.vr-bcard-actions button:hover {
  background: rgba(232, 193, 90, 0.12) !important;
  border-color: var(--vr-gold) !important;
  color: var(--vr-gold-bright) !important;
}

/* Worktree uncommitted-changes warning: readable body, orange COMMIT button. */
.vr-table-warning { color: var(--vr-text) !important; font-size: 13px !important; }
.vr-table-warning button { color: var(--vr-orange) !important; font-size: 9.5px !important; letter-spacing: 1.2px; }
.vr-table-warning button:hover { background: var(--vr-orange) !important; color: #0b0b0d !important; }

/* Empty-state + add-version footer button. */
.vr-table-empty { color: #cfc6b6 !important; font-size: 11.5px !important; }
.vr-table-foot button { color: var(--vr-text) !important; border-color: var(--vr-border-strong) !important; }
.vr-table-foot button:hover { background: rgba(232, 193, 90, 0.1) !important; color: var(--vr-gold-bright) !important; }

/* ---------- (3) CLEAR STAMP FIX (region-map node badge clipped) ---------- */
/* The comic-notch clip-path on .vr-arch-node:not(.is-card) clips its
   corner-mounted .vr-arch-node-badge, cutting "CLEAR" -> "CLEA.". Per the
   manga rule (never notch anything whose badge reaches a corner), drop the
   notch on these nodes and keep the ink/halftone look via a hairline. */
.vr-arch-node:not(.is-card) {
  clip-path: none;
  overflow: visible;
  border: 1.5px solid var(--vr-border-strong);
  background-image: radial-gradient(rgba(232, 193, 90, 0.05) 1px, transparent 1.4px);
  background-size: 8px 8px;
}
.vr-studio-architecture.is-region-map .vr-arch-node:not(.is-card) .vr-arch-node-badge.vr-stamp.is-mini {
  overflow: visible;
  z-index: 3;
  background: var(--vr-bg);
}

/* ---------- (4) WELCOME MODAL QUICKSTART CARDS (flip bleed-through) ---------- */
/* On a DONE card (is-flipped, e.g. SCAN "SETUP · WON") the back-face mascot +
   FLIP label bled through because both faces trusted only backface-visibility.
   Hide the inactive face explicitly (opacity+visibility) and give the flip a
   fixed height so the four cards stay aligned. Make the back opaque. */
.vr-qs-card.is-hero { position: relative; }
.vr-qs-card.is-hero [data-flip-card],
.vr-qs-card.is-hero .vr-flip-inner { height: 100%; }
.vr-qs-card.is-hero .vr-flip-inner { min-height: 318px; }
.vr-qs-card .vr-flip-face,
.vr-qs-card .vr-flip-back {
  position: absolute;
  inset: 0;
  height: 100%;
  transition: opacity 200ms ease, visibility 200ms ease;
}
.vr-qs-card:not(.is-flipped) .vr-flip-face { opacity: 0; visibility: hidden; }
.vr-qs-card.is-flipped .vr-flip-face { opacity: 1; visibility: visible; }
.vr-qs-card.is-flipped .vr-flip-back { opacity: 0; visibility: hidden; }
.vr-qs-card:not(.is-flipped) .vr-flip-back { opacity: 1; visibility: visible; }
.vr-qs-card .vr-qs-back { background-color: #0e0e12; }
.vr-qs-card.is-hero .vr-qs-card-inner { position: relative; z-index: 1; }

/* ---------- (5) READABILITY (retone off-palette / low-contrast text) ---------- */

/* Agent answer body / structured sections: warm near-white cream on the
   highest-traffic reading surface (was cool blue-greys). */
.vr-agent-answer-body,
.vr-agent-answer-text { color: #f2efe6; }
.vr-agent-answer-body p { color: #eae6db; }
.vr-agent-list li,
.vr-chat-message p { color: var(--vr-text); } /* merged: cream token wins over #eae6db/#e7e7e9 */
.vr-agent-answer-body .vr-agent-empty { color: #bcb4a6; }

/* Inline code / pill chips: near-white on true-black chip + white hairline,
   gold only as the faint left tick (was gold body text). */
.vr-agent-answer-body code {
  background: rgba(4, 4, 6, 0.85);
  border-color: rgba(238, 232, 220, 0.16);
  border-left: 2px solid var(--vr-gold);
  color: #f4f1e8;
}
.vr-chat-message b {
  border-color: rgba(238, 232, 220, 0.24);
  background: rgba(255, 255, 255, 0.05);
  color: #f4f1e8;
}

/* Chat sub-caption / notes / inline em: readable neutral cream-grey. */
.vr-chat-message em,
.vr-chat-copy { color: #c6bfb2; }
.vr-chat-note { color: #cfc8ba; }

/* Chat bubbles (agent/system telemetry): true-black glass + white hairline +
   warm-white text (was #1d1e22 grey slab w/ blue-grey borders). */
.vr-chat-bubble {
  background: rgba(7, 7, 9, 0.92);
  border-color: rgba(238, 232, 220, 0.16);
}
.vr-chat-bubble.is-system { background: rgba(4, 4, 6, 0.9); border-color: rgba(238, 232, 220, 0.14); }
.vr-chat-bubble span { color: #e9e2d5; }
.vr-chat-bubble p,
.vr-chat-bubble ul { color: #f5f1e8; }

/* Terminal output: warm near-white body color (was cold #cbd5e1). */
.vr-terminal-line { color: #ece7db; }

/* Region-map / architecture captions + hints (cold slate -> warm muted). */
.vr-arch-zone { color: rgba(232, 214, 176, 0.82); font-weight: 800; }
.vr-arch-hint { color: var(--vr-muted); }
.vr-inspector-body .vr-studio-architecture.is-inspector-map .vr-arch-zone { color: rgba(244, 241, 232, 0.86); }

/* Card / hero TYPE eyebrows (were 6-7.5px at 0.5-0.55 alpha, illegible). */
.vr-tcard-type { color: rgba(244, 241, 232, 0.9); font-size: 8px; letter-spacing: 1px; }
.vr-qs-type {
  color: rgba(244, 241, 232, 0.9);
  font-size: 9px;
  position: relative;   /* merged w/ Bug-2 stacking so SETUP·WON sits above art */
  z-index: 2;
  margin-top: 2px;
  white-space: nowrap;
}

/* Misc muted secondary lines / captions (cold slate -> warm muted). */
.vr-context-chip-label .muted { color: var(--vr-muted); font-weight: 550; }
.vr-recent-chat em,
.vr-recent-chat small { color: var(--vr-muted); }
.vr-provider-drop-zone { color: var(--vr-muted); }
.vr-chat-agent-task header em { color: var(--vr-muted); }
.vr-provider-mcp-panel em { color: var(--vr-muted); }

/* Icon-only close/secondary button: readable at rest, gold on hover. */
.vr-context-chip-remove { color: var(--vr-muted); }
.vr-context-chip-remove:hover { color: var(--vr-gold-bright); }

/* ==========================================================================
   LIVE TABLE STATS strip — real repo/provider metrics on the table (the
   "Active Users" KPI idea, sourced from real data). Manga stat cards: ink
   plate, white hairline, gold top-tick accent, big Anton number, mono label.
   ========================================================================== */
.vr-stat-strip {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
  margin: 0 0 16px;
}
@media (max-width: 1080px) { .vr-stat-strip { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
.vr-stat-card {
  position: relative;
  padding: 11px 13px 10px;
  border: 1px solid var(--vr-border-strong);
  border-top: 2px solid rgba(238, 232, 220, 0.28);
  border-radius: 4px;
  background:
    radial-gradient(rgba(232, 193, 90, 0.045) 1px, transparent 1.4px),
    rgba(9, 9, 11, 0.94);
  background-size: 9px 9px, auto;
  overflow: hidden;
}
.vr-stat-card::after {
  content: '';
  position: absolute;
  left: 0; top: 0;
  width: 26px; height: 2px;
  background: var(--vr-gold);
}
.vr-stat-card b {
  display: block;
  font-family: var(--mg-display);
  font-weight: 400;
  font-size: 27px;
  line-height: 1;
  letter-spacing: 0.01em;
  color: var(--vr-text);
}
.vr-stat-card.is-word b { font-size: 18px; padding: 4px 0 3px; }
.vr-stat-card span {
  display: block;
  margin-top: 5px;
  font-family: var(--vr-hud-mono);
  font-size: 8.5px;
  font-weight: 650;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--vr-muted);
}
.vr-stat-card.is-gold b { color: var(--vr-gold-bright); }
.vr-stat-card.is-green b { color: var(--vr-green); }
.vr-stat-card.is-orange b { color: var(--vr-orange); }
.vr-stat-card.is-muted b { color: rgba(244, 241, 232, 0.6); }
.vr-stat-card.is-green::after { background: var(--vr-green); }
.vr-stat-card.is-orange::after { background: var(--vr-orange); }

/* ==========================================================================
   FINAL FIXES — hand spread + hover, worktree tag clip, placed-card readability
   ========================================================================== */
/* Hand: cards stick together more (was -34 = too spread) so the fan reads as a
   held hand, with a clean hover lift on a high z so it never hides behind a
   neighbour. */
.vr-hand-fan .vr-tcard { margin-left: -46px; }
.vr-hand-fan .vr-tcard:first-child { margin-left: 0; }
/* Stable hover: lift STRAIGHT up with almost no scale. A big scale grows the
   card footprint and flickers against the overlapping neighbours (the "buggy"
   hover). Keep the same width, just rise + straighten; smooth + GPU-hinted. */
.vr-hand-fan .vr-tcard {
  transition: transform 130ms ease, box-shadow 130ms ease;
  will-change: transform;
}
.vr-hand-fan .vr-tcard:hover {
  transform: rotate(0deg) translateY(-26px) scale(1.02);
  z-index: 30;
}

/* Worktree branch cards: drop the comic-notch that was slicing the
   "YOU ARE HERE" tag on the current branch (same clip bug as the region-map
   stamp). Keep the ink+gold-spine look via border only. */
.vr-bcard { clip-path: none; overflow: visible; }
.vr-bcard .vr-stamp.is-mini { z-index: 4; }

/* Placed-card X sits above the holo foil so it is always clickable. */
.vr-tcard.is-placed .vr-tcard-holofoil,
.vr-tcard.is-placed .vr-tcard-glare { pointer-events: none; }

/* Placed PROVIDER card X: top-left (grade coin is top-right), small + clean. */
.vr-tcard.is-placed .vr-tcard-unplace {
  width: 17px;
  height: 17px;
  top: 5px;
  left: 5px;
  right: auto;
  font-size: 9px;
}
/* Placed VERSION card X: top-RIGHT (the V1.x label sits top-left), small. */
.vr-vcard.is-mini.is-placed .vr-tcard-unplace {
  opacity: 1;
  width: 17px;
  height: 17px;
  top: 5px;
  right: 5px;
  left: auto;
  font-size: 9px;
  background: rgba(6, 6, 8, 0.92);
  border: 1.5px solid var(--vr-gold);
  color: var(--vr-gold-bright);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.7);
}
.vr-vcard.is-mini.is-placed .vr-tcard-unplace:hover { background: var(--vr-red); border-color: var(--vr-red); color: #fff; }

/* Placed-card HOVER must KEEP the translate(-50%,-50%) centering — the has-art
   hover rule was replacing it, so the card JUMPED off-position (the "buggy
   hover"). Gentle lift, keep centered, no snap. */
.vr-tcard.is-placed:hover,
.vr-tcard.is-placed.has-art:hover {
  transform: translate(-50%, -50%) rotate(0deg) scale(1.05) !important;
  z-index: 40;
}

/* ==========================================================================
   MANGA READABILITY + CARD-VIBE PASS
   Appended after the FINAL FIXES block (>16354) so it wins by source order.
   (1) Typography: 3-tier hierarchy — Anton=headline only, mono=legible floor,
       sans=running/secondary UI. (2) Manga card-vibe: faint margin-only ink,
       gold halftone + card/raven/poster watermarks that NEVER sit behind text.
   !important is used ONLY where an existing same-file !important forces it.
   ========================================================================== */

/* -------------------------------------------------------------------------
   (1) TYPOGRAPHY
   ------------------------------------------------------------------------- */

/* 1a. Small mono-telemetry label FLOOR — lift every sub-9.5px cap to legible.
   (.vr-tcard-type/-grade base 7-8px; .vr-bcard em / .vr-vpile-card em carry
   an existing 9px !important, so those need !important to reach the floor.) */
.vr-tcard-type,
.vr-tcard-grade,
.vr-tcard.is-back .vr-tcard-backname,
.vr-qs-local,
.vr-bcard em,
.vr-vpile-card em,
.vr-addpick-list button em {
  font-size: 9.5px !important;      /* was 6–9px; beats 16104/16079 !important */
  line-height: 1.25;
  font-weight: 620;                 /* thin mono needs weight on black paper */
}
.vr-tcard.is-dealt .vr-tcard-type,
.vr-tcard.is-dealt .vr-tcard-grade { font-size: 10px !important; }

/* 1b. Letter-spacing CAP on tiny caps — extreme 1.4–2px tracking smears words.
   (Cap to ~0.07em. .vr-hud-strip / chip .muted already retoned at 15992+,
   so only their tracking is nudged, not restated.) */
.vr-tcard-type,
.vr-tcard-grade,
.vr-tcard.is-back .vr-tcard-backname,
.vr-qs-local,
.vr-pile-shuffle,
.vr-bcard-actions button,
.vr-table-warning button {
  letter-spacing: 0.07em;
}
.vr-hud-strip { letter-spacing: 0.04em; }

/* 1c. Anton DEMOTION — pull the condensed poster face off running UI text.
   Menu labels + action-button captions move to the readable sans stack. */
.vr-scope-menu p,
.vr-studio-add-chat,
.vr-provider-ask-agent,
.vr-new-chat-button,
.vr-agent-followups button.is-primary,
.vr-chat-command-popover button.is-primary,
.vr-cli-action-button.is-primary {
  font-family: var(--vr-hud-sans, 'Geist', 'Inter', system-ui, sans-serif);
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}
.vr-scope-menu p { font-size: 10px; }

/* 1d. Studio tab bar — Anton stays (display scale) but sized up + opened for
   scannable CHAT / ARCHITECTURE / TERMINAL / DIFF. */
.vr-studio-tabs button {
  font-size: 13px;
  letter-spacing: 0.06em;
  font-weight: 400;                 /* Anton is already heavy */
}

/* 1e. HUD telemetry strip — bigger, weightier instrument line. */
.vr-hud-strip { font-size: 10px; color: #d2cabc; }
.vr-hud-strip strong { font-weight: 720; color: #f7f4ec; }
.vr-hud-strip em,
.vr-hud-strip b { font-weight: 600; }

/* 1f. Context chips — cream sans label, drop the cold-grey muted qualifier. */
.vr-context-chip-label {
  font-size: 12px;
  font-weight: 620;
  letter-spacing: 0.01em;
}
.vr-context-chip-label .muted {
  color: var(--vr-muted);
  font-weight: 560;
}

/* 1g. Region-map / architecture node badges + zone/hint — weight up, cap track. */
.vr-arch-node-badge {
  font-size: 10.5px;
  font-weight: 780;
  letter-spacing: 0.02em;
}
.vr-arch-zone { font-size: 10px; letter-spacing: 0.06em; }
.vr-arch-hint { font-size: 11px; letter-spacing: 0.01em; line-height: 1.4; }

/* 1h. Model/scope picker button — selected model reads clean, non-condensed. */
.vr-model-picker > button strong {
  font-family: var(--vr-hud-sans, 'Geist', 'Inter', system-ui, sans-serif);
  font-size: 12px;
  font-weight: 680;
  letter-spacing: 0.01em;
}
.vr-model-picker > button span {
  font-size: 10px;
  letter-spacing: 0.02em;
  color: var(--vr-muted);
}

/* 1i. Dropdown menu rows — readable item body + sub-caption, sans not condensed. */
.vr-model-menu button,
.vr-scope-menu button,
.vr-chat-command-popover button {
  font-size: 12.5px;
  letter-spacing: 0.005em;
}
.vr-model-menu button strong { font-weight: 660; }
.vr-model-menu button em { font-size: 11px; font-style: normal; color: var(--vr-muted); }

/* 1j. Stat-card label under the big Anton KPI number — size up the smear. */
.vr-stat-card span {
  font-size: 9.5px;
  letter-spacing: 0.08em;
  font-weight: 620;
  color: #ccc4b6;
}

/* 1k. Version card meta / branch / pile label — floor size + cap tracking.
   (Overrides the contrast-pass 8.5px !important at 16063-64 and the pile
   letter-spacing at 16080, so font-size/letter-spacing need !important.) */
.vr-vcard-meta,
.vr-vcard-branch {
  font-size: 9.5px !important;      /* was 8.5px !important */
  letter-spacing: 0.05em !important;
}
.vr-version-pile-label {
  font-size: 9.5px !important;
  letter-spacing: 0.08em !important; /* was 1.8px */
  font-weight: 640;
}

/* 1l. SHUFFLE / worktree / table-foot action captions — legible click labels. */
.vr-pile-shuffle,
.vr-bcard-actions button,
.vr-table-warning button,
.vr-table-foot button {
  font-size: 10px;
  letter-spacing: 0.07em;
  font-weight: 680;
}

/* 1m. Highest-traffic reading surfaces — comfortable body size + leading. */
.vr-agent-answer-body,
.vr-agent-answer-body p,
.vr-chat-message p,
.vr-chat-bubble p {
  font-size: 13.5px;
  line-height: 1.55;
  letter-spacing: 0.003em;
}
.vr-terminal-line { font-size: 12.5px; line-height: 1.5; }

/* 1n. Empty-state / drop-zone / note / recent-chat meta — lift learn-the-UI text. */
.vr-table-empty { font-size: 12.5px; line-height: 1.45; }
.vr-provider-drop-zone { font-size: 12px; letter-spacing: 0.01em; }
.vr-chat-note { font-size: 12px; line-height: 1.45; }
.vr-recent-chat em,
.vr-recent-chat small { font-size: 11px; font-style: normal; }

/* 1o. Env-connect code chip + terminal compose — legible mono command hints. */
.vr-env-connect-option b {
  font-size: 10px;
  letter-spacing: 0.04em;
  font-weight: 640;
}
.vr-terminal-compose textarea {
  font-size: 13px;
  line-height: 1.5;
  letter-spacing: 0;
}

/* -------------------------------------------------------------------------
   (2) MANGA CARD-VIBE BACKGROUND — all margin/corner-masked, never behind text
   ------------------------------------------------------------------------- */

/* Keep app chrome above the fixed texture layers so opaque panels occlude them. */
.vr-app { position: relative; z-index: 1; }
.vr-composed-shell { position: relative; z-index: 1; }

/* 2a. Fixed full-viewport ink-splatter, painted ONLY in the outer page gutter.
   The .vr-composed-shell (opaque near-black, margin:10px 12px) sits on top and
   blocks it wherever real content lives; screen-blend keeps it light ink. */
body::before {
  content: '';
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background: url('/manga/bg.webp') no-repeat center center / cover;
  /* opacity + mask only — no mix-blend/filter (those are GPU-heavy on a
     fixed full-viewport layer and stall headless capture). The art is already
     ink-on-black so it reads as faint ink in the gutter at this opacity. */
  opacity: 0.09;
  -webkit-mask-image: radial-gradient(ellipse 74% 70% at 50% 46%, transparent 60%, #000 92%);
  mask-image: radial-gradient(ellipse 74% 70% at 50% 46%, transparent 60%, #000 92%);
}

/* 2b. Corner-weighted fine GOLD halftone screentone (manga-card dot vibe),
   masked to two opposite corners only so the chat/panel mid-screen stays clean. */
body::after {
  content: '';
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background-image: radial-gradient(rgba(232, 193, 90, 0.10) 0.9px, transparent 1.3px);
  background-size: 5px 5px;
  opacity: 0.5;
  -webkit-mask-image:
    radial-gradient(circle at 100% 0%, #000 0%, transparent 34%),
    radial-gradient(circle at 0% 100%, #000 0%, transparent 34%);
  mask-image:
    radial-gradient(circle at 100% 0%, #000 0%, transparent 34%),
    radial-gradient(circle at 0% 100%, #000 0%, transparent 34%);
  -webkit-mask-composite: source-over;
  mask-composite: add;
}

/* 2c. Ghost provider card tucked into the shell's top-left gutter, behind the
   translucent topbar/rail only. Lives inside overflow:hidden (clipped to shell),
   blurred + rotated like a card left on the table, faded before the chat column.
   RISK NOTE: .vr-composed-shell::after is reused as the drop overlay while
   dragging (.vr-app.is-dragging-*), which harmlessly hides this watermark
   during an active drag; it returns on drop. Idle state is unaffected. */
.vr-composed-shell .vr-studio-body::after {
  content: '';
  position: absolute;
  left: -70px;
  top: -40px;
  width: 300px;
  height: 420px;
  z-index: 0;
  pointer-events: none;
  background: url('/manga/cards/supabase.webp') no-repeat center / contain;
  opacity: 0.05;
  transform: rotate(-13deg);
  filter: grayscale(0.6) contrast(0.95) blur(0.4px);
  -webkit-mask-image: linear-gradient(135deg, #000 12%, transparent 62%);
  mask-image: linear-gradient(135deg, #000 12%, transparent 62%);
}

/* 2d. Existing raven emblem watermark (base at 15577, opacity 0.06, no mask):
   add a corner-fade mask + push below content so it never creeps under rows.
   !important here re-targets the already-textured pseudo across states. */
.vr-table-view::after,
.vr-studio-architecture.is-region-map::after {
  z-index: 0 !important;
  opacity: 0.07 !important;
  -webkit-mask-image: radial-gradient(circle at 100% 100%, #000 0%, transparent 58%) !important;
  mask-image: radial-gradient(circle at 100% 100%, #000 0%, transparent 58%) !important;
}
.vr-table-view > *,
.vr-studio-architecture.is-region-map > * { position: relative; z-index: 1; }

/* 2e. Poster ghost low in the left gutter of the studio body — far-corner masked
   + blurred so it never reaches the readable center/right columns. */
.vr-composed-shell .vr-studio-body { position: relative; }
.vr-composed-shell .vr-studio-body::before {
  content: '';
  position: absolute;
  left: -30px;
  bottom: -30px;
  width: 280px;
  height: 360px;
  z-index: 0;
  pointer-events: none;
  background: url('/manga/poster.webp') no-repeat left bottom / contain;
  opacity: 0.045;
  filter: grayscale(0.7) contrast(1.05) blur(0.6px);
  -webkit-mask-image: radial-gradient(circle at 0% 100%, #000 0%, transparent 55%);
  mask-image: radial-gradient(circle at 0% 100%, #000 0%, transparent 55%);
}

/* 2f. CONTRAST GUARD — the three translucent panels are rgba(18,20,24,.78),
   22% transparent, so texture could faintly show under text. Bump the ink base
   more opaque; margins keep the vibe, text stays crisp. (background-color only,
   later source order beats the shorthand at 1737 without !important.) */
.vr-studio-chat,
.vr-studio-terminal,
.vr-studio-diff { background-color: rgba(14, 15, 19, 0.9); }

/* ============================================================================
   MANGA READABILITY — FINAL ENFORCEMENT PASS (appended after all prior
   override chains: MANGA THEME PASS / B&W CONTRAST / FINAL FIXES / READABILITY).
   Wins by source order. Two groups:
     (1) READABLE FONTS — strict 3-tier type system, no coloured/gradient
         button text, condensed Anton pulled off all running/clickable UI.
     (2) MENTION + WELCOME/HANDOFF MANGA THEME — re-skin the old blue-slate
         PromptModal + quickstart to ink/gold manga.
   !important is used ONLY where an existing same-file !important forces it
   (documented inline). Readability always wins over theme where they overlap.
   RISK NOTES: clip-path notches added to modal/menu panels can clip focus
   rings / drop-shadows on the notched corner — acceptable (decorative corner
   only, ~12-18px, no interactive target sits there). No overflow:hidden added,
   so popovers/tooltips are unaffected.
   ========================================================================= */

/* ---------------------------------------------------------------------------
   GROUP 1 — READABLE FONTS
   --------------------------------------------------------------------------- */

/* 1.0 — Foundation: guarantee one clean non-condensed sans stack for TIER 2.
   Every rule below that says var(--vr-hud-sans) resolves to this. */
:root {
  --vr-hud-sans: 'Geist', 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
}

/* 1.1 — Composer action bar (ADD CONTEXT / MENTION / COMMANDS / WORST CARD /
   ADD CARD): the exact pills the user screenshotted. Clean sans, normal-case,
   comfortable size, single cream colour. Neutralise any inherited condensed
   face and any -webkit-text-fill on the label span. */
.vr-chat-inline-actions > button,
.vr-chat-command-trigger > button,
.vr-chat-inline-actions button {
  font-family: var(--vr-hud-sans);
  font-size: 12.5px;
  font-weight: 650;
  letter-spacing: 0.02em;
  text-transform: none;
  color: var(--vr-text);
}
.vr-chat-inline-actions > button span,
.vr-chat-command-trigger > button span {
  font-family: var(--vr-hud-sans);
  font-weight: 650;
  letter-spacing: 0.02em;
  color: var(--vr-text);
  -webkit-text-fill-color: currentColor;
  background: none;
}

/* 1.2 — Composer action icons: kill MENTION multicolour / ADD CARD purple.
   Pin all glyphs to the same muted cream as the label so each pill is one
   legible colour. (Worst-card icon keeps a gold accent — see 1.3.) */
.vr-chat-inline-actions > button i[data-icon],
.vr-chat-inline-actions > button svg,
.vr-chat-command-trigger > button i[data-icon],
.vr-chat-command-trigger > button svg {
  color: var(--vr-muted);
  stroke: var(--vr-muted);
}

/* 1.3 — WORST CARD pill: remove the gold TEXT (overrides 14663-14664). Label
   goes cream like its siblings; gold survives only as border + icon accent. */
.vr-chat-inline-actions > button.is-worst-card,
.vr-chat-inline-actions > button.is-worst-card span {
  color: var(--vr-text);
}
.vr-chat-inline-actions > button.is-worst-card {
  border-color: rgba(232, 193, 90, 0.42);
}
.vr-chat-inline-actions > button.is-worst-card i[data-icon],
.vr-chat-inline-actions > button.is-worst-card svg {
  color: var(--vr-gold);
  stroke: var(--vr-gold);
}

/* 1.4 — is-primary composer pills (gold fill): dark ink text, not gold text. */
.vr-chat-inline-actions button.is-primary,
.vr-chat-inline-actions button.is-primary span {
  color: #1a1206;
}

/* 1.5 — Hover on composer buttons: emphasis via border + bright ink, not by
   flipping the whole label. Gold-bright label on hover is legible on the
   darkened background and matches the menu hover language elsewhere. */
.vr-chat-inline-actions button:hover,
.vr-chat-inline-actions > button:hover,
.vr-chat-command-trigger > button:hover {
  color: var(--vr-gold-bright);
  border-color: var(--vr-gold);
  background: rgba(20, 18, 12, 0.85);
}
.vr-chat-inline-actions > button:hover span { color: var(--vr-gold-bright); }
.vr-chat-inline-actions > button:hover i[data-icon],
.vr-chat-inline-actions > button:hover svg {
  color: var(--vr-gold-bright);
  stroke: var(--vr-gold-bright);
}

/* 1.6 — ADD CARD shelf chip + is-gold variant. Base 8.5px/1.4px mono (14503)
   is NOT !important, so plain declarations win by source order — no
   !important needed. Readable sans, >=11px, tight tracking; gold stays as the
   FILL with dark ink text. */
.vr-shelf-chip {
  font-family: var(--vr-hud-sans);
  font-size: 11px;
  font-weight: 650;
  letter-spacing: 0.03em;
  text-transform: none;
  color: var(--vr-text);
}
.vr-shelf-chip.is-gold { color: #1a1206; }

/* 1.7 — Quick-action tiles (left rail). Sans, readable weight/size, single
   cream colour; icon a quiet accent. */
.vr-quick-action,
.vr-quick-action strong,
.vr-quick-action em {
  font-family: var(--vr-hud-sans);
  letter-spacing: 0.01em;
  text-transform: none;
  color: var(--vr-text);
}
.vr-quick-action strong { font-size: 12.5px; font-weight: 660; }
.vr-quick-action em { font-size: 11px; font-weight: 500; color: var(--vr-muted); }
.vr-quick-action i, .vr-quick-action svg { color: var(--vr-muted); stroke: var(--vr-muted); }

/* 1.8 — Dropdown menu rows (model / scope / command popover). Sans, comfortable
   size, cream text. Section HEADERS (.vr-model-menu p / .vr-scope-menu p) stay
   Anton gold — that is a valid TIER-1 eyebrow, restyled in 1.9 / GROUP 2. */
.vr-model-menu button,
.vr-scope-menu button,
.vr-chat-command-popover button {
  font-family: var(--vr-hud-sans);
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: 0.005em;
  text-transform: none;
  color: var(--vr-text);
}
.vr-model-menu button strong,
.vr-scope-menu button strong { font-family: var(--vr-hud-sans); font-weight: 660; }
.vr-model-menu button em,
.vr-scope-menu button em {
  font-family: var(--vr-hud-sans);
  font-style: normal;
  font-weight: 500;
  color: var(--vr-muted);
}

/* 1.9 — Quickstrike command menu: clickable rows go sans/cream; header stays a
   small tracked eyebrow. */
.vr-quickstrike button {
  font-family: var(--vr-hud-sans);
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: 0.01em;
  text-transform: none;
  color: var(--vr-text);
}
.vr-quickstrike header {
  font-size: 11px;
  letter-spacing: 0.06em;
}

/* 1.10 — Model/scope picker trigger (selected-model label). */
.vr-model-picker > button strong {
  font-family: var(--vr-hud-sans);
  font-size: 12px;
  font-weight: 660;
  letter-spacing: 0.01em;
  color: var(--vr-text);
}
.vr-model-picker > button span {
  font-family: var(--vr-hud-sans);
  font-size: 10.5px;
  letter-spacing: 0.02em;
  color: var(--vr-muted);
}

/* 1.11 — Primary gold CTAs that were switched to Anton (15704+): pull them to
   bold sans, dark ink on gold. Gold is fill/accent, never text colour. */
.vr-new-chat-button,
.vr-provider-ask-agent,
.vr-approve-all,
.vr-chat-command-popover button.is-primary,
.vr-agent-followups button.is-primary,
.vr-agent-inline-action.is-primary,
.vr-cli-action-button.is-primary,
.vr-studio-add-chat,
.vr-studio-architecture > footer button.is-primary,
.vr-arch-drawer footer button.is-primary,
.vr-wt-actions button.is-primary {
  font-family: var(--vr-hud-sans);
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: none;
  color: #1a1206;
}

/* 1.12 — Studio tab bar (CHAT / ARCHITECTURE / TERMINAL / DIFF): legitimate
   TIER-1 marquee. Keep Anton, but lock size/tracking legible; active tab keeps
   dark ink on gold. */
.vr-studio-tabs button {
  font-family: var(--mg-display);
  font-size: 13.5px;
  letter-spacing: 0.06em;
  font-weight: 400;
}
.vr-studio-tabs button.is-active { color: #0a0b0e; }

/* 1.13 — Context chips + provider drop-label in the composer. */
.vr-context-chip-label,
.vr-provider-drop-label {
  font-family: var(--vr-hud-sans);
  font-size: 12px;
  font-weight: 620;
  letter-spacing: 0.01em;
  text-transform: none;
  color: var(--vr-text);
}
.vr-context-chip-label .muted { font-weight: 520; color: var(--vr-muted); }

/* 1.14 — Stat-card LABEL beneath the Anton KPI number. The number
   (.vr-stat-card b) keeps Anton untouched; only the micro-label is lifted. */
.vr-stat-card span {
  font-family: var(--vr-hud-sans);
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #ccc4b6;
}

/* 1.15 — Ribbon stat qualifier + table-ribbon brand value. */
.vr-ribbon-stat i {
  font-family: var(--vr-hud-sans);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.03em;
  color: var(--vr-muted);
}
.vr-table-ribbon > b {
  font-family: var(--vr-hud-sans);
  font-size: 12.5px;
  font-weight: 700;
  color: var(--vr-gold-bright);
}

/* 1.16 — Version card meta / branch / pile labels. These carry same-file
   !important (16062/16064/16065/16081) on color/size/family, so !important is
   required here to win on family + tracking. Size floors from 16386 are left
   intact (readability floor already >=9.5px). */
.vr-vcard-meta,
.vr-vcard-branch,
.vr-version-pile-label {
  font-family: var(--vr-hud-sans) !important;
  letter-spacing: 0.03em !important;
  text-transform: none;
}
.vr-vpile-card b {
  font-family: var(--vr-hud-sans) !important;   /* beats 16062 !important */
  letter-spacing: 0.01em;
}

/* 1.17 — Shuffle / worktree / table-foot / back-card / addpick action captions:
   every click label a plain readable word, not a condensed cap. */
.vr-pile-shuffle,
.vr-bcard-actions button,
.vr-table-warning button,
.vr-table-foot button,
.vr-addpick-list button strong {
  font-family: var(--vr-hud-sans);
  font-size: 11px;
  font-weight: 640;
  letter-spacing: 0.03em;
  text-transform: none;
  color: var(--vr-text);
}

/* 1.18 — Global guard: no gradient/clipped text may re-enter any button/label.
   (No same-file !important on -webkit-text-fill-color, so none needed here.) */
.vr-chat-inline-actions button,
.vr-chat-command-trigger button,
.vr-quick-action,
.vr-quick-action strong,
.vr-quick-action em,
.vr-shelf-chip,
.vr-studio-tabs button,
.vr-model-menu button,
.vr-scope-menu button,
.vr-chat-command-popover button {
  -webkit-text-fill-color: currentColor;
  -webkit-background-clip: border-box;
  background-clip: border-box;
}

/* ---------------------------------------------------------------------------
   GROUP 2 — MENTION + WELCOME/HANDOFF MANGA THEME
   The composer "Mention" button (data-action="prompt") opens the PromptModal,
   so re-theming the PromptModal fixes both the "mention screen" and the Scoped
   Handoff / Agent Mission modal. Also sweeps the leftover blue-slate theme off
   Guide/Plan/Notifications and finishes the quickstart cards.
   RISK NOTE: clip-path notch on modal panels clips the far corner only; no
   text or control sits there.
   --------------------------------------------------------------------------- */

/* 2.1 — Modal header shell (Agent Mission / Guide): navy gradient + slate
   border -> ink panel, gold left spine, gold halftone. */
.vr-modal-prompt-head,
.vr-modal-guide-head {
  border: 1px solid var(--vr-border-strong);
  border-left: 3px solid var(--vr-gold);
  border-radius: 0;
  clip-path: polygon(0 0, calc(100% - 18px) 0, 100% 18px, 100% 100%, 18px 100%, 0 calc(100% - 18px));
  background-color: rgba(9, 9, 11, 0.94);
  background-image:
    radial-gradient(circle at 12% 30%, rgba(232, 193, 90, 0.07), transparent 40%),
    radial-gradient(rgba(232, 193, 90, 0.05) 1px, transparent 1.4px);
  background-size: auto, 9px 9px;
  box-shadow: 5px 6px 0 rgba(0, 0, 0, 0.55);
}

/* 2.2 — Header eyebrow: gold token, small Anton poster eyebrow. */
.vr-modal-prompt-head p,
.vr-modal-guide-head p {
  color: var(--vr-gold);
  font-family: var(--mg-display);
  font-weight: 400;
  font-size: 12px;
  letter-spacing: 0.14em;
}

/* 2.3 — Header title: Anton poster caps, cream ink. */
.vr-modal-prompt-head h2,
.vr-modal-guide-head h2 {
  font-family: var(--mg-display);
  font-weight: 400;
  font-size: 40px;
  letter-spacing: 0.01em;
  text-transform: uppercase;
  color: var(--vr-text);
}

/* 2.4 — Header sub-copy: ice-blue -> readable cream sans. */
.vr-modal-prompt-head em,
.vr-modal-guide-head em {
  font-family: var(--vr-hud-sans);
  color: var(--vr-muted);
  font-size: 14px;
  font-style: normal;
  line-height: 1.5;
}

/* 2.5 — Header side aside (Scope / One gap): slate glass -> ink + gold hairline. */
.vr-modal-prompt-head aside,
.vr-modal-guide-head aside {
  border: 1px solid var(--vr-border-strong);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.28);
}
.vr-modal-prompt-head aside > i,
.vr-modal-guide-head aside > i {
  background: rgba(232, 193, 90, 0.10);
  color: var(--vr-gold-bright);
  border-radius: 0;
}
.vr-modal-prompt-head aside > span,
.vr-modal-guide-head aside > span {
  color: var(--vr-gold);
  font-family: var(--vr-hud-sans);
  letter-spacing: 0.06em;
}
.vr-modal-prompt-head aside > strong,
.vr-modal-guide-head aside > strong { color: var(--vr-text); }

/* 2.6 — Scoped-handoff mission <pre> card: navy border + ice-blue mono ->
   ink card, gold spine, cream mono. */
.vr-modal-prompt-card {
  border: 1px solid var(--vr-border);
  border-left: 3px solid var(--vr-gold);
  border-radius: 0;
  clip-path: polygon(0 0, calc(100% - 14px) 0, 100% 14px, 100% 100%, 14px 100%, 0 calc(100% - 14px));
  background:
    radial-gradient(circle at 88% 0%, rgba(232, 193, 90, 0.05), transparent 34%),
    rgba(9, 9, 11, 0.94);
}
.vr-modal-prompt-card pre {
  color: var(--vr-text);
  font-family: var(--vr-hud-mono);
  font-size: 12.5px;
  line-height: 1.7;
}

/* 2.7 — Flow/signal list panels: navy -> ink + gold halftone. */
.vr-modal-flow-list,
.vr-modal-signal-list {
  border: 1px solid var(--vr-border-strong);
  border-radius: 0;
  clip-path: polygon(0 0, calc(100% - 16px) 0, 100% 16px, 100% 100%, 16px 100%, 0 calc(100% - 16px));
  background:
    radial-gradient(rgba(232, 193, 90, 0.04) 1px, transparent 1.4px) 0 0 / 9px 9px,
    rgba(9, 9, 11, 0.94);
}

/* 2.8 — Flow-list step rows: slate borders + purple glow + cold-blue caption
   -> ink rows, gold-tinted hover spine, readable sans. */
.vr-modal-flow-list button {
  border: 1px solid var(--vr-border);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.25);
}
.vr-modal-flow-list button:hover {
  border-color: var(--vr-gold);
  box-shadow: inset 3px 0 0 var(--vr-gold);
  background: rgba(232, 193, 90, 0.10);
}
.vr-modal-flow-list button > span {
  border: 2px solid var(--vr-gold);
  color: var(--vr-gold-bright);
}
.vr-modal-flow-list strong { font-family: var(--vr-hud-sans); color: var(--vr-text); }
.vr-modal-flow-list em {
  font-family: var(--vr-hud-sans);
  color: var(--vr-muted);
  font-size: 12px;
  line-height: 1.45;
}

/* 2.9 — Composer scope/mention popup panel: reinforce ink + gold spine +
   comic-notch so it reads as part of the manga card system. */
.vr-scope-menu {
  border-radius: 0;
  border-left: 3px solid var(--vr-gold);
  clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 12px 100%, 0 calc(100% - 12px));
  background-color: rgba(9, 9, 11, 0.96);
  box-shadow: 4px 6px 0 rgba(0, 0, 0, 0.55);
}

/* 2.10 — Scope/mention popup section label: Anton gold eyebrow, legible size.
   (Group 1 already forced the ROWS to sans; this only styles the <p> header.) */
.vr-scope-menu p {
  font-family: var(--mg-display);
  font-size: 11px;
  letter-spacing: 0.14em;
  color: var(--vr-gold);
}

/* 2.11 — Scope/mention popup rows: gold-tinted hover + selected state.
   (Font-family/size/colour already set sans in Group 1 §1.8 — here we only add
   the hover/selected theming so the two passes don't fight.) */
.vr-scope-menu button:hover {
  background: rgba(232, 193, 90, 0.14);
  box-shadow: inset 3px 0 0 var(--vr-gold);
  color: var(--vr-gold-bright);
}
.vr-scope-menu button:has(> b) {
  background: rgba(232, 193, 90, 0.18);
  box-shadow: inset 3px 0 0 var(--vr-gold-bright);
  color: var(--vr-gold-bright);
}

/* 2.12 — Welcome/quickstart title: condensed --vr-display -> Anton poster. */
.vr-qs-head h2 {
  font-family: var(--mg-display);
  font-weight: 400;
  font-size: 32px;
  letter-spacing: 0.02em;
  color: var(--vr-text);
}

/* 2.13 — Welcome sub-copy + LOCAL badge. The 9.5px floor at 16386 keeps
   .vr-qs-local legible; here we only recolor to gold (no size restated, so we
   don't fight that !important). */
.vr-qs-head p {
  font-family: var(--vr-hud-sans);
  font-size: 13px;
  color: var(--vr-muted);
}
.vr-qs-local {
  color: var(--vr-gold);
  font-weight: 660;
}

/* 2.14 — Welcome hero cards: rounded flat -> gold clipped-frame collector card. */
.vr-qs-card.is-hero {
  border-radius: 0;
  clip-path: polygon(0 0, calc(100% - 14px) 0, 100% 14px, 100% 100%, 14px 100%, 0 calc(100% - 14px));
  background: linear-gradient(160deg, var(--vr-gold), rgba(232, 193, 90, 0.35));
  padding: 2px;
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.6);
}
.vr-qs-card.is-hero .vr-qs-card-inner {
  border-radius: 0;
  clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 12px 100%, 0 calc(100% - 12px));
  background:
    radial-gradient(rgba(232, 193, 90, 0.05) 1px, transparent 1.4px) 0 0 / 8px 8px,
    rgba(9, 9, 11, 0.96);
}

/* 2.15 — Welcome hero card title: Anton only on the title; body/labels go sans. */
.vr-qs-card.is-hero .vr-qs-card-top strong {
  font-family: var(--mg-display);
  font-weight: 400;
  font-size: 15px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--vr-text);
}
.vr-qs-card.is-hero .vr-qs-card em,
.vr-qs-card.is-hero .vr-qs-type {
  font-family: var(--vr-hud-sans);
  color: var(--vr-muted);
}
.vr-qs-card.is-hero button {
  font-family: var(--vr-hud-sans);
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: none;
  color: var(--vr-gold-bright);
  border-color: var(--vr-gold);
}

/* ==========================================================================
   FINAL POLISH — drag ghost, active tab, low-quality chat cards
   ========================================================================== */
/* Drag ghost: a clean floating card preview. It was a clone that KEPT the
   placed/hand card's position:absolute + translate(-50%,-50%) / rotation /
   negative margin, so it rendered as a corrupted half-card. Reset to a plain
   fixed, upright (slightly tilted) card sized to the source. */
.vr-drag-ghost {
  position: fixed !important;
  margin: 0 !important;
  transform: rotate(-4deg) !important;
  transform-origin: top left;
  z-index: 100000 !important;
  pointer-events: none !important;
  opacity: 0.96;
  box-shadow: 0 24px 46px rgba(0, 0, 0, 0.78);
  transition: none !important;
}
.vr-drag-ghost .vr-tcard-unplace { display: none !important; }
.vr-drag-ghost .vr-tcard-holofoil,
.vr-drag-ghost .vr-tcard-glare { animation: none !important; opacity: 0.2 !important; }

/* Active tab: was dark #0a0b0e text on a near-transparent wash = an unreadable
   "black mark". Gold-bright text on a subtle wash + gold underline reads clean. */
.vr-studio-tabs button.is-active {
  color: var(--vr-gold-bright) !important;
  background: rgba(244, 241, 232, 0.05);
  box-shadow: inset 0 -2px 0 var(--vr-gold), inset 0 0 0 1px rgba(232, 193, 90, 0.26);
  border-radius: 4px;
}

/* ==========================================================================
   VERSION CARDS — richer "release card" (was small/plain crimson-inner).
   Gold ornate frame + comic notch + halftone + BIG Anton version number,
   matching the premium provider-card language. No full-art (releases have no
   art), so the version number IS the hero.
   ========================================================================== */
.vr-vcard {
  border: 1.5px solid var(--vr-border-strong) !important;
  border-radius: 5px !important;
  clip-path: polygon(0 0, calc(100% - 16px) 0, 100% 16px, 100% 100%, 16px 100%, 0 calc(100% - 16px));
  background: rgba(9, 9, 11, 0.97) !important;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.6), inset 0 0 0 1px rgba(232, 193, 90, 0.16) !important;
  overflow: hidden !important;
}
.vr-vcard::before {
  inset: 0 !important;
  border-radius: 0 !important;
  background-color: transparent !important;
  background-image:
    radial-gradient(rgba(232, 193, 90, 0.05) 1px, transparent 1.4px),
    radial-gradient(ellipse 78% 46% at 50% 0%, rgba(232, 193, 90, 0.07), transparent 60%) !important;
  background-size: 9px 9px, 100% 100% !important;
  background-repeat: repeat, no-repeat !important;
  opacity: 1 !important;
}
.vr-vcard:not(.is-current) { filter: none !important; opacity: 0.92; }
.vr-vcard.is-current {
  border-color: var(--vr-gold) !important;
  border-left: 3px solid var(--vr-gold) !important;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.6), 0 0 22px rgba(232, 193, 90, 0.24), inset 0 0 0 1px rgba(232, 193, 90, 0.2) !important;
}
.vr-vcard-top b {
  font-family: var(--mg-display) !important;
  font-size: 26px !important;
  font-weight: 400 !important;
  color: var(--vr-gold-bright) !important;
  letter-spacing: 0.02em !important;
}
.vr-vcard.is-mini .vr-vcard-top b { font-size: 22px !important; }
.vr-vcard-branch { color: var(--vr-muted) !important; }
/* four gold corner ticks like the provider cards */
.vr-vcard .vr-vcard-foot::after {
  content: '';
  position: absolute;
  left: 8px; bottom: 8px; right: 8px;
  height: 1px;
  background: linear-gradient(90deg, var(--vr-gold), transparent 70%);
  opacity: 0.5;
}

/* ==========================================================================
   WELCOME FLIP-CARD BACK — flat manga halftone (was a gold spiral). Ink plate,
   gold halftone screentone, a soft gold top-glow, the fierce raven mark, gold
   FLIP label. Reads as a face-down manga card, not a casino spiral.
   ========================================================================== */
.vr-qs-back,
.vr-tcard.is-back:not(.has-art) {
  border: 1.5px solid var(--vr-border-strong) !important;
  border-radius: 5px !important;
  background:
    radial-gradient(rgba(232, 193, 90, 0.06) 1px, transparent 1.4px) 0 0 / 9px 9px,
    radial-gradient(ellipse 72% 52% at 50% 40%, rgba(232, 193, 90, 0.08), transparent 62%),
    #0a0a0d !important;
}
.vr-qs-back::after,
.vr-tcard.is-back:not(.has-art)::after {
  content: '';
  position: absolute;
  inset: 5px;
  border: 1px solid rgba(232, 193, 90, 0.22);
  border-radius: 3px;
  pointer-events: none;
}
.vr-qs-back img,
.vr-tcard.is-back:not(.has-art) .vr-tcard-backart img {
  width: 62px !important;
  height: 62px !important;
  opacity: 0.96 !important;
  filter: drop-shadow(0 0 10px rgba(232, 193, 90, 0.22));
}
.vr-qs-back b,
.vr-tcard.is-back:not(.has-art) .vr-tcard-backname {
  color: var(--vr-gold-bright) !important;
  font-family: var(--vr-hud-mono) !important;
  letter-spacing: 0.16em !important;
}

/* Region map: keep the grade medallion in the top-right corner like the binder,
   just scaled down to fit the small map cards so it stays tucked in the corner
   instead of covering the provider name. */
.vr-studio-architecture.is-region-map .vr-arch-node.is-card .vr-tcard-hp.is-onart {
  top: 5px;
  right: 5px;
  bottom: auto;
  transform: none;
  width: 16px;
  height: 16px;
}
.vr-studio-architecture.is-region-map .vr-arch-node.is-card .vr-tcard-hp.is-onart i {
  font-size: 9px;
}
`;
